{
 " ao(à) paciente {nome}{cpf}": "（患者：{nome}{cpf}）",
 " junto ao plano de saúde {c}": "向医疗保险 {c}",
 " às {h}": " {h}",
 "\"1\", \"1 / 10\" ou \"Página 1 de 10\", no canto que quiser.": "\"1\"、\"1 / 10\" 或 \"页面 1 / 10\"，放在任意角落。",
 "\"{nome}\" está no {provedor}.": "“{nome}”已保存到 {provedor}。",
 "\"{nome}\" não é JPG nem PNG. Converta para JPG e tente de novo.": "\"{nome}\" 不是 JPG 或 PNG。请转换为 JPG 后重试。",
 "\"{nome}\" não é um PDF.": "\"{nome}\" 不是 PDF。",
 "\"{nova}\" às {hora} coincide com: {outras}.": "“{nova}”（{hora}）与以下时间冲突：{outras}。",
 "\"{n}\" agora é do grupo. Em até 1 minuto os outros membros veem tudo.": "\"{n}\"现在属于群组。1 分钟内其他成员就能看到全部内容。",
 "\"{titulo}\" foi criada com os mesmos dados.": "\"{titulo}\" 已使用相同数据创建。",
 "\"{titulo}\" já foi adicionado em {data}.": "\"{titulo}\" 已于 {data} 添加。",
 "% ao mês": "%（月利率）",
 "(No computador do administrador: 32-LIGAR-DRIVE-ONEDRIVE.bat.)": "（在管理员的电脑上：32-LIGAR-DRIVE-ONEDRIVE.bat。）",
 "(cópia)": "（副本）",
 "(sem título)": "（无标题）",
 "+ Adicionar alerta": "+ 添加提醒",
 "+ Adicionar outra OAB": "+ 添加其他 OAB",
 "+ Adicionar pausa": "+ 添加休息",
 "+ Adicionar subtarefa": "+ 添加子任务",
 "+ Matéria em {nome}": "+ 在 {nome} 中添加科目",
 "+ Perfil": "+ 档案",
 "+ Subtarefa": "+ 子任务",
 "+5 min": "+5 分钟",
 "+{n} acompanhante(s)": "+{n} 位同伴",
 "+{n} páginas acima da meta": "超出目标 {n} 页",
 ", carteirinha nº {n},": "，保险卡号 {n}，",
 ", pago em {d}{f}": "，已于 {d} 支付{f}",
 "1 cápsula": "1粒胶囊",
 "1 dose": "1份",
 "1 dose (30 g)": "1份（30 g）",
 "1 pessoa": "1 人",
 "1 publicação nova": "1 条新公告",
 "1 página": "1 页",
 "1 tarja no documento": "文档中有 1 处涂黑",
 "1. Instale o My Planner e crie sua conta.  2. Abra este link de novo (ou digite o código em Ajustes › Grupos e convites).": "1. 安装 My Planner 并创建账户。  2. 再次打开此链接（或在 设置 › 群组和邀请 中输入邀请码）。",
 "1. Quais dados tratamos": "1. 我们处理哪些数据",
 "1. Sobre o app": "1. 关于本应用",
 "1ª dose": "第 1 剂",
 "2 por folha": "每张 2 页",
 "2 xícaras de farinha\n3 ovos\n1 colher de fermento": "2 杯面粉\n3 个鸡蛋\n1 勺泡打粉",
 "2, 4, 6 ou 9 páginas em cada folha (para imprimir).": "每张纸 2、4、6 或 9 页（用于打印）。",
 "2. Para que usamos": "2. 我们的用途",
 "2. Sua conta": "2. 你的账户",
 "2ª dose": "第 2 剂",
 "3 a 5 g": "3–5 g",
 "3. Bases legais (LGPD)": "3. 法律依据（LGPD）",
 "3. Uso correto": "3. 正确使用",
 "3ª dose": "第 3 剂",
 "4 por folha": "每张 4 页",
 "4. Com quem compartilhamos": "4. 我们与谁共享",
 "4. Planos e testes": "4. 套餐和试用",
 "5. Limites": "5. 责任限制",
 "5. Segurança": "5. 安全",
 "6 por folha": "每张 6 页",
 "6. Por quanto tempo": "6. 保存期限",
 "7. Seus direitos (art. 18 da LGPD)": "7. 你的权利（LGPD art. 18）",
 "8. Crianças e adolescentes": "8. 儿童和青少年",
 "9 por folha": "每张 9 页",
 "9. Mudanças": "9. 变更",
 "@letra-dom": "日",
 "@letra-qua": "三",
 "@letra-qui": "四",
 "@letra-sab": "六",
 "@letra-seg": "一",
 "@letra-sex": "五",
 "@letra-ter": "二",
 "A IA está classificando...": "AI 正在分类...",
 "A IA está lendo a caixa...": "AI 正在读取收纳盒...",
 "A IA lê as páginas e o PDF passa a aceitar busca e cópia.": "AI 读取页面，让 PDF 可搜索、可复制。",
 "A IA lê o PDF e sugere um nome claro.": "AI 读取 PDF 并建议一个清晰的名称。",
 "A IA não devolveu uma resposta no formato esperado. Tente de novo.": "AI 返回的结果格式不正确。请重试。",
 "A IA não encontrou dados para esta ficha no arquivo.": "AI 未在文件中找到此卡片的数据。",
 "A IA não encontrou tarefas nesta caixa.": "AI 未在此收纳盒中找到任务。",
 "A IA resume o PDF e responde perguntas.": "AI 总结 PDF 并回答问题。",
 "A SEFAZ registra que a nota chegou ao seu conhecimento (não confirma nem recusa a compra) e libera o XML completo na próxima busca, em até 1 hora.": "SEFAZ 会记录你已知悉这张发票（不代表确认或拒绝该笔购买），并在下次查询时（1 小时内）提供完整的 XML。",
 "A VENCER (7 DIAS)": "即将到期（7天内）",
 "A aba inteira": "整个标签页",
 "A aba {aba} está perto do limite. Arquive ou apague itens antigos dela.": "“{aba}”标签页快达到上限了。请归档或删除其中的旧项目。",
 "A aba {aba} não está assinada. O vínculo fica guardado e volta ao assinar.": "{aba} 标签页尚未订阅。关联会被保留，订阅后即可恢复。",
 "A busca de \"{nome}\" está ampla demais. Use o nome completo.": "\"{nome}\" 的搜索范围太广。请使用全名。",
 "A busca de GIFs ainda não foi ligada neste app. Enquanto isso, use as figurinhas animadas (🎉).": "本应用尚未开启 GIF 搜索。你可以先使用动态贴纸 (🎉)。",
 "A cada": "每隔",
 "A cada N páginas": "每 N 页",
 "A cada quantos dias": "每隔几天",
 "A cada {n} dia(s)": "每 {n} 天",
 "A cada {n} mês(es)": "每 {n} 个月",
 "A cada {n} mês(es) · dia {d}": "每 {n} 个月 · {d} 日",
 "A cada {n} semana(s)": "每 {n} 周",
 "A cada {n} semana(s) · {dia}": "每 {n} 周 · {dia}",
 "A caixa está em {aba}, em \"Anotações recebidas\".": "该收纳盒位于 {aba} 的\"收到的笔记\"中。",
 "A caixa foi para {destino}.": "收纳盒已发送到 {destino}。",
 "A chave fica guardada só neste dispositivo, no cofre do sistema. Em outro dispositivo, cadastre de novo.": "密钥仅保存在此设备的系统保险库中。在其他设备上需要重新添加。",
 "A chave fica guardada só neste navegador. Use num computador pessoal.": "密钥仅保存在此浏览器中。请在个人电脑上使用。",
 "A conexão é criptografada. O cofre usa criptografia de ponta a ponta (AES-256): nem o suporte consegue ler. O app pode ser bloqueado com senha, desenho ou biometria.": "连接经过加密。保险库使用端到端加密（AES-256）：连客服也无法读取。应用可以用密码、图案或生物识别锁定。",
 "A confirmação pelo WhatsApp ainda não foi ligada no servidor.": "服务器尚未开启 WhatsApp 验证。",
 "A conta e todos os dados guardados na nuvem: tarefas, anotações, abas, fichas, mensagens, arquivos enviados ao app e configurações. Também são apagados os dados deste dispositivo. Não há como desfazer.": "账户以及云端保存的所有数据：任务、笔记、标签页、档案、消息、发送到应用的文件和设置。本设备上的数据也会被删除。此操作无法撤销。",
 "A cor aparece na barra, nos títulos e nas tarefas ligadas a esta aba.": "颜色会显示在栏、标题以及与此标签页关联的任务中。",
 "A cor do My Planner é a cor de destaque do app. Cada tarefa pode ter uma cor própria na ficha.": "My Planner 颜色是应用的强调色。每个任务也可以在详情中设置自己的颜色。",
 "A data de fim é anterior à de início.": "结束日期早于开始日期。",
 "A data inicial precisa ser antes da final.": "开始日期必须早于结束日期。",
 "A equipe vai olhar o erro e corrigir numa próxima atualização.": "团队会查看该错误并在后续更新中修复。",
 "A equipe vê e altera conforme o papel de cada um": "团队按各自的角色查看和修改",
 "A fazer": "待办",
 "A foto passa de 8 MB.": "照片超过 8 MB。",
 "A foto é grande demais. Instale o app novo para recortar a foto.": "照片太大。请安装新版应用来裁剪照片。",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 32-LIGAR-DRIVE-ONEDRIVE.bat.": "“nuvem” 函数尚未发布到服务器。请运行 32-LIGAR-DRIVE-ONEDRIVE.bat。",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 9-LIGAR-DRIVE-ONEDRIVE.bat (veja COMO RODAR, versão 0.15.1).": "服务器上尚未发布“nuvem”函数。请运行 9-LIGAR-DRIVE-ONEDRIVE.bat（见 COMO RODAR，版本 0.15.1）。",
 "A gravação ainda está sendo preparada. Tente de novo em alguns minutos.": "录制文件仍在准备中，请过几分钟再试。",
 "A hora fica marcada neste fuso. Em outro fuso, o app mostra e avisa no horário convertido.": "时间按此时区记录。在其他时区，应用会按换算后的时间显示并提醒。",
 "A imagem original não está neste dispositivo.": "原始图片不在此设备上。",
 "A pagar": "待付",
 "A pagar: {v}": "待付：{v}",
 "A permissão da agenda foi retirada. Libere de novo nas configurações do celular.": "日历权限已被撤销。请在手机设置中重新允许。",
 "A pessoa sai do grupo e deixa de receber os envios.": "此人将退出群组，不再接收发送内容。",
 "A receber": "待收",
 "A receber: {v}": "待收：{v}",
 "A reunião ainda está sendo gravada.": "会议仍在录制中。",
 "A senha atual não confere.": "当前密码不正确。",
 "A senha do cofre precisa ter 6 caracteres ou mais.": "保险库密码至少需要 6 个字符。",
 "A senha precisa ter 8 caracteres ou mais.": "密码至少需要 8 个字符。",
 "A senha precisa ter pelo menos 8 caracteres.": "密码至少需要 8 个字符。",
 "A senha é a mesma no celular e no My Planner Web.": "手机和 My Planner Web 使用同一个密码。",
 "A sincronização roda ao abrir o app e depois de cada alteração. Tarefas ligadas à agenda mostram 📆.": "打开应用时以及每次更改后都会同步。与日历关联的任务会显示 📆。",
 "A sua equipe num lugar só": "把你的团队聚在一起",
 "A tarefa da casa não entra no My Planner sozinha. \"Enviar para o My Planner\" abre a ficha completa para escolher dia, horário, frequência, pausas e alertas.": "家务不会自动进入 My Planner。“发送到 My Planner”会打开完整表单，可选择日期、时间、频率、休息和提醒。",
 "A validade não pode ser antes da emissão.": "有效期不能早于签发日期。",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web.": "iPhone 版即将登陆 App Store。在此之前，请使用 My Planner Web。",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web: no Safari, toque em Compartilhar > Adicionar à Tela de Início para ele virar um ícone no celular.": "iPhone 版即将登陆 App Store。在此之前，请使用 My Planner Web：在 Safari 中轻点“分享”>“添加到主屏幕”，即可在手机上生成图标。",
 "A4, Carta, A5 ou Ofício, sem cortar nada.": "A4、Letter、A5 或 Legal，不裁切任何内容。",
 "ADICIONAR AMIGO": "添加好友",
 "AGUARDANDO RESPOSTA": "等待回复",
 "AMIGOS": "好友",
 "ANOTAÇÕES": "笔记",
 "ANOTAÇÕES RECEBIDAS · {aba}": "收到的笔记 · {aba}",
 "ATIVIDADE": "活动",
 "ATIVIDADE FÍSICA": "体育锻炼",
 "ATRASADAS": "已逾期",
 "Aba": "标签页",
 "Aba bloqueada": "标签页已锁定",
 "Aba {nome}": "{nome} 标签页",
 "Abas": "标签页",
 "Abas liberadas pelo suporte": "由客服开通的标签页",
 "Abas para comprar": "可购买的标签页",
 "Abas que você já tem": "已拥有的标签页",
 "Abastecimento": "加油",
 "Abastecimentos": "加油记录",
 "Abdominal": "卷腹",
 "Abertura do prazo da declaração do IR": "个税申报期开始",
 "Abra a empresa e toque em \"Buscar notas\" para digitar a senha do cofre.": "打开公司，点按“查询发票”，然后输入保险库密码。",
 "Abra o My Planner Anne e entre com o seu CPF e senha.": "打开 My Planner Anne，用你的证件号和密码登录。",
 "Abra o My Planner no celular.": "请在手机上打开 My Planner。",
 "Abra o cofre": "打开保险库",
 "Abra um PDF para começar.": "打开一个 PDF 开始吧。",
 "Abra uma matéria e toque em \"Estudar agora\" para cronometrar. Defina metas semanais em cada matéria.": "打开一个科目并点击\"立即学习\"开始计时。可为每个科目设置每周目标。",
 "Abraço": "抱抱",
 "Abre a janela do celular: WhatsApp, e-mail, Google Drive, OneDrive, salvar em Arquivos e outros.": "打开手机的分享菜单：WhatsApp、电子邮件、Google Drive、OneDrive、存储到“文件”等。",
 "Abre o PDF para ler aqui mesmo.": "直接在这里打开阅读 PDF。",
 "Abre o Scanner PDF (bordas e sombras corrigidas).": "打开 PDF 扫描仪（已校正边缘和阴影）。",
 "Abrir": "打开",
 "Abrir Ajustes": "打开设置",
 "Abrir PDF": "打开 PDF",
 "Abrir PDF do celular, Drive ou OneDrive": "从手机、Drive 或 OneDrive 打开 PDF",
 "Abrir a aba": "打开标签页",
 "Abrir a cópia guardada": "打开保存的副本",
 "Abrir a pasta no Drive": "在 Drive 中打开文件夹",
 "Abrir com outro app": "用其他应用打开",
 "Abrir configurações": "打开设置",
 "Abrir em outro app": "在其他应用中打开",
 "Abrir no DJEN": "在 DJEN 中打开",
 "Abrir no modo seguro": "以安全模式打开",
 "Abrir normalmente": "正常打开",
 "Abrir nota fiscal": "打开发票",
 "Abrir o PDF": "打开 PDF",
 "Abrir o PDF no {nome}": "在 {nome} 中打开 PDF",
 "Abrir o XML": "打开 XML",
 "Abrir o app": "打开应用",
 "Abrir o app My Planner": "打开 My Planner 应用",
 "Abrir o cartão": "打开卡片",
 "Abrir o cofre": "打开保险库",
 "Abrir o cofre para ver": "打开保险库查看",
 "Abrir o diário oficial": "打开政府公报",
 "Abrir ou baixar": "打开或下载",
 "Abrir página": "打开页面",
 "Abrir site": "打开网站",
 "Abrir {nome}": "打开 {nome}",
 "Acabamento": "收尾装修",
 "Acabou": "已用完",
 "Academia": "健身房",
 "Aceitar": "接受",
 "Aceitar, editar ou recusar": "接受、编辑或拒绝",
 "Aceite os termos para continuar.": "请接受条款以继续。",
 "Aceito": "已接受",
 "Aceito com alterações": "已接受（有修改）",
 "Acerto de contas": "结算",
 "Acerto de contas: {v}": "结算：{v}",
 "Acessibilidade": "无障碍",
 "Acesso ilimitado": "无限制访问",
 "Acesso ilimitado a todas as funções, sem prazo": "无限制使用所有功能，永久有效",
 "Achatar": "扁平化",
 "Acompanha tudo, inclusive os gastos, e registra no diário.": "查看全部内容（包括支出），并记录日志。",
 "Acompanhamento": "配菜",
 "Acompanhantes": "同伴",
 "Acrescentar no fim da página": "添加到页面末尾",
 "Adaptador de tomada": "插头转换器",
 "Adestramento": "训练",
 "Adicionar": "添加",
 "Adicionar amigo": "添加好友",
 "Adicionar amigos do app": "添加 App 好友",
 "Adicionar ao Planner?": "添加到 Planner？",
 "Adicionar arquivo": "添加文件",
 "Adicionar cômodo": "添加房间",
 "Adicionar fotos e vídeos": "添加照片和视频",
 "Adicionar imagem": "添加图片",
 "Adicionar item (ex.: 2 ovos mexidos)": "添加条目（例：2 个炒蛋）",
 "Adicionar na página": "添加到页面",
 "Adicionar passo": "添加步骤",
 "Adicionar país": "添加国家",
 "Adicionar página": "添加页面",
 "Adicionar texto": "添加文字",
 "Adicionar {nome}": "添加{nome}",
 "Adicionar à equipe": "加入团队",
 "Adicione um amigo pelo código dele ou mande o seu código para quem você quer.": "通过好友代码添加好友，或把你的代码发给你想加的人。",
 "Admin": "管理员",
 "Administração": "管理学",
 "Adubar a cada quantos dias": "每隔几天施肥",
 "Adubar: {p}": "施肥：{p}",
 "Adubei hoje": "今天已施肥",
 "Advogado": "律师",
 "Advogados": "律师",
 "Afundo": "弓步蹲",
 "Agachamento": "深蹲",
 "Agenda do Google": "Google 日历",
 "Agenda limpa": "日程已清理",
 "Agenda não liberada": "未允许访问日历",
 "Agenda sincronizada ✓": "日历已同步 ✓",
 "Agenda, anotações, finanças, estudos, mensagens e muito mais num app só.": "日程、笔记、财务、学习、消息等功能，尽在一个应用。",
 "Agenda, cadastro dos pacientes e pagamentos, sem o prontuário.": "日程、患者档案和付款，不含病历。",
 "Agendado": "已安排",
 "Agendado no My Planner": "已安排到 My Planner",
 "Agendamento no pet shop": "宠物店预约",
 "Agendar": "安排",
 "Agendar no My Planner": "安排到 My Planner",
 "Agendar no My Planner (dias e horários)": "安排到 My Planner（日期和时间）",
 "Agora não": "以后再说",
 "Agora o verso do documento.": "现在扫描证件背面。",
 "Agora, {hora}": "现在，{hora}",
 "Agora: {ml}": "当前：{ml}",
 "Aguardando o celular · {s}s": "等待手机 · {s} 秒",
 "Aguarde": "请稍候",
 "Aguarde um pouco": "请稍候",
 "Aguarde...": "请稍候...",
 "Ainda a pagar no mês": "本月待付",
 "Ainda a receber no mês": "本月待收",
 "Ainda não confirmado": "尚未验证",
 "Ainda não disponível: falta configurar no servidor.": "暂不可用：服务器尚未配置。",
 "Ainda não guardou nada este mês. Que tal separar {v} (10% do que entrou) assim que o dinheiro cair?": "本月还没有存钱。钱一到账，就先存下 {v}（收入的10%）怎么样？",
 "Ainda não há feriados deste país para este ano.": "该国家今年暂无假日数据。",
 "Ainda não há nada nesta aba para compartilhar. Crie primeiro (ex.: a viagem) e volte aqui.": "此标签页还没有可分享的内容。请先创建（例如：旅行），再回到这里。",
 "Ainda não há outras pessoas no grupo (ou você não vê a lista de membros).": "群组里还没有其他人（或你看不到成员列表）。",
 "Ainda não marcado como feito. Toque para abrir.": "尚未标记为完成。点按即可打开。",
 "Ainda não sincronizado": "尚未同步",
 "Ainda sem chave neste dispositivo.": "此设备上尚未添加密钥。",
 "Airbnb": "Airbnb",
 "Airbnb, Booking ou direto: reservas, limpeza no check-out, receitas, despesas e lucro do mês": "Airbnb、Booking 或直接预订：预订、退房清洁、收入、支出和当月利润",
 "Ajuda na organização": "协助组织",
 "Ajudante": "帮手",
 "Ajustar": "调整",
 "Ajustar a data final": "调整结束日期",
 "Ajustar a folha": "调整纸张",
 "Ajustar tamanho da página": "调整页面尺寸",
 "Ajuste visual": "视觉调整",
 "Ajustes": "设置",
 "Alarme dos remédios": "用药闹钟",
 "Alarme que insiste até marcar como tomado": "持续响铃，直到标记为已服用",
 "Alemão": "德语",
 "Alergia": "过敏",
 "Alergias": "过敏",
 "Alergias e alertas": "过敏与注意事项",
 "Alertas": "提醒",
 "Alertas das tarefas": "任务提醒",
 "Alertas dos compromissos": "日程提醒",
 "Algo deu errado, mas o app continua aberto": "出了点问题，但应用仍然打开着",
 "Alguns arquivos foram guardados em outro dispositivo.": "部分文件保存在另一台设备上。",
 "Alguns relógios (como os da Huawei) podem não enviar dados para o Health Connect. Nesse caso, digite à mão.": "部分手表（如华为）可能不会向 Health Connect 发送数据。这种情况下，请手动输入。",
 "Alguém": "有人",
 "Alguém indicou o app para você?": "有人向你推荐了本应用吗？",
 "Alimentação": "饮食",
 "Alimentação & Despensa": "饮食与食品柜",
 "Alimentação {semana}": "饮食 {semana}",
 "Alimento": "食物",
 "Alinhamento e balanceamento": "四轮定位与动平衡",
 "Almoço": "午餐",
 "Alongamento": "拉伸",
 "Alta": "高",
 "Alterado por último por {nome}": "最后修改者：{nome}",
 "Alterar metadados": "修改元数据",
 "Alterar o valor pago": "修改已付金额",
 "Alterações": "变更",
 "Alto-falante": "扬声器",
 "Aluga como": "出租方式",
 "Alugar a casa ou um cômodo": "出租整套房或单间",
 "Aluguel": "租金",
 "Aluguel & Hospedagem": "出租与民宿",
 "Aluguel de carro": "租车",
 "Aluno": "学生",
 "Alunos": "学生",
 "Alvará ou licença": "许可证或执照",
 "Alvenaria": "砌筑",
 "Alvo": "目标金额",
 "Alíquota do ISS (%)": "ISS 税率（%）",
 "Alíquota do ISS deste serviço (%)": "此服务的 ISS 税率（%）",
 "Amanhã": "明天",
 "Ambiente": "环境",
 "Ameno": "温和",
 "Amigos": "朋友",
 "Amor": "爱",
 "Amortização": "本金偿还",
 "Ampliar a foto": "放大照片",
 "Amém": "阿门",
 "Analisar com IA": "用 AI 分析",
 "Anamnese e histórico (no cofre)": "问诊与病史（保险库中）",
 "Anexar arquivos": "附加文件",
 "Anexar comprovante": "附上凭证",
 "Anexar documentos, importar extratos e salvar relatórios, PDFs e cópias de segurança.": "附加文件、导入对账单，以及保存报告、PDF 和备份。",
 "Anexos": "附件",
 "Anexos guardados aqui no dispositivo: {n}": "保存在此设备上的附件：{n}",
 "Animais e natureza": "动物与自然",
 "Animação": "动画",
 "Anime": "动画",
 "Aniversário": "生日",
 "Aniversário de Campo Grande": "大坎普市建市纪念日",
 "Aniversário de São Paulo": "圣保罗市建市纪念日",
 "Ano": "年份",
 "Ano anterior": "上一年",
 "Ano de lançamento": "上映年份",
 "Ano de {ano}": "{ano} 年",
 "Ano passado": "去年",
 "Anotar pela foto da página": "用页面照片记笔记",
 "Anotação": "笔记",
 "Anotação de {data}": "{data} 的笔记",
 "Anotação do professor": "教师笔记",
 "Anotação à mão": "手写笔记",
 "Anotações": "笔记",
 "Anotações Rápidas": "快速笔记",
 "Anotações arquivadas": "已归档的笔记",
 "Anotações arquivadas ({n})": "已归档的笔记（{n}）",
 "Anote cada reserva com as datas, a origem e os valores. A limpeza do check-out entra sozinha na lista de limpezas.": "记录每笔预订的日期、来源和金额。退房清洁会自动加入清洁列表。",
 "Anote o dia a dia da obra com fotos. Marque as fotos como Antes ou Depois para ver a evolução.": "用照片记录工程的每一天。把照片标记为“之前”或“之后”，即可看到进展。",
 "Anote o que emprestou ou pegou emprestado, com foto e prazo. O app avisa no dia da devolução.": "记下你借出或借入的东西，附上照片和期限。归还当天应用会提醒你。",
 "Anote os lugares que quer conhecer. Pesquise no Google Maps ou no Waze, trace a rota passando por todos e coloque no roteiro do dia.": "记下想去的地方。在 Google Maps 或 Waze 中搜索，规划一条经过所有地点的路线，并加入当天的行程。",
 "Anteriores ({n})": "以往会议（{n}）",
 "Antes": "之前",
 "Antes de começar, confira o que o app usa e por quê. Você pode mudar tudo depois em Ajustes > Privacidade e termos.": "开始之前，请先了解应用使用哪些权限以及原因。之后你可以在 设置 > 隐私和条款 中随时更改。",
 "Antes de uma data": "某日期之前",
 "Antes do início": "开始前",
 "Antes e depois": "前后对比",
 "Antes: {lista}": "提前：{lista}",
 "Antipulgas": "驱跳蚤",
 "Anual": "每年",
 "Ao ar livre": "户外",
 "Ao cancelar, a aba fica em preto e branco e os vínculos somem das tarefas, mas nada é apagado.": "取消后，该标签页将变为黑白，任务中的关联会消失，但不会删除任何内容。",
 "Ao criar a conta ou continuar usando o app, você concorda com estes termos e com a política de privacidade abaixo.": "创建账户或继续使用本应用，即表示你同意本条款及下方的隐私政策。",
 "Ao fechar, a página é salva.": "关闭时页面会自动保存。",
 "Ao salvar, você cria a senha do cofre. Este campo é criptografado no dispositivo.": "保存时将创建保险库密码。此字段会在设备上加密。",
 "Ao tocar em \"Arquivo\" ou \"Foto\" em Estudos e Documentos, o seletor do celular mostra o Google Drive, o OneDrive e o Dropbox (quando os apps estão instalados). Escolha o arquivo direto de lá.": "在“学习”和“证件”中点按“文件”或“照片”时，手机的选择器会显示 Google Drive、OneDrive 和 Dropbox（如果已安装这些应用）。直接从那里选择文件即可。",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (no Android, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "点按附件，会用你选择的手机应用打开（在 Android 上可选“仅此一次”或“始终”）。在那里所做的编辑会保存在文件本身。",
 "Apaga a conta e todos os vencimentos dela.": "删除此账单及其所有到期日。",
 "Apaga as matérias e páginas deste fichário. As tarefas do planner continuam.": "删除此活页夹中的科目和页面。计划中的任务会保留。",
 "Apaga as páginas desta matéria. O tempo estudado continua no histórico.": "删除此科目的页面。学习时长仍保留在历史记录中。",
 "Apaga o cartão e as compras dele.": "删除此卡及其消费记录。",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não há como desfazer.": "永久删除账户以及云端和本设备上的所有数据。此操作无法撤销。",
 "Apaga todas as tarefas da agenda, passadas e futuras.": "删除日程中的所有任务，包括过去和将来的。",
 "Apaga todas as {n} parcelas.": "删除全部 {n} 期分期。",
 "Apaga todos os meses desta conta.": "删除此账单的所有月份。",
 "Apagar": "删除",
 "Apagar \"{nome}\"?": "删除“{nome}”？",
 "Apagar a caixa?": "删除收纳盒？",
 "Apagar a chave": "删除密钥",
 "Apagar a chave deste dispositivo?": "要删除此设备上的密钥吗？",
 "Apagar a conta?": "删除账户？",
 "Apagar a lista de erros?": "清除错误列表？",
 "Apagar a pasta (os documentos continuam)": "删除文件夹（文档会保留）",
 "Apagar as da agenda": "删除日历中的",
 "Apagar caixa": "删除收纳盒",
 "Apagar de verdade (as páginas com tarja viram imagem)": "彻底删除（涂黑的页面会变成图片）",
 "Apagar de vez": "永久删除",
 "Apagar desenho": "清除绘图",
 "Apagar envio": "删除发送内容",
 "Apagar lista": "清除列表",
 "Apagar minha conta": "删除我的账户",
 "Apagar minha conta e todos os dados": "删除我的账户和所有数据",
 "Apagar o escritório": "删除办公室",
 "Apagar o escritório?": "删除办公室？",
 "Apagar o grupo": "删除群组",
 "Apagar o grupo?": "删除该群组？",
 "Apagar o lançamento?": "删除这笔记录？",
 "Apagar para todos": "为所有人删除",
 "Apagar tudo": "全部删除",
 "Apagar tudo antes de": "删除此日期之前的全部",
 "Apague de uma vez as tarefas de hoje, do mês, de um período ou pelo nome. Antes de apagar, o app mostra o que vai sair e pede a sua senha.": "一次性删除今天、本月、某个时间段或按名称筛选的任务。删除前，应用会显示将被删除的内容并要求输入你的密码。",
 "Aparece na barra quando estiver liberada": "开通后会显示在标签栏中",
 "Aparecem no Planner, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "会显示在 Planner 中，同时显示选择性假日（狂欢节、圣灰星期三和基督圣体节）。",
 "Aplicar": "应用",
 "Aponte a câmera do celular para este QR Code.": "用手机摄像头对准此二维码。",
 "Aponte para o QR Code na tela do computador": "对准电脑屏幕上的二维码",
 "Apostila": "讲义",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para um grupo, cada aluno recebe no app dele.": "讲义、习题、幻灯片、视频、链接和通知。通过 ⋮ › 发送到群组，每个学生都会在自己的应用中收到。",
 "App usado no botão \"Rota\" dos endereços (tarefas, consultas, roteiro da viagem, obras, escola...).": "地址上“路线”按钮使用的应用（任务、就诊、旅行行程、装修、学校…）。",
 "Apple Saúde": "Apple 健康",
 "Apple Watch: já grava tudo no app Saúde do iPhone. Não precisa fazer nada.": "Apple Watch：已将所有数据记录到 iPhone 的“健康”App 中，无需任何操作。",
 "Apresentação": "展示",
 "Aprovação": "待审批",
 "Aqui": "此地",
 "Ar-condicionado": "空调",
 "Arco-íris": "彩虹",
 "Arenoso": "沙质土",
 "Armazenamento": "存储空间",
 "Armário": "橱柜",
 "Arquivadas ({n})": "已归档（{n}）",
 "Arquivados ({n})": "已归档（{n}）",
 "Arquivar": "归档",
 "Arquivar a caixa de anotações?": "归档此笔记收纳盒？",
 "Arquivar conversa": "归档聊天",
 "Arquivo": "文件",
 "Arquivo (Drive, OneDrive, Dropbox ou do dispositivo)": "文件（Drive、OneDrive、Dropbox 或本设备）",
 "Arquivo OFX ou CSV do banco": "银行的 OFX 或 CSV 文件",
 "Arquivo adicionado": "已添加文件",
 "Arquivo menor (para WhatsApp e e-mail)": "较小的文件（适用于 WhatsApp 和电子邮件）",
 "Arquivo menor para WhatsApp e e-mail.": "更小的文件，方便 WhatsApp 和邮件发送。",
 "Arquivo não encontrado.": "未找到文件。",
 "Arquivo ou PDF": "文件或 PDF",
 "Arquivo ou documento": "文件或文档",
 "Arquivos": "文件",
 "Arquivos (frente, verso, PDF)": "文件（正面、背面、PDF）",
 "Arquivos (importar e exportar)": "文件（导入和导出）",
 "Arquivos de {nome}": "{nome} 的文件",
 "Arquivos na nuvem e cópias de segurança": "云端文件和备份",
 "Arrasou!": "太棒了！",
 "Arraste as bolinhas até as 4 pontas da folha. O app recorta e endireita a página.": "将圆点拖到纸张的 4 个角。应用会裁剪并拉直页面。",
 "Arraste o dedo sobre o que quer esconder. Toque numa tarja para tirar.": "用手指划过要隐藏的内容。点按黑条可移除。",
 "Arraste para a direita para excluir, ou para a esquerda para enviar a outra aba.": "向右滑动删除，向左滑动发送到其他标签页。",
 "Arraste para a direita para excluir.": "向右滑动即可删除。",
 "Arraste para mudar a ordem, gire, duplique, apague e ponha página em branco.": "拖动调整顺序，可旋转、复制、删除和插入空白页。",
 "Arraste para ver o resto do quadro. Ele cresce para baixo e para a direita.": "拖动查看看板的其余部分。它会向下和向右扩展。",
 "Arraste um documento para a direita para excluir.": "将文档向右滑动即可删除。",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir.": "将收纳盒向左滑动可归档，向右滑动可删除。",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure ⋮⋮ para mudar a ordem.": "向左滑动卡片可归档，向右滑动可删除。按住 ⋮⋮ 可调整顺序。",
 "Arroz": "米饭",
 "Artes": "艺术",
 "As assinaturas Claude Pro, ChatGPT Plus e Gemini Advanced não podem ser usadas por outros apps. Para ligar a IA aqui, crie uma chave de API na sua conta (o Gemini tem uso gratuito; Claude e ChatGPT cobram por uso, centavos por análise).": "Claude Pro、ChatGPT Plus 和 Gemini Advanced 订阅不能被其他应用使用。要在这里启用 AI，请在你的账户中创建 API 密钥（Gemini 有免费额度；Claude 和 ChatGPT 按用量收费，每次分析只需几分钱）。",
 "As chamadas ainda não foram ligadas no servidor (17-LIGAR-MENSAGENS.bat).": "服务器上尚未开启通话功能（17-LIGAR-MENSAGENS.bat）。",
 "As compras dele também saem das Finanças.": "它的消费记录也会从金融中删除。",
 "As compras parceladas entram com todas as parcelas: as próximas já aparecem nas faturas seguintes.": "分期消费会录入全部期数：后续各期会显示在之后的账单中。",
 "As fotos deste documento estão no dispositivo onde ele foi escaneado. Lá dá para editar, compartilhar e ler o texto.": "此文档的照片在扫描它的设备上。在那台设备上可以编辑、分享和读取文字。",
 "As imagens vão só para a IA que você escolheu, com a sua chave.": "图片只会发送给你选择的 AI，并使用你自己的密钥。",
 "As limpezas dos check-outs aparecem aqui sozinhas, com checklist e fotos de antes e depois.": "退房清洁会自动显示在这里，附带清单和前后对比照片。",
 "As notas emitidas aqui, as encontradas na busca e os XML importados aparecem nesta lista.": "在这里开具的发票、查询到的发票和导入的 XML 都会显示在此列表中。",
 "As parcelas aparecem aqui. Anexe o comprovante (foto, PDF ou print do PIX) em cada uma.": "各期分期会显示在这里。请为每期附上付款凭证（照片、PDF 或 PIX 截图）。",
 "As parcelas dos próximos 12 meses já estão no My Planner.": "未来 12 个月的分期已加入 My Planner。",
 "As parcelas em aberto são refeitas com o valor, os juros e o prazo atuais do contrato. As pagas não mudam.": "未付的分期将按合同当前的金额、利率和期限重新计算。已付的分期不变。",
 "As páginas deste documento estão no dispositivo onde ele foi escaneado. Abra por lá ou use a cópia guardada no Drive ou no OneDrive.": "此文档的页面在扫描它的设备上。请在那台设备上打开，或使用保存在 Drive 或 OneDrive 中的副本。",
 "As páginas viram imagem mais leve: ótimo para PDFs escaneados. O texto deixa de ser pesquisável (use o OCR depois, se precisar).": "页面会变成更轻的图片：非常适合扫描版 PDF。文字将无法搜索（如有需要，之后可用 OCR）。",
 "As páginas vão só para a IA que você escolheu, com a sua chave.": "页面只发送给你选择的 AI，使用你自己的密钥。",
 "As receitas do cardápio já têm tudo na despensa.": "菜单中的食谱所需食材，食品柜里都有了。",
 "As senhas novas não conferem.": "两次输入的新密码不一致。",
 "As senhas não conferem.": "两次输入的密码不一致。",
 "As tarefas continuam no My Planner. Quer apagar também as que vieram da agenda do Google?": "任务会保留在 My Planner 中。是否也删除来自 Google 日历的任务？",
 "As tarefas do cômodo continuam em Minha Casa, sem cômodo.": "该房间的任务仍保留在“我的家”中，但不属于任何房间。",
 "As tarefas vinculadas continuam no My Planner.": "关联的任务仍保留在 My Planner 中。",
 "Aspirar e passar pano": "吸尘和拖地",
 "Assinada": "已订阅",
 "Assinar": "签名",
 "Assinar (simulação de teste)": "订阅（测试模拟）",
 "Assinar o documento": "签署文档",
 "Assinatura": "签名",
 "Assinatura do profissional": "专业人员签名",
 "Assinatura e segurança": "签名与安全",
 "Assinaturas (simulação de teste)": "订阅（测试模拟）",
 "Assine a aba em Ajustes para enviar anotações para ela.": "请在设置中订阅该标签页，才能向其发送笔记。",
 "Assine a aba em Ajustes para vincular.": "请在设置中订阅该标签页以进行关联。",
 "Assine a aba em Ajustes › Compras para enviar anotações para ela.": "请在 设置 › 购买 中订阅该标签页，才能向其发送笔记。",
 "Assine a aba em Ajustes › Compras para vincular.": "请在 设置 › 购买 中订阅该标签页以进行关联。",
 "Assine a aba para abrir o vínculo.": "订阅该标签页以打开关联。",
 "Assisti mais uma aula": "又看了一节课",
 "Assistido": "已看",
 "Assistindo": "在看",
 "Assistência técnica (nome)": "售后服务（名称）",
 "Assistência: {nome}": "售后服务：{nome}",
 "Assunto": "事项",
 "Assunto (ex.: Reunião semanal)": "主题（例如：每周例会）",
 "Atender": "接听",
 "Atendimento": "就诊",
 "Atendimentos": "就诊记录",
 "Ativar avisos": "开启通知",
 "Ativar monitor": "启用监控",
 "Ativas": "有效",
 "Atividade": "活动",
 "Atividade do roteiro": "行程活动",
 "Atividade hoje": "今日活动",
 "Atividade: {blocos}": "活动时间：{blocos}",
 "Atividades": "活动",
 "Atividades de hoje": "今日活动",
 "Atividades e materiais": "活动与材料",
 "Atividades físicas e saúde": "运动与健康",
 "Atrasada": "已逾期",
 "Atrasada há {n} dia(s)": "已逾期 {n} 天",
 "Atrasadas": "已逾期",
 "Atrasados": "已逾期",
 "Atuais": "当前",
 "Atualidades": "时事",
 "Atualizar": "更新",
 "Atualizar agora": "立即更新",
 "Atualizar alarmes no My Planner": "在 My Planner 中更新闹钟",
 "Atualizar rega e adubo na agenda": "更新日程中的浇水和施肥",
 "Atualização automática disponível no app instalado (APK).": "已安装的应用（APK）可自动更新。",
 "Atualização baixada. Entra ao reabrir o app ou ao tocar no aviso.": "更新已下载。重新打开应用或点击通知后生效。",
 "Atualização pronta": "更新已就绪",
 "Atualizações": "更新",
 "Até": "截止",
 "Audiência": "庭审",
 "Aula dada": "已授课",
 "Aula {a} de {n} ({p}%)": "第 {a}/{n} 课（{p}%）",
 "Aulas assistidas": "已看课时",
 "Autoajuda": "自我提升",
 "Autor": "作者",
 "Avaliação": "评估",
 "Avaliações e notas": "评估与成绩",
 "Avançado": "高级",
 "Aveia": "燕麦",
 "Avisar a hora de sair": "提醒出发时间",
 "Avisar antes de vencer": "到期前提醒",
 "Avisar no celular quando alguém incluir algo": "有人添加内容时在手机上提醒我",
 "Aviso": "通知",
 "Aviso com as tarefas do dia": "当日任务通知",
 "Aviso de teste enviado pelo servidor. Ele chega em alguns segundos; saia do app para ver na barra do celular.": "服务器已发送测试通知，几秒内到达；退出应用即可在手机通知栏看到。",
 "Aviso enviado": "通知已发送",
 "Aviso {dias} dia(s) antes e no dia": "提前 {dias} 天及当天提醒",
 "Avisos no celular": "手机通知",
 "Avisos no celular passam pelos serviços da Expo, da Google e da Apple.": "手机通知会经过 Expo、Google 和 Apple 的服务。",
 "Ação": "动作",
 "Ações": "股票",
 "BOLETO E DOCUMENTOS": "BOLETO 和文件",
 "Backup importado.": "备份已导入。",
 "Bairro": "街区",
 "Baixa": "低",
 "Baixando atualização...": "正在下载更新...",
 "Baixar": "下载",
 "Baixar a versão {v}": "下载 {v} 版本",
 "Baixar agora": "立即下载",
 "Baixar o My Planner para Android": "下载 Android 版 My Planner",
 "Baixar o My Planner para Android (versão {v})": "下载 Android 版 My Planner（版本 {v}）",
 "Baixar o My Planner para iPhone": "下载 iPhone 版 My Planner",
 "Baixar o PDF da nota (DANFSe)": "下载发票 PDF（DANFSe）",
 "Baixar o PDF?": "下载 PDF？",
 "Baixar o XML completo (dá ciência na SEFAZ)": "下载完整 XML（向 SEFAZ 确认知悉）",
 "Baixe a versão mais recente para Android: {apk}": "下载最新的 Android 版本：{apk}",
 "Baixe aqui a versão mais recente: {link}": "在此下载最新版本：{link}",
 "Balança": "摇摆",
 "Balanço e relatórios": "资产负债表和报告",
 "Banana": "香蕉",
 "Banco": "银行",
 "Banco, financeira ou pessoa": "银行、金融公司或个人",
 "Bandeiras": "旗帜",
 "Banheiro": "卫生间",
 "Banho": "洗澡",
 "Banho e tosa": "洗澡和美容",
 "Barra": "标签栏",
 "Bateria": "电瓶",
 "Batimentos (média)": "心率（平均）",
 "Batizado": "洗礼",
 "Bebida": "饮品",
 "Bebê": "婴儿",
 "Beijo": "亲亲",
 "Bem": "资产",
 "Bem clara": "很淡",
 "Bem-Estar": "健康",
 "Bem-Estar · Cronograma alimentar": "健康 · 饮食计划",
 "Bens": "资产",
 "Bichos e diversão": "动物与娱乐",
 "Bicicleta": "自行车",
 "Bicicleta ergométrica": "健身单车",
 "Biografia": "传记",
 "Biologia": "生物",
 "Biometria (digital ou rosto)": "生物识别（指纹或面部）",
 "Biometria ({tipos})": "生物识别（{tipos}）",
 "Biometria não confirmada.": "生物识别未通过。",
 "Bloqueado": "已封锁",
 "Bloquear": "屏蔽",
 "Bloquear agora": "立即锁定",
 "Bloqueio": "封锁",
 "Blusas de frio": "保暖上衣",
 "Boa noite": "晚安",
 "Boa sorte!": "祝好运！",
 "Boas-vindas ao My Planner": "欢迎使用 My Planner",
 "Boas-vindas pelo WhatsApp": "通过 WhatsApp 发送欢迎消息",
 "Boleto": "Boleto（付款单）",
 "Boleto anexado": "已附上 Boleto",
 "Boleto do banco {b}": "{b} 银行的 Boleto",
 "Boleto e documentos (foto, PDF ou arquivo)": "Boleto 和文件（照片、PDF 或文件）",
 "Boleto ou conta (foto, PDF ou arquivo)": "Boleto 或账单（照片、PDF 或文件）",
 "Boleto por foto": "拍照识别 Boleto",
 "Bolinha": "圆点",
 "Bom dia": "早上好",
 "Bom dia!": "早上好！",
 "Bom dia! Seu dia no My Planner": "早上好！你今天在 My Planner 中的安排",
 "Booking": "Booking",
 "Bora!": "走起！",
 "Borboleta": "蝴蝶",
 "Borracha": "橡皮擦",
 "Botas para neve": "雪地靴",
 "Brasil": "巴西",
 "Braços acima da cabeça": "双臂举过头顶",
 "Brilho": "闪光",
 "Brinquedo ou livro para a viagem": "旅途用的玩具或书",
 "Busca de notas": "发票查询",
 "Busca o nome nos diários municipais reunidos pelo Querido Diário (Open Knowledge Brasil). Nem todos os municípios estão incluídos, e os diários oficiais não fazem parte do DJEN.": "在 Querido Diário（Open Knowledge Brasil）收集的市政公报中搜索该名称。并非所有城市都已收录，且政府公报不属于 DJEN。",
 "Buscando...": "正在查询...",
 "Buscar": "搜索",
 "Buscar GIF (ex.: parabéns, bom dia)": "搜索 GIF（例如：恭喜、早上好）",
 "Buscar cidade, país ou GMT": "搜索城市、国家或 GMT",
 "Buscar conversa": "搜索聊天",
 "Buscar documento, titular ou órgão": "搜索证件、持有人或签发机关",
 "Buscar em {nome}": "在{nome}中搜索",
 "Buscar emoji (ex.: coração, risada)": "搜索表情（例如：爱心、大笑）",
 "Buscar figurinha": "搜索贴纸",
 "Buscar notas": "查询发票",
 "Buscar ou digitar um alimento": "搜索或输入食物",
 "Buscar país": "搜索国家",
 "Buscar pelo nome ou pelo texto": "按名称或文字搜索",
 "Buscar produto, loja ou observação": "搜索产品、商店或备注",
 "Buscar tarefas": "搜索任务",
 "Buscar: processo, parte, tribunal, palavra...": "搜索：案件、当事人、法院、关键词...",
 "CAIXA {n}": "箱子 {n}",
 "CARDS DE ANOTAÇÕES": "笔记卡片",
 "CARTÕES": "信用卡",
 "CEP": "CEP（邮编）",
 "CID (se o paciente pedir na declaração)": "CID（如患者要求写入证明）",
 "CID: {c}": "CID：{c}",
 "CNH": "CNH（巴西驾照）",
 "CNPJ (se tiver)": "CNPJ（如有）",
 "CNPJ ou CPF": "CNPJ 或 CPF",
 "COMPROVANTE DE PAGAMENTO": "付款凭证",
 "COMPROVANTE DE RECEBIMENTO": "收款凭证",
 "COMPROVANTES ANTERIORES": "以往凭证",
 "CONTAS DO MÊS": "本月账单",
 "CPF": "CPF",
 "CPF (Brasil)": "CPF（巴西）",
 "CPF de quem paga": "付款人的 CPF",
 "CPF do paciente": "患者的 CPF",
 "CPF do pagador": "付款人 CPF",
 "CPF inválido": "CPF 无效",
 "CPF ou CNPJ de quem recebeu": "收款方的 CPF 或 CNPJ",
 "CPF ou senha incorretos.": "CPF 或密码错误。",
 "CRIAR CÔMODO": "创建房间",
 "CRIAR UM GRUPO": "创建群组",
 "CRONOGRAMA ALIMENTAR": "饮食计划",
 "CUIDADOS PESSOAIS": "个人护理",
 "Cabeleireiro": "理发师",
 "Cabelo": "头发",
 "Cachorro": "狗",
 "Cactos e suculentas": "仙人掌和多肉",
 "Cada aba extra: {n} dias grátis; depois {preco} por ano.": "每个额外标签页：免费 {n} 天；之后每年 {preco}。",
 "Cada arquivo pronto vai para o {nome}. Os PDFs abertos ficam também neste dispositivo, na lista abaixo.": "每个完成的文件都会存到 {nome}。打开过的 PDF 也会保留在本设备的下方列表中。",
 "Cada dia da semana": "每周的每一天",
 "Cada documento novo vai para o {nome} quando você sai dele. As fotos das páginas ficam só neste dispositivo.": "每个新文档在你离开时都会保存到 {nome}。页面照片只保留在此设备上。",
 "Cada pessoa da equipe recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "团队每个人都会在收件箱收到会议，一键即可连同提醒加入 Planner。",
 "Cada pessoa do grupo recebe e decide se aceita.": "群组中的每个人都会收到，并决定是否接受。",
 "Cada página guarda um resumo, aula ou capítulo. Marque como revisada quando terminar.": "每个页面可保存一份摘要、一节课或一个章节。完成后标记为已复习。",
 "Cada página vira uma imagem JPG.": "每页变成一张 JPG 图片。",
 "Cada refeição se repete nos dias dela": "每餐在其设定的日子重复",
 "Cadastrar": "添加",
 "Cadastrar cartão de crédito": "添加信用卡",
 "Cadastrar pela foto (página do curso, certificado, folheto)": "拍照添加（课程页面、证书、传单）",
 "Cadastrar pela foto da capa": "拍封面照片添加",
 "Cadastre \"Meus dados\" para os recibos saírem com seu nome, conselho e número.": "填写“我的信息”，收据上就会显示你的姓名、执业协会和编号。",
 "Cadastre RG, CNH, passaporte, contratos e certidões. O app avisa antes de vencer e envia o documento com um toque.": "添加身份证、驾照、护照、合同和证明。应用会在到期前提醒你，一键即可发送证件。",
 "Cadastre a empresa (ou você, como profissional) com CNPJ ou CPF, município e regime. Depois ligue o certificado A1 para emitir NFS-e pelo Padrão Nacional e buscar as notas emitidas e recebidas.": "用 CNPJ 或 CPF、城市和税制登记公司（或作为个人从业者的你）。然后连接 A1 证书，即可通过 Padrão Nacional 开具 NFS-e，并查询已开具和已收到的发票。",
 "Cadastre a obra e, dentro dela, as etapas com orçamento, o diário com fotos, os profissionais e as entregas de material.": "先登记工程，再在其中添加带预算的阶段、带照片的日志、施工人员和材料送货。",
 "Cadastre a viagem e, dentro dela, o roteiro de cada dia, as reservas e a mala. Durante a viagem, o roteiro aparece no My Planner.": "先登记旅行，再在其中添加每天的行程、预订和行李。旅行期间，行程会显示在 My Planner 中。",
 "Cadastre apenas o seu próprio nome e a sua OAB.": "请只登记你本人的姓名和 OAB 号码。",
 "Cadastre as crianças: provas, reuniões, consultas e vacinas ficam dentro de cada uma.": "登记孩子：考试、会议、就诊和疫苗都放在各自名下。",
 "Cadastre cada pet: carteira de vacinação, vermífugos, remédios e pet shop ficam dentro dele.": "登记每只宠物：疫苗本、驱虫、用药和宠物店都放在它名下。",
 "Cadastre cada planta com luz, solo e de quantos em quantos dias regar e adubar. O app monta o calendário na agenda.": "登记每株植物的光照、土壤，以及每隔几天浇水和施肥。应用会在日程中生成日历。",
 "Cadastre cada veículo. Dentro dele ficam as manutenções (com aviso por km e por data) e os vencimentos de IPVA, licenciamento e seguro.": "登记每辆车。车辆下包含保养（按里程和日期提醒），以及 IPVA、年检登记和保险的到期日。",
 "Cadastre digital ou rosto no aparelho para usar.": "请先在设备上录入指纹或面容。",
 "Cadastre o cartão primeiro": "请先添加信用卡",
 "Cadastre o financiamento ou empréstimo com o valor, os juros e o número de parcelas. O app calcula as parcelas, o saldo devedor e avisa os vencimentos.": "登记贷款或借款的金额、利率和期数。应用会计算每期金额和剩余欠款，并提醒到期日。",
 "Cadastre o imóvel inteiro ou cada quarto que você aluga. Dentro de cada um ficam as reservas, a limpeza e as despesas.": "登记你出租的整套房源或每个房间。每个房源下包含预订、清洁和支出。",
 "Cadastre o livro com o total de páginas e a meta por dia. Toque em ⋮ para somar as páginas lidas.": "登记书籍的总页数和每日目标。点按 ⋮ 累加已读页数。",
 "Cadastre o remédio com os horários e toque em ⋮ para colocar na linha do tempo com alarme.": "登记药品和服药时间，点按 ⋮ 即可加入带闹钟的时间线。",
 "Cadastre os alunos da turma na aba Alunos.": "请在“学生”标签页中登记本班学生。",
 "Cadastre os clientes para separar as horas.": "登记客户，以便分开统计工时。",
 "Cadastre os clientes que recebem as suas notas. O endereço é opcional (se preencher, informe CEP, código IBGE, rua, número e bairro).": "登记接收你发票的客户。地址可选（如填写，请填 CEP、IBGE 代码、街道、门牌号和街区）。",
 "Cadastre os serviços que você mais emite, com o código de tributação nacional. Na hora de emitir é só tocar.": "登记你最常开票的服务及其国家税务代码。开票时点一下即可。",
 "Cadastre primeiro em {nome}.": "请先在{nome}中登记。",
 "Cadastre seu nome, conselho e número do registro. Eles saem nos recibos e nas declarações.": "填写你的姓名、执业协会和注册编号。它们会显示在收据和证明上。",
 "Cadastre seus clientes na aba \"Tomadores\" da empresa para escolher aqui.": "在公司的“服务接收方”标签页中登记客户，即可在这里选择。",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no documento.": "请在“我的信息”中填写职业信息（姓名、执业协会和编号），以便显示在文件上。",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no recibo.": "请在“我的信息”中填写职业信息（姓名、执业协会和编号），以便显示在收据上。",
 "Cadastre seus pacientes. Dentro de cada um ficam os atendimentos com evolução, prescrição, pagamento, recibo e declaração para o plano de saúde.": "登记你的患者。每位患者下包含就诊记录，附病程记录、处方、付款、收据和医保证明。",
 "Cadastre você e cada pessoa da família. Dentro de cada uma ficam consultas, exames, vacinas e remédios. Dados sensíveis vão para o cofre criptografado.": "登记你自己和每位家庭成员。每人名下包含就诊、检查、疫苗和用药。敏感数据会存入加密保险库。",
 "Cadastro aguardando liberação: desligue \"Confirm email\" no Supabase (veja COMO RODAR).": "注册待开通：请在 Supabase 中关闭 \"Confirm email\"（见 COMO RODAR）。",
 "Cadastro recebido": "注册已收到",
 "Cadastro: nome, CPF ou e-mail, senha (guardada só em forma protegida) e e-mail de contato.": "注册信息：姓名、CPF 或电子邮箱、密码（仅以受保护形式保存）和联系邮箱。",
 "Cadastros": "登记",
 "Cadastros e comprovantes": "登记与凭证",
 "Cadeira extensora": "坐姿腿屈伸",
 "Café": "咖啡",
 "Café da manhã": "早餐",
 "Café ou bar": "咖啡馆或酒吧",
 "Café?": "喝咖啡？",
 "Cafés": "咖啡馆",
 "Caixa": "箱子",
 "Caixa arquivada": "已归档的收纳盒",
 "Caixa com checklist, lista ou texto livre": "包含清单、列表或自由文本的卡片",
 "Caixa {n}": "箱子 {n}",
 "Caixas": "箱子",
 "Caixas e cronograma da mudança.": "搬家的箱子和时间安排。",
 "Caixas por cômodo com etiqueta, troca de água, luz e internet, vistorias e o cronograma dos dias.": "按房间分类并贴标签的箱子、水电和网络的转移、交接检查以及每天的安排。",
 "Calculadora": "计算器",
 "Calculando...": "正在计算...",
 "Calendário": "日历",
 "Calendário da planta": "植物日历",
 "Calendário do imposto": "税务日历",
 "Calendários": "日历",
 "Calorias em atividade": "活动消耗",
 "Calorias gastas em atividade (kcal)": "活动消耗卡路里（kcal）",
 "Calça térmica (segunda pele)": "保暖裤（打底裤）",
 "Calças ou bermudas": "长裤或短裤",
 "Cama": "床",
 "Caminhada": "健走",
 "Caminhão": "卡车",
 "Camisetas": "T 恤",
 "Campo Grande": "大坎普",
 "Campo Grande (MS)": "大坎普 (MS)",
 "Campos de formulário": "表单字段",
 "Cancelada": "已取消",
 "Canceladas": "已取消",
 "Cancelar": "取消",
 "Cancelar a NFS-e": "作废 NFS-e",
 "Cancelar a NFS-e {n}?": "作废 NFS-e {n}？",
 "Cancelar a nota": "作废发票",
 "Cancelar a reunião \"{nome}\"?": "取消会议“{nome}”？",
 "Cancelar reunião": "取消会议",
 "Caneta": "画笔",
 "Captura automática do servidor: de 2 em 2 horas, das 08h às 20h": "服务器自动抓取：每 2 小时一次，08:00 至 20:00",
 "Captura automática: todos os dias às 08h e 12h": "自动抓取：每天 08:00 和 12:00",
 "Card": "卡片",
 "Cardápio": "菜单",
 "Cardápio da semana, receitas, lista de compras automática e validade da despensa.": "每周菜单、食谱、自动生成的购物清单和食品柜保质期。",
 "Cardápio só para este dia. Os outros dias continuam com o da semana.": "仅限这一天的菜单。其他日子仍使用每周菜单。",
 "Carga (kg)": "重量（kg）",
 "Carimbo": "印章",
 "Carnaval": "狂欢节",
 "Carne magra": "瘦肉",
 "Carregando feriados...": "正在加载假日...",
 "Carregando...": "加载中...",
 "Carro": "汽车",
 "Carta": "Letter",
 "Carteira": "钱包",
 "Carteira de trabalho": "劳动卡",
 "Carteira profissional (OAB, CRC, CREA...)": "职业证件（OAB、CRC、CREA...）",
 "Cartão": "卡片",
 "Cartão de contato das Mensagens: a foto, o telefone, o e-mail e a frase que você mesmo escolher pôr. Só quem conversa com você, os seus amigos e quem divide um grupo do app com você veem.": "消息联系人名片：你自己选择填写的照片、电话、邮箱和签名。只有与你聊天的人、你的好友以及与你同在 App 群组中的人可以看到。",
 "Cartão de crédito": "信用卡",
 "Cartão de débito": "借记卡",
 "Cartão parcelado": "信用卡分期",
 "Cartões": "信用卡",
 "Cartões de visita": "名片",
 "Cartões e dinheiro": "银行卡和现金",
 "Casa": "家",
 "Casa e rotina": "家居与日常",
 "Casa, família e veículos": "家庭、家人和车辆",
 "Casaco leve": "薄外套",
 "Casaco pesado": "厚外套",
 "Casamento": "婚礼",
 "Castanhas": "坚果",
 "Categoria": "类别",
 "Categoria de \"{d}\"": "“{d}”的类别",
 "Categorias": "类别",
 "Caução": "押金",
 "Ceia": "夜宵",
 "Celular": "手机",
 "Celular confirmado": "手机已验证",
 "Celular e carregador": "手机和充电器",
 "Certidão": "证明",
 "Certificado digital": "数字证书",
 "Certificado digital A1": "A1 数字证书",
 "Certificado ligado": "证书已连接",
 "Chamada": "点名",
 "Chamada ainda não feita neste dia. Toque em quem faltou ou confirme todos presentes.": "今天还没点名。点按缺席的人，或确认全部到齐。",
 "Chamada, notas, planos de aula e materiais.": "点名、成绩、教案和资料。",
 "Chamadas": "通话",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada e sem gravação.": "语音和视频通话经由 LiveKit 的服务器传输，仅在通话期间，且不录音。",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada. Só há gravação nas reuniões do Escritório, quando o administrador grava, e o arquivo vai direto para o armazenamento do app.": "音频和视频通话仅在通话期间经过 LiveKit 的服务器。只有在办公室会议中由管理员录制时才会进行录制，文件会直接保存到应用的存储空间。",
 "Chamando...": "正在呼叫...",
 "Chapéu ou boné": "帽子",
 "Chave da IA não cadastrada neste dispositivo (Ajustes › Inteligência artificial).": "此设备上未添加 AI 密钥（设置 › 人工智能）。",
 "Chave de acesso": "访问密钥",
 "Check-in": "入住",
 "Check-in: {d} a partir das {h}": "入住：{d} {h} 起",
 "Check-in: {h} · {e}": "入住：{h} · {e}",
 "Check-out": "退房",
 "Check-out: {d} até as {h}": "退房：{d} {h} 前",
 "Check-out: {h} · {e}": "退房：{h} · {e}",
 "Checklist": "清单",
 "Chinelo": "拖鞋",
 "Chá de bebê": "迎婴派对",
 "Cidade": "城市",
 "Cidade (para a data dos recibos)": "城市（用于收据日期）",
 "Cidade de {nome}": "{nome} 市",
 "Cidades": "城市",
 "Cifrão": "货币符号",
 "Cinza": "灰色",
 "Cirurgia": "手术",
 "Ciências": "科学",
 "Clara": "淡",
 "Clareia PDFs escaneados: fundo branco, cinza ou preto e branco.": "让扫描版 PDF 更清晰：白色、灰色或黑白背景。",
 "Claro": "浅色",
 "Classificar categorias com IA": "用 AI 分类",
 "Claude, ChatGPT ou Gemini": "Claude、ChatGPT 或 Gemini",
 "Cliente": "客户",
 "Clientes": "客户",
 "Clima esperado": "预计天气",
 "Co-anfitrião": "联合房东",
 "Cobrança": "收费",
 "Cobranças": "收费",
 "Coelho": "兔子",
 "Cofre (criptografia de ponta a ponta)": "保险库（端到端加密）",
 "Cofre aberto (fecha sozinho em 5 minutos sem uso)": "保险库已打开（闲置 5 分钟后自动关闭）",
 "Cofre ainda não criado": "尚未创建保险库",
 "Cofre com criptografia para RG, CNH, passaporte, contratos e certidões, com contagem até vencer e envio com um toque.": "加密保险库，存放身份证、驾照、护照、合同和证书，显示到期倒计时，一键发送。",
 "Cofre fechado": "保险库已关闭",
 "Cofrinho": "存钱罐",
 "Cole aqui a chave ({ini}...)": "在此粘贴密钥（{ini}...）",
 "Cole o link (https://...)": "粘贴链接（https://...）",
 "Cole ou digite o código de barras (ou o Pix copia e cola) no campo do código: o app calcula o valor e o vencimento sozinho. Com a sua IA ligada, ele lê tudo pela foto.": "在代码栏粘贴或输入条形码（或 Pix 复制粘贴码）：应用会自动计算金额和到期日。开启你的 AI 后，它会从照片中读取全部信息。",
 "Coloca arquivos dentro do PDF.": "把文件放进 PDF 里。",
 "Colocar na agenda": "加入日程",
 "Colocar na linha do tempo com alarme": "加入带闹钟的时间线",
 "Colocar no My Planner": "加入 My Planner",
 "Colocar rega e adubo na agenda": "将浇水和施肥加入日程",
 "Coloque o valor da mensalidade na turma (Editar) ou no aluno. As cobranças deste mês que já existem não se repetem.": "在班级（编辑）或学生中填写月费金额。本月已有的收费不会重复。",
 "Coluna": "列",
 "Colágeno": "胶原蛋白",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, use o desenho ou a senha.": "开启生物识别后会优先使用它。如果失败，请使用图案或密码。",
 "Com convênio": "有医保",
 "Com o código do país e o DDD. Ex.: +55 41 99999-0000": "包含国家代码和区号。例如：+55 41 99999-0000",
 "Com outras pessoas": "在别人那里",
 "Com prazo, o app calcula quanto guardar por mês. O dinheiro guardado conta como \"Guardou\" no mês.": "设定期限后，应用会计算每月需要存多少。存下的钱会计入当月的\"储蓄\"。",
 "Com quem": "对方",
 "Com quem pagou, o paciente, a data e o valor de cada atendimento pago. Como pessoa física, lance cada um no app Receita Federal › Receita Saúde; com CNPJ, emita a nota de serviço.": "包含每次已付就诊的付款人、患者、日期和金额。个人身份请在 Receita Federal 应用 › Receita Saúde 中逐条录入；有 CNPJ 的请开具服务发票。",
 "Com valor a receber": "有待收款",
 "Com vencimento": "有到期日",
 "Combinado": "一言为定",
 "Combinado 👍": "好的 👍",
 "Combustível": "燃料",
 "Comece cadastrando as contas fixas do mês (aluguel, luz, internet) e o seu cartão. Eu aviso antes de cada vencimento.": "先添加每月的固定开支（房租、电费、网费）和你的信用卡。每次到期前我都会提醒你。",
 "Comecei em": "开始于",
 "Comentários": "评论",
 "Começa amanhã": "明天开始",
 "Começa às {hora} (em {m} min)": "{hora} 开始（{m} 分钟后）",
 "Começar": "开始",
 "Começar com o modelo: café, lanche, almoço, lanche e jantar": "使用模板开始：早餐、加餐、午餐、加餐和晚餐",
 "Começar em": "起始编号",
 "Começar o teste grátis": "开始免费试用",
 "Comi outros alimentos ou quantidades": "我吃了其他食物或其他分量",
 "Comida": "食物",
 "Comidas e bebidas": "食物与饮料",
 "Comido": "已吃",
 "Comido / alterações": "已吃 / 变更",
 "Comido conta as refeições marcadas como feitas (ou com alterações) até hoje.": "“已吃”统计截至今天标记为完成（或有变更）的餐次。",
 "Comigo": "在我这里",
 "Comissão da plataforma": "平台佣金",
 "Como apagar a sua conta e os seus dados": "如何删除你的账户和数据",
 "Como chegar": "如何到达",
 "Como ela está": "状态如何",
 "Como estou comparado ao mês passado?": "和上个月相比怎么样？",
 "Como funciona": "使用说明",
 "Como planejado": "按计划",
 "Compartilhado no grupo": "已在群组中共享",
 "Compartilhado no grupo · só leitura": "已在群组中共享 · 只读",
 "Compartilhamento indisponível neste dispositivo.": "此设备不支持分享。",
 "Compartilhar": "分享",
 "Compartilhar PDF": "分享 PDF",
 "Compartilhar a limpeza": "分享清洁任务",
 "Compartilhar os dados": "共享数据",
 "Compartilhar os dados com a equipe": "与团队共享数据",
 "Compartilhar os dados com o grupo?": "要与群组共享数据吗？",
 "Compartilhar texto": "分享文字",
 "Competência (mês de referência)": "所属期（参考月份）",
 "Competência {d}": "所属期 {d}",
 "Complemento": "补充地址",
 "Complete seus dados": "请完善你的信息",
 "Compra": "消费",
 "Compra e venda de imóveis, veículos e ações, recibos dedutíveis e o calendário do imposto.": "房产、车辆和股票的买卖、可抵扣收据以及税务日历。",
 "Compra feita": "已购买",
 "Compra no cartão": "信用卡消费",
 "Compras": "购买",
 "Compras da semana": "本周采购",
 "Comprimir": "压缩",
 "Compromisso": "日程",
 "Compromisso da escola": "学校事项",
 "Comprovante": "凭证",
 "Comprovante guardado": "凭证已保存",
 "Comprovantes": "凭证",
 "Computador": "电脑",
 "Comédia": "喜剧",
 "Concedi": "借出",
 "Concluir": "完成",
 "Concluir (esquerda)": "完成（左滑）",
 "Concluída": "已完成",
 "Concluído": "已完成",
 "Concluído (%)": "完成度（%）",
 "Concluído!": "已完成！",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "我同意我的姓名、CPF 和电子邮箱仅用于识别我的账户，且我的任务和笔记保存在该账户中。我可以随时在 设置 › 安全 中删除账户及所有数据。",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes.": "我同意我的姓名、CPF 和电子邮件仅用于识别我的账户，并且我的任务和笔记保存在该账户中。我可以随时在设置中删除账户及所有数据。",
 "Concordo que meu nome, documento e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "我同意我的姓名、证件号和电子邮箱仅用于识别我的账户，且我的任务和笔记保存在该账户中。我可以随时在 设置 › 安全 中删除账户及所有数据。",
 "Concursos": "公务员考试",
 "Condicionador": "护发素",
 "Condomínio": "物业费",
 "Condomínio e IPTU": "物业费和房产税",
 "Conectado": "已连接",
 "Conectando...": "正在连接...",
 "Conectar": "连接",
 "Conectar navegador": "连接浏览器",
 "Conectar o {nome}": "连接 {nome}",
 "Conectar relógio ou app de saúde": "连接手表或健康 App",
 "Conectar {nome}": "连接 {nome}",
 "Conecte o {nome} em Ajustes › Google Drive e OneDrive.": "请在 设置 › Google Drive 和 OneDrive 中连接 {nome}。",
 "Conferindo...": "正在核对...",
 "Conferir controles, chaves e Wi-Fi": "检查遥控器、钥匙和 Wi-Fi",
 "Conferir o prazo no sistema oficial": "在官方系统中核对期限",
 "Confete": "彩纸",
 "Configuração geral": "常规设置",
 "Confira a senha da sua conta e tente de novo.": "请检查你的账户密码，然后重试。",
 "Confira as datas oficiais no site da Receita Federal e ajuste se precisar.": "请在巴西联邦税务局（Receita Federal）网站核对官方日期，必要时调整。",
 "Confira o código. Ele tem 6 letras e números.": "请检查代码。它由 6 位字母和数字组成。",
 "Confira o e-mail ou deixe em branco.": "请检查电子邮件或留空。",
 "Confira o e-mail.": "请检查电子邮箱。",
 "Confira o prazo no sistema oficial.": "请在官方系统中核对期限。",
 "Confira os 11 números.": "请检查这 11 位数字。",
 "Confira os campos antes de salvar.": "保存前请核对各字段。",
 "Confira se a sua conta Google está adicionada no celular e com a agenda sincronizando.": "请确认手机上已添加你的 Google 帐号，且日历正在同步。",
 "Confirmada": "已确认",
 "Confirmado": "已确认",
 "Confirmar": "确认",
 "Confirme a declaração sobre a empresa.": "请确认关于公司的声明。",
 "Confirme o seu celular": "验证您的手机",
 "Confirme para ativar a biometria": "确认以启用生物识别",
 "Confirme para excluir": "确认删除",
 "Confirme sua senha para sincronizar": "请确认密码以同步",
 "Confraternização": "聚会",
 "Confraternização Universal": "元旦",
 "Conselho": "执业协会",
 "Consignado": "工资代扣贷款",
 "Consulta": "就诊",
 "Consulta ou vacina": "就诊或疫苗",
 "Consultas": "就诊",
 "Consultório": "诊所",
 "Consumo médio: {v} km/L": "平均油耗：{v} km/L",
 "Conta": "账户",
 "Conta a pagar": "应付账单",
 "Conta a receber": "应收款项",
 "Conta de consumo ou tributo": "生活缴费或税费",
 "Conta os dias em que cada item estava previsto (pelos dias da semana dele) e os que foram marcados como feitos.": "统计每项按其星期安排应进行的天数，以及标记为已完成的天数。",
 "Conta paga": "已付",
 "Conta recebida": "已收",
 "Conta vence hoje": "账单今天到期",
 "Conta vencendo": "账单即将到期",
 "Contabilidade": "会计",
 "Contando os acompanhantes. Toque no status do convidado para mudar.": "含同伴人数。点按宾客的状态即可更改。",
 "Contando: {cliente}": "计时中：{cliente}",
 "Contas": "账款",
 "Contas a pagar": "应付账款",
 "Contas a pagar e a receber, gastos do mês, aviso de vencimento e controle do MEI (Mestre Achado).": "应付和应收账款、每月支出、到期提醒以及 MEI 管理（Mestre Achado）。",
 "Contas a receber": "应收账款",
 "Contas fixas": "固定开支",
 "Contato": "联系人",
 "Contato de emergência": "紧急联系人",
 "Contato do encarregado de dados:": "数据保护负责人联系方式：",
 "Conte a sua ideia para o app ficar melhor.": "告诉我们你的想法，让应用变得更好。",
 "Conte o que está difícil ou não funciona como deveria.": "告诉我们哪里不好用或没有正常工作。",
 "Conte o que você fez, o que esperava e o que apareceu. Se tiver uma mensagem de erro, copie aqui.": "请说明你做了什么、预期结果以及实际出现了什么。如果有错误信息，请复制到这里。",
 "Conte para a gente problemas, erros e ideias de melhoria. Sua mensagem vai direto para a equipe do My Planner.": "告诉我们问题、错误和改进建议。你的消息会直接发送给 My Planner 团队。",
 "Conteúdo": "内容",
 "Conteúdo que você cria: tarefas, anotações, finanças, documentos, fotos, anexos e dados das abas.": "你创建的内容：任务、笔记、财务、文件、照片、附件和各标签页的数据。",
 "Conteúdo, matéria, tarefa de casa...": "内容、科目、家庭作业…",
 "Continuar": "继续",
 "Continue usando o My Planner e as Anotações por {preco} por ano. Seus dados continuam guardados.": "以每年 {preco} 继续使用 My Planner 和笔记。你的数据仍会保留。",
 "Contratado": "已签约",
 "Contratado: {v}": "已签约：{v}",
 "Contrato": "合同",
 "Conversa": "聊天",
 "Conversa do grupo": "群聊",
 "Conversar": "发消息",
 "Conversar com o Mestre (precisa da sua IA)": "和大师聊天（需要你的 AI）",
 "Converse com amigos e grupos, e faça chamadas de áudio e vídeo.": "与好友和群组聊天，并进行语音和视频通话。",
 "Converter de PDF": "从 PDF 转换",
 "Converter para PDF": "转换为 PDF",
 "Convidado": "宾客",
 "Convidados": "宾客",
 "Convidados com confirmação de presença, fornecedores e o cronograma do grande dia.": "宾客出席确认、供应商以及大日子的流程安排。",
 "Convidados e cronograma do dia, sem os valores.": "宾客和当天日程，不含金额。",
 "Convidar": "邀请",
 "Convidar pelo WhatsApp": "通过 WhatsApp 邀请",
 "Convite": "邀请",
 "Convite copiado. Cole onde quiser enviar.": "邀请已复制。粘贴到任何你想发送的地方。",
 "Convite inválido ou trocado pelo administrador. Peça um link novo.": "邀请无效或已被管理员更换。请索取新链接。",
 "Convite para o My Planner": "邀请加入 My Planner",
 "Convênio": "医保",
 "Copiar": "复制",
 "Copiar a lista para uma tarefa": "将清单复制为任务",
 "Copiar o código": "复制代码",
 "Copiar para hoje": "复制到今天",
 "Copo de outro tamanho": "其他容量的杯子",
 "Copo {n}": "第 {n} 杯",
 "Cor": "颜色",
 "Cor do fichário": "活页夹颜色",
 "Cor do tema": "主题颜色",
 "Cor do tema de cada aba": "各标签页的主题颜色",
 "Coração": "爱心",
 "Corações": "爱心",
 "Cores das abas": "标签页颜色",
 "Cores das conversas": "聊天颜色",
 "Cores e opções desta aba": "此标签页的颜色和选项",
 "Corpo": "身体",
 "Corporativo": "公司活动",
 "Corpus Christi": "基督圣体节",
 "Corredor": "走廊",
 "Correia dentada": "正时皮带",
 "Corrida": "跑步",
 "Corta as bordas em branco ou partes da página.": "裁掉空白边缘或页面的部分区域。",
 "Cortesia": "免费",
 "Coxa e sobrecoxa": "鸡腿（大腿和小腿）",
 "Cozinha": "厨房",
 "Creatina": "肌酸",
 "Criada em {data}": "创建于 {data}",
 "Criado com": "创建工具",
 "Criado em": "创建时间",
 "Criança": "孩子",
 "Crianças": "孩子",
 "Criar": "创建",
 "Criar animada": "制作动态贴纸",
 "Criar conta": "创建账户",
 "Criar do zero": "从头创建",
 "Criar documento, planilha ou apresentação": "创建文档、表格或演示文稿",
 "Criar em outro app": "在其他应用中创建",
 "Criar escritório": "创建办公室",
 "Criar fichário": "创建活页夹",
 "Criar figurinha": "制作贴纸",
 "Criar grupo": "创建群组",
 "Criar grupo e convidar pessoas": "创建群组并邀请他人",
 "Criar minha chave de API": "创建我的 API 密钥",
 "Criar o cofre": "创建保险库",
 "Criar o grupo e convidar": "创建群组并邀请",
 "Criar os prazos do IR de {ano}": "创建 {ano} 年个税期限",
 "Criar uma meta (viagem, reserva, carro...)": "创建目标（旅行、储备金、汽车...）",
 "Criar uma senha nova": "创建新密码",
 "Criar {n} tarefa(s)": "创建 {n} 个任务",
 "Criação do Estado de MS": "南马托格罗索州建州纪念日",
 "Crie a mudança e o app já monta a lista de transferências (luz, água, internet...). Depois cadastre as caixas por cômodo, as vistorias e o cronograma dos dias.": "创建搬家后，应用会自动生成转移清单（电、水、网络……）。然后登记各房间的箱子、交接检查和每天的安排。",
 "Crie a pasta de cada cliente, convide o cliente pelo link (ele só vê a pasta dele) e troquem documentos nos dois sentidos: notas, guias, folha, extratos, contratos.": "为每位客户创建文件夹，通过链接邀请客户（客户只能看到自己的文件夹），双方互传文件：发票、缴税单、工资单、对账单、合同。",
 "Crie a turma (ou grupo de mentoria, treino, curso) e, dentro dela, os alunos, a chamada, as notas, os planos de aula, os materiais e as cobranças.": "创建班级（或辅导、训练、课程小组），并在其中添加学生、点名、成绩、教案、资料和收费。",
 "Crie a turma e, dentro dela, os alunos, a chamada, as avaliações com notas e os planos de aula.": "创建班级，再在其中添加学生、点名、带成绩的评估和教案。",
 "Crie as tarefas da casa (limpar banheiro, trocar roupa de cama...) com a frequência. O app avisa quando estão atrasadas, sem encher o My Planner.": "创建家务（打扫卫生间、换床单……）并设置频率。家务逾期时应用会提醒你，而不会塞满 My Planner。",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para arquivar.": "为这门科目创建卡片：清单、列表、自由文本或绘图。向右滑动删除，向左滑动归档。",
 "Crie o escritório, chame a equipe (amigos do app ou convite pelo link) e troquem mensagens e documentos, marquem reuniões e façam reunião de vídeo. Você, que administra, pode gravar as reuniões.": "创建办公室，邀请团队（App 好友或通过链接邀请），互发消息和文档、安排会议、开视频会议。你作为管理员可以录制会议。",
 "Crie o evento e, dentro dele, a lista de convidados com confirmação de presença, os fornecedores e o cronograma do dia.": "创建活动，再在其中添加带出席确认的宾客名单、供应商和当天流程。",
 "Crie o grupo e mande o link: quem entrar recebe data, local, avisos e tudo o que você enviar, e aceita, edita ou recusa.": "创建群组并发送链接：加入的人会收到日期、地点、通知以及你发送的所有内容，并可以接受、编辑或拒绝。",
 "Crie o grupo e mande o link: quem entrar vê e participa conforme o papel que você escolher. Só quem administra coloca ou tira pessoas.": "创建群组并发送链接：加入的人可按你选择的角色查看和参与。只有管理员可以添加或移除成员。",
 "Crie o grupo e mande o link: quem entrar vê tudo o que está aqui dentro e participa (inclui, edita, põe fotos). Só quem administra coloca ou tira pessoas.": "创建群组并发送链接：加入的人可以看到这里的所有内容并参与（添加、编辑、上传照片）。只有管理员可以添加或移除成员。",
 "Crie sua conta. Seus dados ficam salvos na nuvem e neste dispositivo.": "创建你的账户。你的数据会保存在云端和本设备上。",
 "Crie um fichário (ex.: Doutorado, Inglês, Concurso) e dentro dele as matérias e páginas.": "创建一个活页夹（例：博士、英语、公务员考试），并在其中添加科目和页面。",
 "Crie um grupo (turma, pacientes, equipe, convidados, clientes), mande o link de convite e envie compromissos, materiais e avisos. Cada pessoa aceita, edita ou recusa o que recebe.": "创建群组（班级、患者、团队、来宾、客户），分享邀请链接，并发送日程、资料和通知。每个人都可以接受、编辑或拒绝收到的内容。",
 "Crie um perfil com nome e, se for advogado, a OAB.": "创建一个档案，填写姓名；如果是律师，请填写 OAB 号码。",
 "Criptografado no cofre, só neste dispositivo": "已在保险库中加密，仅保存在此设备",
 "Criptomoedas": "加密货币",
 "Cronograma": "日程安排",
 "Cronograma alimentar, cuidados pessoais com passo a passo e água do dia.": "饮食计划、分步个人护理和每日饮水。",
 "Cronograma do dia": "当天流程",
 "Cronograma físico-financeiro": "工程进度与资金计划",
 "Cronograma físico-financeiro por etapa, diário da obra com antes e depois, profissionais e entregas.": "按阶段的工程进度与资金计划、带前后对比的施工日志、施工人员和送货。",
 "Cronômetro de horas": "工时计时器",
 "Crédito empresarial": "企业贷款",
 "Créditos": "额度",
 "Cuida das reservas, da limpeza e das despesas.": "负责预订、清洁和支出。",
 "Cuidado": "护理",
 "Cuidado pessoal": "个人护理",
 "Cuidados": "养护",
 "Cupom do mercado": "超市小票",
 "Cupom do mercado (foto)": "超市小票（照片）",
 "Cupom lançado": "小票已录入",
 "Curitiba": "库里蒂巴",
 "Curitiba (PR)": "库里蒂巴 (PR)",
 "Curso": "课程",
 "Cursos": "课程",
 "Cursos livres e certificações": "自修课程与证书",
 "Cuscuz": "玉米蒸糕（巴西风味）",
 "CÓDIGO PARA PAGAR": "付款代码",
 "CÔMODOS": "房间",
 "Câmera": "相机",
 "Câmera e galeria": "相机和相册",
 "Câmera não liberada": "未授权摄像头",
 "Código IBGE do município": "城市 IBGE 代码",
 "Código IBGE do município (7 números)": "城市 IBGE 代码（7 位数字）",
 "Código NBS (9 números, opcional)": "NBS 代码（9 位数字，可选）",
 "Código copiado": "代码已复制",
 "Código da reserva (localizador)": "预订代码",
 "Código de barras, linha digitável ou Pix copia e cola (opcional)": "条形码、数字码或 Pix 复制粘贴码（可选）",
 "Código de indicação": "推荐码",
 "Código de indicação (opcional)": "推荐码（可选）",
 "Código de quem convidou você": "邀请人的代码",
 "Código de tributação nacional (6 números)": "国家税务代码（6 位数字）",
 "Código de tributação nacional (6 números, ex.: 171901)": "国家税务代码（6 位数字，例如 171901）",
 "Código do amigo": "好友代码",
 "Código do convite": "邀请码",
 "Código do procedimento (TUSS ou do plano)": "项目代码（TUSS 或保险方代码）",
 "Código errado. Confira e tente de novo.": "验证码错误。请检查后重试。",
 "Código não encontrado. Confira as letras e os números.": "未找到该代码。请检查字母和数字。",
 "Código não reconhecido. Confira os números (boleto: 47 ou 48 números).": "无法识别代码。请检查数字（Boleto：47 或 48 位）。",
 "Código: {c}": "代码：{c}",
 "Cópia automática toda semana": "每周自动备份",
 "Cópia criada.": "已创建副本。",
 "Cópia de segurança": "备份",
 "Cópia feita": "备份完成",
 "Cópia restaurada.": "备份已恢复。",
 "Cômodo": "房间",
 "Cômodo ou quarto": "单间",
 "Cômodos da casa e as tarefas de cada um.": "家中的房间及各自的任务。",
 "DAS de {mes} pago": "{mes} 的 DAS 已缴",
 "DAS de {mes}: vence dia {dia}": "{mes} 的 DAS：{dia} 日到期",
 "DAS do MEI": "MEI 的 DAS",
 "DECLARAÇÃO DE ATENDIMENTO": "就诊证明",
 "DICA DO MESTRE ACHADO": "Mestre Achado 的小贴士",
 "DPS nº {n}, série {s}": "DPS 编号 {n}，系列 {s}",
 "Da galeria ou dos arquivos": "从相册或文件",
 "Da meta de passos": "步数目标完成度",
 "Dados compartilhados": "共享数据",
 "Dados compartilhados com o grupo": "与群组共享的数据",
 "Dados compartilhados · seu papel: {p}": "共享数据 · 你的角色：{p}",
 "Dados de saúde que você mesmo registra são tratados só para você e para quem você compartilhar, com o seu consentimento (art. 11, I).": "你自己记录的健康数据仅为你本人及你选择共享的人处理，并基于你的同意（art. 11, I）。",
 "Dados do dispositivo: idioma, país e fuso horário (para datas, feriados e moeda), modelo do dispositivo e o código para avisos no celular.": "设备数据：语言、国家和时区（用于日期、假日和货币）、设备型号以及手机通知所需的代码。",
 "Dados do relógio e de saúde não são usados para publicidade nem repassados a ninguém. Você pode desconectar e revogar a permissão a qualquer momento.": "手表和健康数据绝不会用于广告，也不会提供给任何人。你可以随时断开连接并撤销授权。",
 "Dança": "舞蹈",
 "Dar ciência": "确认知悉",
 "Dar ciência da operação?": "确认知悉此交易？",
 "Data": "日期",
 "Data (embarque ou check-in)": "日期（出发或入住）",
 "Data agendada": "预约日期",
 "Data da aplicação": "接种日期",
 "Data da compra": "购买日期",
 "Data da entrega": "交付日期",
 "Data da venda": "出售日期",
 "Data de nascimento": "出生日期",
 "Data do empréstimo": "借出日期",
 "Data do pagamento": "付款日期",
 "Data em que foi feita": "完成日期",
 "Data sugerida com 2 dias úteis de folga. Confira no sistema oficial.": "建议日期预留了 2 个工作日的余量。请在官方系统中核对。",
 "De": "从",
 "De uma foto": "用照片制作",
 "De {de} para {para} ({p}% menor).": "从 {de} 到 {para}（缩小 {p}%）。",
 "Declaração": "申报表",
 "Declaração de atendimento": "就诊证明",
 "Declaração para reembolso (PDF)": "报销证明（PDF）",
 "Declaro que esta empresa é minha ou de cliente que autorizou o acompanhamento.": "我声明此公司属于我本人，或属于已授权我进行跟踪的客户。",
 "Declaro, para fins de reembolso{conv}, que o(a) paciente {nome}{cpf}{cart} foi atendido(a) por mim em {data}{hora}, em {tipo}.": "兹证明，患者 {nome}{cpf}{cart}于 {data}{hora}在本人处接受了{tipo}，特此用于{conv}报销。",
 "Defina a meta de aulas por dia ou por semana em Editar.": "在“编辑”中设置每天或每周的课程目标。",
 "Defina a meta de páginas por dia em Editar.": "在“编辑”中设置每天的页数目标。",
 "Defina um horário": "设置时间",
 "Defina um horário para usar pausas.": "设置时间后才能使用休息。",
 "Demaquilante ou água micelar": "卸妆液或胶束水",
 "Demolição": "拆除",
 "Demonstração": "演示",
 "Dentista": "牙医",
 "Dependentes": "受抚养人",
 "Depois": "之后",
 "Depois da aula": "课后",
 "Depois de apagadas, as tarefas não voltam. Digite a senha da sua conta para confirmar.": "任务删除后无法恢复。请输入你的账户密码以确认。",
 "Depois de baixar, abra o arquivo e toque em Instalar. Se o celular pedir, permita instalar apps desta fonte.": "下载后，打开文件并轻点“安装”。如果手机提示，请允许安装来自此来源的应用。",
 "Depois de criar": "创建之后",
 "Depois de {nome}. Toque para pular.": "{nome} 之后。点按跳过。",
 "Depois é só ajustar horários e o que comer em cada um.": "之后只需调整各餐的时间和吃什么。",
 "Desarquivar": "取消归档",
 "Desbloquear": "解锁",
 "Desbloquear com": "解锁方式",
 "Desbloquear com biometria": "使用生物识别解锁",
 "Desbloquear o My Planner": "解锁 My Planner",
 "Desbloqueio do app": "应用解锁",
 "Descanso": "休息",
 "Descartadas": "已忽略",
 "Descartar": "忽略",
 "Descartar este tempo?": "放弃这段时间？",
 "Descobrir lugares em {d}": "发现{d}的好去处",
 "Desconectar": "断开连接",
 "Desconectar o {nome}?": "断开 {nome} 的连接？",
 "Desconto": "折扣",
 "Desconto de {v}": "优惠 {v}",
 "Descontos obtidos": "获得的优惠",
 "Descrição": "描述",
 "Descrição (cliente, nota fiscal...)": "描述（客户、发票...）",
 "Descrição do serviço (sai na nota)": "服务描述（显示在发票上）",
 "Descrição que sai na nota": "显示在发票上的描述",
 "Desenhar a assinatura": "绘制签名",
 "Desenhar com caneta ou dedo": "用笔或手指绘图",
 "Desenhe a assinatura e escolha a página e o lugar.": "绘制签名并选择页面和位置。",
 "Desenhe a assinatura primeiro.": "请先绘制签名。",
 "Desenhe com o dedo ou com a caneta (S Pen, Apple Pencil ou caneta de tablet).": "用手指或触控笔绘画（S Pen、Apple Pencil 或平板电脑触控笔）。",
 "Desenhe com o dedo ou com a caneta. Para rolar o quadro, toque em Mover.": "用手指或触控笔绘画。要滚动看板，请点按“移动”。",
 "Desenhe de novo para confirmar.": "请再画一次以确认。",
 "Desenhe o seu padrão": "绘制您的图案",
 "Desenhe pelo menos uma tarja.": "请至少画一个黑条。",
 "Desenhe um padrão ligando pelo menos 4 pontos.": "请绘制一个至少连接 4 个点的图案。",
 "Desenho": "绘图",
 "Desenho com caneta ou dedo": "用笔或手指绘图",
 "Desenho incorreto": "图案错误",
 "Desenho padrão": "图案解锁",
 "Desenho padrão salvo.": "图案已保存。",
 "Desenvolvimento": "肩上推举",
 "Desfazer": "撤销",
 "Desfazer amizade": "删除好友",
 "Desligar": "关闭",
 "Desligar a sincronização?": "关闭同步？",
 "Deslize para os lados para ver outros dias (até 60 dias à frente). Toque numa refeição para planejar o cardápio só daquele dia. Arraste para a direita para excluir.": "左右滑动查看其他日期（最多未来 60 天）。点按某餐可只为那一天安排菜单。向右拖动可删除。",
 "Desmarcado": "已取消",
 "Desmarcar como recebida": "取消已收款标记",
 "Desmarcar feita hoje": "取消今天已完成",
 "Desmarcar grupo": "取消选择该组",
 "Desmarcar pagamento": "取消已付标记",
 "Desodorante": "止汗剂",
 "Despensa": "储藏室",
 "Despesa": "支出",
 "Despesas": "支出",
 "Destino": "目的地",
 "Detalhes": "详情",
 "Devolver até": "归还期限",
 "Devolver: {i} ({p})": "归还：{i}（{p}）",
 "Devolvido": "已归还",
 "Devolvidos": "已归还",
 "Dia": "日期",
 "Dia a dia": "日常",
 "Dia da mudança": "搬家当天",
 "Dia de vencimento do DAS": "DAS 到期日",
 "Dia do Trabalho": "劳动节",
 "Dia do vencimento": "到期日",
 "Dia em que a fatura fecha": "账单日",
 "Dia planejado": "计划日期",
 "Dia {d} de {total}": "第 {d} 天，共 {total} 天",
 "Diagnóstico": "诊断",
 "Dias e horários": "日期和时间",
 "Dias específicos": "指定日期",
 "Dias úteis": "工作日",
 "Dias: {dias}": "日期：{dias}",
 "Dicas e observações": "提示和备注",
 "Diesel": "柴油",
 "Diferença": "差额",
 "Digitado": "手动",
 "Digitar": "输入",
 "Digitar à mão": "手动输入",
 "Digite a senha do cofre. Ele fecha sozinho depois de 5 minutos sem uso.": "输入保险库密码。闲置 5 分钟后会自动关闭。",
 "Digite em minutos (90) ou em horas e minutos (1:30 ou 01:30) e toque em OK.": "输入分钟数（90）或小时和分钟（1:30 或 01:30），然后点按\"确定\"。",
 "Digite no formato HH:MM, por exemplo 13:30.": "请按 HH:MM 格式输入，例如 13:30。",
 "Digite o código e ganhe 10 dias com todas as abas liberadas. Se não tiver, deixe em branco.": "输入代码，即可获得 10 天全部标签页解锁。如果没有，请留空。",
 "Digite o nome da tarefa.": "请输入任务名称。",
 "Dinheiro": "现金",
 "Dinheiro e documentos": "钱和证件",
 "Direita": "右",
 "Direito": "法律",
 "Direito Administrativo": "行政法",
 "Direito Civil": "民法",
 "Direito Constitucional": "宪法",
 "Direito Empresarial": "商法",
 "Direito Penal": "刑法",
 "Direito Tributário": "税法",
 "Direito do Trabalho": "劳动法",
 "Direto": "直接预订",
 "Disciplina": "科目",
 "Dispensar": "关闭",
 "Dispensar o aviso": "忽略提醒",
 "Dispensar todas": "全部忽略",
 "Disponibilizada em": "发布日期",
 "Disponível no app novo": "新版应用中可用",
 "Distância": "距离",
 "Divida o curso em matérias ou módulos. Em cada uma, marque em que aula parou e crie cards de anotações.": "把课程分成科目或模块。在每个科目中标记学到第几课，并创建笔记卡片。",
 "Dividir": "拆分",
 "Dividir entre (nenhum marcado = todos)": "分摊人（不勾选 = 所有人）",
 "Divisão das despesas": "费用分摊",
 "Diária": "每晚房价",
 "Diária padrão": "默认每晚房价",
 "Diário": "日志",
 "Diários municipais": "市政公报",
 "Do celular, do Google Drive ou do OneDrive": "从手机、Google Drive 或 OneDrive",
 "Do cliente": "来自客户",
 "Do escritório": "来自事务所",
 "Doações": "捐赠",
 "Docs": "证件",
 "Documento": "文件",
 "Documento (fundo branco)": "文档（白色背景）",
 "Documento do veículo (CRLV)": "车辆证件（CRLV）",
 "Documento pessoal": "个人证件",
 "Documento vence hoje": "证件今天到期",
 "Documento vencendo": "证件即将到期",
 "Documento: {o}": "文件：{o}",
 "Documentos": "证件",
 "Documentos (contrato, nota, recibo...)": "文件（合同、发票、收据...）",
 "Documentos (passaporte, identidade, carteira de motorista)": "证件（护照、身份证、驾照）",
 "Documentos e autorização das crianças": "孩子的证件和授权书",
 "Documentos protegidos, exames, histórico de saúde e outros campos com 🔒 são criptografados aqui no aparelho (AES-256) com a senha do cofre. Nem o suporte consegue ler. Sem a senha, esses dados não podem ser recuperados.": "受保护的证件、检查、健康史以及其他带 🔒 的字段，会在本设备上用保险库密码加密（AES-256）。连客服也无法读取。没有密码，这些数据将无法恢复。",
 "Documentos, recibos, cadernos e quadros, com várias páginas": "文档、收据、笔记本和白板，支持多页",
 "Documentos, reuniões e gravações são apagados para todos. A conversa continua no Mensagens.": "文档、会议和录制将为所有人删除。聊天仍保留在消息中。",
 "Documentário": "纪录片",
 "Doenças, cirurgias e observações": "疾病、手术和备注",
 "Dois dedos ou toque duplo para ampliar": "双指缩放或双击放大",
 "Domingo": "星期日",
 "Dono da obra": "业主",
 "Dose": "剂量",
 "Dose (ex.: 1 cápsula, 5 g)": "剂量（例如：1粒胶囊、5 g）",
 "Dose única": "单剂",
 "Drama": "剧情",
 "Duplicar": "复制",
 "Duplicar tarefa": "复制任务",
 "Duração": "时长",
 "Duração de cada sessão": "每次学习时长",
 "Duração {dur}": "时长 {dur}",
 "Dá para comprar algo de 3 mil em 10 vezes?": "3000 的东西能分 10 期买吗？",
 "Débito automático": "自动扣款",
 "Débito, Pix ou dinheiro": "借记卡、Pix 或现金",
 "Dê um nome ao cartão.": "请给卡片起个名字。",
 "Dê um nome ao cuidado.": "请为护理项目命名。",
 "Dê um nome ao cômodo.": "请为房间命名。",
 "Dê um nome ao fichário.": "请为活页夹命名。",
 "Dê um nome ao grupo.": "请为群组命名。",
 "Dê um nome ao suplemento.": "请为补充剂命名。",
 "Dê um nome ao treino.": "请为训练命名。",
 "Dê um nome à conta.": "请为账单命名。",
 "Dê um nome à matéria.": "请为科目命名。",
 "Dê um nome à meta.": "请给目标起个名字。",
 "Dê um nome à refeição.": "请为餐次命名。",
 "Dê um nome à tarefa.": "请为任务命名。",
 "E-MAIL (OPCIONAL)": "邮箱（选填）",
 "E-mail": "电子邮箱",
 "E-mail (recebe a nota)": "邮箱（接收发票）",
 "E-mail de contato": "联系邮箱",
 "E-mail do responsável": "监护人邮箱",
 "E-mail inválido": "电子邮件无效",
 "E-mail inválido.": "电子邮件无效。",
 "E-mail ou WhatsApp para resposta (opcional)": "用于回复的电子邮箱或 WhatsApp（可选）",
 "E-mail para contato (opcional)": "联系邮箱（可选）",
 "E-mail salvo.": "邮箱已保存。",
 "EM ATRASO": "已逾期",
 "ENTRAR COM UM CÓDIGO": "用邀请码加入",
 "ENVIADOS": "已发送",
 "ESCOLHA AS ATIVIDADES": "选择活动",
 "ESTA SEMANA": "本周",
 "EXERCÍCIO FÍSICO": "体育锻炼",
 "Economia": "经济学",
 "Edita tudo": "全部编辑",
 "Edita tudo: etapas, orçamento, diário e entregas.": "全部编辑：阶段、预算、日志和交付。",
 "Editar": "编辑",
 "Editar cartão": "编辑卡片",
 "Editar compra": "编辑消费",
 "Editar cômodo": "编辑房间",
 "Editar desenho": "编辑绘图",
 "Editar documento": "编辑证件",
 "Editar fichário": "编辑活页夹",
 "Editar garantia": "编辑保修",
 "Editar matéria": "编辑科目",
 "Editar meta": "编辑目标",
 "Editar perfil": "编辑资料",
 "Editar tarefa": "编辑任务",
 "Editar {nome}": "编辑{nome}",
 "Educação": "教育",
 "Educação Física": "体育",
 "Efeito de scanner": "扫描效果",
 "Ela sai da lista e dos Recebidos da equipe.": "它会从列表和团队的收件箱中移除。",
 "Ela também fica guardada em \"Minhas figurinhas\" para mandar de novo.": "它也会保存在\"我的贴纸\"中，方便再次发送。",
 "Ela vem da aba Empréstimos & Financiamentos. Marque aqui como paga ou abra a aba para ver o contrato.": "它来自\"借款与贷款\"标签页。在这里标记为已付款，或打开该标签页查看合同。",
 "Ela vem da aba Notas Fiscais. Marque como recebida quando o dinheiro entrar.": "它来自\"发票（NF）\"标签页。钱到账后标记为已收款。",
 "Eleitorais": "选举法院",
 "Eletrodoméstico": "家电",
 "Eletrodomésticos": "家用电器",
 "Eletrodomésticos, eletrônicos e móveis: nota fiscal, assistência técnica e aviso 15 dias antes de a garantia acabar.": "家电、电子产品和家具：发票、售后服务，保修到期前 15 天提醒。",
 "Eletrônico": "电子产品",
 "Elétrica": "电路",
 "Elétrico": "纯电动",
 "Em Editar, cole o link do calendário (iCal) do anúncio. No Airbnb: Calendário › Disponibilidade › Conectar calendários › Exportar calendário. No Booking: Tarifas e disponibilidade › Sincronizar calendários.": "在“编辑”中粘贴房源的日历链接（iCal）。Airbnb：日历 › 可订状态 › 连接日历 › 导出日历。Booking：房价与房态 › 同步日历。",
 "Em aberto": "未完成",
 "Em alta": "热门",
 "Em andamento": "进行中",
 "Em atraso": "已逾期",
 "Em branco": "空白",
 "Em casa": "在家",
 "Em cima": "顶部",
 "Em construção": "建设中",
 "Em dia. As melhorias chegam sozinhas quando o app abre.": "已是最新。应用打开时会自动获取改进。",
 "Em limpeza": "清洁中",
 "Em quais páginas": "哪些页面",
 "Em qual agenda criar os eventos:": "在哪个日历中创建活动：",
 "Em qual página e onde": "在哪一页、哪个位置",
 "Em tratamento": "治疗中",
 "Em um horário específico": "在指定时间",
 "Em uso: {ia}": "正在使用：{ia}",
 "Em {n} dia(s)": "{n} 天后",
 "Embaixo": "底部",
 "Embaixo à esquerda": "左下",
 "Emissão": "签发",
 "Emissão +": "签发 +",
 "Emissão: {data}": "签发：{data}",
 "Emitida": "已开具",
 "Emitida em {data}": "开具于 {data}",
 "Emitida ou recebida": "已开具或已收到",
 "Emitidas": "已开具",
 "Emitidas: {v} · Recebidas: {r} · {n} nota(s)": "已开具：{v} · 已收到：{r} · {n} 张发票",
 "Emitir": "开具",
 "Emitir NFS-e": "开具 NFS-e",
 "Emitir NFS-e pelo Padrão Nacional com o certificado A1, buscar as notas emitidas e recebidas e exportar XML, planilha e PDF.": "使用 A1 证书通过 Padrão Nacional 开具 NFS-e，查询已开具和已收到的发票，并导出 XML、表格和 PDF。",
 "Emitir a nota de verdade?": "开具正式发票？",
 "Emitir no ambiente de teste?": "在测试环境中开具？",
 "Emojis": "表情",
 "Emojis animados": "动态表情",
 "Emojis animados: Noto, do Google (CC BY 4.0).": "动态表情：Google 的 Noto (CC BY 4.0)。",
 "Emojis, GIFs e figurinhas": "表情、GIF 和贴纸",
 "Empresa": "公司",
 "Empresa de mudança": "搬家公司",
 "Empresa ou pessoa": "公司或个人",
 "Empresa, hotel ou voo": "公司、酒店或航班",
 "Empresas": "公司",
 "Emprestei": "我借出",
 "Empréstimo": "借用",
 "Empréstimo entre pessoas": "个人借贷",
 "Empréstimo pessoal": "个人贷款",
 "Empréstimos": "借用",
 "Empréstimos & Financiamentos": "借款与贷款",
 "Encaminhada para {nome}.": "已转发给 {nome}。",
 "Encaminhar": "转发",
 "Encaminhar para": "转发给",
 "Encerrar e salvar": "结束并保存",
 "Encontrada para {perfil}": "为 {perfil} 找到",
 "Endereço": "地址",
 "Endereço (opcional)": "地址（可选）",
 "Endereço (se for presencial)": "地址（线下时填写）",
 "Endereço atual": "当前地址",
 "Endereço da escola": "学校地址",
 "Endereço da oficina": "维修厂地址",
 "Endereço de quem está com o item": "持有物品者的地址",
 "Endereço do consultório": "诊所地址",
 "Endereço do imóvel": "房产地址",
 "Endereço do laboratório": "化验室地址",
 "Endereço do veterinário": "兽医地址",
 "Endereço no trabalho e na escola": "在工作单位和学校的地址",
 "Endereço nos Correios e entregas": "在邮局和快递的地址",
 "Endereço nos bancos e cartões": "在银行和银行卡的地址",
 "Endereço novo": "新地址",
 "Endereço ou nome do lugar": "地址或地点名称",
 "Endereço ou terminal": "地址或航站楼",
 "Energia": "精力",
 "Enfermeiro": "护士",
 "Engenharia": "工程",
 "Engenheiro ou arquiteto": "工程师或建筑师",
 "Enquadre o documento e toque no botão": "将证件放入取景框，然后点击按钮",
 "Enquadre o rosto e toque no botão. 🔄 vira a câmera.": "将脸部对准画面并点按按钮。🔄 切换摄像头。",
 "Ensino Fundamental": "小学与初中",
 "Ensino Médio e ENEM": "高中与 ENEM",
 "Entendi e concordo em usar o monitor nessas condições.": "我已了解并同意在上述条件下使用监控。",
 "Entra direto no Planner, com horário, dias e a lista de itens. Se o horário já estiver ocupado, você escolhe: substituir, manter as duas ou cancelar.": "直接添加到 Planner，包含时间、日期和项目列表。如果该时间已被占用，你可以选择：替换、两者都保留或取消。",
 "Entrada": "收入",
 "Entrada (imóvel novo)": "入住检查（新房）",
 "Entrada de dinheiro": "收入",
 "Entrando...": "正在登录...",
 "Entrar": "登录",
 "Entrar com CPF e senha": "使用 CPF 和密码登录",
 "Entrar com outra conta": "使用其他账户登录",
 "Entrar de novo": "重新登录",
 "Entrar na chamada": "加入通话",
 "Entrar na reunião": "加入会议",
 "Entrar na sala online": "进入线上诊室",
 "Entrar no grupo": "加入群组",
 "Entrar no navegador?": "登录浏览器？",
 "Entre com seu CPF e sua senha.": "请使用你的 CPF 和密码登录。",
 "Entre com seu e-mail e sua senha.": "使用电子邮箱和密码登录。",
 "Entre na sua conta de novo.": "请重新登录。",
 "Entre na sua conta para usar as notas fiscais.": "登录你的账户以使用发票功能。",
 "Entre no app com o seu e-mail e a senha nova.": "请用你的电子邮箱和新密码登录应用。",
 "Entrega de material": "材料送货",
 "Entrega prevista": "预计送达",
 "Entregas": "送货",
 "Entregue": "已提交",
 "Entrou": "收入",
 "Entrou no total da semana.": "已计入本周总计。",
 "Enviada": "已发送",
 "Enviado": "已发送",
 "Enviado para o Planner": "已发送到 Planner",
 "Enviado pelo cliente": "客户发送",
 "Enviado pelo escritório": "事务所发送",
 "Enviado por {quem} no grupo {g}": "由 {quem} 在群组 {g} 中发送",
 "Enviando {f} de {n}...": "正在上传 {f}/{n}...",
 "Enviando...": "正在发送…",
 "Enviar": "发送",
 "Enviar \"{nome}\"": "发送“{nome}”",
 "Enviar \"{nome}\" para…": "将\"{nome}\"发送到…",
 "Enviar \"{titulo}\" para": "将 \"{titulo}\" 发送到",
 "Enviar ao grupo": "发送到群组",
 "Enviar convite": "发送邀请",
 "Enviar convite para {nome}": "向{nome}发送邀请",
 "Enviar convite pelo WhatsApp": "通过 WhatsApp 发送邀请",
 "Enviar documento": "上传文档",
 "Enviar instruções ao hóspede": "向房客发送入住说明",
 "Enviar o convite": "发送邀请",
 "Enviar ou copiar o código": "发送或复制代码",
 "Enviar ou imprimir a etiqueta": "发送或打印标签",
 "Enviar para Estudos": "发送到学习",
 "Enviar para My Planner": "发送到 My Planner",
 "Enviar para a equipe": "发送给团队",
 "Enviar para o My Planner": "发送到 My Planner",
 "Enviar para o Planner": "发送到 Planner",
 "Enviar para o grupo": "发送到群组",
 "Enviar para o grupo de estudos": "发送到学习群",
 "Enviar para o {nome} os {n} arquivo(s) deste dispositivo": "将本设备上的 {n} 个文件上传到 {nome}",
 "Enviar para um grupo": "发送到某个群组",
 "Enviar para {g}": "发送到 {g}",
 "Enviar para…": "发送到…",
 "Enviar por e-mail": "通过电子邮件发送",
 "Enviar relatório": "发送报告",
 "Enviar relatório para a equipe": "将报告发送给团队",
 "Enviar também as tarefas que já existem (de hoje em diante)": "同时发送已有任务（从今天起）",
 "Enviar tarefas do My Planner para a agenda": "将 My Planner 任务发送到日历",
 "Envie guias, notas e relatórios para o cliente, ou veja o que ele mandou. Cada documento aceita fotos, PDFs e links.": "向客户发送缴税单、发票和报告，或查看客户发来的文件。每份文件都可以附加照片、PDF 和链接。",
 "Enxaguante": "漱口水",
 "Episódio": "集",
 "Equipe": "团队",
 "Equipe ({n})": "团队（{n}）",
 "Equipe de limpeza": "清洁团队",
 "Equipe do consultório": "诊所团队",
 "Equipe do imóvel (limpeza e co-anfitrião)": "房源团队（保洁和联合房东）",
 "Erro": "错误",
 "Erro na emissão": "开票出错",
 "Erro: {erro}": "错误：{erro}",
 "Erros registrados neste dispositivo ({n})": "本设备记录的错误（{n}）",
 "Escanear documento": "扫描文档",
 "Escanear o verso": "扫描背面",
 "Escanear para PDF": "扫描为 PDF",
 "Escaneie documentos, recibos, cadernos e quadros: bordas e sombras corrigidas, várias páginas, identidade frente e verso, assinatura e PDF guardado no celular, no Google Drive ou no OneDrive.": "扫描文档、收据、笔记本和白板：自动修正边缘和阴影，支持多页、证件正反面、签名，PDF 可保存到手机、Google Drive 或 OneDrive。",
 "Escaneie, deixe a imagem mais clara, organize em pastas e mande o PDF por WhatsApp, e-mail ou Drive. Com a sua IA ligada, o app lê o texto, resume e responde perguntas sobre o documento.": "扫描文档，让图片更清晰，按文件夹整理，并通过 WhatsApp、电子邮件或 Drive 发送 PDF。开启你的 AI 后，应用可以读取文字、生成摘要并回答关于文档的问题。",
 "Escola": "学校",
 "Escolha a aba:": "选择标签页：",
 "Escolha a data do compromisso.": "请选择日程日期。",
 "Escolha a imagem.": "请选择图片。",
 "Escolha a matéria": "选择科目",
 "Escolha a pasta do celular (ex.: Documentos). O app guarda lá sozinho.": "选择手机上的文件夹（例如：文档）。应用会自动保存到那里。",
 "Escolha a página": "选择页面",
 "Escolha ao menos um tribunal ou marque \"Todos os tribunais\".": "请至少选择一个法院，或勾选\"所有法院\"。",
 "Escolha ao menos uma agenda.": "请至少选择一个日历。",
 "Escolha o PDF": "选择 PDF",
 "Escolha o arquivo .pfx (ou .p12) do certificado A1 da empresa e digite a senha dele. Ele fica criptografado no seu cofre.": "选择公司 A1 证书的 .pfx（或 .p12）文件并输入其密码。证书会加密保存在你的保险库中。",
 "Escolha o arquivo .xml da NFS-e, NF-e ou CT-e.": "选择 NFS-e、NF-e 或 CT-e 的 .xml 文件。",
 "Escolha o fichário": "选择活页夹",
 "Escolha o grupo para enviar: {t}": "选择要发送的群组：{t}",
 "Escolha os PDFs": "选择 PDF 文件",
 "Escolha os arquivos.": "请选择文件。",
 "Escolha os feriados que aparecem no Planner e no botão 🎉 Feriados.": "选择在 Planner 和 🎉 假日 按钮中显示的假日。",
 "Escolha para quem enviar.": "请选择发送对象。",
 "Escolha pelo menos um dia.": "请至少选择一天。",
 "Escolha pelo menos uma página que exista no PDF (ex.: 1-3, 5).": "请至少选择 PDF 中存在的一页（例如：1-3, 5）。",
 "Escolha quem participa:": "选择成员：",
 "Escolher": "选择",
 "Escolher a imagem": "选择图片",
 "Escolher a pasta": "选择文件夹",
 "Escolher agendas": "选择日历",
 "Escolher alimento": "选择食物",
 "Escolher arquivo": "选择文件",
 "Escolher arquivos": "选择文件",
 "Escolher arquivos do Drive ou do OneDrive": "从 Drive 或 OneDrive 选择文件",
 "Escolher as imagens e criar o PDF": "选择图片并创建 PDF",
 "Escolher da galeria": "从相册选择",
 "Escolher da galeria ou arquivo (foto ou PDF)": "从相册或文件中选择（照片或 PDF）",
 "Escolher data": "选择日期",
 "Escolher fuso": "选择时区",
 "Escolher hora": "选择时间",
 "Escolher horário": "选择时间",
 "Escolher o certificado": "选择证书",
 "Escolher outro": "换一个",
 "Escolher pessoas": "选择成员",
 "Escolher tribunais": "选择法院",
 "Escolher ícone": "选择图标",
 "Esconder da equipe (só administradores)": "对团队隐藏（仅管理员）",
 "Esconder detalhes": "隐藏详情",
 "Esconder o texto completo": "收起全文",
 "Escondido de {n} pessoa(s)": "对 {n} 人隐藏",
 "Escondido de: {n}": "对以下人员隐藏：{n}",
 "Escondidos no Planner.": "已在 Planner 中隐藏。",
 "Escova e pasta de dente": "牙刷和牙膏",
 "Escovar os dentes": "刷牙",
 "Escreva aqui": "在此输入",
 "Escreva e dê Enter (ex.: lavar a máquina)": "输入后按回车（例：清洗洗衣机）",
 "Escreva em uma ou em todas as páginas.": "在一页或所有页面上书写。",
 "Escreva o motivo em \"Motivo do cancelamento\" na ficha da nota (pelo menos 15 letras) e toque aqui de novo.": "在发票详情的“作废原因”中填写原因（至少 15 个字母），然后再次点按这里。",
 "Escreva o resumo, tópicos, dúvidas...": "写下摘要、要点、疑问...",
 "Escreva o texto da marca d'água.": "请输入水印文字。",
 "Escreva o texto.": "请输入文字。",
 "Escreva o título.": "请填写标题。",
 "Escreva ou cole o texto. Linha começando com \"# \" vira título.": "输入或粘贴文字。以 \"# \" 开头的行会变成标题。",
 "Escreva ou cole um texto e gere o PDF.": "输入或粘贴文字，生成 PDF。",
 "Escritório": "办公室",
 "Escritório: documentos e reuniões da equipe. Só o administrador do escritório pode gravar uma reunião, e todos na reunião veem o aviso \"Gravando\" enquanto ela é gravada. A gravação fica nos documentos do escritório, visível só para o administrador até ele liberar para a equipe.": "办公室：团队的文档和会议。只有办公室管理员可以录制会议，录制期间所有与会者都会看到“录制中”提示。录制文件保存在办公室文档中，在管理员向团队开放之前，仅管理员可见。",
 "Escuro": "深色",
 "Espanhol": "西班牙语",
 "Espaço": "房源",
 "Espaço livre, dados de cada aba e anexos": "可用空间、各标签页数据和附件",
 "Especialidade": "专科",
 "Espécie": "物种",
 "Esquadro": "角尺",
 "Esqueci a senha": "忘记密码",
 "Esquerda": "左",
 "Esse código é o seu.": "这是你自己的代码。",
 "Esse código é o seu. Use o código de quem indicou o app para você.": "这是你自己的代码。请使用向你推荐本应用的人的代码。",
 "Esse endereço não respondeu como servidor de notas. Confira e tente de novo.": "该地址没有以发票服务器的方式响应。请检查后重试。",
 "Esta aba ainda não está no seu plano.": "此标签页尚未包含在您的套餐中。",
 "Esta e todas as futuras": "此次及之后所有",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou instale o APK novo.": "此工具需要查看 PDF 页面，新版应用（0.50 版）才支持。请使用浏览器或安装新的 APK。",
 "Esta imagem foi guardada em outro dispositivo.": "此图片保存在另一台设备上。",
 "Esta janela pode ser fechada.": "可以关闭此窗口了。",
 "Esta pessoa ainda não preencheu o cartão de contato.": "此人尚未填写联系人名片。",
 "Esta semana: {a} de {m} aulas ({p}%)": "本周：{a}/{m} 课（{p}%）",
 "Esta senha é de outra conta.": "此密码属于另一个账户。",
 "Esta tarefa não tem horário: \"No início\" e \"Antes do início\" não se aplicam. Use \"Em um horário específico\".": "此任务没有时间：\"开始时\"和\"开始前\"不适用。请使用\"在指定时间\"。",
 "Esta tarefa se repete. O que excluir?": "此任务会重复。要删除哪些？",
 "Esta tela teve um problema": "此页面出现了问题",
 "Estado (UF) do registro": "注册所在州（UF）",
 "Estado de Mato Grosso do Sul": "南马托格罗索州",
 "Estado de São Paulo": "圣保罗州",
 "Estado do Paraná": "巴拉那州",
 "Estados": "州",
 "Estaduais": "州法院",
 "Estadual": "州级",
 "Estas abas aparecem na barra de baixo, nesta ordem. My Planner, Abas e Ajustes ficam sempre. As outras continuam aqui na tela Abas.": "这些标签页按此顺序显示在底部标签栏中。My Planner、标签页和设置始终显示。其他标签页仍在“标签页”页面中。",
 "Estatística": "统计学",
 "Este CPF já tem cadastro. Use \"Entrar\".": "此 CPF 已注册。请使用\"登录\"。",
 "Este PDF está no dispositivo onde foi aberto.": "此 PDF 在打开它的设备上。",
 "Este PDF está no dispositivo onde foi aberto. Abra por lá, ou abra de novo a cópia guardada no Drive ou no OneDrive.": "此 PDF 在打开它的设备上。请在那台设备上打开，或重新打开保存在 Drive 或 OneDrive 中的副本。",
 "Este PDF está protegido com senha. Tire a senha no programa onde ele foi criado e tente de novo.": "此 PDF 受密码保护。请在创建它的程序中移除密码后重试。",
 "Este PDF não tem campos de formulário. Use \"Adicionar texto\" para escrever nele.": "此 PDF 没有表单字段。请使用\"添加文字\"在上面书写。",
 "Este ano": "今年",
 "Este dispositivo": "此设备",
 "Este dispositivo não consegue abrir o arquivo.": "此设备无法打开该文件。",
 "Este dispositivo não consegue compartilhar arquivos.": "此设备无法分享文件。",
 "Este dispositivo não tem dados de saúde. Dá para digitar à mão.": "此设备没有健康数据。你可以手动输入。",
 "Este arquivo foi guardado em outro dispositivo.": "此文件保存在另一台设备上。",
 "Este arquivo foi guardado no celular. Abra pelo app no celular.": "此文件保存在手机上。请在手机上的应用中打开。",
 "Este arquivo não é um backup do My Planner.": "此文件不是 My Planner 备份。",
 "Este celular ainda não recebe avisos com o app fechado. Instale o app {v} ou mais novo (APK com os avisos do servidor). Com o app aberto, os avisos já funcionam.": "此手机在应用关闭时还无法接收通知。请安装 {v} 或更新版本的应用（带服务器通知的 APK）。应用打开时，通知已可正常使用。",
 "Este certificado é de {doc}, diferente do CNPJ/CPF da empresa ({emp}).": "此证书属于 {doc}，与公司的 CNPJ/CPF（{emp}）不同。",
 "Este fichário ainda não tem matérias.": "此活页夹还没有科目。",
 "Este grupo já está cheio.": "该群组已满。",
 "Este mês": "本月",
 "Este mês: emitidas {e} · recebidas {r}": "本月：已开具 {e} · 已收到 {r}",
 "Este mês: {h}": "本月：{h}",
 "Este navegador": "此浏览器",
 "Este país só tem feriados nacionais.": "该国家只有全国性假日。",
 "Esteira": "跑步机",
 "Esteticista": "美容师",
 "Estou usando o My Planner para organizar a agenda, as finanças e muito mais. Baixe o app e, ao criar a sua conta, use o meu código {codigo} para ganhar 10 dias com todas as abas liberadas.": "我正在用 My Planner 管理日程、财务等等。下载应用，创建账户时使用我的代码 {codigo}，即可获得 10 天全部标签页解锁。",
 "Estratégia": "教学策略",
 "Estrela": "星星",
 "Estudando": "学习中",
 "Estudar agora": "立即学习",
 "Estudar {nome}": "学习 {nome}",
 "Estudar: {c}": "学习：{c}",
 "Estudo": "研究",
 "Estudos": "学习",
 "Estudos e exatas": "学习与理科",
 "Estudos, lazer e viagens": "学习、休闲和旅行",
 "Está em Patrimônio & IR › Recibos dedutíveis. Abra lá para anexar a foto do recibo e o CPF ou CNPJ de quem recebeu.": "它在\"资产与个人所得税 › 可抵扣收据\"中。去那里附上收据照片以及收款人的 CPF 或 CNPJ。",
 "Está na página \"{titulo}\" e em \"Ver arquivos\".": "已保存在页面\"{titulo}\"和\"查看文件\"中。",
 "Etanol": "乙醇",
 "Etapa": "阶段",
 "Etapa do cronograma": "进度阶段",
 "Etapas": "阶段",
 "Evento": "活动",
 "Eventos": "活动",
 "Eventos & Celebrações": "活动与庆典",
 "Evolução (no cofre)": "病程记录（保险库中）",
 "Ex.: 08:00 e 20:00": "例如：08:00 和 20:00",
 "Ex.: 08:00, 14:00 e 20:00": "例如：08:00、14:00 和 20:00",
 "Ex.: 09/2026": "例如：09/2026",
 "Ex.: 1 comprimido": "例如：1 片",
 "Ex.: 1-3, 4-10, 11-": "例如：1-3, 4-10, 11-",
 "Ex.: 1-3, 5, 8-10": "例如：1-3, 5, 8-10",
 "Ex.: 171901 (consultoria), 010101 (programação)": "例如：171901（咨询）、010101（编程）",
 "Ex.: 40 sacos de cimento": "例如：40 袋水泥",
 "Ex.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)": "例如：4106902（Curitiba）、5002704（Campo Grande）、3550308（São Paulo）",
 "Ex.: 8º ano B": "例如：八年级 B 班",
 "Ex.: Alongamento lombar, Dieta 1.800 kcal": "例如：腰部拉伸、1800 千卡饮食",
 "Ex.: Aniversário de 30 anos da Ana": "例如：Ana 的 30 岁生日",
 "Ex.: Apartamento da praia, Suíte 1, Edícula": "例如：海边公寓、套房 1、后院小屋",
 "Ex.: Apartamento na Rua X, 100 ações PETR4": "例如：X 街公寓、100 股 PETR4",
 "Ex.: Aula de revisão, Consulta de retorno": "例如：复习课、复诊",
 "Ex.: Buffet, DJ, decoração, fotógrafo": "例如：餐饮、DJ、装饰、摄影师",
 "Ex.: CONFIDENCIAL, CÓPIA, RASCUNHO": "例如：机密、副本、草稿",
 "Ex.: Cardiologista": "例如：心内科",
 "Ex.: Consultoria mensal": "例如：月度咨询",
 "Ex.: Costela-de-adão da sala": "例如：客厅的龟背竹",
 "Ex.: DAS de setembro, Extrato do Itaú": "例如：9 月的 DAS、Itaú 对账单",
 "Ex.: Desmontar os móveis do quarto": "例如：拆卸卧室家具",
 "Ex.: Disponível · Em aula até 18h · Bora viajar!": "例如：有空 · 上课到 18 点 · 出发旅行！",
 "Ex.: Eletricista, loja de material": "例如：电工、建材店",
 "Ex.: Entrada dos noivos": "例如：新人入场",
 "Ex.: Financiamento do carro": "例如：车贷",
 "Ex.: Fisioterapeuta, Nutricionista, Cardiologista": "例如：物理治疗师、营养师、心脏科医生",
 "Ex.: Furadeira, livro, R$ 200": "例如：电钻、书、R$ 200",
 "Ex.: Hemograma": "例如：血常规",
 "Ex.: IPVA 2027, parcela 1": "例如：IPVA 2027，第 1 期",
 "Ex.: Lisboa, Portugal": "例如：葡萄牙里斯本",
 "Ex.: Mala da Ana": "例如：Ana 的行李箱",
 "Ex.: Mensalidade de outubro, material": "例如：10 月学费、资料费",
 "Ex.: Netflix, cinema": "例如：Netflix、电影院",
 "Ex.: Notas de compra de setembro": "例如：9 月的采购发票",
 "Ex.: Onix 2022": "例如：Onix 2022",
 "Ex.: Prova 1, Trabalho em grupo": "例如：考试 1、小组作业",
 "Ex.: Prova de matemática": "例如：数学考试",
 "Ex.: Pôr do sol no Tejo": "例如：特茹河上的日落",
 "Ex.: Reforma da cozinha": "例如：厨房翻新",
 "Ex.: TAP TP 108": "例如：TAP TP 108",
 "Ex.: Torre de Belém": "例如：贝伦塔",
 "Ex.: Troca da fiação da sala": "例如：更换客厅电线",
 "Ex.: V10, antirrábica": "例如：V10、狂犬疫苗",
 "Ex.: Visita ao Mosteiro dos Jerónimos": "例如：参观热罗尼莫斯修道院",
 "Ex.: cerâmica 30 cm": "例如：30 厘米瓷砖",
 "Ex.: kg, pacotes, latas": "例如：kg、包、罐",
 "Ex.: seg e qua, 07:30": "例如：周一和周三，07:30",
 "Ex.: troquei o arroz por batata doce": "例如：把米饭换成了红薯",
 "Ex.: varanda, sala": "例如：阳台、客厅",
 "Exame": "检查",
 "Exame da OAB": "OAB 律师资格考试",
 "Exames": "检查",
 "Excel": "Excel",
 "Excluir": "删除",
 "Excluir \"{nome}\"?": "删除 \"{nome}\"？",
 "Excluir \"{titulo}\"?": "删除 \"{titulo}\"？",
 "Excluir a caixa?": "删除收纳盒？",
 "Excluir a compra": "删除消费",
 "Excluir a compra?": "删除这笔消费？",
 "Excluir a meta \"{m}\"?": "删除目标\"{m}\"？",
 "Excluir cartão": "删除卡片",
 "Excluir conta": "删除账款",
 "Excluir cuidado": "删除护理项目",
 "Excluir cômodo": "删除房间",
 "Excluir esta página?": "删除此页？",
 "Excluir fichário": "删除活页夹",
 "Excluir matéria": "删除科目",
 "Excluir o cartão \"{c}\"?": "删除卡片\"{c}\"？",
 "Excluir o documento": "删除文档",
 "Excluir o fichário {nome}": "删除活页夹 {nome}",
 "Excluir página": "删除页面",
 "Excluir refeição": "删除餐次",
 "Excluir suplemento": "删除补充剂",
 "Excluir tarefa": "删除任务",
 "Excluir tarefa repetida": "删除重复任务",
 "Excluir tarefa?": "删除任务？",
 "Excluir treino": "删除训练",
 "Excluir {nome}?": "删除 {nome}？",
 "Excluídas em definitivo 30 dias depois do descarte.": "丢弃 30 天后将被永久删除。",
 "Executivo e profissional": "商务与职业",
 "Execução do contrato (art. 7º, V), para entregar o serviço; consentimento (art. 7º, I), para câmera, galeria, microfone e localização; cumprimento de obrigação legal (art. 7º, II); e legítimo interesse (art. 7º, IX), para segurança e prevenção de fraudes.": "履行合同（art. 7º, V），用于提供服务；同意（art. 7º, I），用于相机、相册、麦克风和位置；履行法定义务（art. 7º, II）；以及正当利益（art. 7º, IX），用于安全和防范欺诈。",
 "Exemplos: 13:30, 1330, 9:05": "示例：13:30、1330、9:05",
 "Exercício": "锻炼",
 "Exercício físico": "体育锻炼",
 "Experimente grátis por {n} dias": "免费试用 {n} 天",
 "Explique o motivo (para cancelar)": "说明原因（用于作废）",
 "Exportar arquivo": "导出文件",
 "Exportar para o contador": "导出给会计",
 "Extrair páginas": "提取页面",
 "Extras (pet, check-in tardio...)": "额外费用（宠物、延迟入住...）",
 "Extrato": "流水",
 "Extrato bancário": "银行对账单",
 "Extrato do banco (foto ou PDF)": "银行流水（照片或 PDF）",
 "Extrato importado": "对账单已导入",
 "Extrato por foto": "拍照识别流水",
 "FRASE": "签名",
 "FRÁGIL": "易碎",
 "Fabricante ou estendida: {n} meses": "厂家或延长保修：{n} 个月",
 "Facultativo": "选择性",
 "Falar com a limpeza": "联系保洁",
 "Fale conosco": "联系我们",
 "Falta": "缺席",
 "Falta XML": "缺少 XML",
 "Falta ligar o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar.": "还未连接发票服务器：在电脑上双击 13-LIGAR-NOTAS.bat，然后把显示的地址粘贴到这里。",
 "Falta o Health Connect, o app do Google que junta os dados dos relógios e apps de saúde.": "缺少 Health Connect，这是 Google 的 App，用于汇集手表和健康 App 的数据。",
 "Faltam": "待去",
 "Faltam {ml} ({n} copo(s))": "还差 {ml}（{n} 杯）",
 "Faltam {n} dia(s) do seu período grátis": "免费试用期还剩 {n} 天",
 "Faltam {n} dias": "还剩 {n} 天",
 "Faltou": "未到",
 "Família": "家人",
 "Fantasia": "奇幻",
 "Fatura": "账单",
 "Fatura com vencimento em {d}.": "到期日为 {d} 的账单。",
 "Fatura de {mes}": "{mes}账单",
 "Fatura de {mes}: vence {data}": "{mes}账单：{data} 到期",
 "Fatura do cartão (foto ou PDF)": "信用卡账单（照片或 PDF）",
 "Fatura importada": "账单已导入",
 "Fatura paga (toque para desfazer)": "账单已还（点按撤销）",
 "Fatura {c}": "{c} 账单",
 "Faturamento em {ano}: {v} de {lim}": "{ano} 年营业额：{v} / {lim}",
 "Faturas dos cartões": "信用卡账单",
 "Fazer agora, passo a passo": "立即执行，分步进行",
 "Fazer com este PDF": "对此 PDF 进行操作",
 "Fazer cópia agora": "立即备份",
 "Fecha dia {f} · vence dia {v}": "{f} 日结账 · {v} 日到期",
 "Fecha {f} · vence {v}": "{f} 出账 · {v} 到期",
 "Fechar": "关闭",
 "Fechar o cofre": "关闭保险库",
 "Feche e abra o app de novo": "请关闭后重新打开应用",
 "Federais": "联邦法院",
 "Feijão": "豆子",
 "Feita em {data}": "完成于 {data}",
 "Feita hoje": "今天已完成",
 "Feitas": "已完成",
 "Feitas (não se repetem) · {n}": "已完成（不重复）· {n}",
 "Feito": "已完成",
 "Feito!": "搞定！",
 "Feliz aniversário": "生日快乐",
 "Feminino": "女性",
 "Feminino e suave": "女性柔美",
 "Feriado escolar": "学校假期",
 "Feriado estadual": "州法定假日",
 "Feriado estadual: {nome}": "州假日：{nome}",
 "Feriado municipal": "市法定假日",
 "Feriado municipal: {nome}": "市假日：{nome}",
 "Feriado nacional": "全国法定假日",
 "Feriado nacional: {nome}": "全国假日：{nome}",
 "Feriado regional": "地区假日",
 "Feriado regional: {nome}": "地区假日：{nome}",
 "Feriados": "假日",
 "Feriados nacionais": "全国法定假日",
 "Feriados no planner": "在计划中显示节假日",
 "Feriados, cotações, sugestões da inteligência artificial e leituras automáticas de boletos e notas podem ter erros. Confira antes de usar.": "假日、汇率、人工智能建议以及对付款单和票据的自动识别可能有误。使用前请核对。",
 "Ferramenta": "工具",
 "Ferramentas": "工具",
 "Ficha de cada planta, replantio e calendário de rega e adubo na agenda.": "每株植物的档案、换盆记录，以及日程中的浇水和施肥日历。",
 "Ficha preenchida": "表单已填写",
 "Fichários, matérias e páginas, cronômetro de estudo e metas por semana.": "活页夹、科目和页面，学习计时器和每周目标。",
 "Ficção": "小说",
 "Figurinha": "贴纸",
 "Figurinhas": "贴纸",
 "Filme": "电影",
 "Filme ou série": "电影或剧集",
 "Filmes e séries": "电影和剧集",
 "Filosofia": "哲学",
 "Filtros": "滤清器",
 "Fim": "结束",
 "Fim (vazio = uso contínuo)": "结束（留空 = 长期用药）",
 "Fim da garantia": "保修结束",
 "Fim da garantia:": "保修截止：",
 "Fim da pausa. Continue: {tarefa}": "休息结束。继续：{tarefa}",
 "Fim de semana": "周末",
 "Fim previsto": "预计完成",
 "Fina": "细",
 "Finados": "万灵节",
 "Finalizador": "定型产品",
 "Financeiro": "财务",
 "Financeiro: {gasto} de {orcado} ({p}%)": "资金：{gasto} / {orcado}（{p}%）",
 "Financiamento": "贷款",
 "Financiamento de veículo": "车贷",
 "Financiamento imobiliário": "房贷",
 "Financiamentos": "贷款",
 "Financiamentos e empréstimos": "贷款与借款",
 "Financiamentos e empréstimos com parcelas, juros, saldo devedor e comprovantes; objetos emprestados com foto e aviso da devolução.": "包含分期、利息、剩余欠款和付款凭证的贷款与借款；借出或借入的物品可附照片并提醒归还。",
 "Finanças": "金融",
 "Finanças {p}": "金融 {p}",
 "Finanças · {p}": "金融 · {p}",
 "Fins de semana": "周末",
 "Fio dental": "牙线",
 "Flex": "灵活燃料",
 "Flexão de braço": "俯卧撑",
 "Flor": "花",
 "Flutua": "漂浮",
 "Foguete": "火箭",
 "Fogão": "炉灶",
 "Foi no cartão de crédito? Lançar como compra no cartão": "是用信用卡付的吗？记为信用卡消费",
 "Foi para {destino}.": "已发送到{destino}。",
 "Foi para {destino}. Quer tirar daqui?": "已发送到{destino}。要从这里移除吗？",
 "Folha de pagamento": "工资单",
 "Fone": "听筒",
 "Fone de ouvido": "耳机",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados e das leis de cada estado. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no aparelho.": "来源：巴西假日由应用根据联邦假日公告和各州法律计算。其他国家：公共数据库 Nager.Date (date.nager.at)，通过网络下载并保存在设备上。",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados, das leis de cada estado e dos calendários oficiais das capitais. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no dispositivo.": "来源：巴西的数据由应用根据联邦假日公告、各州法律和各州首府的官方日历计算得出。其他国家：公共数据库 Nager.Date（date.nager.at），通过网络下载并保存在设备上。",
 "Forma": "方式",
 "Forma das parcelas": "还款方式",
 "Forma de pagamento": "付款方式",
 "Forma de pagamento: {f}.": "付款方式：{f}。",
 "Formas": "形状",
 "Formato": "格式",
 "Formatos": "格式",
 "Formatura": "毕业典礼",
 "Fornecedor": "供应商",
 "Fornecedores": "供应商",
 "Forte": "浓",
 "Foto": "照片",
 "Foto da galeria": "从相册选择",
 "Foto do contato": "联系人照片",
 "Foto inteira": "整张照片",
 "Foto ou PDF (lido pela sua IA)": "照片或 PDF（由你的 AI 读取）",
 "Fotografe cada cômodo na vistoria de saída e na de entrada. As fotos protegem você na hora de devolver o imóvel.": "在退房和入住检查时给每个房间拍照。交还房屋时，这些照片能保护你。",
 "Fotografe cada recibo de médico, dentista, escola e previdência assim que pagar. No fim do ano está tudo pronto.": "每次付款后，立即拍下医生、牙医、学校和养老金的收据。到年底就全部准备好了。",
 "Fotos": "照片",
 "Fotos JPG, PNG e outras viram um PDF.": "JPG、PNG 等照片合成一个 PDF。",
 "Fotos de {d}": "{d} 的照片",
 "Fotos do espaço pronto": "清洁完成后的照片",
 "Fotos e arquivos desta ficha também vão para a pasta do grupo, para quem participa abrir.": "此档案的照片和文件也会存入群组文件夹，方便成员打开。",
 "Fotos e arquivos ficam guardados só neste dispositivo. Os dados do documento vão para a sua conta, protegidos.": "照片和文件只保存在此设备上。证件信息会受保护地保存在你的账户中。",
 "Fotos e arquivos ficam neste dispositivo (e no seu Drive ou OneDrive, se estiver ligado em Ajustes).": "照片和文件保存在本设备上（如果在设置中已连接，也会保存到你的 Drive 或 OneDrive）。",
 "Fotos e notas": "照片和笔记",
 "Fotos e vídeos": "照片和视频",
 "Fotos, arquivos e links": "照片、文件和链接",
 "Fraldas e lenços": "尿布和湿巾",
 "Francês": "法语",
 "Frango com osso": "带骨鸡肉",
 "Frango sem osso": "去骨鸡肉",
 "Frase (opcional, ex.: Bom dia!)": "文字（可选，例如：早上好！）",
 "Freelancer & Projetos": "自由职业与项目",
 "Freezer": "冷冻柜",
 "Freios": "刹车",
 "Frente": "正面",
 "Frente do documento": "文档正面",
 "Frente e verso na mesma folha": "正反面在同一页",
 "Frente pronta": "正面完成",
 "Frequência": "频率",
 "Frio": "寒冷",
 "Fruta": "水果",
 "Frágil": "易碎",
 "Fundação e estrutura": "地基和结构",
 "Fundo": "背景",
 "Fundos e renda fixa": "基金和固定收益",
 "Fuso": "时区",
 "Fuso horário": "时区",
 "Fuso horário do destino": "目的地时区",
 "Futebol": "足球",
 "Física": "物理",
 "Físico (obra pronta): {p}%": "实际进度（工程完成）：{p}%",
 "GASTOS POR CATEGORIA": "按类别支出",
 "GIF guardado nos seus GIFs.": "GIF 已保存到你的 GIF。",
 "Garagem": "车库",
 "Garantia": "保修",
 "Garantia até {data}.": "保修至 {data}。",
 "Garantia legal": "法定保修",
 "Garantia vencendo": "保修即将到期",
 "Garantias": "保修",
 "Garrafa de água": "水瓶",
 "Gasolina": "汽油",
 "Gasto": "支出",
 "Gasto até agora": "目前已花费",
 "Gasto de {v} lançado. {n} preço(s) guardado(s) para a sua lista de compras.": "已记录 {v} 的支出。已为你的购物清单保存 {n} 个价格。",
 "Gasto neste mês: {v}": "本月支出：{v}",
 "Gasto: {v}": "已花费：{v}",
 "Gastos": "花费",
 "Gastos por categoria": "分类支出",
 "Gato": "猫",
 "Geladeira": "冰箱",
 "Geografia": "地理",
 "Gerado por": "生成工具",
 "Gerando QR Code...": "正在生成二维码...",
 "Gerar PDF": "生成 PDF",
 "Gerar as cobranças do mês": "生成本月收费",
 "Gerar as parcelas": "生成分期",
 "Gerar lista da mala": "生成行李清单",
 "Gerar pelo cardápio e pela despensa": "根据菜单和食品柜生成",
 "Gesso e forro": "石膏和吊顶",
 "Gira todas as páginas ou só as escolhidas.": "旋转所有页面或仅选中的页面。",
 "Girar": "旋转",
 "Google Drive e OneDrive": "Google Drive 和 OneDrive",
 "Google Drive, OneDrive e agenda do Google: só se você conectar, e só para guardar os seus arquivos e eventos.": "Google Drive、OneDrive 和 Google 日历：仅在你连接后使用，且仅用于保存你的文件和活动。",
 "Gorro, cachecol e luvas": "帽子、围巾和手套",
 "Gota": "水滴",
 "Graduação e Pós": "本科与研究生",
 "Grande": "大",
 "Gravando": "录制中",
 "Gravar lembretes e anotações por voz quando você pedir. O microfone só liga com o seu toque.": "在你需要时用语音录制提醒和笔记。只有你点按后麦克风才会开启。",
 "Gravar reunião": "录制会议",
 "Gravação de áudio": "录音",
 "Gravações das reuniões": "会议录制",
 "Grossa": "粗",
 "Grupo": "分组",
 "Grupo com convite (turma, equipe, convidados)": "邀请制群组（班级、团队、来宾）",
 "Grupo criado": "群组已创建",
 "Grupo da família": "家庭群",
 "Grupo da mudança (família e ajudantes)": "搬家群（家人和帮手）",
 "Grupo da obra (equipe)": "工程群（团队）",
 "Grupo da turma (convidar alunos)": "班级群（邀请学生）",
 "Grupo da viagem (convidar quem vai)": "旅行群（邀请同行者）",
 "Grupo de cuidado (família ou profissional)": "照护群（家人或护理人员）",
 "Grupo de estudos (convidar colegas)": "学习群（邀请同学）",
 "Grupo de leitura (convidar)": "读书群（邀请）",
 "Grupo do cliente": "客户群",
 "Grupo do evento (convidar)": "活动群（邀请）",
 "Grupos": "群组",
 "Grupos de estudo": "学习群",
 "Grupos de {aba}": "{aba} 群组",
 "Grupos desta aba: {n}": "此标签页的群组：{n}",
 "Grupos e convites": "群组和邀请",
 "Grátis no lançamento": "上线期间免费",
 "Guarda-chuva": "雨伞",
 "Guardada nas suas figurinhas.": "已保存到你的贴纸。",
 "Guardado": "已存",
 "Guardado até agora: {v}": "目前已存：{v}",
 "Guardado em outro dispositivo": "保存在其他设备上",
 "Guardado na pasta \"{pasta}\" do celular.": "已保存到手机的 \"{pasta}\" 文件夹。",
 "Guardado no cofre, com criptografia de ponta a ponta.": "已存入保险库，端到端加密。",
 "Guardado no {nome}.": "已保存到 {nome}。",
 "Guardado {onde} em {quando}": "已于 {quando} 保存到 {onde}",
 "Guardando...": "正在保存...",
 "Guardar": "存入",
 "Guardar como recibo do IR": "保存为 IR（个税）收据",
 "Guardar dinheiro": "存钱",
 "Guardar e enviar": "保存并发送",
 "Guardar na meta": "存入目标",
 "Guardar nas minhas figurinhas": "保存到我的贴纸",
 "Guardar nos meus GIFs": "保存到我的 GIF",
 "Guardar o PDF {onde}": "将 PDF 保存到 {onde}",
 "Guardar os PDFs em": "PDF 保存位置",
 "Guardar os arquivos prontos em": "完成的文件保存到",
 "Guardar sozinho cada arquivo pronto": "自动保存每个完成的文件",
 "Guarde as prescrições e orientações que você usa sempre. No atendimento, toque em ⋮ › Usar modelo.": "保存你常用的处方和医嘱。就诊时点按 ⋮ › 使用模板。",
 "Guarde seus documentos num lugar só": "把你的证件集中存放在一处",
 "Guarde {v} por mês até {d}": "每月存 {v}，直到 {d}",
 "Guardou": "储蓄",
 "Guia de imposto": "缴税单",
 "Gás": "燃气",
 "Gênero ou categoria": "类型或分类",
 "HISTÓRICO DOS DADOS": "数据历史",
 "HOJE": "今天",
 "Hall de entrada": "玄关",
 "Halteres": "哑铃",
 "Hexágono": "六边形",
 "Hidratante": "保湿霜",
 "Hidratante labial": "润唇膏",
 "Hidráulica": "给排水",
 "Higiene bucal": "口腔清洁",
 "Higienizar": "清理",
 "História": "历史",
 "Histórico": "病史",
 "Histórico da família, exames protegidos, vacinas, consultas e alarme dos remédios na linha do tempo.": "家庭病史、受保护的检查、疫苗、就诊，以及时间线上的用药闹钟。",
 "Hmm...": "嗯...",
 "Hoje": "今天",
 "Hoje: {a} de {m} aulas ({p}%)": "今天：{a}/{m} 课（{p}%）",
 "Hoje: {n} página(s)": "今天：{n} 页",
 "Hora": "时间",
 "Hora da pausa": "休息时间",
 "Hora de voltar": "该回来了",
 "Hora de voltar!": "该回来了！",
 "Hora do check-in": "入住时间",
 "Hora do check-out": "退房时间",
 "Horas": "小时",
 "Horas de sono": "睡眠时长",
 "Horário": "时间",
 "Horário de check-in": "入住时段",
 "Horário de check-out": "退房时段",
 "Horário do lembrete": "提醒时间",
 "Horário inválido": "时间无效",
 "Horário ocupado": "时间已被占用",
 "Horários": "时间",
 "Horários (remédio diário)": "时间（每日用药）",
 "Hospedados agora": "当前入住",
 "Hospedagem": "住宿",
 "Hospital ou pronto-socorro de referência": "常去的医院或急诊",
 "Hotel": "酒店",
 "Há uma versão nova do My Planner Web. Recarregue para usar.": "My Planner Web 有新版本。请刷新后使用。",
 "Híbrido": "混合动力",
 "Hóspede": "房客",
 "Hóspede ({c})": "房客（{c}）",
 "Hóspedes (máximo)": "最多房客数",
 "IA ligada": "AI 已启用",
 "IA não ligada": "AI 未启用",
 "IA não ligada. Ligue em Ajustes › Inteligência artificial.": "AI 未启用。请在 设置 › 人工智能 中开启。",
 "IPVA": "IPVA",
 "ISS": "ISS",
 "ISS %": "ISS %",
 "ISS retido pelo tomador": "由服务接收方代扣 ISS",
 "Ida": "出发",
 "Identidade": "身份证件",
 "Idioma": "语言",
 "Idiomas": "语言",
 "Ilimitados": "无限",
 "Imagem": "图片",
 "Imagem escolhida (trocar)": "已选图片（更换）",
 "Imagem guardada no {nome}. Toque para abrir.": "图片已保存到 {nome}。点按即可打开。",
 "Imagens para PDF": "图片转 PDF",
 "Imagens {data}": "图片 {data}",
 "Imperdíveis": "必去",
 "Imperdível": "必去",
 "Importar": "导入",
 "Importar XML de nota": "导入发票 XML",
 "Importar arquivo": "导入文件",
 "Importar backup?": "导入备份？",
 "Importar extrato": "导入对账单",
 "Importar extrato do banco (OFX ou CSV)": "导入银行对账单（OFX 或 CSV）",
 "Importar fatura": "导入账单",
 "Importar fotos": "导入照片",
 "Importar reservas do Airbnb, Booking...": "从 Airbnb、Booking 等导入预订",
 "Importar {n} lançamento(s)": "导入 {n} 笔记录",
 "Imóveis e espaços": "房源",
 "Imóvel": "房产",
 "Imóvel inteiro": "整套房源",
 "Imóvel inteiro ou por cômodo: reservas do Airbnb, Booking ou direto, limpeza no check-out, despesas, ocupação e lucro do mês.": "整套或按间出租：Airbnb、Booking 或直接预订、退房清洁、支出、入住率和当月利润。",
 "Inclui {v} das notas fiscais emitidas na aba Notas Fiscais.": "包含\"发票（NF）\"标签页中已开具发票的 {v}。",
 "Independência do Brasil": "巴西独立日",
 "Indicação": "推荐",
 "Indique e ganhe": "推荐有礼",
 "Indique o My Planner para amigos e família. Quem criar a conta com o seu código ganha 10 dias com todas as abas liberadas.": "把 My Planner 推荐给朋友和家人。使用你的代码创建账户的人可获得 10 天全部标签页解锁。",
 "Infantil": "儿童",
 "Informações do PDF": "PDF 信息",
 "Informe a descrição e o valor.": "请填写描述和金额。",
 "Informe de quantos em quantos dias regar ou adubar.": "请填写每隔几天浇水或施肥。",
 "Informe o nome do produto.": "请输入产品名称。",
 "Informe o rótulo e o nome.": "请输入标签和名称。",
 "Informe o total de aulas da matéria em Editar.": "在“编辑”中填写该科目的总课数。",
 "Informe o valor.": "请填写金额。",
 "Informe os horários": "请填写时间",
 "Informe quanto quer juntar.": "请输入想存的金额。",
 "Informe seu nome.": "请输入你的姓名。",
 "Informática": "计算机",
 "Inglês": "英语",
 "Ingredientes (um por linha)": "食材（每行一项）",
 "Inscrição municipal (se tiver)": "市政登记号（如有）",
 "Inspeção": "车检",
 "Instalar ou atualizar o Health Connect": "安装或更新 Health Connect",
 "Instruções, receita, observações...": "说明、食谱、备注...",
 "Insumos (papel, sabonete, café)": "消耗品（纸巾、香皂、咖啡）",
 "Inteligência artificial": "人工智能",
 "Inteligência artificial (Claude, ChatGPT ou Gemini): só se você ligar, com a sua própria chave, que fica apenas no dispositivo. O texto da pergunta vai direto para o serviço escolhido.": "人工智能（Claude、ChatGPT 或 Gemini）：仅在你开启后使用，并使用你自己的密钥，密钥只保存在设备上。提问内容会直接发送到你选择的服务。",
 "Intensidade": "强度",
 "Internação": "住院",
 "Internet": "网络",
 "Intimação": "送达通知",
 "Intimação com prazo": "附期限的送达通知",
 "Investimento": "投资",
 "Investimentos": "投资",
 "Início": "开始",
 "Início {ini} · Fim {fim} · Duração {dur}": "开始 {ini} · 结束 {fim} · 时长 {dur}",
 "Iogurte": "酸奶",
 "Ir para Ajustes (exportar meus dados)": "前往设置（导出我的数据）",
 "Ir para hoje": "回到今天",
 "Ir para o My Planner Web": "前往 My Planner 网页版",
 "Italiano": "意大利语",
 "Item": "条目",
 "Item da despensa": "食品柜物品",
 "Item protegido: fotos e arquivos ficam criptografados no cofre, só neste dispositivo (não vão para o Drive ou OneDrive).": "受保护项目：照片和文件在保险库中加密，仅保存在此设备（不会上传到 Drive 或 OneDrive）。",
 "Itens": "物品",
 "Itens de higiene (xampu, sabonete)": "洗护用品（洗发水、香皂）",
 "Jantar": "晚餐",
 "Japonês": "日语",
 "Jaqueta impermeável": "防水夹克",
 "Jogo": "游戏",
 "Jovem e divertido": "年轻活泼",
 "Juntar PDFs": "合并 PDF",
 "Juros": "利息",
 "Juros ainda por vir: {v}": "未来利息：{v}",
 "Juros ao mês": "月利率",
 "JÁ RESPONDIDOS": "已回复",
 "Já aberta na casa nova": "已在新家拆开",
 "Já enviado para a turma": "已发送给班级",
 "Já está compacto": "已经很精简了",
 "Já está no Planner": "已在 Planner 中",
 "Já está pago": "已付款",
 "Já há horários deste item no My Planner": "My Planner 中已有此项目的时间",
 "Já pago: {v}": "已付：{v}",
 "Já tenho o app: abrir nele": "已安装应用：在应用中打开",
 "Já tenho o app: abrir o convite nele": "我已安装应用：在应用中打开邀请",
 "Já visitei": "已去过",
 "Kit de primeiros socorros": "急救包",
 "Kkkk": "哈哈",
 "Kkkkk": "哈哈哈",
 "Km de hoje no painel": "今天仪表盘上的里程",
 "Km no dia": "当天里程",
 "Km no painel": "仪表盘里程",
 "LANÇAMENTOS": "收支记录",
 "LINHA DO TEMPO": "时间线",
 "Laboratório": "检验机构",
 "Lanche": "小吃",
 "Lanche da manhã": "上午加餐",
 "Lanche da tarde": "下午加餐",
 "Lanches e água": "零食和水",
 "Lançamentos": "收支记录",
 "Lavanderia": "洗衣房",
 "Lavanderia, insumos, manutenção, contas e taxas. Entram no lucro do mês.": "洗衣、消耗品、维修、账单和费用。会计入当月利润。",
 "Lavar o rosto com sabonete facial": "用洗面奶洗脸",
 "Lazer": "休闲",
 "Leg press": "腿举",
 "Legenda": "说明",
 "Legislação Específica": "专门法规",
 "Legumes": "蔬菜",
 "Leia hoje para começar uma sequência": "今天读一点，开始连续记录",
 "Leite": "牛奶",
 "Leitura": "阅读",
 "Leitura automática do texto": "文本自动识别",
 "Leitura da IA": "AI 解读",
 "Leitura, Cursos & Mídia": "阅读、课程与媒体",
 "Lembrete": "提醒",
 "Lembrete de hoje": "今日提醒",
 "Lembrete de renovação no Planner": "在 Planner 中添加续期提醒",
 "Lembrete no Planner": "在 Planner 中提醒",
 "Lembrete no planner": "在计划中提醒",
 "Lembrete pelo WhatsApp": "WhatsApp 提醒",
 "Lembrete: começa às {hora}": "提醒：{hora} 开始",
 "Lemos todas as mensagens. Se precisar, respondemos pelo seu e-mail.": "我们会阅读每一条消息。如有需要，会通过你的电子邮箱回复。",
 "Lendo": "在读",
 "Lendo a fatura...": "正在读取账单...",
 "Lendo a página": "正在读取页面",
 "Lendo o boleto...": "正在读取 Boleto...",
 "Lendo o cupom...": "正在读取小票...",
 "Lendo o documento...": "正在读取证件...",
 "Lendo o extrato...": "正在读取流水...",
 "Lendo o relógio...": "正在读取手表...",
 "Lendo o texto": "正在读取文字",
 "Ler a fatura": "读取账单",
 "Ler a publicação inteira": "阅读完整公告",
 "Ler com a minha IA": "用我的 AI 识别",
 "Ler de novo": "重新读取",
 "Ler de novo agora": "立即重新读取",
 "Ler o texto": "读取文字",
 "Ler o texto completo": "阅读全文",
 "Ler publicação inteira": "阅读完整公告",
 "Ler sozinho as publicações novas": "自动读取新公告",
 "Leve": "轻",
 "Leve (sem perder qualidade)": "轻度（不损失质量）",
 "Li e aceito os termos e a política de privacidade": "我已阅读并接受条款和隐私政策",
 "Li mais {n} páginas": "又读了 {n} 页",
 "Liberada pelo suporte": "由客服开通",
 "Liberar para a equipe": "对团队开放",
 "Liberar para a turma em": "向班级发布日期",
 "Liberar para o grupo": "向群组开放",
 "Liberações e créditos são vinculados ao seu CPF. Atualiza ao sincronizar.": "开通权限和额度与你的 CPF 绑定。同步时更新。",
 "Libere a câmera para o My Planner nas configurações do celular para ler o QR Code.": "请在手机设置中允许 My Planner 使用摄像头，以扫描二维码。",
 "Libere a câmera para o My Planner nas configurações do celular.": "请在手机设置中允许 My Planner 使用相机。",
 "Libere outras abas em Ajustes › Compras.": "在 设置 › 购买 中解锁其他标签页。",
 "Licenciamento": "年检登记",
 "Lidas hoje": "今日已读",
 "Lido": "已读",
 "Ligando. Toque para atender.": "来电中，点击接听。",
 "Ligar": "拨打电话",
 "Ligar certificado": "连接证书",
 "Ligar para a assistência": "致电售后服务",
 "Ligar para {nome}": "致电 {nome}",
 "Ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini) para usar esta ferramenta.": "请在 设置 › 人工智能（Claude、ChatGPT 或 Gemini）中启用你的 AI，才能使用此工具。",
 "Ligue a sua IA em Ajustes › Inteligência artificial para ler o texto, resumir e perguntar sobre o documento.": "请在 设置 › 人工智能 中开启你的 AI，即可读取文字、生成摘要并询问关于文档的问题。",
 "Ligue a sua IA em Ajustes › Inteligência artificial.": "请在 设置 › 人工智能 中开启你的 AI。",
 "Ligue o certificado A1 da empresa primeiro.": "请先连接公司的 A1 证书。",
 "Ligue o seu Google Drive ou OneDrive para guardar fotos e arquivos (que passam a abrir em qualquer dispositivo) e para ter cópias de segurança completas.": "连接你的 Google Drive 或 OneDrive，用来保存照片和文件（可在任何设备上打开），并进行完整备份。",
 "Ligue para o grupo trabalhar nos mesmos dados (obra, viagem, turma, imóvel, consultório), cada pessoa com o seu papel.": "开启后，群组可在同一份数据上协作（工程、旅行、班级、房产、诊所），每人有各自的角色。",
 "Ligue pelo menos 4 pontos.": "请至少连接 4 个点。",
 "Limite anual editável em Ajustes › Abas › Aba Finanças. Confira sempre com o seu contador.": "年度限额可在 设置 › 标签页 › 金融标签页 中修改。请务必与你的会计师核对。",
 "Limite de consultas atingido. Tente de novo em 1 minuto.": "已达到查询上限。请 1 分钟后重试。",
 "Limite de energia por dia": "每日精力上限",
 "Limite de faturamento anual do MEI (confira o valor vigente com o seu contador).": "MEI 年营业额上限（请与你的会计师核对现行数额）。",
 "Limite de mensagens por hoje atingido. Tente amanhã.": "今天的消息数量已达上限。请明天再试。",
 "Limite diário": "每日上限",
 "Limite livre: {v} de {l}": "可用额度：{v} / {l}",
 "Limite total (opcional)": "总额度（可选）",
 "Limpar": "清除",
 "Limpar a agenda": "清理日程",
 "Limpar banheiro": "清洁卫生间",
 "Limpar cozinha e louça": "清洁厨房和餐具",
 "Limpar feitos": "清除已完成",
 "Limpeza": "清洁",
 "Limpeza após {h}": "{h} 退房后清洁",
 "Limpeza final": "最后清洁",
 "Limpeza · {e}": "清洁 · {e}",
 "Limpeza: {e}": "清洁：{e}",
 "Limpezas": "清洁",
 "Linha do tempo, tarefas, energia e alertas.": "时间线、任务、精力和提醒。",
 "Link": "链接",
 "Link (Drive, OneDrive, Dropbox)": "链接（Drive、OneDrive、Dropbox）",
 "Link copiado. Cole onde quiser enviar.": "链接已复制。粘贴到你想发送的地方。",
 "Link da aula ou reunião online (opcional)": "课程或线上会议链接（可选）",
 "Link da nota fiscal (Drive ou OneDrive)": "发票链接（Drive 或 OneDrive）",
 "Link da pasta no Drive ou OneDrive (opcional)": "Drive 或 OneDrive 文件夹链接（可选）",
 "Link da reserva": "预订链接",
 "Link da sala online (Meet, Zoom...)": "线上会议室链接（Meet、Zoom...）",
 "Link de outro calendário (iCal)": "其他日历链接（iCal）",
 "Link do calendário do Airbnb (iCal)": "Airbnb 日历链接（iCal）",
 "Link do calendário do Booking (iCal)": "Booking 日历链接（iCal）",
 "Link inválido": "链接无效",
 "Links de materiais (Drive, vídeos, PDFs), um por linha": "资料链接（Drive、视频、PDF），每行一个",
 "Links: {n}": "链接：{n}",
 "Lista": "列表",
 "Lista da mala": "行李清单",
 "Lista de compras": "购物清单",
 "Lista de exercícios": "习题",
 "Lista rápida": "快速清单",
 "Listas rápidas e caixas que viram tarefa ou vão para outra aba.": "快速清单和收纳盒，可转为任务或发送到其他标签页。",
 "Literatura": "文学",
 "Litros": "升",
 "Livre": "空闲",
 "Livro": "书",
 "Livros": "书籍",
 "Local": "地点",
 "Local ou endereço": "地点或地址",
 "Local: {l}": "地点：{l}",
 "Localização (país e fuso horário)": "位置（国家和时区）",
 "Logo, foto ou rubrica nas páginas.": "在页面上添加标志、照片或简签。",
 "Loja (opcional)": "商店（可选）",
 "Lote": "批号",
 "Lua": "月亮",
 "Lugar": "地点",
 "Lugar para visitar": "想去的地方",
 "Lugares": "地点",
 "Luz": "电",
 "Luz indireta": "散射光",
 "Luz, água, gás e internet": "水电燃气和网络",
 "Lápis": "铅笔",
 "Língua Portuguesa": "葡萄牙语",
 "MAIS ADIANTE": "以后",
 "MAIS USADOS": "最常用",
 "ME ou EPP do Simples": "Simples 的 ME 或 EPP",
 "MEI": "MEI",
 "MEI: faturamento em {ano} de {v} (limite {l}).": "MEI：{ano} 年营业额 {v}（上限 {l}）。",
 "MEMBROS ({n})": "成员（{n}）",
 "METAS": "目标",
 "MS": "MS",
 "Mais": "更多",
 "Mais abas": "更多标签页",
 "Mais cidades entram nas próximas versões.": "更多城市将在后续版本中加入。",
 "Mais emojis": "更多表情",
 "Mais ferramentas": "更多工具",
 "Mais figurinhas animadas (KLIPY)": "更多动态贴纸 (KLIPY)",
 "Mais opções desta aba chegam nas próximas versões.": "此标签页的更多选项将在后续版本中推出。",
 "Mais uma": "再扫一页",
 "Mala": "行李",
 "Mala ({clima}, {n} dias)": "行李（{clima}，{n} 天）",
 "Mamadeiras e leite": "奶瓶和奶粉",
 "Mandamos um código de 6 números no WhatsApp do número {tel}.": "我们已向号码 {tel} 的 WhatsApp 发送了 6 位数验证码。",
 "Mandar as orientações pelo WhatsApp": "通过 WhatsApp 发送医嘱",
 "Mandar de novo": "重新发送",
 "Mandar e-mail": "发送邮件",
 "Mandar lembrete": "发送提醒",
 "Mandar meu código": "发送我的代码",
 "Mandar o acerto para o grupo": "把结算发到群里",
 "Mandar para quem limpa (WhatsApp)": "发给保洁（WhatsApp）",
 "Mandarim": "普通话",
 "Mande um e-mail pedindo a exclusão, com o CPF da conta. Respondemos em até 15 dias.": "发送电子邮件申请删除，并附上账户的证件号。我们会在 15 天内回复。",
 "Manter": "保留",
 "Manter ambas": "两者都保留",
 "Manter ambos": "两者都保留",
 "Manter aqui também": "这里也保留",
 "Manter tarefas": "保留任务",
 "Manutenção": "保养",
 "Manutenções": "保养",
 "Mapas (Apple)": "Apple 地图",
 "Marca d'água": "水印",
 "Marca-texto": "荧光笔",
 "Marcado": "已勾选",
 "Marcado como feito hoje.": "今天已标记为完成。",
 "Marcar como concluída ({dia})": "标记为完成（{dia}）",
 "Marcar como devolvido": "标记为已归还",
 "Marcar como feita hoje": "标记为今天已完成",
 "Marcar como lido": "标为已读",
 "Marcar como paga": "标记为已付",
 "Marcar como pago": "标记为已付",
 "Marcar como quitado": "标记为已还清",
 "Marcar como recebida": "标记为已收",
 "Marcar como recebida?": "标记为已收？",
 "Marcar como recebido": "标记为已收",
 "Marcar como visto": "标记为已查看",
 "Marcar e avisar a equipe": "安排并通知团队",
 "Marcar esta conta como paga?": "将这笔账款标记为已付？",
 "Marcar fatura como paga": "标记账单为已还",
 "Marcar grupo": "选择该组",
 "Marcar reunião": "安排会议",
 "Marcenaria": "木工",
 "Margem": "边距",
 "Marketing": "市场营销",
 "Marque as fotos do diário como Antes ou Depois para montar a galeria.": "将日志照片标记为“之前”或“之后”，即可生成图库。",
 "Marque os dias em que você estuda e o horário de cada dia. Cada dia vira uma tarefa que se repete toda semana, ligada a este item.": "勾选你学习的日子以及每天的时间。每一天都会变成一个每周重复的任务，并与此项目关联。",
 "Marque um ou mais estados.": "请勾选一个或多个州。",
 "Martelo": "锤子",
 "Masculino": "男性",
 "Masculino e minimalista": "男性简约",
 "Matemática": "数学",
 "Materiais": "资料",
 "Material": "材料",
 "Matrícula, placa, código ou CNPJ": "登记号、车牌、代码或 CNPJ",
 "Matéria ou material": "科目或资料",
 "Matéria ou módulo": "科目或模块",
 "Matérias": "科目",
 "Meia-sombra": "半阴",
 "Melhorando a imagem...": "正在优化图片...",
 "Melhorias novas já foram baixadas. Leva só alguns segundos e seus dados continuam.": "新的改进已下载完成。只需几秒钟，你的数据会保留。",
 "Membros": "成员",
 "Menos de 1 minuto": "不到 1 分钟",
 "Mensagem": "消息",
 "Mensagem apagada": "消息已删除",
 "Mensagem enviada. Obrigado!": "消息已发送。谢谢！",
 "Mensagem ou observações": "留言或备注",
 "Mensagens": "消息",
 "Mensagens que você envia em Fale conosco.": "你在 联系我们 中发送的消息。",
 "Mensagens: a sua lista de amigos, as conversas, as fotos e os arquivos enviados ficam guardados no servidor para chegar aos outros dispositivos. As chamadas de áudio e vídeo não são gravadas.": "消息：你的好友列表、聊天、发送的照片和文件会保存在服务器上，以便同步到其他设备。语音和视频通话不会被录音。",
 "Mensalidade de {m}": "{m} 月费",
 "Mensalidade ou valor por aluno": "月费或每位学生金额",
 "Mensalidades, aulas avulsas e materiais. Em ⋮ da turma, \"Gerar as cobranças do mês\" cria uma para cada aluno.": "月费、单次课和资料费。在班级的 ⋮ 中选择“生成本月收费”，会为每位学生各生成一笔。",
 "Mercado": "超市",
 "Mesa flexora": "俯卧腿弯举",
 "Mestre Achado": "Mestre Achado",
 "Mestre de obras": "工长",
 "Meta": "目标",
 "Meta 100% batida": "目标 100% 完成",
 "Meta atingida": "目标已达成",
 "Meta atingida!": "目标达成！",
 "Meta da semana: {dur}": "本周目标：{dur}",
 "Meta de aulas": "课程目标",
 "Meta de aulas batida": "课程目标已完成",
 "Meta de copos por dia": "每日目标杯数",
 "Meta de páginas por dia": "每日阅读页数目标",
 "Meta de páginas, progresso e resumos dos livros, filmes e séries para ver e aulas dos cursos.": "阅读页数目标、进度，以及书籍、想看的电影和剧集的摘要，还有课程的课时。",
 "Meta diária": "每日目标",
 "Meta por dia": "每日目标",
 "Meta por semana:": "每周目标：",
 "Meta {meta} · copo de {copo} · {n} copos": "目标 {meta} · 每杯 {copo} · {n} 杯",
 "Metas": "目标",
 "Metodologia Científica": "科研方法",
 "Meu caderno": "我的笔记本",
 "Meu cartão de contato": "我的联系人名片",
 "Meu plano": "我的套餐",
 "Meus GIFs ({n})": "我的 GIF ({n})",
 "Meus PDFs": "我的 PDF",
 "Meus dados": "我的信息",
 "Meus dados profissionais": "我的职业信息",
 "Microchip": "芯片",
 "Microfone": "麦克风",
 "Microscópio": "显微镜",
 "Militares estaduais": "州军事法院",
 "Minha Casa": "我的家",
 "Minha conta": "我的账户",
 "Minhas anotações do livro": "我的读书笔记",
 "Minhas figurinhas": "我的贴纸",
 "Minutos": "分钟",
 "Minutos de exercício": "锻炼分钟数",
 "Mirante": "观景台",
 "Mirantes": "观景台",
 "Modelo": "模型",
 "Modelo de prescrição": "处方模板",
 "Modelos": "模板",
 "Modificado em": "修改时间",
 "Modo": "模式",
 "Modo de preparo": "做法",
 "Modo seguro: tarefas automáticas desligadas até abrir o app de novo": "安全模式：自动任务已关闭，重新打开应用后恢复",
 "Moeda": "货币",
 "Moeda: {m}": "货币：{m}",
 "Moedas": "硬币",
 "Momento do evento": "活动环节",
 "Monitor do Diário de Justiça Eletrônico (DJEN) por nome e OAB.": "按姓名和 OAB 号码监控电子司法公报（DJEN）。",
 "Monitor ou co-professor": "助教或合作教师",
 "Montando o PDF: página {n} de {total}...": "正在生成 PDF：第 {n} 页，共 {total} 页...",
 "Montar a mala pelo clima ({n} dias)": "按天气准备行李（{n} 天）",
 "Monte o cronograma alimentar para ver o relatório.": "请先制定饮食计划，再查看报告。",
 "Monte o roteiro dia a dia. No período da viagem, ele aparece na linha do tempo do My Planner.": "逐日安排行程。旅行期间，行程会显示在 My Planner 的时间线上。",
 "Monte seu cronograma alimentar e seus cuidados abaixo. O que for de hoje aparece aqui para marcar.": "在下方设置你的饮食计划和护理项目。今天的内容会显示在这里供你勾选。",
 "Monte seu cronograma alimentar, cuidados, treinos e suplementos abaixo. O que for de hoje aparece aqui para marcar.": "在下方设置你的饮食计划、护理、训练和补充剂。今天的项目会显示在这里供你勾选。",
 "Monte seus treinos com atividades prontas: aparelhos da academia, exercícios em casa, caminhada, corrida, yoga, pilates...": "用现成的活动组合你的训练：健身器械、居家锻炼、健走、跑步、瑜伽、普拉提……",
 "Mostrando as 120 mais recentes.": "显示最近的 120 张。",
 "Mostrando só o roteiro. {n} tarefa(s) do dia escondida(s).": "仅显示行程。已隐藏当天 {n} 项任务。",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. Não usamos o GPS.": "根据你所在的地方显示正确的日期、时间、货币和假日。我们不使用 GPS。",
 "Mostrar menos": "收起",
 "Mostrar só o roteiro durante a viagem": "旅行期间只显示行程",
 "Motivo do cancelamento": "作废原因",
 "Moto": "摩托车",
 "Mover": "移动",
 "Mover para hoje": "移到今天",
 "Mudança": "搬家",
 "Mudança: {para}": "搬家：{para}",
 "Mudanças": "搬家",
 "Mudar e-mail": "更改邮箱",
 "Mudar o nome": "重命名",
 "Mudar senha": "更改密码",
 "Mudo": "静音",
 "Muitas tentativas": "尝试次数过多",
 "Muitas tentativas erradas. Tente de novo em {s} segundos.": "错误次数过多。请在 {s} 秒后重试。",
 "Muitas tentativas. Aguarde alguns minutos.": "尝试次数过多。请稍等几分钟。",
 "Muito bem: já guardou {v} este mês. Constância vale mais que valor alto.": "很好：本月已经存了 {v}。坚持比金额大更重要。",
 "Multa": "罚款",
 "Multa e juros": "滞纳金和利息",
 "Multa e juros de {v}": "滞纳金和利息 {v}",
 "Multa e juros estimados: {v}": "预估罚款和利息：{v}",
 "Multas e juros pagos": "已付滞纳金和利息",
 "Mundo": "世界",
 "Municipal": "市级",
 "Município da prestação (IBGE), se for outro": "服务提供地城市（IBGE），如不同",
 "Município da prestação (código IBGE, 7 números)": "服务提供地城市（IBGE 代码，7 位数字）",
 "Mural": "公告",
 "Museu": "博物馆",
 "Museus": "博物馆",
 "My Planner (vira tarefa)": "My Planner（转为任务）",
 "My Planner bloqueado": "My Planner 已锁定",
 "Máxima": "最高",
 "Média": "中",
 "Média para aprovação": "及格平均分",
 "Média · repouso {n}": "平均 · 静息 {n}",
 "Médico": "医生",
 "Médico ou clínica": "医生或诊所",
 "Médio": "中",
 "Mês": "月份",
 "Mês a mês": "按月",
 "Mês atual": "本月",
 "Mês passado": "上个月",
 "Móveis e enxoval": "家具和床品",
 "Móvel": "家具",
 "Música": "音乐",
 "NAS ABAS": "在各标签页中",
 "NF-e: a SEFAZ pede 1 hora entre as buscas. Próxima a partir das {h}.": "NF-e：SEFAZ 要求两次查询间隔 1 小时。下次可在 {h} 之后查询。",
 "NF-e: informe a UF da empresa para buscar as notas de produtos.": "NF-e：请填写公司所在州（UF）以查询商品发票。",
 "NFS-e emitida": "NFS-e 已开具",
 "NFS-e: {m}": "NFS-e：{m}",
 "Na (opcional):": "星期（可选）：",
 "Na agenda": "已加入日程",
 "Na agenda em {data}": "已加入 {data} 的日程",
 "Na barra": "在标签栏",
 "Na demonstração não há servidor de notas. Use o app com a sua conta.": "演示模式没有发票服务器。请用你的账户使用应用。",
 "Na hora": "立即",
 "Na hora da pausa aparece um aviso grande na tela, com contagem regressiva.": "到休息时间时，屏幕上会显示一个带倒计时的大提示。",
 "Na linha do tempo, tocar no temporizador também abre esta página.": "在时间线上点击计时器也会打开此页面。",
 "Na pasta \"{pasta}\" do celular. Cada arquivo pronto vai para lá.": "在手机的 \"{pasta}\" 文件夹中。每个完成的文件都会存到那里。",
 "Na pasta \"{pasta}\" do celular. Cada documento novo vai para lá quando você sai dele.": "在手机的 \"{pasta}\" 文件夹中。每个新文档在你离开时都会保存到那里。",
 "Na prévia de demonstração não há chamadas de verdade.": "演示预览中没有真实通话。",
 "Na prévia de demonstração não há gravação de verdade.": "演示预览中没有真实的录制。",
 "Na prévia de demonstração os arquivos não abrem.": "演示预览中无法打开文件。",
 "Na versão das lojas, a compra será pela Google Play ou pela App Store. Por enquanto a chave simula a assinatura para testes.": "在应用商店版本中，将通过 Google Play 或 App Store 购买。目前此开关仅用于模拟订阅以供测试。",
 "Na versão das lojas, este botão abre a compra da Google Play ou da App Store.": "在应用商店版本中，此按钮会打开 Google Play 或 App Store 的购买页面。",
 "Nacional": "全国",
 "Nada a gerar": "没有可生成的",
 "Nada encontrado.": "未找到任何内容。",
 "Nada entra na agenda de ninguém sem autorização: cada pessoa aceita, edita ou recusa.": "未经同意，任何内容都不会进入他人的日程：每个人都可以接受、编辑或拒绝。",
 "Nada foi registrado.": "没有任何记录。",
 "Nada lançado neste mês.": "本月暂无记录。",
 "Nada no mês": "本月没有记录",
 "Nada no roteiro deste dia.": "这一天没有行程。",
 "Nada para apagar com esse filtro.": "此筛选条件下没有可删除的内容。",
 "Nada para comprar": "没有要买的东西",
 "Nada para enviar.": "没有可发送的内容。",
 "Nada planejado para este dia": "这一天没有安排",
 "Nada planejado para hoje. Bom dia!": "今天没有安排。早上好！",
 "Nada por aqui.": "这里什么也没有。",
 "Nada recebido ainda.": "还没有收到任何内容。",
 "Nas conversas, cada pessoa vê o seu nome e o que você manda ali. Você pode apagar uma mensagem para todos, sair de um grupo ou bloquear alguém.": "在聊天中，每个人都能看到你的名字和你在那里发送的内容。你可以为所有人删除消息、退出群组或屏蔽某人。",
 "Nascimento": "出生",
 "Natal": "圣诞节",
 "Natação": "游泳",
 "Navegador conectado": "浏览器已连接",
 "Negrito": "粗体",
 "Negócios": "商业",
 "Nenhum": "无",
 "Nenhum XML neste período (ou foram guardados em outro dispositivo).": "此期间没有 XML（或保存在其他设备上）。",
 "Nenhum amigo para adicionar. Convide pelo WhatsApp ou adicione amigos no Mensagens (código do amigo).": "没有可添加的好友。通过 WhatsApp 邀请，或在消息中添加好友（好友代码）。",
 "Nenhum arquivo, imagem ou link nas páginas desta matéria.": "此科目的页面中没有文件、图片或链接。",
 "Nenhum arquivo.": "没有文件。",
 "Nenhum atendimento pago neste mês.": "本月没有已付款的就诊。",
 "Nenhum cartão": "没有卡片",
 "Nenhum comprovante guardado ainda. Ao pagar uma conta, toque nela e anexe a foto, o PDF ou o print do comprovante.": "还没有保存任何凭证。付款后，点击该账款并附上凭证的照片、PDF 或截图。",
 "Nenhum cômodo ainda": "还没有房间",
 "Nenhum dia": "不选日期",
 "Nenhum documento ainda.": "还没有文档。",
 "Nenhum documento neste filtro.": "此筛选下没有证件。",
 "Nenhum e-mail cadastrado": "未登记邮箱",
 "Nenhum erro registrado. Se o app fechar sozinho ou uma tela der problema, o erro aparece aqui para você mandar para a equipe.": "暂无错误记录。如果应用自行关闭或某个页面出错，错误会显示在这里，方便你发送给团队。",
 "Nenhum feriado neste ano.": "今年没有假日。",
 "Nenhum fichário ainda": "还没有活页夹",
 "Nenhum grupo ainda.": "还没有群组。",
 "Nenhum item em {nome}": "{nome}中没有项目",
 "Nenhum lançamento encontrado": "未找到记录",
 "Nenhum país encontrado.": "未找到国家。",
 "Nenhum selecionado": "未选择",
 "Nenhuma (plano gratuito)": "无（免费套餐）",
 "Nenhuma aba encontrada.": "未找到标签页。",
 "Nenhuma aba fixada além do My Planner.": "除 My Planner 外，没有固定的标签页。",
 "Nenhuma aba liberada para receber": "没有可接收的已解锁标签页",
 "Nenhuma agenda encontrada": "未找到日历",
 "Nenhuma agenda para trazer": "没有可导入的日历",
 "Nenhuma audiência ou prazo encontrado nesta publicação.": "此公告中未发现庭审或期限。",
 "Nenhuma caixa arquivada. Arraste uma caixa para a esquerda para arquivar.": "没有已归档的收纳盒。将收纳盒向左滑动即可归档。",
 "Nenhuma compra encontrada": "未找到消费",
 "Nenhuma compra nesta fatura.": "此账单没有消费。",
 "Nenhuma conta a pagar cadastrada.": "没有应付账款。",
 "Nenhuma conta a receber cadastrada.": "没有应收账款。",
 "Nenhuma conta neste mês. Toque em + para cadastrar (aluguel, luz, cartão...).": "本月没有账单。点按 + 添加（房租、电费、信用卡...）。",
 "Nenhuma cópia de segurança ainda.": "还没有备份。",
 "Nenhuma cópia encontrada.": "未找到备份。",
 "Nenhuma garantia ativa. Cadastre com o +.": "没有有效的保修。点击 + 添加。",
 "Nenhuma garantia vencida.": "没有已过期的保修。",
 "Nenhuma mensagem ainda. Diga oi! 👋": "还没有消息。打个招呼吧！👋",
 "Nenhuma nota neste período.": "此期间没有发票。",
 "Nenhuma opção ainda.": "还没有选项。",
 "Nenhuma publicação nova.": "没有新公告。",
 "Nenhuma refeição neste dia.": "这一天没有餐次。",
 "Nenhuma reunião marcada.": "没有已安排的会议。",
 "Nesse ritmo, termina em {d}": "按这个节奏，将于 {d} 完成",
 "Nesta fase de lançamento, todas as abas estão liberadas e grátis.": "在上线阶段，所有标签页均已解锁并免费。",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF ou e-mail.": "测试阶段，密码由客服重置。请发送邮件至 {email}，并提供你的 CPF 或电子邮箱。",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF.": "在测试阶段，密码由客服重置。请发送邮件至 {email} 并注明你的 CPF。",
 "Neve": "雪地",
 "Ninguém deve nada a ninguém.": "互不相欠。",
 "Ninguém entrou ainda. Envie o convite.": "还没有人加入。发送邀请吧。",
 "Ninguém usou o seu código ainda.": "还没有人使用你的代码。",
 "No Android, o app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "在 Android 上，应用只保存所选文件的快捷方式：文件仍留在原处（Drive、OneDrive、下载），并在手机应用中打开。不会复制任何内容。此选项适用于用相机拍摄的照片。",
 "No Google Drive ou OneDrive: {n}": "在 Google Drive 或 OneDrive 中：{n}",
 "No Google Drive, o app só enxerga os arquivos que ele mesmo criou na pasta My Planner. O uso das informações recebidas das APIs do Google segue a Política de Dados do Usuário dos Serviços de API do Google, inclusive as regras de Uso Limitado: nada é vendido, usado para publicidade ou lido por pessoas, salvo com a sua autorização ou por obrigação legal.": "在 Google Drive 中，应用只能看到它自己在 My Planner 文件夹中创建的文件。对从 Google API 获得的信息的使用遵守《Google API 服务用户数据政策》，包括其中的“有限使用”要求：除非获得您的授权或依法须为之，否则不会出售任何信息、不会将其用于广告，也不会由人工读取。",
 "No app do seu relógio (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), ligue a opção \"Health Connect\" ou \"Sincronizar com o Health Connect\".": "在手表的 App 中（Samsung Health、Garmin Connect、Mi Fitness、Zepp、Fitbit、Amazfit、Google Fit...），打开 \"Health Connect\" 或 \"与 Health Connect 同步\" 选项。",
 "No app novo (versão 0.49), o celular acha as bordas da folha sozinho. Nesta versão, ajuste os 4 cantos com o dedo.": "在新版应用（0.49 版）中，手机会自动找到纸张边缘。在此版本中，请用手指调整 4 个角。",
 "No centro": "居中",
 "No computador, abra {url}, toque no botão acima e aponte a câmera para o QR Code da tela.": "在电脑上打开 {url}，点击上方按钮，然后用摄像头对准屏幕上的二维码。",
 "No dia (opcional):": "日期（可选）：",
 "No iPhone, o app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "在 iPhone 上，应用会打开 \"存储到文件\"，让你选择文件夹（也可以是 iCloud Drive）。",
 "No início": "开始时",
 "No modo seguro o app abre sem as tarefas automáticas (avisos, agenda do Google, publicações, mensagens e relógio). Os seus dados não mudam e tudo volta ao normal na próxima vez que abrir.": "安全模式下，应用打开时不运行自动任务（提醒、Google 日历、公告、消息和手表）。你的数据不会改变，下次打开时一切恢复正常。",
 "No navegador, as páginas ficam só enquanto esta página estiver aberta.": "在浏览器中，页面只在此页面打开期间保留。",
 "No navegador, cole o link do arquivo do Drive, OneDrive ou Dropbox (em Estudos ou Documentos, opção Link). No celular, o botão de arquivo já mostra o Drive e o OneDrive.": "在浏览器中，粘贴 Drive、OneDrive 或 Dropbox 中文件的链接（在“学习”或“证件”中选择“链接”）。在手机上，文件按钮会直接显示 Drive 和 OneDrive。",
 "No navegador, o PDF é baixado para o computador.": "在浏览器中，PDF 会下载到电脑。",
 "No navegador, só dá para guardar imagens pequenas (até 200 KB). Para outros arquivos, adicione um link do Drive, OneDrive ou Dropbox, ou use o app no celular.": "在浏览器中只能保存小图片（最大 200 KB）。其他文件请添加 Drive、OneDrive 或 Dropbox 的链接，或使用手机上的应用。",
 "No outro app, copie o link do arquivo (Compartilhar › Copiar link) e cole no bloco de link que ficou nesta página.": "在其他应用中复制文件链接（分享 › 复制链接），然后粘贴到此页面上的链接块中。",
 "No ritmo atual, o ano fecha em {v}.": "按当前速度，全年将达到 {v}。",
 "No seu fuso: {hora}{dia}": "你的时区：{hora}{dia}",
 "Nome": "名称",
 "Nome (cliente ou fornecedor)": "名称（客户或供应商）",
 "Nome (ex.: 8º ano B, Pacientes da clínica, Aniversário da Ana)": "名称（例如：八年级B班、诊所患者、Ana 的生日）",
 "Nome (ex.: Almoço)": "名称（例：午餐）",
 "Nome (ex.: Aluguel recebido, Cliente X)": "名称（例如：收到的房租、客户 X）",
 "Nome (ex.: Aluguel, Luz, Internet)": "名称（例如：房租、电费、网费）",
 "Nome (ex.: Doutorado UFPR)": "名称（例：UFPR 博士）",
 "Nome (ex.: Nubank, Itaú Visa)": "名称（例：Nubank、Itaú Visa）",
 "Nome (ex.: Skincare da noite)": "名称（例：夜间护肤）",
 "Nome (ex.: Treino A)": "名称（例如：训练 A）",
 "Nome (ex.: Viagem de férias, Reserva de emergência)": "名称（例：假期旅行、应急储备金）",
 "Nome (ex.: Vitamina C)": "名称（例如：维生素C）",
 "Nome (opcional)": "名称（可选）",
 "Nome (opcional, ex.: CNH do Walter)": "名称（可选，例如：Walter 的 CNH）",
 "Nome (pode editar, ex.: \"Suco de uva\")": "名称（可编辑，例如：“葡萄汁”）",
 "Nome completo": "全名",
 "Nome curto": "简称",
 "Nome da lista": "清单名称",
 "Nome da matéria": "科目名称",
 "Nome da obra": "工程名称",
 "Nome da pasta (ex.: Recibos, Contratos)": "文件夹名称（例如：收据、合同）",
 "Nome da tarefa": "任务名称",
 "Nome da tarefa (ex.: Academia)": "任务名称（例如：健身房）",
 "Nome da tarefa (ex.: Limpar o banheiro)": "任务名称（例如：打扫卫生间）",
 "Nome do PDF (opcional)": "PDF 名称（可选）",
 "Nome do conselho": "执业协会名称",
 "Nome do cômodo": "房间名称",
 "Nome do documento": "文档名称",
 "Nome do escritório (ex.: Ravasco Contabilidade)": "办公室名称（例如：Ravasco Contabilidade）",
 "Nome do evento": "活动名称",
 "Nome do grupo (ex.: Família)": "群组名称（例如：家人）",
 "Nome do modelo": "模板名称",
 "Nome ou modelo": "名称或型号",
 "Nome ou razão social": "姓名或公司名称",
 "Nome, subtarefa ou anotação": "名称、子任务或笔记",
 "Nos grupos, cada pessoa responde pelo que inclui. Quem administra o grupo decide quem participa.": "在群组中，每个人对自己添加的内容负责。群组管理员决定谁可以参与。",
 "Nossa Senhora Aparecida": "阿帕雷西达圣母节",
 "Nossa Senhora da Luz dos Pinhais": "松林光明圣母节",
 "Nota cancelada": "发票已作废",
 "Nota fiscal": "发票",
 "Nota fiscal emitida": "已开具发票",
 "Nota fiscal, certificado de garantia e fotos": "发票、保修卡和照片",
 "Nota importada": "已导入的发票",
 "Notas": "发票",
 "Notas Fiscais": "发票（NF）",
 "Notebook e carregador": "笔记本电脑和充电器",
 "Nova avaliação": "新评估",
 "Nova caixa (ex.: Compras, Ideias)": "新收纳盒（例：购物、想法）",
 "Nova conversa": "新聊天",
 "Nova garantia": "新保修",
 "Nova matéria": "新科目",
 "Nova meta": "新目标",
 "Nova pasta": "新建文件夹",
 "Nova página": "新页面",
 "Nova página com esta caixa": "用此收纳盒新建页面",
 "Nova refeição": "新餐次",
 "Nova tarefa": "新任务",
 "Nova tarefa da casa": "新家务",
 "Nova tarefa neste cômodo": "在此房间新建任务",
 "Novas": "新的",
 "Novo": "新建",
 "Novo alerta:": "新提醒：",
 "Novo cartão": "新卡片",
 "Novo cartão de crédito": "新信用卡",
 "Novo cuidado": "新护理项目",
 "Novo documento": "新证件",
 "Novo e-mail": "新邮箱",
 "Novo fichário": "新活页夹",
 "Novo grupo": "新建群组",
 "Novo item": "新项目",
 "Novo perfil": "新档案",
 "Novo suplemento": "新补充剂",
 "Novo treino": "新训练",
 "Novo: {nome}": "新建：{nome}",
 "Novos": "新的",
 "Num período": "按时间段",
 "Numere cada caixa e diga o cômodo e o conteúdo. Use a busca para achar onde está cada coisa.": "给每个箱子编号，并注明房间和内容。用搜索功能找到每样东西在哪里。",
 "Nº": "编号",
 "Não": "否",
 "Não achei o total no cupom. Tente uma foto mais nítida.": "小票上没找到总额。请试试更清晰的照片。",
 "Não consegue entrar?": "无法登录？",
 "Não consegui abrir \"{nome}\". Tente a ferramenta Reparar PDF.": "无法打开 \"{nome}\"。请试试\"修复 PDF\"工具。",
 "Não consegui conectar a chamada. Confira a internet e tente de novo.": "无法接通通话。请检查网络后重试。",
 "Não deu certo: {msg}": "未成功：{msg}",
 "Não deu para diminuir mais este PDF ({tam}).": "此 PDF 无法再缩小了（{tam}）。",
 "Não dá para tirar todas as páginas.": "不能删除所有页面。",
 "Não encontrei texto neste PDF.": "此 PDF 中未找到文字。",
 "Não encontrei texto neste documento.": "在此文档中未找到文字。",
 "Não foi possível": "无法完成",
 "Não foi possível abrir": "无法打开",
 "Não foi possível abrir o certificado guardado. Ligue o certificado de novo.": "无法打开已保存的证书。请重新连接证书。",
 "Não foi possível abrir.": "无法打开。",
 "Não foi possível baixar os feriados deste país. Confira a internet.": "无法下载该国家的假日。请检查网络连接。",
 "Não foi possível conectar": "无法连接",
 "Não foi possível conectar o {nome}": "无法连接 {nome}",
 "Não foi possível consultar o DJEN agora.": "目前无法查询 DJEN。",
 "Não foi possível continuar": "无法继续",
 "Não foi possível criar um evento na agenda: {msg}": "无法在日历中创建活动：{msg}",
 "Não foi possível entrar.": "无法登录。",
 "Não foi possível enviar": "无法发送",
 "Não foi possível enviar.": "无法发送。",
 "Não foi possível guardar: {erro}": "无法保存：{erro}",
 "Não foi possível ler o arquivo.": "无法读取文件。",
 "Não foi possível ler o calendário. Confira o link em Editar.": "无法读取日历。请在“编辑”中检查链接。",
 "Não foi possível procurar agora. Tenta de novo sozinho mais tarde.": "目前无法搜索。稍后会自动重试。",
 "Não foi possível reiniciar sozinho.": "无法自动重启。",
 "Não foi possível sincronizar com a agenda: {msg}": "无法与日历同步：{msg}",
 "Não foi possível trocar a foto": "无法更换照片",
 "Não há garantia de aviso com o app fechado. A verificação ocorre ao abrir o app (a cada 6 horas) ou em \"Verificar agora\".": "应用关闭时无法保证收到通知。检查会在打开应用时（每 6 小时）或点击\"立即检查\"时进行。",
 "Não identificado": "未识别",
 "Não marcada como feita": "未标记为完成",
 "Não optante pelo Simples": "未加入 Simples",
 "Não se repete": "不重复",
 "Não use o app para atividades ilegais, para guardar conteúdo de terceiros sem autorização ou para tentar acessar dados de outras pessoas.": "请勿将本应用用于违法活动、未经授权存储他人内容，或试图访问他人的数据。",
 "Não vai": "不参加",
 "Não vence": "不过期",
 "Não vendemos seus dados e não usamos o seu conteúdo para publicidade.": "我们不出售你的数据，也不将你的内容用于广告。",
 "Não é possível adicionar esta pessoa.": "无法添加此人。",
 "Não é um XML de nota fiscal": "不是发票 XML",
 "Número": "号码",
 "Número (opcional)": "号码（可选）",
 "Número da OAB": "OAB 号码",
 "Número da caixa": "箱子编号",
 "Número da carteirinha": "会员卡号",
 "Número da guia do convênio": "医保单号",
 "Número da parcela": "期数",
 "Número de hóspedes": "房客人数",
 "Número de parcelas": "分期期数",
 "Número do contrato": "合同编号",
 "Número do registro": "注册编号",
 "Número na chamada": "点名序号",
 "Número {n}. O XML ficou guardado na nota. Toque nela para ver o PDF.": "编号 {n}。XML 已保存在发票中。点按发票可查看 PDF。",
 "Número, órgão emissor e observações ficam criptografados (AES-256) no aparelho antes de ir para a nuvem.": "号码、签发机关和备注会先在设备上加密（AES-256），再上传到云端。",
 "Número, órgão emissor, observações, fotos e PDFs ficam criptografados (AES-256) no dispositivo. Os arquivos protegidos ficam só neste dispositivo.": "号码、签发机关、备注、照片和 PDF 都会在设备上加密（AES-256）。受保护的文件仅保存在此设备。",
 "Número: {n}": "号码：{n}",
 "Números de página": "页码",
 "O ChatGPT não lê PDF por aqui. Tire uma foto ou um print da página, ou use o Claude ou o Gemini em Ajustes › Inteligência artificial.": "ChatGPT 在这里无法读取 PDF。请拍照或截图该页面，或在 设置 › 人工智能 中使用 Claude 或 Gemini。",
 "O DAS vence dia {dia}. Marque como pago em Finanças.": "DAS 于 {dia} 日到期。缴纳后请在金融中标记为已付。",
 "O Escritório ainda não foi ligado no servidor. No computador, rode o 29-SERVIDOR-0.45.bat (uma vez só).": "服务器上尚未启用办公室功能。请在电脑上运行 29-SERVIDOR-0.45.bat（仅需一次）。",
 "O Mestre Achado cuida do seu dinheiro: contas, cartões e faturas, orçamento por categoria, metas, extrato e cupom pela foto, relatório e MEI.": "Mestre Achado 帮你管钱：账款、信用卡和账单、分类预算、目标、拍照识别流水和小票、报告以及 MEI。",
 "O Mestre está pensando...": "大师正在思考...",
 "O My Planner cria a pasta \"My Planner\" no seu Drive e só enxerga o que ele mesmo guardou lá.": "My Planner 会在你的 Drive 中创建“My Planner”文件夹，并且只能看到它自己保存在那里的内容。",
 "O My Planner já abriu no computador, com os seus dados.": "My Planner 已在电脑上打开，并载入了你的数据。",
 "O My Planner lê os dados do relógio pelo {fonte}, onde o relógio e os apps de saúde e de exercício guardam tudo.": "My Planner 通过 {fonte} 读取手表数据，手表以及健康和运动 App 的数据都保存在那里。",
 "O My Planner organiza a sua agenda, tarefas, finanças, documentos e outras áreas da vida. É oferecido por Walter Ravasco da Costa, que é o controlador dos dados pessoais tratados no app.": "My Planner 帮你管理日程、任务、财务、文件以及生活的其他方面。本应用由 Walter Ravasco da Costa 提供，他是应用中所处理个人数据的控制者。",
 "O My Planner usa só a pasta Aplicativos › My Planner do seu OneDrive.": "My Planner 只使用你 OneDrive 中的 应用 › My Planner 文件夹。",
 "O PDF e as imagens saem deste dispositivo e da nuvem.": "PDF 和图片将从此设备和云端删除。",
 "O PDF passou de 15 MB. Se o WhatsApp ou o e-mail recusar, ligue \"Arquivo menor\".": "PDF 超过 15 MB。如果 WhatsApp 或电子邮件拒收，请开启 \"较小的文件\"。",
 "O QUE COMER": "吃什么",
 "O QUE OS MEMBROS PODEM": "成员权限",
 "O QUE VOCÊ MANDA": "你发送的",
 "O QUE VOCÊ RECEBE": "你收到的",
 "O acesso continua sendo pelo CPF. O e-mail serve para o suporte falar com você.": "仍然使用 CPF 登录。邮箱用于客服与您联系。",
 "O administrador do grupo poderá enviar compromissos, materiais e avisos. Nada entra na sua agenda sem você aceitar.": "群组管理员可以发送日程、资料和通知。未经你接受，任何内容都不会进入你的日程。",
 "O alarme toca de novo a cada 2 minutos (até 4 vezes) enquanto o remédio não for marcado como tomado.": "只要药品还未标记为已服用，闹钟会每 2 分钟再响一次（最多 4 次）。",
 "O app ajuda a organizar, mas não substitui orientação de médicos, advogados, contadores ou outros profissionais. Confira prazos, valores e datas importantes.": "本应用帮助你整理事务，但不能替代医生、律师、会计师或其他专业人士的意见。请核对重要的期限、金额和日期。",
 "O app avisa 3 dias antes e no dia do vencimento, às 9h.": "应用会在到期前 3 天和到期当天上午 9 点提醒。",
 "O app consulta o serviço público do CNJ (DJEN) com os nomes e a OAB que você cadastrar. Esses dados são enviados a esse serviço a cada verificação.": "应用会使用你登记的姓名和 OAB 号码查询 CNJ 的公共服务（DJEN）。每次检查时都会将这些数据发送给该服务。",
 "O app e o servidor do My Planner consultam o serviço público do CNJ (DJEN) com os nomes e as OABs que você cadastrar e, se você marcar, o Querido Diário (diários oficiais municipais). Esses dados são enviados a esses serviços a cada verificação.": "My Planner 应用和服务器会使用你登记的姓名和 OAB 号查询 CNJ 公共服务（DJEN），如果你勾选，还会查询 Querido Diário（市政政府公报）。每次检查时，这些数据都会发送给这些服务。",
 "O app fechou sozinho {n} vezes seguidas": "应用已连续 {n} 次自行关闭",
 "O app instalado neste aparelho é a versão {v}. Para fazer chamadas de áudio e vídeo, instale o app 0.35 ou mais novo (APK novo). As mensagens já funcionam.": "此设备上安装的应用版本为 {v}。如需语音和视频通话，请安装 0.35 或更高版本的应用（新 APK）。消息功能已可使用。",
 "O app não fechou e os seus dados continuam salvos. Tente de novo ou mande o relatório para a equipe corrigir.": "应用没有关闭，你的数据仍已保存。请重试，或将报告发送给团队修复。",
 "O app pede o desbloqueio ao abrir e ao voltar do segundo plano.": "打开应用及从后台返回时，应用会要求解锁。",
 "O app pede o desbloqueio ao abrir. Trocar de app ou de tela rapidinho não pede de novo; se o celular ficar travado ou o app ficar fora da tela por mais tempo que o prazo abaixo, pede.": "打开应用时会要求解锁。快速切换应用或页面不会再次要求；如果手机锁屏或应用离开屏幕的时间超过下方设定的时长，则会要求。",
 "O app só lê (passos, distância, calorias, exercício, batimentos e sono) e nunca altera os seus dados de saúde. Os totais de cada dia ficam na sua conta para aparecer também no site e no outro celular.": "本 App 只读取数据（步数、距离、卡路里、锻炼、心率和睡眠），绝不会修改你的健康数据。每天的汇总保存在你的账户中，以便在网站和另一部手机上也能显示。",
 "O app volta a pedir a senha para desbloquear.": "应用将重新要求输入密码解锁。",
 "O app é feito para maiores de 18 anos. Dados de crianças só podem ser registrados pelos pais ou responsáveis.": "本应用面向 18 岁以上用户。儿童的数据只能由父母或监护人登记。",
 "O arquivo ficou só neste dispositivo. Não foi possível guardar no {nome}: {erro}": "文件只保存在本设备上。无法保存到 {nome}：{erro}",
 "O arquivo não está mais nesse lugar (foi apagado ou movido).": "文件已不在该位置（已删除或移动）。",
 "O arquivo não está mais nesse lugar (foi apagado, movido ou o app dele tirou a permissão). Anexe de novo.": "文件已不在该位置（已删除、移动，或其应用撤销了权限）。请重新添加附件。",
 "O arquivo passa de 15 MB.": "文件超过 15 MB。",
 "O arquivo passa de 15 MB. Ligue \"Arquivo menor\" e tente de novo.": "文件超过 15 MB。请开启 \"较小的文件\" 后重试。",
 "O arquivo passa de 25 MB.": "文件超过 25 MB。",
 "O arquivo passa de 50 MB.": "文件超过 50 MB。",
 "O arquivo sai deste celular. As cópias que você salvou no Drive, OneDrive ou mandou para alguém continuam lá.": "文件将从此手机中删除。你保存到 Drive、OneDrive 或发送给他人的副本仍会保留。",
 "O arquivo sai do escritório para todos.": "该文件将从办公室中为所有人移除。",
 "O aviso chega às 9h, e de novo no dia do vencimento.": "提醒会在 9 点送达，到期当天会再提醒一次。",
 "O banco ainda não foi preparado. Rode o arquivo supabase/schema.sql no Supabase.": "数据库尚未准备好。请在 Supabase 中运行 supabase/schema.sql 文件。",
 "O cartão {c} está com {p}% do limite tomado. Evite parcelar coisa nova nele por enquanto.": "卡片 {c} 已用掉 {p}% 的额度。暂时避免在这张卡上新增分期。",
 "O celular não avisa o app quando a tela é travada, por isso o app conta o tempo fora. Com 1 minuto, travar o celular e voltar depois pede a biometria; responder uma mensagem rápida, não.": "手机锁屏时不会通知应用，因此应用会计算离开的时间。设为 1 分钟时，锁屏后再回来会要求生物识别；快速回复一条消息则不会。",
 "O celular serve só para confirmar que a conta é sua (código pelo WhatsApp no cadastro e ao trocar de número). Um número por conta.": "手机号仅用于确认账户归您所有（注册和更换号码时通过 WhatsApp 发送验证码）。每个账户一个号码。",
 "O compartilhamento ainda não foi ligado no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 12-LIGAR-COMPARTILHAMENTO.bat (uma vez só).": "服务器上尚未开启共享。请在电脑上打开 C:\\MyPlanner 文件夹，双击 12-LIGAR-COMPARTILHAMENTO.bat（只需一次）。",
 "O computador vai abrir o My Planner com a sua conta. Faça isso só em computadores de confiança.": "电脑将使用你的账户打开 My Planner。请仅在可信任的电脑上进行此操作。",
 "O convite leva o link do app e do APK mais recente. Quem entra pelo link cai direto no escritório.": "邀请中包含 App 链接和最新的 APK。通过链接加入的人会直接进入办公室。",
 "O código de indicação vale só nos primeiros 30 dias da conta.": "推荐码仅在账户创建后的前 30 天内有效。",
 "O desenho fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o desenho.": "图案仅安全保存在此设备上。如果忘记图案，仍可使用密码。",
 "O dinheiro gasto está à frente do andamento da obra.": "已花费的资金超前于工程进度。",
 "O documento não tem páginas.": "文档没有页面。",
 "O extrato é lido aqui no aparelho. Contas a pagar com o mesmo valor e data próxima recebem baixa automática.": "对账单仅在本设备上读取。金额相同且日期相近的应付账单会自动标记为已付。",
 "O extrato é lido aqui no dispositivo. Contas a pagar com o mesmo valor e data próxima recebem baixa automática. O pagamento da fatura do cartão não conta duas vezes.": "流水在本机读取。金额相同、日期相近的应付账款会自动核销。信用卡账单的还款不会重复计算。",
 "O governo recusou a nota": "政府拒绝了该发票",
 "O governo recusou a nota.": "政府拒绝了该发票。",
 "O idioma vale para este dispositivo. Os dados que você digitou não são traduzidos.": "语言设置仅对本设备有效。你输入的数据不会被翻译。",
 "O item vinculado foi apagado ou movido.": "关联的项目已被删除或移动。",
 "O item vinculado foi apagado ou movido. Edite a tarefa para escolher outro.": "关联的项目已被删除或移动。请编辑任务以选择其他项目。",
 "O link antigo deixa de funcionar.": "旧链接将失效。",
 "O link antigo deixa de funcionar. Quem já está no grupo continua.": "旧链接将失效。已在群组中的人不受影响。",
 "O link deve começar com https://": "链接必须以 https:// 开头",
 "O navegador não deixa ler o calendário das plataformas. Importe pelo app no celular.": "浏览器无法读取平台日历。请在手机应用中导入。",
 "O plano básico e os períodos de teste das abas seguem as regras mostradas em Ajustes > Compras. Benefícios de indicação valem uma vez por conta.": "基础套餐和各标签页的试用期遵循 设置 > 购买 中显示的规则。推荐奖励每个账户只能领取一次。",
 "O que acontece": "环节内容",
 "O que apagar": "删除哪些",
 "O que comprou": "买了什么",
 "O que fazer": "要做的事",
 "O que foi comido:": "实际吃了：",
 "O que foi feito": "完成的工作",
 "O que foi visto": "讲授内容",
 "O que funcionou, o que ajustar, metodologias, resumos...": "有效的做法、需要调整的地方、教学方法、总结...",
 "O que já foi guardado continua nos lançamentos como investimento.": "已存的钱会作为投资保留在收支记录中。",
 "O que levar ou estudar": "要带的东西或要复习的内容",
 "O que o app pode usar": "应用可以使用的权限",
 "O que o médico disse": "医生的意见",
 "O que os seus grupos enviaram. Compromissos aceitos vão para o My Planner; materiais e avisos vão para as Anotações.": "你的群组发来的内容。接受的日程进入 My Planner；资料和通知进入 笔记。",
 "O que precisa": "需要什么",
 "O que tem dentro": "里面装了什么",
 "O que você emprestou ou pegou emprestado: foto, com quem está e aviso da devolução.": "你借出或借入的东西：照片、在谁那里，以及归还提醒。",
 "O que é apagado": "会删除哪些内容",
 "O quê": "事项",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O app guarda só o atalho: o arquivo continua onde está e abre no app do celular.": "如果手机上安装了 Google Drive、OneDrive 和 Dropbox，选择器会显示它们。应用只保存快捷方式：文件仍在原处，并在手机应用中打开。",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O arquivo escolhido fica guardado neste dispositivo.": "如果手机上安装了 Google Drive、OneDrive 和 Dropbox，选择器中会显示它们。所选文件会保存在此设备上。",
 "O servidor ainda não buscou para os seus perfis.": "服务器尚未为您的档案进行搜索。",
 "O servidor ainda não está preparado para as mensagens. Rode o 17-LIGAR-MENSAGENS.bat.": "服务器尚未为消息功能做好准备。请运行 17-LIGAR-MENSAGENS.bat。",
 "O servidor ainda não está preparado para indicações. Tente de novo mais tarde.": "服务器尚未支持推荐功能。请稍后再试。",
 "O servidor ainda não está preparado para o cartão de contato. Rode o 19-LIGAR-CONTATO.bat.": "服务器尚未支持联系人名片。请运行 19-LIGAR-CONTATO.bat。",
 "O servidor ainda não foi preparado para dados compartilhados. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "服务器尚未准备好共享数据。请在电脑上打开文件夹 C:\\MyPlanner，双击 15-LIGAR-GRUPOS-COLABORATIVOS.bat（只需一次）。",
 "O servidor ainda não foi preparado para o Drive e o OneDrive (veja COMO RODAR, versão 0.14).": "服务器尚未为 Drive 和 OneDrive 做好准备（请参阅 COMO RODAR，0.14 版）。",
 "O servidor ainda não foi preparado para o acesso pela web (rode supabase/migracao-0.6.sql).": "服务器尚未支持网页访问（请运行 supabase/migracao-0.6.sql）。",
 "O servidor ainda não tem a função \"qr-login\". Veja o passo da versão 0.6 no COMO RODAR.": "服务器尚未提供 \"qr-login\" 函数。请参阅 COMO RODAR 中 0.6 版本的步骤。",
 "O servidor de chamadas recusou a chave do LiveKit. No computador do administrador, rode o 30-CONSERTAR-CHAMADAS.bat.": "通话服务器拒绝了 LiveKit 密钥。请在管理员的电脑上运行 30-CONSERTAR-CHAMADAS.bat。",
 "O servidor de notas respondeu algo inesperado (HTTP {s}). Confira o endereço.": "发票服务器返回了意外的响应（HTTP {s}）。请检查地址。",
 "O servidor faz a captura automática de 2 em 2 horas, das 08h às 20h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "服务器每 2 小时自动抓取一次，时间为 08:00 至 20:00（巴西利亚时间），即使应用已关闭。抓取到的公告会在您打开应用时显示。您也可以使用“立即检查”。",
 "O servidor faz a captura automática todos os dias às 08h e 12h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "即使应用已关闭，服务器也会在每天 08:00 和 12:00（巴西利亚时间）自动抓取。抓取到的公告会在你打开应用时显示。你也可以使用\"立即检查\"。",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 32-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "服务器拒绝访问：请在 Supabase 的 “nuvem” 函数中关闭 “Verify JWT”（32-LIGAR-DRIVE-ONEDRIVE.bat 已会执行此操作）。",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 9-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "服务器拒绝访问：请在 Supabase 的“nuvem”函数中关闭“Verify JWT”（9-LIGAR-DRIVE-ONEDRIVE.bat 已会处理）。",
 "O seu papel no grupo não permite incluir aqui.": "你在群组中的角色不允许在此添加。",
 "O site deve começar com https://": "网址必须以 https:// 开头",
 "O tamanho padrão do copo ({copo}) muda em Ajustar, no quadro da água.": "默认杯子容量（{copo}）可在饮水卡片的“调整”中更改。",
 "O tema muda as cores das abas (os ícones continuam os mesmos) e vale nos modos claro e escuro. Depois você ainda pode trocar a cor de uma aba em Ajustes > Abas.": "主题会改变标签页的颜色（图标保持不变），在浅色和深色模式下都有效。之后你仍可以在 设置 > 标签页 中更改单个标签页的颜色。",
 "O temporizador se enche de cor conforme o tempo da tarefa passa. Tocar nele abre o vínculo da tarefa.": "随着任务时间推移，计时器会逐渐填满颜色。点击它可打开任务的关联。",
 "O teste grátis terminou": "免费试用已结束",
 "O texto": "文字",
 "O texto do PDF num arquivo .docx para editar.": "将 PDF 文字导出为可编辑的 .docx 文件。",
 "O texto também vai escondido dentro do PDF: dá para buscar e copiar no leitor de PDF.": "文字也会隐藏在 PDF 中：可以在 PDF 阅读器中搜索和复制。",
 "O tom escolhido fica para os próximos emojis.": "所选肤色将用于之后的表情。",
 "O total aparece no topo do My Planner. Se passar do limite, o raio fica vermelho. Tarefas \"Relaxar\" valem 0.": "总计显示在 My Planner 顶部。超过上限时，闪电图标会变红。\"放松\"类任务计为 0。",
 "OAB (opcional, para advogados)": "OAB（可选，供律师使用）",
 "OBS": "备注",
 "OCR: texto pesquisável": "OCR：可搜索文字",
 "OK": "确定",
 "OU ESCOLHER CÔMODO…": "或选择房间…",
 "Objetivos": "目标",
 "Objeto": "物品",
 "Objetos": "物品",
 "Objetos e valores": "物品与钱款",
 "Obra": "工程",
 "Obras": "工程",
 "Obras & Reformas": "工程与装修",
 "Obrigado": "谢谢",
 "Obrigado!": "谢谢！",
 "Observações": "备注",
 "Observações (alergias, ração...)": "备注（过敏、饲料……）",
 "Observações (chave Pix, conta para depósito...)": "备注（Pix 密钥、收款账户...）",
 "Observações (código de barras, chave Pix...)": "备注（条形码、Pix 密钥...）",
 "Observações (dados bancários, PIX...)": "备注（银行信息、PIX...）",
 "Observações (estado do item...)": "备注（物品状况……）",
 "Observações (garantia, seguro, CET...)": "备注（担保、保险、综合成本...）",
 "Observações (nº de série, modelo...)": "备注（序列号、型号...）",
 "Observações (onde está o original, categoria da CNH...)": "备注（原件存放位置、驾照类别...）",
 "Observações (recibo de entrega, número...)": "备注（送货回执、编号……）",
 "Observações (restrição alimentar...)": "备注（饮食限制……）",
 "Ocultar texto (tarja)": "隐藏文字（涂黑）",
 "Ocupado": "已入住",
 "Oficina": "修理厂",
 "Ofício": "Legal",
 "Oi!": "嗨！",
 "Oi! Tudo certo para sábado?": "嗨！周六都安排好了吗？",
 "Oi, {pessoa}! Ainda estou com o(a) {coisa} que você me emprestou. Quando fica bom para eu devolver?": "你好，{pessoa}！你借给我的{coisa}还在我这儿。什么时候方便还给你？",
 "Oi, {pessoa}! Tudo bem? Passando para lembrar do(a) {coisa} que te emprestei em {data}. Consegue devolver {quando}?": "你好，{pessoa}！最近好吗？想提醒一下我在 {data} 借给你的{coisa}。能在{quando}还给我吗？",
 "Oi?!": "啥？！",
 "Olá!": "你好！",
 "Olá! Eu sou o Mestre Achado. Pergunte sobre os seus gastos, contas, cartões e metas: eu respondo com os seus números.": "你好！我是 Mestre Achado。问我关于你的支出、账款、信用卡和目标的问题：我会用你的数据来回答。",
 "Olá! Passando para lembrar do pagamento de {ref} ({v}), com vencimento em {d}. Obrigado(a)!": "你好！提醒一下，{ref}（{v}）的付款将于 {d} 到期。谢谢！",
 "Olá! Preciso de assistência técnica para: {item}": "你好！我需要售后维修：{item}",
 "Olá, {nome}!": "你好，{nome}！",
 "Olá, {nome}! Seja bem-vindo(a).": "你好，{nome}！欢迎。",
 "Ombros: girar para trás": "肩部：向后绕圈",
 "Omelete": "煎蛋卷",
 "Onde": "地点",
 "Onde a IA ajuda: Publicações (audiências e prazos), Documentos (preencher a ficha pela foto) e Anotações (transformar uma caixa em tarefas).": "AI 的用途：公告（庭审和期限）、证件（拍照填写表单）和笔记（把收纳盒变成任务）。",
 "Onde assistir": "在哪里看",
 "Onde eu mais gastei este mês?": "这个月我在哪方面花得最多？",
 "Onde fica": "位置",
 "Onde guardar fotos e arquivos novos": "新照片和文件的保存位置",
 "Onde na página": "页面位置",
 "Ontem": "昨天",
 "Organizar": "整理",
 "Organizar barra": "整理标签栏",
 "Organizar com IA": "用 AI 整理",
 "Organizar com IA (vira tarefas)": "用 AI 整理（转为任务）",
 "Organizar páginas": "整理页面",
 "Orgulho e vibrante": "骄傲多彩",
 "Origem": "来源",
 "Origem da reserva": "预订来源",
 "Original": "原始",
 "Orquídeas": "兰花",
 "Orçado": "预算",
 "Orçamento": "预算",
 "Orçamento do mês": "本月预算",
 "Orçamento por categoria": "分类预算",
 "Orçamento total": "总预算",
 "Orçamento: {v}": "预算：{v}",
 "Os alertas precisam de um horário.": "提醒需要设置时间。",
 "Os anexos que ficam só no dispositivo não aparecem nos outros dispositivos e se perdem se o celular for trocado. Ligue o Google Drive ou o OneDrive em Ajustes para guardar uma cópia.": "仅保存在本设备上的附件不会出现在其他设备上，换手机后会丢失。请在“设置”中连接 Google Drive 或 OneDrive 来保存副本。",
 "Os arquivos e cópias que já estão lá continuam lá. O My Planner só deixa de guardar coisas novas.": "已在那里的文件和备份会保留。My Planner 只是不再保存新内容。",
 "Os arquivos guardados neste dispositivo também serão apagados.": "保存在此设备上的文件也会被删除。",
 "Os arquivos que estão no seu Google Drive, OneDrive ou no celular continuam com você. Registros que a lei obriga a guardar (como os de acesso) podem ficar guardados pelo prazo legal e depois são apagados.": "你的 Google Drive、OneDrive 或手机中的文件仍归你所有。法律要求保留的记录（如访问记录）可能会在法定期限内保留，之后删除。",
 "Os avisos do grupo ainda não foram ligados no servidor. No computador, dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "服务器上尚未开启群组提醒。请在电脑上双击 15-LIGAR-GRUPOS-COLABORATIVOS.bat（只需一次）。",
 "Os avisos estão desligados para o My Planner. Toque em Abrir configurações e ligue as notificações.": "My Planner 的通知已关闭。请点按“打开设置”并开启通知。",
 "Os avisos no celular funcionam no app instalado (Android ou iPhone).": "手机通知仅在已安装的应用中有效（Android 或 iPhone）。",
 "Os campos do formulário viram parte da página.": "表单字段变成页面的一部分。",
 "Os dados atuais serão substituídos pelos do arquivo, aqui e na nuvem.": "当前数据将被文件中的数据替换，包括本设备和云端。",
 "Os dados continuam salvos na nuvem.": "数据仍保存在云端。",
 "Os dados da aba ainda são só seus": "此标签页的数据目前仅你可见",
 "Os dados da aba {aba} passam a ser vistos pela equipe, cada pessoa conforme o papel que você escolher.": "标签页 {aba} 的数据将对团队可见，每人可见的内容取决于你选择的角色。",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo abrir o My Planner atualizado: o app libera sozinho.": "该群组的数据尚未开放。请让创建群组的人打开最新版 My Planner：应用会自动开放。",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo atualizar o My Planner e abrir o grupo: lá aparece o botão para liberar.": "此群组的数据尚未开放。请让群组创建者更新 My Planner 并打开群组：开放按钮会显示在那里。",
 "Os dados do cofre são criptografados aqui no dispositivo (AES-256) antes de ir para a nuvem. Nem o suporte consegue ler. Se esquecer a senha do cofre, esses dados não podem ser recuperados.": "保险库数据会先在本设备上加密（AES-256），再上传到云端。连客服也无法读取。如果忘记保险库密码，这些数据将无法恢复。",
 "Os dados ficam guardados enquanto a conta existir. Ao apagar a conta, os dados são apagados, salvo o que a lei obrigar a manter.": "数据会在账户存在期间一直保存。删除账户后，数据也会被删除，法律要求保留的除外。",
 "Os desenhos não conferem. Comece de novo.": "两次绘制的图案不一致。请重新开始。",
 "Os dias estão no app ou na fatura do banco. Compras feitas depois do fechamento caem na fatura seguinte.": "这些日期可以在银行 App 或账单上查到。出账日之后的消费会计入下一期账单。",
 "Os emojis que você usar aparecem aqui.": "你用过的表情会显示在这里。",
 "Os grupos ainda não foram ligados no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 11-LIGAR-GRUPOS.bat (uma vez só).": "服务器上尚未启用群组。请在电脑上打开 C:\\MyPlanner 文件夹，双击 11-LIGAR-GRUPOS.bat（只需一次）。",
 "Os grupos ainda não foram ligados no servidor. Rode o supabase\\migracao-0.21.sql no Supabase (veja o COMO RODAR).": "服务器上尚未启用群组。请在 Supabase 中运行 supabase\\migracao-0.21.sql（参见 COMO RODAR）。",
 "Os lugares abrem no Google Maps, no Waze ou no Mapas, como escolhido em Ajustes.": "地点会按照设置中的选择，在 Google Maps、Waze 或“地图”中打开。",
 "Os membros sempre veem os administradores e só recebem o que foi enviado para eles.": "成员始终能看到管理员，并且只会收到发给他们的内容。",
 "Os outros membros deixam de ver os dados (a cópia some do dispositivo deles). Tudo continua com você.": "其他成员将看不到这些数据（副本会从他们的设备上删除）。所有数据仍保留在你这里。",
 "Os perfis e os resultados ficam na sua conta do My Planner.": "档案和结果保存在你的 My Planner 账户中。",
 "Os perfis, as OABs e os tribunais ficam dentro da aba Publicações. A busca automática roda no servidor às 08h e às 12h (horário de Brasília).": "个人资料、OAB 和法院都在 公告 标签页中设置。自动搜索在服务器上于每天 08:00 和 12:00（巴西利亚时间）运行。",
 "Os preços ficam guardados e aparecem na lista de Compras da aba Alimentação & Despensa como o preço da última compra.": "价格会被保存，并作为最近一次购买价显示在\"饮食与食品柜\"标签页的购物清单中。",
 "Os resultados deste perfil também serão apagados.": "此档案的结果也将被删除。",
 "Os termos foram atualizados": "条款已更新",
 "Ou digite (ex.: 2 ovos mexidos)": "或直接输入（例如：2个炒鸡蛋）",
 "Ou escreva o prato": "或输入菜名",
 "Ou escreva o seu": "或输入自定义文字",
 "Outra": "其他",
 "Outra aba…": "其他标签页…",
 "Outra atividade (digite e dê Enter)": "其他活动（输入后按回车）",
 "Outro": "其他",
 "Outro (ml)": "其他（ml）",
 "Outro valor": "其他金额",
 "Outros": "其他",
 "Outros países": "其他国家",
 "Outros relógios (Garmin, Samsung, Xiaomi, Amazfit...): no app do relógio, ligue a opção de enviar os dados para o app Saúde (Apple Health).": "其他手表（Garmin、Samsung、Xiaomi、Amazfit...）：在手表的 App 中，打开将数据发送到“健康”App（Apple 健康）的选项。",
 "Ovo": "鸡蛋",
 "PAGO, RECEBIDO, CONFIDENCIAL, APROVADO ou o seu texto, com a data.": "已付款、已收到、机密、已批准或你的文字，附带日期。",
 "PARA ACERTAR": "待结算",
 "PARA QUEM": "发送对象",
 "PARA {refeicao}": "用于{refeicao}",
 "PASSO A PASSO": "分步进行",
 "PASSO {n}": "第 {n} 步",
 "PDF": "PDF",
 "PDF Edit": "PDF Edit",
 "PDF com texto digital: sai na hora no navegador. PDF escaneado (foto): a sua IA lê cada página.": "带数字文字的 PDF：在浏览器中即时完成。扫描版 PDF（照片）：由你的 AI 逐页读取。",
 "PDF grande": "PDF 较大",
 "PDF guardado na pasta \"{pasta}\" do celular.": "PDF 已保存到手机的 \"{pasta}\" 文件夹。",
 "PDF guardado no {nome}.": "PDF 已保存到 {nome}。",
 "PDF numa página só": "PDF 合成单页",
 "PDF para Word": "PDF 转 Word",
 "PDF para imagens": "PDF 转图片",
 "PDF para texto": "PDF 转文字",
 "PDFs arquivados ({n})": "已归档的 PDF ({n})",
 "PDFs juntados {data}": "合并的 PDF {data}",
 "PEDIDOS RECEBIDOS": "收到的请求",
 "PIX": "PIX",
 "PIX COPIA E COLA": "PIX 复制粘贴",
 "PRÓXIMAS FATURAS (JÁ COMPROMETIDO)": "后续账单（已占用）",
 "Paciente": "患者",
 "Paciente ou aluno": "病人或学生",
 "Pacientes": "患者",
 "Padrão": "默认",
 "Padrão da aba": "标签页默认",
 "Paga": "已付",
 "Paga (toque para desfazer)": "已付（点击撤销）",
 "Pagador": "付款人",
 "Pagamento já contado": "已计入的付款",
 "Pagar": "付款",
 "Pagar parcela {n}/{t} · {c}": "支付第 {n}/{t} 期 · {c}",
 "Pagas": "已付",
 "Pago": "已付款",
 "Pago com": "支付方式",
 "Pago: {p} · Falta pagar: {f}": "已付：{p} · 待付：{f}",
 "Pagos": "已付款",
 "Pagou {v}? Se teve desconto, multa ou juros, informe o valor pago. Quer guardar o comprovante agora?": "已支付 {v}？如有优惠、滞纳金或利息，请输入实际支付金额。现在保存凭证吗？",
 "Paguei outro valor (desconto, multa ou juros)": "我支付了其他金额（优惠、滞纳金或利息）",
 "Paixão de Cristo": "耶稣受难日",
 "Palavras-chave (separe com vírgula)": "关键词（用逗号分隔）",
 "Para a meta \"{m}\" chegar no prazo, seriam {v} por mês. Vale esticar o prazo ou começar com um valor menor.": "要让目标\"{m}\"按期达成，每月需要 {v}。可以考虑延长期限，或从更小的金额开始。",
 "Para clareza, firmo o presente.": "特此证明。",
 "Para comprar": "可购买",
 "Para continuar, digite a senha do app.": "如需继续，请输入应用密码。",
 "Para conversar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "要聊天，请在 设置 › 人工智能 中开启你的 AI（Claude、ChatGPT 或 Gemini）。",
 "Para dividir as despesas, escreva em \"Quem vai\" os nomes separados por vírgula (edite a viagem).": "要分摊费用，请在“同行者”中填写名字，用逗号分隔（编辑旅行）。",
 "Para emitir e buscar notas, ligue uma vez o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar (termina em .netlify.app).": "要开具和查询发票，请先连接一次发票服务器：在电脑上双击 13-LIGAR-NOTAS.bat，然后把显示的地址（以 .netlify.app 结尾）粘贴到这里。",
 "Para exercer seus direitos, use Fale conosco no app ou escreva para o e-mail abaixo. Respondemos em até 15 dias.": "如需行使你的权利，请在应用内使用 联系我们，或发送邮件至下方地址。我们会在 15 天内回复。",
 "Para fazer chamadas de áudio e vídeo, instale a versão nova do app (0.35). As mensagens já funcionam.": "要进行语音和视频通话，请安装新版应用（0.35）。消息功能已经可以使用。",
 "Para fazer o app funcionar: guardar e sincronizar seus dados entre dispositivos, mandar alertas, compartilhar com os grupos que você escolheu e dar suporte.": "为使应用正常运行：在设备之间保存和同步你的数据、发送提醒、与你选择的群组共享以及提供支持。",
 "Para guardar os PDFs no {nome}, conecte a sua conta em Ajustes › Google Drive e OneDrive.": "要将 PDF 保存到 {nome}，请在 设置 › Google Drive 和 OneDrive 中连接你的账号。",
 "Para hoje": "到今天",
 "Para ler foto ou PDF, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini). O extrato em OFX ou CSV funciona sem IA.": "要读取照片或 PDF，请在 设置 › 人工智能 中开启你的 AI（Claude、ChatGPT 或 Gemini）。OFX 或 CSV 流水无需 AI 也能使用。",
 "Para ler o relógio automaticamente, instale a versão nova do app (0.33). Enquanto isso, dá para digitar à mão.": "要自动读取手表数据，请安装新版本 App（0.33）。在此之前，可以手动输入。",
 "Para ler o relógio, conecte pelo app no celular. Os números aparecem aqui também.": "要读取手表数据，请在手机上的 App 中连接。数字也会显示在这里。",
 "Para ler o relógio, libere os dados de atividade para o My Planner.": "要读取手表数据，请允许 My Planner 访问活动数据。",
 "Para ler o texto, resumir e perguntar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "要读取文字、生成摘要和提问，请在 设置 › 人工智能 中开启你的 AI（Claude、ChatGPT 或 Gemini）。",
 "Para ligar, use o app no celular (Ajustes > Agenda do Google). Depois, tudo aparece aqui também.": "如需开启，请在手机上使用应用（设置 > Google 日历）。之后所有内容也会显示在这里。",
 "Para ligar, use o app no celular (Ajustes › Configuração geral › Agenda do Google). Depois, tudo aparece aqui também.": "如需开启，请在手机上使用应用（设置 › 常规设置 › Google 日历）。之后所有内容也会显示在这里。",
 "Para monitorar a OAB, informe o número e a UF.": "要监控 OAB，请填写号码和州（UF）。",
 "Para não perguntar mais, escolha o app em Ajustes › Configuração geral.": "如不想再被询问，请在 设置 › 常规设置 中选择应用。",
 "Para profissionais de saúde: pacientes, evolução no cofre, prescrições com modelos, financeiro, recibo e declaração para reembolso em PDF.": "面向医疗从业者：患者、保险库中的病程记录、带模板的处方、财务、收据和 PDF 报销证明。",
 "Para profissionais de saúde: pacientes, evolução, prescrições com modelos, financeiro com convênio, recibo e declaração para reembolso.": "面向医疗从业者：患者、病程记录、带模板的处方、含医保的财务、收据和报销证明。",
 "Para proteger a sua conta, confirmamos o seu celular uma vez, com um código pelo WhatsApp. Ele só é pedido de novo se você trocar de número.": "为保护您的账户，我们会通过 WhatsApp 验证码验证一次您的手机。只有在您更换号码时才会再次要求验证。",
 "Para quem aluga o imóvel ou um cômodo por temporada (Airbnb, Booking ou direto): reservas, limpeza, despesas e o lucro de cada mês.": "适合短租整套房或单间的人（Airbnb、Booking 或直接）：预订、清洁、支出和每月利润。",
 "Para receber a agenda, o local e os avisos do evento no celular, entre no grupo: {link}": "要在手机上接收活动的日程、地点和通知，请加入群组：{link}",
 "Para sincronizar, libere o acesso à agenda para o My Planner nas configurações do celular.": "如需同步，请在手机设置中允许 My Planner 访问日历。",
 "Para tirar uma permissão que você já deu ao sistema (câmera, fotos, microfone), use também os ajustes do celular.": "如需撤销已授予系统的权限（相机、照片、麦克风），也请使用手机设置。",
 "Para uma leitura mais completa, ligue a sua IA em Ajustes › Inteligência artificial.": "如需更完整的解读，请在 设置 › 人工智能 中开启你的 AI。",
 "Parabéns": "恭喜",
 "Parabéns!": "恭喜！",
 "Parada": "静止",
 "Parar": "停止",
 "Parar de compartilhar?": "停止共享？",
 "Parar e salvar": "停止并保存",
 "Parar gravação": "停止录制",
 "Parcela": "分期",
 "Parcela de financiamento": "贷款分期",
 "Parcela {n}/{t}": "第 {n}/{t} 期",
 "Parcela {n}/{t} · {c}": "第 {n}/{t} 期 · {c}",
 "Parcelas": "分期",
 "Parcelas a pagar nos próximos meses": "未来几个月待付分期",
 "Parcelas recalculadas": "分期已重新计算",
 "Parece que foi impresso e escaneado.": "看起来像是打印后再扫描的。",
 "Parei": "已暂停",
 "Parei na aula": "学到第几课",
 "Parei na aula...": "学到第几课…",
 "Pares de meia": "袜子（双）",
 "Parque ou natureza": "公园或自然",
 "Parques": "公园",
 "Parte": "当事人",
 "Partes": "当事人",
 "Participa": "参与者",
 "Participantes": "成员",
 "Participação em empresa": "公司股权",
 "Passa do limite do MEI: fale com seu contador.": "超过 MEI 限额：请咨询你的会计师。",
 "Passaporte": "护照",
 "Passe o dedo sobre o desenho para apagar só aquele pedaço.": "用手指划过绘图，只擦除那一部分。",
 "Passeio": "出游",
 "Passeios": "游览",
 "Passo a passo": "分步进行",
 "Passos": "步数",
 "Passos, exercício, calorias, batimentos e sono": "步数、锻炼、卡路里、心率和睡眠",
 "Passou do orçamento": "超出预算",
 "Passou do orçamento em {v}": "超出预算 {v}",
 "Pasta": "文件夹",
 "Patrimônio": "资产",
 "Patrimônio & Imposto de Renda": "资产与个人所得税",
 "Patrimônio pelo valor de compra: {v}": "按购入价计的资产：{v}",
 "Pausa (s)": "休息（秒）",
 "Pausa de {m} min": "休息 {m} 分钟",
 "Pausado": "已暂停",
 "Pausar": "暂停",
 "Pausas": "休息",
 "Pausas de estudo": "学习休息",
 "Pauta (opcional)": "议程（可选）",
 "Paz": "和平",
 "Pediatra": "儿科医生",
 "Pedido": "请求",
 "Pedido enviado para {nome}. Quando aceitar, vocês já podem conversar.": "已向 {nome} 发送请求。对方接受后，你们就可以聊天了。",
 "Pedido enviado. Quando a pessoa aceitar, vocês já podem conversar.": "请求已发送。对方接受后，你们就可以聊天了。",
 "Pedidos de documentos": "文件请求",
 "Pedir de novo depois de": "多久后再次要求",
 "Peguei emprestado": "我借入",
 "Peito de frango": "鸡胸肉",
 "Peixe": "鱼",
 "Pela última compra: cerca de {v}": "按上次购买：约 {v}",
 "Pelas contas que ainda vencem este mês, vão faltar {v}. Veja o que dá para adiar ou cortar antes de assumir gasto novo.": "按本月还要到期的账款计算，将缺 {v}。在新增开支前，看看哪些可以推迟或削减。",
 "Pendente": "待回复",
 "Pensão alimentícia": "赡养费",
 "Pequena": "小",
 "Pequeno": "小",
 "Percentual de tributos do Simples (para sair na nota)": "Simples 税费比例（显示在发票上）",
 "Perguntar ao Mestre": "问问大师",
 "Perguntar sempre": "每次询问",
 "Pergunte ao Mestre...": "问问大师...",
 "Pergunte sobre o documento (ex.: qual o prazo?)": "询问关于文档的问题（例如：期限是什么时候？）",
 "Permissões": "权限",
 "Personalizado": "自定义",
 "Perto do limite do orçamento": "接近预算上限",
 "Período": "时间段",
 "Período da meta": "目标周期",
 "Pescoço: inclinar para os lados": "颈部：向两侧倾斜",
 "Peso": "体重",
 "Peso na média": "在平均分中的权重",
 "Pesquisar no mapa": "在地图中搜索",
 "Pessoa": "人物",
 "Pessoa de contato": "联系人",
 "Pessoas dos seus grupos veem só o que for compartilhado no grupo.": "群组成员只能看到在群组中共享的内容。",
 "Pet": "宠物",
 "Pet & Família": "宠物与家庭",
 "Pet shop": "宠物店",
 "Pet shop ou clínica": "宠物店或诊所",
 "Pets": "宠物",
 "Peça documentos ao cliente com prazo. Ele recebe, anexa e marca como entregue.": "向客户索取文件并设定期限。客户收到后附上文件并标记为已提交。",
 "Pijamas": "睡衣",
 "Pilates": "普拉提",
 "Pintura": "油漆",
 "Pix copia e cola": "Pix 复制粘贴",
 "Placa": "车牌",
 "Planejado": "计划",
 "Planejado e comido": "计划与实际",
 "Planilha": "电子表格",
 "Planilha (Excel)": "表格（Excel）",
 "Planilha do mês para o Receita Saúde": "用于 Receita Saúde 的月度表格",
 "Planner": "Planner",
 "Plano básico: My Planner + Anotações": "基础套餐：My Planner + 笔记",
 "Plano de aula": "教案",
 "Plano de saúde": "医疗保险",
 "Planos de aula": "教案",
 "Planta": "植物",
 "Plantas": "植物",
 "Plantas & Jardim": "植物与园艺",
 "Plataforma ou escola": "平台或学校",
 "Pneus novos": "新轮胎",
 "Podcast": "播客",
 "Pode confirmar sua presença respondendo esta mensagem?": "能否回复此消息确认是否出席？",
 "Polichinelo": "开合跳",
 "Polo ativo": "原告方",
 "Polo passivo": "被告方",
 "Política de privacidade (LGPD)": "隐私政策（LGPD）",
 "Política de privacidade, LGPD e permissões": "隐私政策、LGPD 和权限",
 "Política de privacidade, LGPD e termos": "隐私政策、LGPD 和条款",
 "Ponha aqui as fotos e os vídeos da viagem. No grupo, todos veem e todos podem pôr as suas.": "把旅行的照片和视频放在这里。在群组中，所有人都能看到，也都能添加自己的。",
 "Ponte de glúteos": "臀桥",
 "Ponto facultativo": "选择性休息日",
 "Ponto facultativo: {nome}": "选择性休假日：{nome}",
 "Ponto turístico": "景点",
 "Pontos turísticos": "景点",
 "Por dia": "按天",
 "Por faixas": "按范围",
 "Por mês": "按月",
 "Por nome": "按名称",
 "Por semana": "按周",
 "Portal": "门户",
 "Portal do Cliente": "客户门户",
 "Portal do cliente (convidar o cliente)": "客户门户（邀请客户）",
 "Português": "葡萄牙语",
 "Porão": "地下室",
 "Porções": "份数",
 "Pouco espaço livre: fotos e anexos novos podem não ser salvos. Libere espaço ou guarde os anexos no Google Drive ou OneDrive.": "可用空间不足：新照片和附件可能无法保存。请释放空间，或将附件保存到 Google Drive 或 OneDrive。",
 "Praia": "海滩",
 "Prancha": "平板支撑",
 "Prato do cardápio": "菜单中的菜品",
 "Prato principal": "主菜",
 "Prazo": "期限",
 "Prazo (pagamento ou entrega)": "期限（付款或交付）",
 "Prazo até {fim} · fazer em {dia}": "期限至 {fim} · 于 {dia} 完成",
 "Prazo final: {fim}": "最终期限：{fim}",
 "Prazo: {d}": "期限：{d}",
 "Prazo: {t}": "期限：{t}",
 "Prazos criados": "期限已创建",
 "Precisa da sua IA": "需要你的 AI",
 "Preencha a descrição, o código de tributação nacional (6 números) e o valor.": "请填写描述、国家税务代码（6 位数字）和金额。",
 "Preenche os campos do PDF e, se quiser, trava.": "填写 PDF 字段，并可选择锁定。",
 "Preencher formulário": "填写表单",
 "Preencher pela foto com a minha IA": "用我的 AI 按照片填写",
 "Preencher pela nota fiscal com a minha IA": "用我的 AI 从发票填写",
 "Preparando a conversa da equipe...": "正在准备团队聊天...",
 "Preparando a página {n} de {total}...": "正在准备第 {n} 页，共 {total} 页...",
 "Preparando o arquivo": "正在准备文件",
 "Prescrição, conduta e orientações": "处方、处置与医嘱",
 "Presente": "出席",
 "Presença": "出勤",
 "Pressione e segure o código para copiar, ou toque em Enviar e escolha \"Copiar\".": "长按代码即可复制，或点击发送并选择“复制”。",
 "Pressione e segure o código para copiar.": "长按代码即可复制。",
 "Pressione e segure um lançamento para apagar.": "长按一条记录即可删除。",
 "Pressione e segure um perfil para removê-lo.": "长按档案即可将其删除。",
 "Preto e branco": "黑白",
 "Previdência privada": "私人养老金",
 "Preço ou ingresso": "价格或门票",
 "Price": "Price（等额本息）",
 "Primeira": "首页",
 "Primeira cota ou cota única do IR": "个税第一期或一次性缴纳",
 "Primeira parcela na fatura de {mes}, que vence {data}.": "第一期在{mes}账单中，{data} 到期。",
 "Prioridade": "优先级",
 "Privacidade": "隐私",
 "Privacidade e termos": "隐私和条款",
 "Privacidade: o texto ou a imagem analisada vai direto deste dispositivo para a empresa da IA escolhida, com a sua chave. O My Planner não guarda cópia.": "隐私：被分析的文本或图片会使用你的密钥，直接从此设备发送到所选 AI 公司。My Planner 不保存任何副本。",
 "Problema": "问题",
 "Problemas, erros e sugestões": "问题、错误和建议",
 "Procedimento": "项目",
 "Procedimento: {c}": "项目：{c}",
 "Processo": "案件",
 "Processo Civil": "民事诉讼法",
 "Processo Penal": "刑事诉讼法",
 "Processo do Trabalho": "劳动诉讼法",
 "Processo não informado": "未提供案号",
 "Proclamação da República": "共和国宣言日",
 "Procurando a folha...": "正在寻找纸张...",
 "Procurando atualização...": "正在检查更新...",
 "Procurar aba": "搜索标签页",
 "Procurar atualização agora": "立即检查更新",
 "Procurar documento": "查找文档",
 "Procurar ferramenta (ex.: juntar, assinar, comprimir)": "搜索工具（例如：合并、签名、压缩）",
 "Produto": "产品",
 "Produto (ex.: Geladeira)": "产品（例：冰箱）",
 "Produtos, notas fiscais, assistência técnica e aviso antes de vencer.": "产品、发票、售后服务以及到期前提醒。",
 "Produção (vale de verdade)": "正式环境（真实有效）",
 "Produção restrita (teste)": "受限正式环境（测试）",
 "Produção restrita (teste, não vale)": "受限正式环境（测试，无效）",
 "Produção restrita: ambiente de teste do governo. As notas não valem. Teste tudo aqui antes de mudar para Produção (em Editar).": "受限正式环境：政府的测试环境。发票无效。切换到正式环境（在“编辑”中）之前，请先在这里全部测试。",
 "Produção: as notas emitidas valem de verdade e vão para a prefeitura e a Receita.": "正式环境：开具的发票真实有效，会发送给市政府和税务局。",
 "Produção: vale de verdade": "正式环境：真实有效",
 "Professor": "教师",
 "Professor & Mentoria": "教师与辅导",
 "Professor(a)": "老师",
 "Profissionais": "施工人员",
 "Profissional": "施工人员",
 "Profissional assistente": "助理",
 "Profissional ou fornecedor": "施工人员或供应商",
 "Profissional ou local": "专业人员或地点",
 "Profissão ou especialidade": "职业或专科",
 "Profissões": "职业",
 "Programação": "编程",
 "Progresso geral": "总体进度",
 "Projeto e licenças": "设计和许可",
 "Projetos": "项目",
 "Prontas": "现成",
 "Pronto": "完成",
 "Pronto! Todas as abas estão liberadas até {data}.": "完成！所有标签页已解锁至 {data}。",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer com som.": "完成。请锁定屏幕并等待 1 分钟：提醒应会带声音出现。",
 "Prontuário, evolução e prescrições, sem o financeiro.": "病历、病程记录和处方，不含财务。",
 "Protegendo a chave...": "正在保护密钥…",
 "Proteger no cofre": "存入保险库保护",
 "Protegido": "受保护",
 "Protegido no cofre": "已受保险库保护",
 "Protegidos pelo cofre: {n}": "受保险库保护：{n}",
 "Protetor solar": "防晒霜",
 "Protocolo": "受理编号",
 "Prova": "考试",
 "Próxima": "下次",
 "Próxima até a data": "下次截止日期",
 "Próxima com quantos km": "下次里程",
 "Próxima dose": "下一剂",
 "Próxima: {data}": "下次：{data}",
 "Próxima: {d} · {v}": "下一期：{d} · {v}",
 "Próximas": "即将到来",
 "Próximo": "下一步",
 "Próximo ano": "下一年",
 "Próximo número da DPS": "下一个 DPS 编号",
 "Próximos 7 dias": "未来 7 天",
 "Próximos vencimentos ({n})": "即将到期（{n}）",
 "Publicação": "公告",
 "Publicações": "公告",
 "Pula": "弹跳",
 "Pulsa": "脉动",
 "Punho": "拳头",
 "Puxada frontal": "高位下拉",
 "PÁGINAS": "页面",
 "PÔR NA BARRA": "放入标签栏",
 "Pág. {n}": "第 {n} 页",
 "Página": "页面",
 "Página 1": "页面 1",
 "Página 1 de 10": "页面 1 / 10",
 "Página em branco no fim": "末尾加空白页",
 "Página em que estou": "当前页码",
 "Página escaneada": "页面已扫描",
 "Página inteira": "整页",
 "Página {a} de {n}": "第 {a}/{n} 页",
 "Página {n}": "第 {n} 页",
 "Página {n} de {total}": "第 {n} 页，共 {total} 页",
 "Página: {titulo}": "页面：{titulo}",
 "Páginas": "页面",
 "Páginas, tamanho, autor, datas e campos.": "页数、大小、作者、日期和字段。",
 "Pássaro": "鸟类",
 "Pão francês": "巴西小面包",
 "Pão integral": "全麦面包",
 "Pôr a data de hoje": "添加今天的日期",
 "Pôr as parcelas no My Planner": "将分期加入 My Planner",
 "Pôr na barra": "放入标签栏",
 "Pôr no roteiro da viagem": "加入旅行行程",
 "Pôr uma foto": "添加照片",
 "Quadro": "看板",
 "Quadro Kanban, cronômetro de horas por cliente e prazos no My Planner.": "Kanban 看板、按客户的工时计时器，以及 My Planner 中的截止日期。",
 "Quais contas vencem nos próximos dias?": "未来几天有哪些账款到期？",
 "Quais páginas ficam no PDF novo": "新 PDF 保留哪些页面",
 "Quais páginas sair": "要删除哪些页面",
 "Qual IA": "选择 AI",
 "Qualidade alta": "高质量",
 "Qualidade boa (menor)": "良好质量（更小）",
 "Quantidade": "数量",
 "Quanto cortar de cada lado (% da página)": "每边裁掉多少（页面的 %）",
 "Quanto já tem guardado (opcional)": "已存金额（可选）",
 "Quanto paga por limpeza": "每次清洁支付金额",
 "Quanto preciso guardar por mês para as minhas metas?": "为了我的目标，每月需要存多少？",
 "Quanto quer juntar": "想存多少",
 "Quanto você quer gastar, no máximo, em cada categoria por mês. Deixe em branco para não controlar.": "每个类别每月最多想花多少。留空则不控制。",
 "Quarta": "周三",
 "Quarta-feira de Cinzas (até 14h)": "圣灰星期三（至 14 点）",
 "Quarto": "卧室",
 "Quarto das crianças": "儿童房",
 "Quarto de casal": "主卧",
 "Quarto de hóspedes": "客房",
 "Quarto infantil": "儿童房",
 "Queijo": "奶酪",
 "Queixa principal": "主诉",
 "Quem abrir o link baixa o My Planner (ou usa no navegador), entra na conta e passa a fazer parte do grupo.": "打开链接的人会下载 My Planner（或在浏览器中使用），登录后即加入群组。",
 "Quem criar a conta com o seu código já vira seu amigo aqui, sem precisar pedir.": "用你的代码注册账号的人会直接成为你的好友，无需申请。",
 "Quem enviou": "发送者",
 "Quem está num grupo do app com você (turma, família, viagem...) já pode conversar sem ser amigo. Segure um amigo para desfazer a amizade ou bloquear.": "与你同在应用内某个群组（班级、家人、旅行……）的人，无需成为好友即可聊天。长按好友可删除或屏蔽。",
 "Quem faz a limpeza": "保洁人员",
 "Quem paga, se não for o paciente (mãe, pai, responsável)": "付款人（如非患者本人：母亲、父亲、监护人）",
 "Quem pagou": "付款人",
 "Quem recebeu (médico, escola...)": "收款方（医生、学校……）",
 "Quem vai": "同行者",
 "Quem vai limpar": "谁来清洁",
 "Quem vê: só quem conversa com você, os seus amigos e quem está num grupo do app com você. Deixe em branco o que não quiser mostrar.": "谁可以看到：只有与你聊天的人、你的好友以及与你同在 App 群组中的人。不想显示的内容请留空。",
 "Quente": "炎热",
 "Quer escanear mais uma página?": "要再扫描一页吗？",
 "Quer guardar o comprovante agora? Foto, PDF ou print do Pix.": "现在保存凭证吗？照片、PDF 或 Pix 截图。",
 "Quer mandar um print da tela? Envie por e-mail e anexe a imagem.": "想发送屏幕截图吗？请通过电子邮件发送并附上图片。",
 "Quer trocar pelos novos ou manter os dois?": "要替换为新的，还是两者都保留？",
 "Quero assistir": "想看",
 "Quero ir": "想去",
 "Quero ler": "想读",
 "Quero ver": "想看",
 "Quilometragem atual": "当前里程",
 "Quilometragem: {km}": "里程：{km}",
 "Quinta": "周四",
 "Quintal": "后院",
 "Quitado": "已还清",
 "Quitados": "已还清",
 "Química": "化学",
 "RECIBO": "收据",
 "RG / Carteira de identidade": "RG / 身份证",
 "RG, CNH, passaporte, contratos e certidões, com aviso antes de vencer e envio com um toque.": "身份证、驾照、护照、合同和证明，到期前提醒，一键发送。",
 "Raciocínio Lógico": "逻辑推理",
 "Razão social ou nome": "公司名称或姓名",
 "Razão social ou nome do consultório": "公司名称或诊所名称",
 "Razão social ou nome fantasia": "公司名称或商号",
 "Raça": "品种",
 "Realizado": "已完成",
 "Recado": "留言",
 "Recalcular": "重新计算",
 "Recalcular as parcelas em aberto": "重新计算未付分期",
 "Recalcular as parcelas?": "重新计算分期？",
 "Receber": "收款",
 "Receber de volta: {i} ({p})": "收回：{i}（{p}）",
 "Receber o código no WhatsApp": "通过 WhatsApp 接收验证码",
 "Receber parcela {n}/{t} · {c}": "收取第 {n}/{t} 期 · {c}",
 "Recebeu um convite?": "收到邀请了吗？",
 "Recebeu um código?": "收到代码了吗？",
 "Recebi de {pagador}{doc}, a quantia de {valor}{extenso}, referente a {tipo} realizado(a) em {data}{paciente}.": "兹收到 {pagador}{doc}支付的 {valor}{extenso}，用于 {data} 进行的{tipo}{paciente}。",
 "Recebi outro valor": "我收到了其他金额",
 "Recebida": "已收到",
 "Recebida (toque para desfazer)": "已收（点击撤销）",
 "Recebidas": "已收到",
 "Recebido": "已收到",
 "Recebido: {v}": "已收：{v}",
 "Recebidos": "收件箱",
 "Recebidos dos grupos": "来自群组",
 "Recebimento": "收款",
 "Receita": "食谱",
 "Receitas": "食谱",
 "Recibo": "收据",
 "Recibo em PDF": "PDF 收据",
 "Recibo emitido": "收据已开具",
 "Recibo guardado": "收据已保存",
 "Recibos dedutíveis": "可抵扣收据",
 "Recomendada": "推荐",
 "Recomeçar": "重新开始",
 "Recortar": "裁剪",
 "Recortar margens": "裁剪边距",
 "Recortar, girar e os filtros chegam com o app novo (versão 0.49).": "裁剪、旋转和滤镜将在新版应用（0.49 版）中提供。",
 "Recusada": "已拒绝",
 "Recusado": "已拒绝",
 "Recusar": "拒绝",
 "Redação": "写作",
 "Refazer": "重做",
 "Refeição": "餐次",
 "Refeições, exercícios, cuidados e suplementos marcados para hoje": "今天安排的餐次、运动、养护和补充剂",
 "Referente a": "用途",
 "Referência": "参考资料",
 "Reforço": "加强针",
 "Regar a cada quantos dias": "每隔几天浇水",
 "Regar hoje": "今天浇水",
 "Regar: {p}": "浇水：{p}",
 "Regional": "地区",
 "Registra o diário, as etapas e as entregas, sem ver os valores.": "记录日志、阶段和交付，看不到金额。",
 "Registrar venda/serviço do MEI": "登记 MEI 销售/服务",
 "Registre cada atendimento: a evolução fica no cofre, com criptografia. A prescrição pode vir de um modelo.": "记录每次就诊：病程记录加密保存在保险库中。处方可以使用模板。",
 "Registre compras e vendas de imóveis, veículos e investimentos com os comprovantes. Ajuda muito na hora do imposto.": "记录房产、车辆和投资的买卖及凭证。报税时非常有用。",
 "Registre o que foi diferente do cronograma (trocou um alimento, mudou a refeição). Entra no relatório da semana.": "记录与计划不同的内容（换了食物、改了餐次）。会计入本周报告。",
 "Registro": "记录",
 "Registro clínico": "病历记录",
 "Registro de horas": "工时记录",
 "Registro do diário": "日志记录",
 "Regiões com feriado próprio (marque as suas):": "有专属假日的地区（勾选您所在的地区）：",
 "Regras da casa": "房屋守则",
 "Regras da casa:": "房屋守则：",
 "Reguei": "已浇水",
 "Reguei hoje": "今天已浇水",
 "Reiniciar": "重启",
 "Reiniciar o app": "重启应用",
 "Relatório": "报告",
 "Relatório da semana": "本周报告",
 "Relatório em PDF ou Excel": "PDF 或 Excel 报告",
 "Relatório enviado. Obrigado!": "报告已发送，谢谢！",
 "Relatórios": "报告",
 "Relatórios do Bem-Estar": "健康报告",
 "Relatórios gerados ({n})": "已生成的报告（{n}）",
 "Relaxar": "放松",
 "Religião": "宗教",
 "Relógio": "时钟",
 "Relógio e apps de saúde": "手表和健康 App",
 "Remada baixa": "坐姿划船",
 "Remover": "移除",
 "Remover \"{nome}\"?": "移除 \"{nome}\"？",
 "Remover anotações": "移除注释",
 "Remover este bloco?": "移除此区块？",
 "Remover páginas": "删除页面",
 "Remover vínculo": "移除关联",
 "Remover {nome}?": "移除 {nome}？",
 "Remédio": "药品",
 "Remédio contínuo": "长期用药",
 "Remédio na linha do tempo": "时间线上的用药",
 "Remédios": "药品",
 "Remédios de uso contínuo": "长期用药",
 "Renavam ou chassi": "Renavam 或车架号",
 "Renegociado": "已重新协商",
 "Renomear": "重命名",
 "Renomear com IA": "用 AI 重命名",
 "Renomear ou trocar ícone": "重命名或更换图标",
 "Renomear pasta": "重命名文件夹",
 "Renomear, ícone ou cor": "重命名、图标或颜色",
 "Renovar: {nome}": "续期：{nome}",
 "Reorganiza o arquivo por dentro. Ajuda pouco em PDFs com fotos.": "在内部重新整理文件。对含照片的 PDF 帮助不大。",
 "Reparar PDF": "修复 PDF",
 "Repelente": "驱蚊液",
 "Repete": "重复",
 "Repetir a cada quantos dias": "每隔几天重复",
 "Repetições": "次数",
 "Repita a senha": "再次输入密码",
 "Repita a senha do cofre": "再次输入保险库密码",
 "Repita a senha nova": "再次输入新密码",
 "Replantio": "换盆",
 "Replantios": "换盆记录",
 "Repor papel higiênico, sabonete e café": "补充卫生纸、香皂和咖啡",
 "Representatividade": "多元代表",
 "Reserva": "预订",
 "Reservas": "预订",
 "Reservas, limpeza, receitas e despesas na aba Aluguel & Hospedagem": "预订、清洁、收入和支出请见“出租与民宿”标签页",
 "Respirar fundo 5 vezes": "深呼吸 5 次",
 "Respondendo a {nome}": "回复 {nome}",
 "Responder": "回复",
 "Responsável": "负责人",
 "Responsável (imobiliária, vistoriador)": "负责人（中介、验房员）",
 "Resposta da SEFAZ": "SEFAZ 回复",
 "Resta {tempo}": "剩余 {tempo}",
 "Restam {ml} = {n} copo(s) de {copo}": "还剩 {ml} = {n} 杯 {copo}",
 "Restaurante": "餐厅",
 "Restaurantes": "餐厅",
 "Restaurar": "恢复",
 "Restaurar esta cópia?": "恢复此备份？",
 "Restaurar troca TODOS os dados atuais pelos da cópia, aqui e na sua conta.": "恢复会用备份中的数据替换当前的全部数据，包括本设备和你的账户。",
 "Restaurar uma cópia": "恢复备份",
 "Resultado": "结果",
 "Resultado nas vendas: {v}": "出售盈亏：{v}",
 "Resumir": "摘要",
 "Resumir e perguntar": "总结与提问",
 "Resumo": "摘要",
 "Resumo (falta o XML completo)": "摘要（缺少完整 XML）",
 "Resumo da manhã": "早间摘要",
 "Resumo da pasta": "文件夹摘要",
 "Resumo e opinião": "摘要和评价",
 "Resumo, gastos por categoria, contas, faturas, metas e todos os lançamentos. Bom para mandar ao contador ou guardar para o IR.": "摘要、分类支出、账款、账单、目标和全部收支记录。方便发给会计或留作 IR（个税）申报用。",
 "Retirar": "取出",
 "Retirar da meta": "从目标中取出",
 "Retorno": "复诊",
 "Reunião": "会议",
 "Reunião agora": "立即开会",
 "Reunião de equipe": "团队会议",
 "Reuniões": "会议",
 "Revestimento e pisos": "饰面和地板",
 "Revisão": "保养检修",
 "Revolução Constitucionalista": "护宪革命纪念日",
 "Rico em matéria orgânica": "富含有机质",
 "Rodízio de pneus": "轮胎换位",
 "Roedor": "啮齿动物",
 "Romance": "爱情",
 "Rosca direta": "杠铃弯举",
 "Rota": "路线",
 "Rota passando pelos {n} lugares que faltam": "经过剩余 {n} 个地点的路线",
 "Rotas e mapas": "路线和地图",
 "Roteiro": "行程",
 "Roteiro por dia que entra na linha do tempo durante a viagem, mala pelo clima, reservas e fusos.": "旅行期间每天的行程会进入时间线，另有按天气准备行李、预订和时区。",
 "Rotina": "日常",
 "Rotinas com passo a passo: skincare, alongamento, cabelo... Toque em \"+ Cuidado\" para escolher um modelo ou criar o seu.": "分步进行的日常护理：护肤、拉伸、护发... 点击\"+ 护理\"选择模板或自行创建。",
 "Roupa": "衣物",
 "Roupa social": "正装",
 "Roupas de banho": "泳衣",
 "Roupas extras das crianças": "孩子的备用衣服",
 "Roupas íntimas": "内衣",
 "Rua": "街道",
 "Rua, número, bairro, cidade (ou o nome do lugar)": "街道、门牌号、街区、城市（或地点名称）",
 "Régua": "直尺",
 "Réptil": "爬行动物",
 "Rótulo (ex.: Meu nome, Empresa do cliente)": "标签（例：我的姓名、客户公司）",
 "SAC": "SAC（等额本金）",
 "SEM HORÁRIO": "未设时间",
 "SEU MÊS EM NÚMEROS": "你本月的数字",
 "SEU TREINO": "你的训练",
 "SEUS GRUPOS DO APP": "你在应用中的群组",
 "SP": "SP",
 "SUBTAREFA": "子任务",
 "SUBTAREFAS": "子任务",
 "SUPLEMENTAÇÃO": "补充剂",
 "Sabonete facial": "洗面奶",
 "Sabão para lavar roupa": "洗衣液",
 "Sacada": "阳台",
 "Sai só da lista deste app. A cópia guardada no Drive, no OneDrive ou na pasta do celular continua lá.": "仅从此应用的列表中移除。保存在 Drive、OneDrive 或手机文件夹中的副本仍然保留。",
 "Sai só da lista. O arquivo continua onde foi salvo.": "仅从列表中移除。文件仍保留在保存的位置。",
 "Sair": "退出",
 "Sair da conta?": "退出账户？",
 "Sair do escritório": "退出办公室",
 "Sair do escritório?": "退出办公室？",
 "Sair do grupo": "退出群组",
 "Sair do grupo?": "退出该群组？",
 "Sair sem baixar": "不下载直接离开",
 "Saiu": "支出",
 "Sala": "教室",
 "Sala de estar": "客厅",
 "Sala de jantar": "餐厅",
 "Sala virtual": "线上会议室",
 "Salada": "沙拉",
 "Saldo": "余额",
 "Saldo depois desta parcela": "本期后剩余欠款",
 "Saldo devedor: {v}": "剩余欠款：{v}",
 "Saldo do mês": "本月结余",
 "Salvar": "保存",
 "Salvar backup do My Planner": "保存 My Planner 备份",
 "Salvar cuidado": "保存护理项目",
 "Salvar cômodo": "保存房间",
 "Salvar e colocar no My Planner": "保存并加入 My Planner",
 "Salvar e sincronizar": "保存并同步",
 "Salvar e testar": "保存并测试",
 "Salvar endereço": "保存地址",
 "Salvar no My Planner": "保存到 My Planner",
 "Salvar refeição": "保存餐次",
 "Salvar suplemento": "保存补充剂",
 "Salvar tarefa": "保存任务",
 "Salvar treino": "保存训练",
 "Sanduíche natural": "健康三明治",
 "Santo Antônio": "圣安东尼节",
 "Sapato confortável": "舒适的鞋",
 "Saudade": "想你",
 "Saída (imóvel antigo)": "退房检查（旧房）",
 "Saída de praia": "沙滩罩衫",
 "Saúde": "健康",
 "Saúde & Prontuário": "健康与病历",
 "Saúde (médicos, dentistas, exames, plano)": "医疗（医生、牙医、检查、医保）",
 "Saúde e bem-estar": "健康与身心",
 "Scanner": "扫描",
 "Scanner PDF": "PDF 扫描",
 "Sci-Fi": "科幻",
 "Se alguma coisa não responder, reinicie o app. Os seus dados estão salvos.": "如果有内容没有响应，请重启应用。你的数据已保存。",
 "Se der tempo": "有时间再去",
 "Se esta política mudar de forma importante, o app avisa e pede o seu aceite de novo.": "如果本政策发生重要变更，应用会通知你并再次请求你的同意。",
 "Se este aviso apareceu, os alertas dos compromissos estão funcionando.": "如果出现了此提醒，说明日程提醒工作正常。",
 "Se existir uma conta com {email}, enviamos um link para criar uma senha nova. Confira também o spam.": "如果存在使用 {email} 的账户，我们已发送创建新密码的链接。也请检查垃圾邮件。",
 "Se o alerta atrasar ou não aparecer: nas configurações do app, deixe as notificações ligadas, a bateria \"sem restrição\" e permita \"Alarmes e lembretes\".": "如果提醒延迟或没有出现：请在应用设置中保持通知开启、电池设为“无限制”，并允许“闹钟和提醒”。",
 "Se o relógio estiver conectado, os números dele entram por cima dos digitados quando ele tiver o dado.": "如果手表已连接，只要手表有数据，就会覆盖手动输入的数字。",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect (Android) ou do app Saúde (iPhone). O app só lê e nunca altera esses dados.": "如果你连接手表：每天的步数、距离、卡路里、锻炼、心率和睡眠汇总，从 Health Connect（Android）或“健康”App（iPhone）读取。本 App 只读取，绝不修改这些数据。",
 "Se você já usou esta aba, nada foi apagado: tudo volta como estava ao assinar.": "如果你之前用过此标签页，内容都没有被删除：订阅后会恢复原样。",
 "Secretária ou recepção": "秘书或前台",
 "Seg a sex": "周一至周五",
 "Seguir": "继续",
 "Segunda": "周一",
 "Segurança": "安全",
 "Segure e arraste para mudar a ordem. ↻ gira, ⧉ duplica e ✕ tira a página.": "按住并拖动以调整顺序。↻ 旋转，⧉ 复制，✕ 删除页面。",
 "Segure um GIF numa conversa e toque em \"Guardar\" para ele aparecer aqui.": "在聊天中长按 GIF 并点按\"保存\"，它就会出现在这里。",
 "Segure um cômodo para mudar de lugar. Com o cômodo aberto, segure uma tarefa e solte em outro cômodo para levá-la.": "按住房间可调整位置。打开房间后，按住任务并拖到另一个房间即可移过去。",
 "Segure um fichário, uma matéria ou uma página para mudar a ordem. Solte uma matéria em outro fichário para levá-la para lá.": "按住活页夹、科目或页面可调整顺序。把科目拖到另一个活页夹即可移过去。",
 "Segure uma conversa para silenciar ou arquivar. Arquivada continua recebendo e enviando, mas sem aviso.": "长按聊天可将其静音或归档。已归档的聊天仍可收发消息，但不会通知。",
 "Seguro": "保险",
 "Seguro da casa": "家庭财产保险",
 "Seguro viagem": "旅行保险",
 "Selecionar": "选择",
 "Sem": "无",
 "Sem alerta": "不提醒",
 "Sem categoria": "无类别",
 "Sem comprovante": "无凭证",
 "Sem conexão com o servidor de notas. Confira a internet e o endereço do servidor.": "无法连接发票服务器。请检查网络和服务器地址。",
 "Sem conexão com o servidor. Confira a internet.": "无法连接服务器。请检查网络。",
 "Sem conexão com os GIFs agora.": "暂时无法连接 GIF。",
 "Sem cômodo": "未指定房间",
 "Sem data de fim": "无结束日期",
 "Sem exercícios": "无锻炼",
 "Sem fatura em {mes}": "{mes}无账单",
 "Sem fim": "无结束",
 "Sem horário": "未设时间",
 "Sem internet ou servidor ainda não preparado.": "没有网络或服务器尚未准备好。",
 "Sem internet. Envia quando voltar.": "无网络。恢复后会自动发送。",
 "Sem internet. Tente de novo.": "没有网络。请重试。",
 "Sem isso, a tarja só cobre: o texto por baixo continua no arquivo e dá para copiar.": "不勾选的话，黑条只是遮盖：下面的文字仍在文件中，可以被复制。",
 "Sem itens": "没有条目",
 "Sem juros": "无息",
 "Sem limite": "无上限",
 "Sem link de calendário": "没有日历链接",
 "Sem margem": "无边距",
 "Sem nome": "未命名",
 "Sem número na primeira página (capa)": "首页（封面）不显示页码",
 "Sem pasta": "无文件夹",
 "Sem pausas": "无休息",
 "Sem permissão": "无权限",
 "Sem prazo": "无期限",
 "Sem recibo": "无收据",
 "Sem tarefas": "没有任务",
 "Sem texto.": "无文本。",
 "Sem tomador identificado": "未识别服务接收方",
 "Sem título": "无标题",
 "Sem validade": "无有效期",
 "Semana": "本周",
 "Semana completa": "整周",
 "Semana de {de} a {ate}": "{de} 至 {ate} 这一周",
 "Semanal": "每周",
 "Semanal · dias úteis": "每周 · 工作日",
 "Semanal · todos os dias": "每周 · 每天",
 "Semanal · {dias}": "每周 · {dias}",
 "Sempre aparecem, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "始终显示，同时显示选择性休息日（狂欢节、圣灰星期三和基督圣体节）。",
 "Senha": "密码",
 "Senha (8 caracteres ou mais)": "密码（8 个字符或以上）",
 "Senha alterada.": "密码已更改。",
 "Senha atual": "当前密码",
 "Senha atual do cofre": "当前保险库密码",
 "Senha da conta": "账户密码",
 "Senha do certificado": "证书密码",
 "Senha do cofre": "保险库密码",
 "Senha do cofre alterada.": "保险库密码已更改。",
 "Senha do cofre incorreta.": "保险库密码错误。",
 "Senha incorreta": "密码错误",
 "Senha incorreta.": "密码错误。",
 "Senha nova (8 caracteres ou mais)": "新密码（8 个字符或以上）",
 "Senha nova do cofre (6 caracteres ou mais)": "新的保险库密码（至少 6 个字符）",
 "Senha, biometria, bloqueio e privacidade": "密码、生物识别、锁定和隐私",
 "Senha, e-mail e formas de desbloquear": "密码、邮箱和解锁方式",
 "Separar informes de rendimentos (bancos, empregador, corretoras)": "整理收入证明（银行、雇主、券商）",
 "Servidor de notas": "发票服务器",
 "Servidor não configurado (lib/config.ts).": "服务器未配置（lib/config.ts）。",
 "Servidor não configurado.": "服务器未配置。",
 "Servidor não configurado: faltam os dados do Supabase em lib/config.ts.": "服务器未配置：lib/config.ts 中缺少 Supabase 数据。",
 "Serviço": "服务",
 "Serviço não prestado": "服务未提供",
 "Serviços": "服务",
 "Será excluída em 1 dia": "将在 1 天后删除",
 "Será excluída em {n} dias": "将在 {n} 天后删除",
 "Será excluída hoje": "将于今天删除",
 "Sessão": "疗程",
 "Seu acesso ainda precisa ser liberado. Tente entrar em alguns instantes.": "你的访问权限尚待开通。请稍后再尝试登录。",
 "Seu código": "你的代码",
 "Seu código de amigo": "你的好友代码",
 "Seu código para amigos ganharem 10 dias com todas as abas": "你的代码，可让朋友获得 10 天全部标签页解锁",
 "Seu nome": "你的姓名",
 "Seu papel: {p}": "你的角色：{p}",
 "Seu papel: {p}. {d}": "你的角色：{p}。{d}",
 "Seu scanner de bolso": "你的口袋扫描仪",
 "Seus dados continuam salvos na nuvem.": "你的数据仍保存在云端。",
 "Seus dados na nuvem do My Planner": "你在 My Planner 云端的数据",
 "Seus dados são seus: não vendemos e não usamos para publicidade. Você pode exportar ou apagar tudo quando quiser.": "你的数据属于你：我们不出售，也不用于广告。你可以随时导出或删除全部数据。",
 "Seus {n} meses grátis terminaram": "你的 {n} 个月免费期已结束",
 "Sexta": "周五",
 "Sextou": "周五",
 "Sextou!": "周五啦！",
 "Shampoo": "洗发水",
 "Show ou passeio": "演出或游览",
 "Silenciar avisos": "关闭通知",
 "Sim": "是",
 "Simples Nacional": "Simples Nacional",
 "Sincronizado em {data}": "同步于 {data}",
 "Sincronizando pelo dispositivo {nome}": "正在通过设备 {nome} 同步",
 "Sincronizando...": "正在同步...",
 "Sincronizar agora": "立即同步",
 "Sincronização parada: confirme sua senha. Nada se perde.": "同步已暂停：请确认密码。不会丢失任何内容。",
 "Site da assistência": "售后服务网站",
 "Site da assistência (https://...)": "售后服务网站（https://...）",
 "Site ou ingresso online": "网站或在线购票",
 "Situação": "状态",
 "Situação agora": "当前状态",
 "Skincare da manhã": "早间护肤",
 "Skincare da noite": "夜间护肤",
 "Slides": "幻灯片",
 "Smileys e pessoas": "笑脸与人物",
 "Sobremesa": "甜点",
 "Sobrou no mês": "本月结余",
 "Sociologia": "社会学",
 "Sofá": "沙发",
 "Sol": "太阳",
 "Sol pleno": "全日照",
 "Solo ou substrato": "土壤或基质",
 "Solte numa matéria para mover a página para lá:": "拖到某个科目上即可把页面移过去：",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia. Avisa 15 e 3 dias antes.": "合计法定保修和厂家保修。请核对保修条款。到期前 15 天和 3 天提醒。",
 "Sombra": "阴凉",
 "Somente esta tarefa": "仅此任务",
 "Sono": "睡眠",
 "Sono da noite": "昨晚睡眠",
 "Sopa": "汤",
 "Sou MEI": "我是 MEI",
 "Status": "状态",
 "Sua conexão com a nuvem venceu (acontece quando o app fica muito tempo sem abrir ou a senha foi trocada em outro dispositivo). Nada se perde: o que está aqui é enviado assim que você confirmar.": "你与云端的连接已过期（应用长时间未打开或在其他设备上更改了密码时会发生）。不会丢失任何内容：确认后，这里的内容会立即发送。",
 "Sua equipe num lugar só: conversa, documentos, reuniões de vídeo com gravação e convite pelo link.": "把你的团队聚在一起：聊天、文档、可录制的视频会议，以及链接邀请。",
 "Sua rotina em um só lugar": "你的日常，一站搞定",
 "Sua senha": "你的密码",
 "Suas abas": "您的标签页",
 "Substituir": "替换",
 "Substrato usado": "使用的基质",
 "Subtarefa {n}": "子任务 {n}",
 "Suco": "果汁",
 "Sugerir nome": "建议名称",
 "Sugestão": "建议",
 "Sugestões de {categoria}": "{categoria} 建议",
 "Supabase: guarda a conta e os dados sincronizados, como operador. Os servidores podem ficar fora do Brasil, com as garantias do art. 33 da LGPD.": "Supabase：作为处理者保存账户和同步的数据。服务器可能位于巴西境外，并受 LGPD art. 33 的保障。",
 "Superiores": "高等法院",
 "Supino reto": "平板卧推",
 "Suplemento": "补充剂",
 "Suspense": "悬疑",
 "Suíte": "套房",
 "Sábado": "星期六",
 "São Paulo": "圣保罗",
 "São Paulo (SP)": "圣保罗 (SP)",
 "São mais de 60 arquivos. Use \"A cada N páginas\".": "超过 60 个文件。请使用\"每 N 页\"。",
 "Série": "剧集",
 "Série da DPS": "DPS 系列",
 "Série e turma": "年级和班级",
 "Séries": "组数",
 "Sérum": "精华液",
 "Símbolos": "符号",
 "Só a equipe do escritório vê. Até 50 MB por arquivo.": "仅办公室团队可见。每个文件最大 50 MB。",
 "Só acompanha": "仅查看",
 "Só acompanha, sem valores": "仅查看，不含金额",
 "Só administradores": "仅管理员",
 "Só em {data}": "仅 {data}",
 "Só leitura": "只读",
 "Só mandar para a aba Estudos (sem escolher página)": "仅发送到学习标签页（不选择页面）",
 "Só neste dispositivo": "仅本设备",
 "Só neste dispositivo: {n}": "仅在此设备：{n}",
 "Só o código": "仅代码",
 "Só o dia {data}": "仅 {data} 当天",
 "Só os dados (texto)": "仅信息（文本）",
 "Só os totais das Finanças vão para a sua IA. Não é recomendação de investimento.": "只有金融的汇总数据会发送给你的 AI。这不是投资建议。",
 "Só seu: estudos, estratégias pedagógicas e o que funcionou ou não em cada aula. Os alunos não veem.": "仅你可见：研究、教学策略以及每节课的得失。学生看不到。",
 "Só um celular sincroniza com a agenda. Para passar para este, toque abaixo.": "只有一部手机可以与日历同步。如要切换到本机，请点按下方。",
 "Só uma vez": "仅一次",
 "Só uma vez (abrir a ficha da tarefa)": "仅一次（打开任务卡片）",
 "Só áudio": "仅音频",
 "Sótão": "阁楼",
 "TAREFAS DA CASA": "家务",
 "TELEFONE (OPCIONAL)": "电话（选填）",
 "TRAZER PARA O MY PLANNER": "导入到 MY PLANNER",
 "TV por assinatura": "付费电视",
 "Tabela": "表格",
 "Talvez": "待定",
 "Tamanho": "大小",
 "Tamanho da foto": "照片尺寸",
 "Tamanho da página": "页面尺寸",
 "Tamanho das páginas": "页面尺寸",
 "Tamanho do arquivo": "文件大小",
 "Tamanho do copo": "杯子容量",
 "Também procurar nos Diários Oficiais dos municípios": "同时搜索各市的政府公报",
 "Também serão excluídos {n} item(ns) dentro dele.": "其中的 {n} 个项目也会被删除。",
 "Tapioca": "木薯饼",
 "Tarefa": "任务",
 "Tarefa da casa": "家务",
 "Tarefa de casa": "家庭作业",
 "Tarefa duplicada": "任务已复制",
 "Tarefa ou entrega": "任务或交付物",
 "Tarefa para {nome}": "{nome} 的任务",
 "Tarefas da casa": "家务",
 "Tarefas e itens de todas as abas": "所有标签页中的任务和项目",
 "Tarefas novas do My Planner vão para: {agenda}": "My Planner 的新任务将添加到：{agenda}",
 "Tarefas que se repetem e passam do período continuam nos outros dias; só os dias escolhidos saem.": "超出时间段的重复任务会在其他日期继续保留；只删除所选的日期。",
 "Tarjas pretas sobre CPF, valores e nomes. Apaga de verdade.": "用黑条遮盖 CPF、金额和姓名。彻底删除。",
 "Tartaruga": "乌龟",
 "Taxa de limpeza": "清洁费",
 "Taxa de limpeza cobrada do hóspede": "向房客收取的清洁费",
 "Taxas e anúncios": "费用与房源推广",
 "Te amo": "爱你",
 "Tecnologia": "科技",
 "Tela cheia": "全屏",
 "Teleconsulta": "远程问诊",
 "Telefone": "电话",
 "Telefone da assistência": "售后服务电话",
 "Telefone da empresa": "公司电话",
 "Telefone da escola": "学校电话",
 "Telefone da limpeza": "保洁电话",
 "Telefone de emergência": "紧急电话",
 "Telefone do veterinário": "兽医电话",
 "Telhado": "屋顶",
 "Tem anexos": "有附件",
 "Tem certeza?": "确定吗？",
 "Tem {n} conta(s) em atraso somando {v}. Pague primeiro as que cobram juros mais altos, como o cartão e o cheque especial.": "你有 {n} 笔逾期账款，共计 {v}。先还利息最高的，比如信用卡和透支。",
 "Tema": "主题",
 "Tempo de preparo": "准备时间",
 "Temporada": "季",
 "Temporizador (direita)": "计时器（右滑）",
 "Tenta consertar um PDF que não abre direito.": "尝试修复无法正常打开的 PDF。",
 "Tentar de novo": "重试",
 "Tente uma foto mais nítida, com a página inteira.": "请试试更清晰、包含整页的照片。",
 "Termina às {hora}": "{hora} 结束",
 "Terminar até": "完成期限",
 "Terminei em": "结束于",
 "Terminou": "已结束",
 "Terminou em {data}. Nada foi apagado: tudo volta como estava ao assinar.": "已于 {data} 结束。没有删除任何内容：订阅后一切恢复原样。",
 "Termos de uso": "使用条款",
 "Termos de uso e privacidade": "使用条款和隐私",
 "Terror": "恐怖",
 "Terça": "周二",
 "Testando...": "正在测试...",
 "Testar alerta (1 minuto)": "测试提醒（1 分钟）",
 "Testar aviso": "测试通知",
 "Teste de alerta do Planner": "Planner 提醒测试",
 "Teste grátis até {data} ({n} dia(s))": "免费试用至 {data}（{n} 天）",
 "Teste grátis: {n} dia(s)": "免费试用：{n} 天",
 "Teste terminado": "试用已结束",
 "Teste terminou em {data}": "试用已于 {data} 结束",
 "Teste: aviso feito pelo próprio celular.": "测试：由本机自身生成的通知。",
 "Texto": "文本",
 "Texto completo": "全文",
 "Texto copiado. Cole onde quiser enviar.": "文本已复制。粘贴到你想发送的地方。",
 "Texto do documento": "文档文字",
 "Texto extra do convite (traje, presentes...)": "邀请附加说明（着装、礼物……）",
 "Texto livre": "自由文本",
 "Texto ou recado": "文本或通知",
 "Texto para PDF": "文字转 PDF",
 "Texto {data}": "文字 {data}",
 "Tipo": "类型",
 "Tipo sanguíneo": "血型",
 "Tira as páginas que você não quer.": "删除不需要的页面。",
 "Tira autor, programas, comandos escondidos e anexos.": "移除作者、程序信息、隐藏命令和附件。",
 "Tira comentários, destaques e desenhos de outros programas.": "移除其他程序添加的批注、高亮和绘图。",
 "Tira o texto do PDF (arquivo .txt).": "提取 PDF 中的文字（.txt 文件）。",
 "Tiradentes": "蒂拉登特斯日",
 "Tirar": "移除",
 "Tirar a assinatura": "移除签名",
 "Tirar a foto": "移除照片",
 "Tirar a foto agora": "立即拍照",
 "Tirar admin": "取消管理员",
 "Tirar alarmes do My Planner": "从 My Planner 移除闹钟",
 "Tirar arquivos anexados": "移除附加的文件",
 "Tirar comentários, destaques e links": "移除批注、高亮和链接",
 "Tirar da agenda": "从日程中移除",
 "Tirar da barra": "从标签栏移除",
 "Tirar daqui": "从这里移除",
 "Tirar das minhas figurinhas?": "从我的贴纸中移除？",
 "Tirar de administrador": "取消管理员",
 "Tirar do escritório": "移出办公室",
 "Tirar dos meus GIFs?": "从我的 GIF 中移除？",
 "Tirar este copo": "移除这杯",
 "Tirar foto": "拍照",
 "Tirar fotos de boletos, cupons e documentos e escolher fotos e vídeos da galeria.": "拍摄付款单、小票和文件，并从相册中选择照片和视频。",
 "Tirar o desenho padrão?": "移除图案解锁？",
 "Tirar o lixo": "倒垃圾",
 "Tire a foto e a sua IA preenche a ficha": "拍张照片，你的 AI 会自动填写表单",
 "Titular (de quem é o documento)": "持有人（证件所属人）",
 "Titular: {nome}": "持有人：{nome}",
 "Toalha de praia": "沙滩巾",
 "Tocar os pés": "弯腰摸脚尖",
 "Toda a agenda": "全部日程",
 "Toda semana": "每周",
 "Todas": "全部",
 "Todas (passadas, esta e futuras)": "全部（过去、此次和之后）",
 "Todas ({n})": "全部（{n}）",
 "Todas as abas liberadas até {data}.": "所有标签页已解锁至 {data}。",
 "Todas as capitais. Marque uma ou mais cidades.": "所有州首府。可选择一个或多个城市。",
 "Todas as ferramentas de PDF: juntar, dividir, organizar, assinar, carimbo, tarja, números de página, formulários, comprimir, converter, OCR e IA. Guarda no celular, no Google Drive ou no OneDrive.": "全套 PDF 工具：合并、拆分、整理、签名、印章、涂黑、页码、表单、压缩、转换、OCR 和 AI。可保存到手机、Google Drive 或 OneDrive。",
 "Todas as ferramentas ficam na tela da aba.": "所有工具都在此标签页的屏幕上。",
 "Todas as fotos da viagem ficam aqui: as que você puser no álbum e as do roteiro, dos lugares e das reservas.": "旅行的所有照片都在这里：你添加到相册的，以及行程、地点和预订中的照片。",
 "Todas as plantas estão regadas.": "所有植物都已浇过水。",
 "Todas as páginas, uma embaixo da outra.": "所有页面上下相连。",
 "Todo ano": "每年",
 "Todo dia": "每天",
 "Todo dia no horário escolhido: quantas tarefas o dia tem, a primeira e a energia total.": "每天在所选时间推送：当天任务数量、第一个任务和总精力。",
 "Todo mês": "每月",
 "Todo mês · dia {d}": "每月 · {d} 日",
 "Todo o histórico": "全部历史记录",
 "Todos": "全部",
 "Todos ({n})": "全部（{n}）",
 "Todos do grupo": "群组全体",
 "Todos do grupo veem": "群组所有人可见",
 "Todos na reunião veem o aviso \"Gravando\". O arquivo vai para os Documentos do escritório, visível só para você até você liberar para a equipe.": "会议中所有人都会看到“录制中”提示。文件会保存到办公室的文档中，在你开放给团队之前仅你可见。",
 "Todos os cuidados": "全部养护",
 "Todos os dias": "每天",
 "Todos os suplementos": "全部补充剂",
 "Todos os treinos": "全部训练",
 "Todos os tribunais": "所有法院",
 "Todos presentes": "全部到齐",
 "Todos saem do grupo. O que cada pessoa já aceitou continua na agenda dela.": "所有人都将退出群组。每个人已接受的内容会保留在其日程中。",
 "Todos trabalham nos mesmos dados, cada um conforme o papel. Toque no papel de cada pessoa em Membros para trocar.": "所有人在同一份数据上协作，各按自己的角色。在“成员”中点按某人的角色即可更改。",
 "Tomador": "服务接收方",
 "Tomador (quem contratou)": "服务接收方（委托人）",
 "Tomadores": "服务接收方",
 "Tomei": "借入",
 "Toque aqui ou no + para criar uma tarefa": "点击这里或 + 创建任务",
 "Toque em \"Apagar minha conta e todos os dados\" e confirme.": "点按“删除我的账户和所有数据”并确认。",
 "Toque em + › Novo cartão de crédito e informe os dias de fechamento e de vencimento.": "点按 + › 新信用卡，并填写账单日和到期日。",
 "Toque em Ajustes e depois em Segurança.": "点按“设置”，然后点按“安全”。",
 "Toque em Conectar e, na tela da Apple, ligue os itens que o My Planner pode ler.": "点按“连接”，然后在 Apple 的界面中打开 My Planner 可读取的项目。",
 "Toque em Conectar e, na tela do Health Connect, permita que o My Planner leia os dados.": "点按“连接”，然后在 Health Connect 界面中允许 My Planner 读取数据。",
 "Toque em quem NÃO deve ver esta ficha (e o que está dentro dela). Ex.: o presente surpresa.": "点选不应看到此卡片（及其内容）的人。例如：惊喜礼物。",
 "Toque em uma aba para abrir. As bloqueadas mostram como assinar.": "点按标签页即可打开。已锁定的标签页会显示订阅方式。",
 "Toque em uma aba para abrir. Cada aba extra pode ser testada de graça por 10 dias.": "点按标签页即可打开。每个额外标签页可免费试用 10 天。",
 "Toque em uma aba para abrir. Toque em 📌 para pôr ou tirar a aba da barra de baixo. Cada aba extra pode ser testada de graça por 10 dias.": "点按标签页即可打开。点按 📌 可将标签页放入或移出底部标签栏。每个额外标签页都可以免费试用 10 天。",
 "Toque em uma área para abrir. As bloqueadas mostram como assinar.": "点击某个区域即可打开。已锁定的区域会显示如何订阅。",
 "Toque no desenho para continuar desenhando.": "点击绘图继续绘画。",
 "Toque no que este grupo vai compartilhar. Tudo o que está dentro (roteiro, fotos, reservas...) vai junto e todos participam.": "点选此群组要分享的内容。里面的一切（行程、照片、预订...）都会一起分享，所有人都能参与。",
 "Toque nos PDFs na ordem em que devem ficar.": "按应有的顺序点按 PDF。",
 "Toque num copo para mudar o volume; segure o + para um copo de outro tamanho.": "点按杯子可更改容量；长按 + 可添加其他容量的杯子。",
 "Toque num feriado para adicioná-lo ao Planner.": "点按假日即可将其添加到 Planner。",
 "Toque num lançamento para trocar a categoria, guardar o recibo no IR ou apagar.": "点按一条记录可以更改类别、保存 IR 收据或删除。",
 "Toque num lançamento para trocar a categoria. Pressione e segure para apagar.": "点按记录可更改类别。长按可删除。",
 "Toque num perfil para editar. Pressione e segure para removê-lo.": "点按资料即可编辑。长按可将其删除。",
 "Toque num texto, desenho ou checklist e arraste para qualquer lugar da folha.": "点按文字、绘图或清单，然后拖到页面上的任意位置。",
 "Toque numa página para recortar, girar ou mudar o filtro. Segure e arraste para mudar a ordem.": "点按页面可裁剪、旋转或更换滤镜。长按并拖动可调整顺序。",
 "Toque numa tarefa para copiar ou mover para hoje.": "点按任务即可复制或移到今天。",
 "Toque onde quer a checklist.": "点按要放置清单的位置。",
 "Toque onde quer escrever.": "点按要书写的位置。",
 "Toque para abrir": "点击打开",
 "Toque para abrir no app do celular. Arraste para a direita para tirar da lista.": "点按可在手机应用中打开。向右滑动可从列表中移除。",
 "Toque para abrir, segure para mudar o nome. Arraste para a esquerda para arquivar ou para a direita para excluir.": "点按打开，长按重命名。向左滑动归档，向右滑动删除。",
 "Toque para abrir. Arraste para a direita para tirar da lista.": "点按打开。向右滑动可从列表中移除。",
 "Toque para aceitar ou recusar.": "点按以接受或拒绝。",
 "Toque para aceitar, editar ou recusar.": "点按以接受、编辑或拒绝。",
 "Toque para aplicar agora. Ou ela entra sozinha ao reabrir o app.": "点击立即应用。或者重新打开应用时自动生效。",
 "Toque para baixar e instalar por cima. Seus dados continuam.": "点击下载并覆盖安装。你的数据会保留。",
 "Toque para conversar": "点按开始聊天",
 "Toque para enviar o emoji animado": "点按发送动态表情",
 "Toque para enviar. Segure para guardar ou tirar das suas.": "点按发送。长按可保存或移除。",
 "Toque para escolher": "点按选择",
 "Toque para fechar": "点按关闭",
 "Toque para gerar um novo QR Code": "点击生成新的二维码",
 "Tornar admin": "设为管理员",
 "Tornar administrador": "设为管理员",
 "Tosa": "美容修剪",
 "Totais por alimento": "按食物汇总",
 "Total": "合计",
 "Total bruto": "总额",
 "Total das reservas: {v}": "预订总额：{v}",
 "Total de aulas": "总课时",
 "Total de capítulos": "总章节数",
 "Total de módulos": "总模块数",
 "Total de páginas": "总页数",
 "Total de recibos: {v}": "收据总额：{v}",
 "Total: {n}. Cada aba pode ter até {lim} de texto (fotos e arquivos não contam: ficam no dispositivo ou no seu Drive).": "总计：{n}。每个标签页最多可有 {lim} 文本（照片和文件不计入：它们保存在设备或你的 Drive 中）。",
 "Total: {v}": "总计：{v}",
 "Trabalhando...": "处理中...",
 "Trabalho": "劳动法院",
 "Traga os compromissos da sua agenda do Google para o My Planner e edite por aqui: as mudanças voltam para a agenda.": "将 Google 日历中的日程导入 My Planner 并在这里编辑：更改会同步回日历。",
 "Trans": "跨性别",
 "Transferir: {s}": "转移：{s}",
 "Transferência": "转移",
 "Transferências": "转移",
 "Transporte": "交通",
 "Tratamento": "治疗",
 "Travar depois de preencher": "填写后锁定",
 "Trazer todas para hoje": "全部移到今天",
 "Trazer tudo para hoje?": "全部移到今天？",
 "Trecho ou ideia": "摘录或想法",
 "Treino": "训练",
 "Trem ou ônibus": "火车或大巴",
 "Treme": "抖动",
 "Tribunais": "法院",
 "Trilha": "徒步",
 "Triste": "难过",
 "Triângulo": "三角形",
 "Troca de óleo": "更换机油",
 "Troca de óleo, rodízio de pneus, revisões por km, IPVA, licenciamento e seguro.": "更换机油、轮胎换位、按里程保养、IPVA、年检登记和保险。",
 "Trocador portátil": "便携尿布台",
 "Trocar": "更换",
 "Trocar a categoria": "更改类别",
 "Trocar a foto": "更换照片",
 "Trocar a pasta": "更换文件夹",
 "Trocar a senha do cofre": "更改保险库密码",
 "Trocar número": "更换号码",
 "Trocar o certificado": "更换证书",
 "Trocar o código": "更换邀请码",
 "Trocar o código?": "更换邀请码？",
 "Trocar o desenho": "更换图案",
 "Trocar o emoji": "更换表情",
 "Trocar o modelo": "更换模型",
 "Trocar o número": "更换号码",
 "Trocar o número do celular": "更换手机号码",
 "Trocar por:": "更换为：",
 "Trocar roupa de cama e toalhas": "更换床品和毛巾",
 "Tríceps na polia": "绳索下压",
 "Tubo de ensaio": "试管",
 "Tudo": "全部",
 "Tudo certo": "一切就绪",
 "Tudo em dia por aqui. Lance os gastos do dia a dia para eu enxergar para onde o dinheiro vai.": "一切正常。记录日常开支，让我看清钱都花到哪儿去了。",
 "Tudo já fica salvo na sua conta. O arquivo é uma cópia extra que você guarda onde quiser.": "所有内容都已保存在你的账户中。此文件是额外的副本，你可以随意保存。",
 "Tudo o que está dentro de \"{nome}\" passa a ser visto pelo grupo, cada pessoa conforme o papel que você escolher (quem entra começa com o papel mais limitado).": "\"{nome}\" 中的所有内容将对群组可见，每人可见的内容取决于你选择的角色（新加入者从权限最少的角色开始）。",
 "Tudo! Já comprei os ingressos.": "都好了！我已经买好票了。",
 "Turma": "班级",
 "Turma (opcional)": "班级（可选）",
 "Turmas": "班级",
 "Turmas e grupos (aulas, mentoria, treino): alunos, chamada, notas, planos, materiais, cobranças e o seu caderno.": "班级与小组（课程、辅导、训练）：学生、点名、成绩、教案、资料、收费和你的笔记本。",
 "Turmas, alunos, chamada, notas e planos de aula.": "班级、学生、点名、成绩和教案。",
 "Turmas, pacientes, equipes e convidados": "班级、患者、团队和来宾",
 "Técnico": "技术",
 "Título": "标题",
 "Título (ex.: Capítulo 3)": "标题（例：第 3 章）",
 "Título (opcional)": "标题（可选）",
 "Título da caixa": "收纳盒标题",
 "Título de eleitor": "选民证",
 "Título, autor, assunto e palavras-chave.": "标题、作者、主题和关键词。",
 "Tô chegando": "马上到",
 "Tônico": "爽肤水",
 "UF": "UF",
 "Uau": "哇",
 "Uhuul!": "耶！",
 "Um PDF novo só com as páginas escolhidas.": "仅包含所选页面的新 PDF。",
 "Um texto clarinho na diagonal de todas as páginas.": "在所有页面上斜向添加淡淡的文字。",
 "Uma pasta para cada cliente: vocês trocam documentos nos dois sentidos e cada cliente só vê a pasta dele.": "每位客户一个文件夹：双方互传文件，每位客户只能看到自己的文件夹。",
 "Uma página por arquivo": "每个文件一页",
 "Uma página por arquivo, a cada N páginas ou por faixas.": "每个文件一页、每 N 页或按范围。",
 "Unicórnio": "独角兽",
 "Unidade": "单位",
 "Universal": "通用土",
 "União": "团结",
 "Usa a conta Google que já está no celular. Nenhuma senha do Google é pedida pelo My Planner.": "使用手机上已有的 Google 帐号。My Planner 不会要求你输入 Google 密码。",
 "Usado: {u} · livre: {v} · limite {l}": "已用：{u} · 可用：{v} · 额度 {l}",
 "Usar": "使用",
 "Usar \"{nome}\"": "使用“{nome}”",
 "Usar biometria": "使用生物识别",
 "Usar desenho padrão": "使用图案解锁",
 "Usar este celular": "使用这部手机",
 "Usar este nome": "使用此名称",
 "Usar modelo: {m}": "使用模板：{m}",
 "Usar no navegador (My Planner Web)": "在浏览器中使用（My Planner Web）",
 "Usar o arquivo já anexado ({nome})": "使用已附加的文件（{nome}）",
 "Usar o código": "使用代码",
 "Usar senha": "使用密码",
 "Usar {ia}": "使用 {ia}",
 "Use a senha nova da próxima vez que entrar, aqui e no My Planner Web.": "下次登录时请使用新密码，包括此处和 My Planner Web。",
 "Use a senha para desbloquear.": "请使用密码解锁。",
 "Use a sua própria IA para ler publicações, documentos e anotações e sugerir agendamentos. Você sempre confirma antes de qualquer coisa entrar no Planner.": "使用你自己的 AI 读取公告、证件和笔记，并给出日程建议。任何内容加入 Planner 之前，都需要你确认。",
 "Use este código ao criar a sua conta e ganhe 10 dias com todas as abas liberadas.": "注册账户时使用此代码，即可获得 10 天全部标签页解锁。",
 "Use o extrato em OFX (o mais indicado) ou CSV, baixado no app ou site do seu banco.": "请使用从银行应用或网站下载的 OFX（推荐）或 CSV 对账单。",
 "Use o seu planner no computador, sincronizado com o celular.": "在电脑上使用你的计划，与手机同步。",
 "Use um link https do Google Drive, Google Docs, OneDrive ou SharePoint.": "请使用 Google Drive、Google Docs、OneDrive 或 SharePoint 的 https 链接。",
 "Uso": "用途",
 "Uso próprio": "自用",
 "VRBO": "VRBO",
 "Vacina": "疫苗",
 "Vacina {nome}: {pet}": "{nome} 疫苗：{pet}",
 "Vacina: {nome}": "疫苗：{nome}",
 "Vacinas": "疫苗",
 "Vacinas e remédios dos pets, pet shop e a rotina da escola e da saúde das crianças.": "宠物的疫苗和用药、宠物店，以及孩子的上学和健康日常。",
 "Vai na viagem": "同行旅客",
 "Vale até {d}": "有效期至 {d}",
 "Vale para Estudos e Documentos. Na nuvem, o arquivo abre em qualquer dispositivo e no My Planner Web (até 15 MB por arquivo).": "适用于“学习”和“证件”。保存在云端时，文件可在任何设备和 My Planner 网页版中打开（每个文件最大 15 MB）。",
 "Vale quantos pontos": "分值",
 "Vale só para você. No máximo um aviso a cada 3 minutos por pessoa, mesmo que ela inclua várias coisas.": "仅对你生效。每人每 3 分钟最多提醒一次，即使对方添加了多项内容。",
 "Vale uma vez, nos primeiros 30 dias da sua conta.": "仅限一次，在账户创建后的前 30 天内有效。",
 "Validade": "有效期",
 "Validade do certificado A1": "A1 证书有效期",
 "Validade: {data}": "有效期：{data}",
 "Valor": "金额",
 "Valor ({m})": "金额（{m}）",
 "Valor a pagar": "应付金额",
 "Valor combinado": "约定金额",
 "Valor combinado por atendimento": "每次就诊约定金额",
 "Valor da hora": "时薪",
 "Valor da parcela (1ª)": "每期金额（第 1 期）",
 "Valor da venda": "出售金额",
 "Valor de costume": "常用金额",
 "Valor do atendimento: {v}{pago}.": "就诊费用：{v}{pago}。",
 "Valor emprestado ou financiado": "借款或贷款金额",
 "Valor final definido pela Google Play ou pela App Store, já na moeda do seu país.": "最终价格由 Google Play 或 App Store 确定，并以你所在国家/地区的货币显示。",
 "Valor maior que o guardado nesta meta.": "金额超过此目标已存的金额。",
 "Valor padrão da consulta ou sessão": "问诊或疗程的默认价格",
 "Valor pago": "已付金额",
 "Valor pago (com multa ou desconto)": "实付金额（含罚金或折扣）",
 "Valor pago (opcional)": "已付金额（可选）",
 "Valor pago: {v}": "已付金额：{v}",
 "Valor que este aluno paga (se for diferente)": "该学生支付的金额（如不同）",
 "Valor recebido": "已收金额",
 "Valor recebido: {v}": "已收金额：{v}",
 "Valor total da compra": "消费总额",
 "Valores e dados clínicos só aparecem para quem o papel permitir. Você pode desligar quando quiser: os dados continuam com você.": "金额和临床数据只对角色允许的人显示。你可以随时关闭：数据仍保留在你这里。",
 "Valores para conferir com o seu contador. As regras de dedução mudam a cada ano.": "这些金额请与你的会计师核对。抵扣规则每年都会变化。",
 "Vamos conversar pelo My Planner? Me adicione como amigo com o código {codigo} (aba Mensagens > Amigos).": "我们用 My Planner 聊天吧？用代码 {codigo} 加我为好友（消息标签页 > 好友）。",
 "Vaso": "花盆",
 "Veja os planos em Ajustes › Compras.": "请在 设置 › 购买 中查看套餐。",
 "Vem da aba Empréstimos & Financiamentos": "来自\"借款与贷款\"标签页",
 "Vence em {data}.": "{data} 到期。",
 "Vence em {fim} (data informada na publicação).": "{fim} 到期（公告中注明的日期）。",
 "Vence em {n} dia(s)": "{n} 天后到期",
 "Vence hoje": "今天到期",
 "Vence {data}": "{data} 到期",
 "Vencendo": "即将到期",
 "Venceu há {n} dia(s)": "已过期 {n} 天",
 "Vencidas": "已过期",
 "Vencidos": "已过期",
 "Vencimento": "到期日",
 "Vencimento (guias e boletos)": "到期日（缴税单和 boleto）",
 "Vencimento da 1ª parcela": "第 1 期到期日",
 "Vencimentos": "到期事项",
 "Venda": "销售",
 "Venda/serviço do MEI": "MEI 销售/服务",
 "Vendidos": "已售出",
 "Ver": "查看",
 "Ver a lista de membros": "查看成员列表",
 "Ver a rota": "查看路线",
 "Ver arquivos": "查看文件",
 "Ver detalhes do erro": "查看错误详情",
 "Ver e editar": "查看和编辑",
 "Ver em Compras": "在购买中查看",
 "Ver mais": "查看更多",
 "Ver mais páginas": "查看更多页面",
 "Ver no My Planner": "在 My Planner 中查看",
 "Ver o dia": "查看当天",
 "Ver os feriados do ano": "查看全年假日",
 "Ver participantes": "查看成员",
 "Ver páginas": "查看页面",
 "Ver todos": "查看全部",
 "Ver todos ({n})": "查看全部 ({n})",
 "Ver {nome}": "查看 {nome}",
 "Verificar agora": "立即检查",
 "Vermífugo": "驱虫药",
 "Vermífugo ou remédio": "驱虫药或药品",
 "Vermífugos e remédios": "驱虫药和药品",
 "Verso": "背面",
 "Verso do documento": "文档背面",
 "Versão do PDF": "PDF 版本",
 "Versão instalada": "已安装版本",
 "Versão {versao} disponível": "{versao} 版本可用",
 "Versão {v}": "版本 {v}",
 "Veterinário": "兽医",
 "Veterinário ou clínica": "兽医或诊所",
 "Veículo": "车辆",
 "Veículo e acessórios": "车辆和配件",
 "Veículos": "车辆",
 "Veículos & Manutenção": "车辆与保养",
 "Vi mais um episódio": "又看了一集",
 "Viagem": "旅行",
 "Viagens": "旅行",
 "Viagens & Lazer": "旅行与休闲",
 "Viagens e lugares": "旅行与地点",
 "Vida noturna": "夜生活",
 "Vidros e esquadrias": "玻璃和门窗",
 "Vigente": "生效中",
 "Vigentes": "生效中",
 "Virar": "翻转",
 "Virar a câmera": "切换摄像头",
 "Virar tarefa (levar à assistência)": "转为任务（送修）",
 "Visita domiciliar": "上门就诊",
 "Visitados": "已去过",
 "Visto": "已看",
 "Vistoria": "交接检查",
 "Vistoria: {i}": "交接检查：{i}",
 "Vistorias": "交接检查",
 "Visualizar feriados": "查看假日",
 "Vitamina": "维生素",
 "Vitamina D": "维生素D",
 "Vitaminas, whey, creatina... com a frequência de cada um. O que for de hoje aparece em \"Hoje\" para marcar.": "维生素、乳清蛋白、肌酸……并设置各自的频率。今天的项目会显示在“今天”中供你勾选。",
 "Você": "你",
 "Você aceitou os termos em {data}.": "你已于 {data} 接受条款。",
 "Você ainda não tem amigos no app. Adicione pelo código.": "你在应用中还没有好友。通过代码添加吧。",
 "Você ainda não tem fichários. Crie um na aba Estudos.": "你还没有活页夹。请在学习标签页中创建一个。",
 "Você deixa de ver a conversa, os documentos e as reuniões.": "你将无法再查看聊天、文档和会议。",
 "Você deve: {v}": "你应付：{v}",
 "Você entrou no grupo": "你已加入群组",
 "Você entrou no grupo \"{nome}\".": "你已加入群组“{nome}”。",
 "Você está convidado(a) para: {evento}": "诚邀你参加：{evento}",
 "Você foi convidado para o My Planner": "你受邀加入 My Planner",
 "Você foi convidado para o grupo": "你被邀请加入群组",
 "Você juntou {v} para \"{m}\".": "你为\"{m}\"存了 {v}。",
 "Você já tem todas as abas.": "您已拥有所有标签页。",
 "Você já usou um código de indicação nesta conta.": "此账户已经使用过推荐码。",
 "Você ligou": "你拨打了通话",
 "Você mesmo pode apagar a conta a qualquer momento, pelo app no celular ou pelo site:": "你可以随时在手机应用或网站上删除账户：",
 "Você não tem permissão para isso neste grupo.": "你在此群组中没有执行此操作的权限。",
 "Você não vê os outros membros deste grupo.": "你无法看到此群组的其他成员。",
 "Você pode apagar a conta a qualquer momento em Ajustes > Segurança. Isso apaga para sempre os dados na nuvem e no dispositivo.": "你可以随时在 设置 > 安全 中删除账户。这会永久删除云端和设备上的数据。",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (exportar o arquivo em Ajustes > Configuração geral), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "你可以：确认我们是否处理你的数据、访问、更正、申请可携带性（在 设置 > 常规设置 中导出文件）、申请删除、了解我们与谁共享、撤回同意，以及向 ANPD 投诉。",
 "Você recebe (líquido)": "你实收（净额）",
 "Você é responsável pela sua senha e pelo que é feito na sua conta. Use dados verdadeiros no cadastro.": "你需对自己的密码以及账户中进行的操作负责。注册时请使用真实信息。",
 "Volta": "返程",
 "Volta ou check-out": "返程或退房",
 "Volta às {hora}": "{hora} 回来",
 "Voltar": "返回",
 "Voltar ao cardápio da semana neste dia": "这一天恢复每周菜单",
 "Voltar ao cálculo": "返回计算",
 "Voltar ao foco": "回到专注",
 "Voltar ao padrão": "恢复默认",
 "Voltar ao planejado": "恢复为计划",
 "Voltar para Anotações": "返回笔记",
 "Voltar para as cores do My Planner": "恢复 My Planner 的颜色",
 "Voltar para novas": "返回新的",
 "Voltar para o QR Code": "返回二维码",
 "Volte para o app My Planner no celular. A tela de Ajustes atualiza sozinha.": "请回到手机上的 My Planner 应用。“设置”页面会自动更新。",
 "Voo": "航班",
 "Voos, hotéis, carro e passeios num lugar só, com o código e o comprovante.": "航班、酒店、租车和游览集中在一处，附带代码和凭证。",
 "Vá em Ajustes e toque em \"Conectar navegador\".": "前往设置并点击\"连接浏览器\"。",
 "Vá em Ajustes › Configuração geral e toque em \"Conectar navegador\".": "前往 设置 › 常规设置 并点击\"连接浏览器\"。",
 "Várias páginas por folha": "每张多页",
 "Vários PDFs num só, na ordem que você escolher.": "将多个 PDF 合而为一，顺序由你决定。",
 "Vê as aulas e os materiais liberados.": "查看已发布的课程和资料。",
 "Vê as etapas e registra o diário.": "查看阶段并记录日志。",
 "Vê e altera tudo, inclusive os valores.": "查看并修改全部内容，包括金额。",
 "Vê e envia os documentos da própria pasta e responde aos pedidos.": "查看和发送自己文件夹中的文件，并回复请求。",
 "Vê o andamento, sem os valores e sem alterar.": "查看进度，不含金额，不可修改。",
 "Vê os check-ins e check-outs e marca a limpeza feita, sem valores.": "查看入住和退房，并标记已完成的清洁，不含金额。",
 "Vê tudo e lança gastos, lugares, roteiro e mala.": "查看全部内容，并记录支出、地点、行程和行李。",
 "Vê tudo, inclui, edita, comenta e põe fotos. Só não coloca nem tira pessoas do grupo.": "可查看全部内容，添加、编辑、评论和上传照片。只是不能添加或移除群组成员。",
 "Vê tudo, inclusive os valores, sem alterar.": "查看全部内容（包括金额），不可修改。",
 "Vídeo": "视频",
 "Vínculo": "关联",
 "Vínculo perdido": "关联丢失",
 "WhatsApp da assistência": "售后 WhatsApp",
 "Whey": "乳清蛋白",
 "Wi-Fi (rede e senha)": "Wi-Fi（网络和密码）",
 "Yoga": "瑜伽",
 "Zumbi e Consciência Negra": "祖比与黑人觉醒日",
 "Zzz": "Zzz",
 "a cada {n} dias": "每 {n} 天",
 "a pagar": "应付",
 "a receber": "待收",
 "a receber {v}": "待收 {v}",
 "a reserva": "本次预订",
 "a última execução falhou; avise o suporte": "上次运行失败；请联系支持",
 "abr": "4月",
 "abril": "4月",
 "acabou": "已用完",
 "achatado": "已扁平化",
 "administra": "管理员",
 "ago": "8月",
 "agosto": "8月",
 "ajustado": "已调整",
 "algo novo": "新内容",
 "alterou": "修改了",
 "amanhã": "明天",
 "anual": "每年",
 "apagou": "删除了",
 "aplicada em {d}": "接种于 {d}",
 "app {v} · atualização {p} de {data}": "应用 {v} · 更新 {p}（{data}）",
 "assinado": "已签名",
 "atrasada": "已逾期",
 "atrasada há {n} dia(s)": "已逾期 {n} 天",
 "até": "至",
 "até {data}": "至 {data}",
 "até {d}": "截至 {d}",
 "aula {a} de {n}": "第 {a}/{n} 课",
 "avisos silenciados": "通知已关闭",
 "caixa": "收纳盒",
 "colher(es)": "勺",
 "coluna": "列",
 "com anexos": "含附件",
 "com imagem": "含图片",
 "com tarjas": "已涂黑",
 "com texto": "含文字",
 "com {p}": "在 {p} 那里",
 "como planejado": "按计划",
 "comprado em {data}": "购于 {data}",
 "comprado em {d} por {v}": "于 {d} 以 {v} 购入",
 "comprimido": "已压缩",
 "comprovante": "凭证",
 "concha(s)": "汤勺",
 "confirmados": "已确认",
 "consulta recusada": "查询被拒绝",
 "contratado": "已签约",
 "contínuo": "长期",
 "copo(s)": "杯",
 "corridos": "自然日",
 "criou o grupo": "创建了群组",
 "de": "/",
 "de Anotações": "来自笔记",
 "de {meta} passos": "目标 {meta} 步",
 "de {n}": "/ {n}",
 "de {p}": "来自 {p}",
 "dentro / fora do planejado": "计划内 / 计划外",
 "desconto {v}": "优惠 {v}",
 "desfazer": "撤销",
 "destino": "目的地",
 "deve {v}": "欠 {v}",
 "devolvido em {d}": "于 {d} 归还",
 "dez": "12月",
 "dezembro": "12月",
 "dia": "天",
 "dias": "天",
 "dias com a meta batida": "达成目标的天数",
 "dias com a meta de passos": "达成步数目标的天数",
 "digital": "指纹",
 "diária média": "平均房价",
 "do cliente": "来自客户",
 "do escritório": "来自事务所",
 "dom": "周日",
 "domingo": "星期日",
 "e mais {n}": "等另外 {n} 项",
 "em aberto": "未结",
 "em atraso": "逾期",
 "em {n} dias": "{n} 天后",
 "emitida": "已开具",
 "entregue": "已提交",
 "entrou no escritório": "加入了办公室",
 "enviado": "已发送",
 "escaneado": "扫描版",
 "escolha": "请选择",
 "este": "本机",
 "este dispositivo": "此设备",
 "este item": "此项目",
 "exercícios concluídos": "已完成的练习",
 "falta {v}": "还差 {v}",
 "faltam {km}": "还剩 {km}",
 "fatia(s)": "片",
 "faturamento": "营收",
 "feita em {d}": "完成于 {d}",
 "feito {dur}": "已完成 {dur}",
 "fev": "2月",
 "fevereiro": "2月",
 "frequência {p}%": "出勤率 {p}%",
 "gasto {v}": "已花费 {v}",
 "girado": "已旋转",
 "guardado": "已保存",
 "higienizado": "已清理",
 "hoje": "今天",
 "hora fixa no dia": "当天固定时间",
 "há {n} dias": "{n} 天前",
 "iPhone ou computador: {link}": "iPhone 或电脑：{link}",
 "incluiu": "添加了",
 "jan": "1月",
 "janeiro": "1月",
 "jul": "7月",
 "julho": "7月",
 "jun": "6月",
 "junho": "6月",
 "já importado": "已导入",
 "liberar em {d}": "{d} 发布",
 "ligou o compartilhamento": "开启了共享",
 "linha": "行",
 "lucro líquido": "净利润",
 "mai": "5月",
 "maio": "5月",
 "mar": "3月",
 "marca d'água": "水印",
 "marcada por {nome}": "由 {nome} 安排",
 "março": "3月",
 "menos de 1 ano": "不到 1 年",
 "mensalidade": "月费",
 "meta batida!": "目标达成！",
 "metadados": "元数据",
 "min": "分钟",
 "min antes": "分钟前",
 "min antes do início": "分钟（开始前）",
 "min · {de} às {ate}": "分钟 · {de} 至 {ate}",
 "multa e juros {v}": "滞纳金和利息 {v}",
 "média {m}": "平均 {m}",
 "mês(es)": "个月",
 "na nuvem": "在云端",
 "na pasta \"{pasta}\"": "\"{pasta}\" 文件夹",
 "na pasta escolhida": "在所选文件夹中",
 "neste dispositivo": "此设备",
 "neste celular": "在此手机上",
 "no Planner": "在 Planner 中",
 "no {nome}": "{nome}",
 "nos próximos dias": "最近几天",
 "nov": "11月",
 "novembro": "11月",
 "numerado": "已编页码",
 "nunca verificado": "从未检查",
 "não vão": "不参加",
 "o documento mudou depois disso: guarde de novo": "文档之后已更改：请重新保存",
 "ocupação": "入住率",
 "ontem": "昨天",
 "organizado": "已整理",
 "orçando": "询价中",
 "out": "10月",
 "outubro": "10月",
 "paga": "已付",
 "paga em {d}": "{d} 已付",
 "pago": "已付款",
 "pago em {d}": "{d} 已付",
 "pago por {p}": "由 {p} 支付",
 "pagou {v}": "已付 {v}",
 "parcela {a} de {n}": "第 {a} 期，共 {n} 期",
 "parece já lançado": "似乎已录入",
 "parte {n}": "第 {n} 部分",
 "passos por dia (média)": "日均步数",
 "passou {km}": "超出 {km}",
 "pausa {p}": "休息 {p}",
 "pausado": "已暂停",
 "peso {n}": "权重 {n}",
 "pesquisável": "可搜索",
 "por dia": "每天",
 "por dia (média)": "日均",
 "por dia disponível": "每可用日",
 "por semana": "每周",
 "por {p}": "来自 {p}",
 "porção(ões)": "份",
 "preenchido": "已填写",
 "primeira às {hora}: {tarefa}": "首个任务 {hora}：{tarefa}",
 "produção": "正式",
 "próxima em {data}": "下次：{data}",
 "próxima rega {d}": "下次浇水 {d}",
 "publicação": "公告",
 "página de estudo": "学习页面",
 "página única": "单页",
 "páginas": "页",
 "páginas {p}": "第 {p} 页",
 "qua": "周三",
 "quarta": "周三",
 "quarta-feira": "星期三",
 "qui": "周四",
 "quinta": "周四",
 "quinta-feira": "星期四",
 "quitada": "已结清",
 "recebe {v}": "应收 {v}",
 "recebida": "已收到",
 "reconhecimento facial": "面部识别",
 "recortado": "已裁剪",
 "refeições feitas": "已完成的餐次",
 "rega a cada {n} dias": "每 {n} 天浇水",
 "regar hoje": "今天浇水",
 "reparado": "已修复",
 "retorno {d}": "复诊 {d}",
 "saldo {v}": "余额 {v}",
 "seg": "周一",
 "segunda": "周一",
 "segunda-feira": "星期一",
 "sem anotações": "无注释",
 "sem as páginas {p}": "去除第 {p} 页",
 "sem cliente": "无客户",
 "sem dias previstos": "无计划日",
 "sem horário": "无时间",
 "sem meta": "无目标",
 "sem resposta": "未回复",
 "sem tempo": "无时间",
 "semana(s)": "周",
 "set": "9月",
 "setembro": "9月",
 "seu@email.com": "you@email.com",
 "sex": "周五",
 "sexta": "周五",
 "sexta-feira": "星期五",
 "sáb": "周六",
 "sábado": "星期六",
 "talvez": "待定",
 "tarefa da casa": "家务任务",
 "tarefa: {t}": "任务：{t}",
 "taxas e despesas": "费用和支出",
 "ter": "周二",
 "termina em {d}": "{d} 结束",
 "terça": "周二",
 "terça-feira": "星期二",
 "teste": "测试",
 "todas": "全部",
 "todo ano em {d}": "每年 {d}",
 "todo dia {d}": "每月 {d} 日",
 "todos": "全体",
 "toque para abrir": "点击打开",
 "toque para pausar": "点击暂停",
 "toque para ver o contato": "点按查看联系人",
 "toque para voltar a hoje": "点按返回今天",
 "treinos concluídos": "已完成的训练",
 "uma vez em {d}": "仅一次：{d}",
 "unidade(s)": "个",
 "vale {n}": "分值 {n}",
 "vence em {n} dias": "{n} 天后到期",
 "vence {d}": "{d} 到期",
 "venceu em {data}": "已于 {data} 过期",
 "vencido": "已过期",
 "vendido com ganho de {v}": "出售获利 {v}",
 "vendido com perda de {v}": "出售亏损 {v}",
 "verificado {quando}": "已检查 {quando}",
 "você": "你",
 "você administra": "你是管理员",
 "xícara(s)": "茶杯",
 "{aba} bloqueada": "{aba} 已锁定",
 "{aba} está bloqueada": "{aba} 已锁定",
 "{aba}, em \"Anotações recebidas\"": "{aba}，在\"收到的笔记\"中",
 "{a} aula(s) feita(s)": "已完成 {a} 课",
 "{a} de {n} aulas": "{a}/{n} 课",
 "{c} chegou a {p}% do orçamento ({g} de {l}).": "{c} 已达预算的 {p}%（{g} / {l}）。",
 "{c} confirmados de {n} convidados": "{n} 位宾客中 {c} 位已确认",
 "{c} está em {p}% do orçamento do mês. Ainda faltam {dias} dia(s) para o mês acabar.": "{c} 已用掉本月预算的 {p}%。距月底还有 {dias} 天。",
 "{c} já está {v} acima do mês passado inteiro. Confira se foi algo fora do comum.": "{c} 已比上个月全月多出 {v}。看看是否有异常开支。",
 "{c} já passou do orçamento: {g} de {l}. Segure esse gasto até o mês virar.": "{c} 已超出预算：{g} / {l}。下个月之前先暂停这类开支。",
 "{c} passou do orçamento: {g} de {l}.": "{c} 超出预算：{g} / {l}。",
 "{de} paga {v} para {para}": "{de} 付给 {para} {v}",
 "{de} às {ate}": "{de} 至 {ate}",
 "{dia}, {d} de {mes} de {a}": "{a}年{mes}{d}日 {dia}",
 "{dia}, {d} {mes}": "{mes}{d}日 {dia}",
 "{dia}, {d}/{m}": "{m}/{d} {dia}",
 "{dur} na semana": "本周 {dur}",
 "{dur} registrados": "已记录 {dur}",
 "{d}/{n} notas": "{d}/{n} 个成绩",
 "{feito} de {meta}": "{feito} / {meta}",
 "{fonte} · {data}": "{fonte} · {data}",
 "{f} de {n} feitas": "已完成 {f}/{n}",
 "{f}/{n} transferências feitas": "已完成 {f}/{n} 项转移",
 "{hora} em {fuso}": "{fuso} {hora}",
 "{h} este mês": "本月 {h}",
 "{h} h": "{h} 小时",
 "{h} h {m} min": "{h} 小时 {m} 分钟",
 "{h} no seu relógio": "你的时间 {h}",
 "{ia} conectado. {n} modelo(s) disponível(is) na sua conta.": "{ia} 已连接。你的账户中有 {n} 个可用模型。",
 "{ia}: chave de API inválida ou sem permissão.": "{ia}：API 密钥无效或没有权限。",
 "{ia}: limite de uso atingido. Confira o saldo ou o limite da sua conta de API.": "{ia}：已达到使用上限。请检查你 API 账户的余额或限额。",
 "{item}: em {n} dias ({data}).": "{item}：{n} 天后（{data}）。",
 "{item}: hoje ({data}).": "{item}：今天（{data}）。",
 "{item}: termina em {n} dias ({data}).": "{item}：将于 {n} 天后到期（{data}）。",
 "{item}: vence em {n} dias ({data}).": "{item}：{n} 天后到期（{data}）。",
 "{item}: vence hoje ({data}).": "{item}：今天到期（{data}）。",
 "{item}: venceu em {data} e ainda não foi marcado como feito.": "{item}：已于 {data} 到期，但尚未标记为完成。",
 "{livre} livres de {total}": "共 {total}，可用 {livre}",
 "{m} min": "{m} 分钟",
 "{nome} agora é seu amigo. Já podem conversar.": "{nome} 现在是你的好友了。你们可以聊天了。",
 "{nome} conectado!": "{nome} 已连接！",
 "{nome} ligou": "{nome} 拨打了通话",
 "{novas} nova(s), {atualizadas} atualizada(s), {enviadas} enviada(s), {removidas} removida(s)": "新增 {novas}，更新 {atualizadas}，发送 {enviadas}，移除 {removidas}",
 "{n} ITEM(NS)": "{n} 件商品",
 "{n} aba(s) no seu plano · cores e opções de cada uma": "套餐中有 {n} 个标签页 · 各自的颜色和选项",
 "{n} aba(s) para comprar": "{n} 个标签页可购买",
 "{n} adicionada(s)": "已添加 {n} 人",
 "{n} alerta(s) agendado(s) neste celular para os próximos dias.": "已在此手机上为未来几天安排了 {n} 条提醒。",
 "{n} aluno(s)": "{n} 名学生",
 "{n} anexo(s)": "{n} 个附件",
 "{n} ano(s)": "{n} 年",
 "{n} arquivo(s)": "{n} 个文件",
 "{n} atendimento(s)": "{n} 次就诊",
 "{n} atrasada(s)": "{n} 项逾期",
 "{n} atrasado(s)": "{n} 项逾期",
 "{n} caixa(s)": "{n} 个箱子",
 "{n} caixa(s) frágil(eis)": "{n} 个易碎箱子",
 "{n} caixa(s) · {a} já aberta(s) na casa nova": "{n} 个箱子 · {a} 个已在新家拆开",
 "{n} cancelada(s).": "已作废 {n} 张。",
 "{n} cartão(ões) abertos": "{n} 张进行中的卡片",
 "{n} cobrança(s) criada(s) com vencimento em {d}.": "已创建 {n} 笔收费，到期日为 {d}。",
 "{n} com vencimento": "{n} 个有到期日",
 "{n} compra(s) no cartão {c}. As parcelas futuras já aparecem nas próximas faturas.": "信用卡 {c} 共 {n} 笔消费。后续分期已显示在之后的账单中。",
 "{n} conta(s) marcada(s) como paga(s) automaticamente.": "{n} 笔账单已自动标记为已付。",
 "{n} copo(s), {ml} de {meta}": "{n} 杯，{ml} / {meta}",
 "{n} de {meta} copos": "{n} / {meta} 杯",
 "{n} de {total}": "{n} / {total}",
 "{n} de {total} dias": "{total} 天中的 {n} 天",
 "{n} de {total} hoje": "今天 {n}/{total}",
 "{n} de {t} item(ns) com preço, dos cupons lidos em Finanças.": "在金融中读取的小票里，{t} 件商品中有 {n} 件有价格。",
 "{n} dia(s)": "{n} 天",
 "{n} dia(s) seguido(s) lendo": "已连续阅读 {n} 天",
 "{n} dia(s) tirado(s) de tarefas que se repetem": "已从重复任务中移除 {n} 天",
 "{n} dias": "{n} 天",
 "{n} dias grátis": "免费 {n} 天",
 "{n} dias grátis para testar": "免费试用 {n} 天",
 "{n} dias {tipo}: publicada em {pub}, contagem a partir de {ini}, vence em {fim}.": "{n} 天（{tipo}）：{pub} 发布，自 {ini} 起算，{fim} 到期。",
 "{n} documento(s)": "{n} 份文件",
 "{n} em atraso": "{n} 笔逾期",
 "{n} etapa(s) atrasada(s)": "{n} 个阶段已延误",
 "{n} exclusão(ões) esperando o celular sincronizar.": "{n} 项删除正在等待手机同步。",
 "{n} falta(s)": "{n} 次缺席",
 "{n} ficha(s) no grupo. Escolha o papel de cada pessoa em Membros.": "群组中有 {n} 份档案。请在“成员”中为每个人选择角色。",
 "{n} foto(s) e vídeo(s) da viagem, de todos do grupo. Fotos do roteiro, dos lugares e das reservas também aparecem aqui.": "群组所有人上传的 {n} 张旅行照片和视频。行程、地点和预订中的照片也会显示在这里。",
 "{n} item(ns) adicionado(s).": "已添加 {n} 个项目。",
 "{n} item(ns) com outras pessoas": "{n} 件物品在别人那里",
 "{n} item(ns) no Planner.": "已向 Planner 添加 {n} 项。",
 "{n} lançamento(s) encontrado(s)": "找到 {n} 笔记录",
 "{n} lançamento(s) novo(s).": "{n} 笔新记录。",
 "{n} lembrete(s) colocado(s) no My Planner.": "已在 My Planner 中添加 {n} 条提醒。",
 "{n} livro(s) lido(s) este ano": "今年已读 {n} 本书",
 "{n} marcado(s)": "已选 {n} 项",
 "{n} matéria(s)": "{n} 个科目",
 "{n} membro(s) · abrir a conversa do grupo": "{n} 位成员 · 打开群聊",
 "{n} meses grátis a partir da criação da conta; depois {preco} por ano.": "自创建账户起免费 {n} 个月；之后每年 {preco}。",
 "{n} min": "{n} 分钟",
 "{n} min antes": "提前 {n} 分钟",
 "{n} módulo(s)": "{n} 个模块",
 "{n} noite(s)": "{n} 晚",
 "{n} nota(s) nova(s).": "{n} 张新发票。",
 "{n} nota(s) sem XML neste dispositivo ficaram de fora.": "此设备上有 {n} 张发票没有 XML，已排除。",
 "{n} nota(s) · emitidas {e} · recebidas {r}": "{n} 张发票 · 已开具 {e} · 已收到 {r}",
 "{n} nova(s)": "{n} 条新",
 "{n} novo(s) do cliente": "{n} 份客户新文件",
 "{n} novo(s) para aceitar, editar ou recusar.": "{n} 条新内容待接受、编辑或拒绝。",
 "{n} parcela(s) colocada(s) no My Planner.": "已将 {n} 期分期加入 My Planner。",
 "{n} parcela(s) em aberto refeitas. As pagas ficaram como estavam.": "已重新计算 {n} 期未付分期。已付的保持不变。",
 "{n} parcela(s) em atraso": "{n} 期逾期",
 "{n} parcela(s) em atraso: {v}": "{n} 期逾期：{v}",
 "{n} participantes · toque para ver": "{n} 位成员 · 点按查看",
 "{n} passo(s)": "{n} 个步骤",
 "{n} pausa(s)": "{n} 次休息",
 "{n} pedido(s) de amizade": "{n} 个好友请求",
 "{n} pedido(s) em aberto": "{n} 个未完成的请求",
 "{n} pessoa(s)": "{n} 人",
 "{n} pessoa(s) já entraram com o seu código.": "已有 {n} 人使用你的代码加入。",
 "{n} pessoas": "{n} 人",
 "{n} por folha": "每张 {n} 页",
 "{n} porções": "{n} 份",
 "{n} publicação(ões) nova(s).": "{n} 条新公告。",
 "{n} publicações novas": "{n} 条新公告",
 "{n} página(s)": "{n} 页",
 "{n} página(s) · {r} revisada(s)": "{n} 页 · 已复习 {r} 页",
 "{n} páginas": "{n} 页",
 "{n} recebido(s) dos seus grupos": "来自你的群组的 {n} 条内容",
 "{n} recebido(s) para responder": "{n} 条待回复",
 "{n} refeição(ões), com o cardápio daquele dia": "{n} 餐，使用当天的菜单",
 "{n} reserva(s) nova(s) ou alterada(s).": "{n} 笔新增或变更的预订。",
 "{n} resultado(s) em todas as publicações": "所有公告中共 {n} 条结果",
 "{n} selecionado(s): {lista}": "已选择 {n} 个：{lista}",
 "{n} tarefa(s)": "{n} 个任务",
 "{n} tarefa(s) apagada(s) por inteiro": "已完整删除 {n} 个任务",
 "{n} tarefa(s) criada(s)": "已创建 {n} 个任务",
 "{n} tarefa(s) da casa saíram do My Planner e agora ficam só em Minha Casa. Para levar uma delas ao Planner, abra a tarefa e toque em \"Enviar para o My Planner\".": "{n} 项家务已移出 My Planner，现在只保留在“我的家”中。要把其中一项放回 Planner，请打开该任务并点按“发送到 My Planner”。",
 "{n} tarefa(s) de ontem sem concluir": "昨天有 {n} 个任务未完成",
 "{n} tarefa(s) dos últimos dias sem concluir": "最近几天有 {n} 个任务未完成",
 "{n} tarefa(s) hoje": "今天 {n} 个任务",
 "{n} tarefa(s) pendente(s) vão para a lista de hoje.": "{n} 个未完成任务将移到今天的列表。",
 "{n} tarjas no documento": "文档中有 {n} 处涂黑",
 "{n} treino(s), cada um nos dias dele": "{n} 次训练，各在其设定的日子",
 "{n} tribunais": "{n} 个法院",
 "{n}x de {v}": "{n} 期 × {v}",
 "{n}º alerta": "第 {n} 个提醒",
 "{n}× {item}": "{n}× {item}",
 "{ok} enviado(s), {falhas} com erro. Tente de novo mais tarde.": "{ok} 个已上传，{falhas} 个出错。请稍后再试。",
 "{ok} enviado(s).": "{ok} 个已上传。",
 "{o} de {d} noites ocupadas. Reservas que passam de um mês para outro são divididas pelas noites.": "{d} 晚中有 {o} 晚已入住。跨月的预订按晚数拆分。",
 "{preco} por ano": "每年 {preco}",
 "{p} de {t} parcelas pagas ({pct}%)": "已付 {p}/{t} 期（{pct}%）",
 "{p} presentes · {f} faltas": "{p} 人出席 · {f} 人缺席",
 "{p}% da meta de {m} páginas": "完成 {m} 页目标的 {p}%",
 "{p}% feito": "已完成 {p}%",
 "{p}% ocupado no mês": "本月入住率 {p}%",
 "{p}% pronta": "已完成 {p}%",
 "{p}/{t} pagas": "已付 {p}/{t}",
 "{quem} convidou você para o grupo \"{grupo}\" no My Planner. Toque no link para entrar (o app é gratuito para começar): {link}\nCódigo do convite: {codigo}": "{quem} 邀请你加入 My Planner 中的群组“{grupo}”。点按链接加入（应用可免费开始使用）：{link}\n邀请码：{codigo}",
 "{quem} e outros incluíram {n} itens no grupo.": "{quem} 等人向群组添加了 {n} 项内容。",
 "{quem} incluiu {item} no grupo.": "{quem} 向群组添加了 {item}。",
 "{servico} do veículo": "车辆{servico}",
 "{s} de {a}": "{s} / {a}",
 "{tarefa}: volte às {hora}": "{tarefa}：{hora} 回来",
 "{tipo}: {p}": "{tipo}：{p}",
 "{titulo} (cópia)": "{titulo}（副本）",
 "{uso} usados de {total} reservados para o site": "网站预留 {total}，已用 {uso}",
 "{v} · atualização de {data}": "{v} · {data} 更新",
 "{v}/hora": "{v}/小时",
 "À direita": "右侧",
 "À vista": "一次付清",
 "Às": "在",
 "Às {hora}": "{hora} 时",
 "ÁGUA": "饮水",
 "Ácido": "酸性土",
 "Água": "饮水",
 "Água hoje": "今日饮水",
 "Área externa": "户外区域",
 "Áreas": "区域",
 "Áudio": "语音",
 "É um auxílio e não substitui o acompanhamento das intimações nos canais oficiais. Prazos devem ser conferidos no sistema oficial.": "本功能仅为辅助，不能替代通过官方渠道跟踪送达通知。期限应在官方系统中核对。",
 "Ética Profissional": "职业道德",
 "Ícone e aba": "图标和标签页",
 "Óculos de sol": "太阳镜",
 "Órgão emissor (ex.: DETRAN-MS, Polícia Federal)": "签发机关（例如：DETRAN-MS、联邦警察局）",
 "Órgão emissor: {nome}": "签发机关：{nome}",
 "Ômega 3": "Omega-3",
 "Última": "末页",
 "Última adubação": "上次施肥",
 "Última aplicação": "上次接种",
 "Última busca do servidor para você: {quando}": "服务器为您最近一次搜索：{quando}",
 "Última cópia de segurança: {data}": "上次备份：{data}",
 "Última rega": "上次浇水",
 "Última sincronização: {quando}": "上次同步：{quando}",
 "Última: {data}": "上次：{data}",
 "Último dia para entregar a declaração do IR": "个税申报截止日",
 "Último erro: {m}": "最近的错误：{m}",
 "Últimos 30 dias": "最近 30 天",
 "Últimos 7 dias": "最近 7 天",
 "íris": "虹膜",
 "última vez em {data}": "上次：{data}",
 "último em {d}": "最近一次：{d}",
 "úteis": "工作日",
 "★ é a cor do My Planner. A escolha vale para todas as conversas deste dispositivo e da sua conta.": "★ 是 My Planner 的颜色。此选择适用于本设备和你账户中的所有聊天。",
 "🎥 {nome} está ligando (vídeo)": "🎥 {nome} 来电（视频）",
 "📆 Conectar a agenda deste celular": "📆 连接这部手机的日历",
 "📞 {nome} está ligando (áudio)": "📞 {nome} 来电（语音）",
 "Link bloqueado por segurança.": "出于安全原因，链接已被阻止。",
 "Este arquivo não é uma imagem válida.": "此文件不是有效的图片。",
 "A busca automática do servidor acompanha os 5 primeiros perfis. Os outros entram quando você toca em \"Verificar agora\".": "服务器自动搜索只跟踪前 5 个档案。其他档案在你点按“立即检查”时检查。",
 "Esta tela mostra a linha do tempo da viagem, com as atividades e os lugares que têm dia marcado. Para adicionar ou editar as informações completas de um lugar, use a aba Lugares.": "此页面显示旅行的时间线，包括已定日期的活动和地点。要添加或编辑某个地点的完整信息，请使用“地点”标签页。",
 "Para a viagem {d}": "用于旅行 {d}",
 "sem nome": "未命名",
 "Foi para a viagem {d}.": "已移至旅行 {d}。",
 "Orçamento total (se não for detalhar)": "总预算（如不细分）",
 "Monte o roteiro dia a dia. Os lugares com dia marcado entram aqui sozinhos. No período da viagem, o roteiro aparece na linha do tempo do My Planner.": "按天安排行程。已定日期的地点会自动出现在这里。旅行期间，行程会显示在 My Planner 的时间线上。",
 "Marque o dia e o horário no lugar para ele aparecer sozinho no Roteiro.": "在地点中设置日期和时间，它就会自动出现在“行程”中。",
 "No roteiro": "已在行程中",
 "\"{nome}\" está no roteiro de {data}. Para mudar o dia ou o horário, edite o lugar.": "“{nome}”在 {data} 的行程中。要更改日期或时间，请编辑该地点。",
 "Para o roteiro desta viagem": "用于本次旅行的行程",
 "Orçamento e gastos": "预算和花费",
 "Parada (cidade)": "停留地（城市）",
 "Item da categoria": "分类项目",
 "Orçamento da viagem inteira": "整个旅行的预算",
 "Orçamento geral da viagem": "旅行总预算",
 "Previsto {p} · gasto {g}": "预计 {p} · 已花 {g}",
 "Aqui ficam os custos da viagem que não são de uma parada (ex.: passagens, seguro). Cada parada tem o seu orçamento.": "这里是不属于某个停留地的旅行费用（例如：机票、保险）。每个停留地都有自己的预算。",
 "Coloque quanto pretende gastar em cada categoria. Ao lançar os gastos, o app mostra quanto já foi usado.": "填写你打算在每个分类中花多少。记录花费后，应用会显示已用了多少。",
 "Orçamento por parada": "按停留地的预算",
 "Vai passar por mais de uma cidade? Cadastre as paradas (aba Paradas): cada uma ganha o seu orçamento e os gastos daquelas datas entram nela sozinhos.": "要去不止一个城市吗？添加停留地（“停留地”标签页）：每个停留地都有自己的预算，这些日期内的花费会自动归入其中。",
 "Coloque o valor do gasto.": "请填写花费金额。",
 "Orçamento de {c}": "{c}预算",
 "Lançar um gasto nesta parada": "为此停留地记一笔花费",
 "Lançar gasto": "记一笔花费",
 "Orçamento e gastos da parada": "停留地的预算和花费",
 "Gastos lançados ({n})": "已记录的花费（{n}）",
 "Para corrigir ou apagar um gasto, use a aba Orçamento e gastos da viagem.": "要修改或删除花费，请使用旅行的“预算和花费”标签页。",
 "Paradas": "停留地",
 "Cidade ou lugar": "城市或地点",
 "Ex.: Porto": "例如：波尔图",
 "Chegada": "到达",
 "Saída": "离开",
 "Onde vai ficar": "住在哪里",
 "gasto {g} de {p}": "已花 {g} / {p}",
 "Vai passar por mais de uma cidade? Cadastre cada parada com as datas. Cada uma ganha o seu orçamento (hospedagem, refeições, transporte...) e os gastos daquelas datas entram nela sozinhos.": "要去不止一个城市吗？为每个停留地添加日期。每个停留地都有自己的预算（住宿、餐饮、交通……），这些日期内的花费会自动归入其中。",
 "Café da tarde": "下午茶",
 "Outros / Lanches": "其他 / 小吃",
 "Gasto {v}": "已花 {v}",
 "Gasto {g} de {p} · {a} acima": "已花 {g} / {p} · 超出 {a}",
 "Gasto {g} de {p}": "已花 {g} / {p}",
 "Tirar \"{nome}\" do orçamento?": "要从预算中移除“{nome}”吗？",
 "Os gastos já lançados nela continuam na lista de gastos.": "其中已记录的花费仍保留在花费列表中。",
 "Previsto para {nome}": "{nome}的预计金额",
 "Tirar {nome}": "移除{nome}",
 "Nome do item (ex.: Jantar especial)": "项目名称（例如：特别晚餐）",
 "Adicionar item": "添加项目",
 "Detalhar em itens": "细分为项目",
 "Nova categoria (ex.: Seguro, Presentes)": "新分类（例如：保险、礼物）",
 "Voltar às categorias sugeridas?": "恢复为推荐的分类？",
 "Os valores previstos desta lista serão apagados. Os gastos lançados continuam.": "此列表中的预计金额将被清除。已记录的花费会保留。",
 "Voltar às categorias sugeridas": "恢复为推荐的分类",
 "Previsto": "预计",
 "Ainda pode gastar": "还可以花",
 "Passou do previsto": "超出预计",
 "Não foi possível buscar o câmbio": "无法获取汇率",
 "Sem internet ou a moeda {m} não está na tabela. Edite a viagem e coloque o câmbio à mão.": "没有网络，或 {m} 不在汇率表中。请编辑行程并手动输入汇率。",
 "Câmbio de {m} ainda não definido": "{m} 汇率尚未设置",
 "Câmbio de hoje": "今日汇率",
 "Atualizado em {d}": "更新于 {d}",
 "Valor em {m}": "以 {m} 计的金额",
 "Moeda do destino": "目的地货币",
 "Câmbio: quanto vale 1 da moeda do destino na sua moeda": "汇率：1 单位目的地货币等于多少你的货币",
 "Sem dia marcado": "未定日期",
 "Valor na moeda do destino": "以目的地货币计的金额",
 "Tirar só desta lista ou excluir de vez?": "只从这个列表移除，还是彻底删除？",
 "Excluir de vez": "彻底删除",
 "Relatório da viagem (PDF)": "行程报告（PDF）",
 "Planilha da viagem (Excel)": "行程表格（Excel）",
 "Geral da viagem": "整个行程",
 "Viagem {d}": "行程 {d}",
 "Quem vai: {p}": "同行者：{p}",
 "Outros gastos": "其他花费",
 "Orçamento · {n}": "预算 · {n}",
 "Código": "代码",
 "Pagou": "付款人",
 "Permissão internacional para dirigir": "国际驾照",
 "Vacina (certificado)": "疫苗（证明）",
 "Autorização de viagem de menor": "未成年人出行授权书",
 "Vence antes da volta": "返程前到期",
 "Vence menos de 6 meses depois da volta (muitos países não aceitam)": "返程后不足 6 个月到期（许多国家不接受）",
 "A lista básica já está aqui.": "基础清单已经在这里了。",
 "{n} documento(s) com validade que pode atrapalhar a viagem": "{n} 份证件的有效期可能影响行程",
 "Lista básica: passaporte de cada um e seguro viagem": "基础清单：每人的护照和旅行保险",
 "Lista básica: identidade de cada um": "基础清单：每人的身份证件",
 "Ponha a validade de cada documento: o app avisa antes de vencer e confere se o passaporte vale por 6 meses depois da volta. As fotos dos documentos ficam protegidas no cofre.": "填写每份证件的有效期：应用会在到期前提醒，并检查护照在返程后是否仍有 6 个月有效期。证件照片受保险库保护。",
 "De quem": "所属人",
 "Número (protegido no cofre)": "号码（受保险库保护）",
 "Está em mãos": "已在手上",
 "Válido até {d}": "有效期至 {d}",
 "Passaporte, visto, seguro viagem, vacina, autorização de menor... com a validade e a foto. Marque quando estiver em mãos.": "护照、签证、旅行保险、疫苗、未成年人授权书……附有效期和照片。拿到手后请勾选。",
 "acerto entre os viajantes (não entra no orçamento)": "旅伴之间的结算（不计入预算）",
 "Só gastos": "只看花费",
 "Acertos": "结算",
 "Marcar como pago?": "标记为已付？",
 "{de} já pagou {v} para {para}?": "{de} 已经付给 {para} {v} 了吗？",
 "Já pagou": "已经付了",
 "Acerto: {de} pagou {para}": "结算：{de} 付给 {para}",
 "Conferir minhas assinaturas": "查看我的订阅",
 "Gerenciar ou cancelar assinaturas na loja": "在商店管理或取消订阅",
 "Restaurar compras": "恢复购买",
 "Procurando...": "正在查找...",
 "{n} assinatura(s) encontrada(s) e liberada(s).": "找到并解锁 {n} 个订阅。",
 "Assinatura anual, renova sozinha. Cancele quando quiser nas assinaturas da loja, até 24 horas antes da renovação.": "年度订阅，自动续订。可随时在商店订阅中取消，需在续订前 24 小时。",
 "Assinaturas da loja": "商店订阅",
 "Gerenciar assinaturas (App Store)": "管理订阅（App Store）",
 "Gerenciar assinaturas (Google Play)": "管理订阅（Google Play）",
 "A assinatura é feita no app do celular (Google Play ou App Store) e vale também aqui no site.": "订阅在手机应用中完成（Google Play 或 App Store），在网站上同样有效。",
 "Esta assinatura ainda não está disponível na loja. Tente de novo mais tarde.": "该订阅暂未在商店上架，请稍后再试。",
 "Assinatura feita": "订阅成功",
 "Já assinei no celular: conferir": "我已在手机上订阅：查看",
 "Nenhuma assinatura encontrada nesta conta da loja.": "此商店账户中没有找到订阅。",
 "Confira a internet e tente de novo. Nada foi cobrado.": "请检查网络后重试。未产生任何扣费。",
 "{aba} liberada. Vale também nos seus outros dispositivos e no site.": "{aba} 已解锁。在你的其他设备和网站上同样有效。",
 "Para assinar, atualize o My Planner pela Google Play ou pela App Store.": "要订阅，请通过 Google Play 或 App Store 更新 My Planner。",
 "Assinada, renova em {data}": "已订阅，{data} 续订",
 "Não deu para assinar agora": "暂时无法订阅",
 "Assinar por {preco} por ano": "以每年 {preco} 订阅",
 "\"{nome}\" foi para o Mural, em Conquistas.": "“{nome}”已放到“成就”的展示墙上。",
 "\"{nome}\" já faz parte da sua rotina. Foi para o Mural, em Conquistas.": "“{nome}”已成为你的日常习惯，已放到“成就”的展示墙上。",
 "\"{nome}\" voltou para o lugar.": "“{nome}”已恢复原位。",
 "1 ano": "1 年",
 "1 mês": "1 个月",
 "A IA não achou o valor no comprovante.": "AI 没有在凭证中找到金额。",
 "A cada {n} dias": "每 {n} 天",
 "A carta está vazia": "信是空的",
 "A carta fica trancada até {d}. Até lá não dá para reler nem editar. Para mudar algo, escreva outra carta.": "这封信会锁定到 {d}。在此之前无法重读或编辑。如需修改，请再写一封信。",
 "A lixeira está vazia.": "回收站是空的。",
 "A mesma do app e do celular": "与应用和手机相同",
 "A mesma forma de desbloqueio do app e do celular": "与应用和手机相同的解锁方式",
 "A senha do diário precisa ter 6 caracteres ou mais.": "日记密码至少需要 6 个字符。",
 "A senha precisa ter 6 caracteres ou mais.": "密码至少需要 6 个字符。",
 "A turma ainda não tem grupo": "该班级还没有群组",
 "AS 4 BOLINHAS DE COR": "4 个颜色圆点",
 "Aberta em {d}": "打开于 {d}",
 "Abra a aba para poder restaurar": "打开该标签页才能恢复",
 "Abra o diário primeiro": "请先打开日记",
 "Abre com a biometria, o reconhecimento facial ou a senha do app. A senha do diário só é pedida na primeira vez em cada aparelho.": "使用生物识别、面部识别或应用密码打开。每台设备仅在第一次时需要输入日记密码。",
 "Abre em {d}": "{d} 打开",
 "Abrir carta para o futuro": "打开给未来的信",
 "Abrir em {aba}": "在 {aba} 中打开",
 "Abrir o Diário": "打开日记",
 "Abrir o diário": "打开日记",
 "Abrir {aba}": "打开 {aba}",
 "Acompanha o imóvel, as reservas, a ocupação, as despesas e o lucro, sem alterar nada.": "查看房产、预订、入住率、支出和利润，不做任何更改。",
 "Adicionar foto": "添加照片",
 "Apaga tudo o que está no quadro desta página.": "清除此页面画板上的所有内容。",
 "Apagar o desenho?": "删除这幅画？",
 "Apagar o diário": "删除日记",
 "Apagar para todos?": "为所有人删除？",
 "Aplicar a todas as páginas desta matéria": "应用到此科目的所有页面",
 "Aplicar a todas as páginas desta pasta": "应用到此文件夹的所有页面",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para a turma, cada aluno recebe no app dele.": "讲义、习题、幻灯片、视频、链接和通知。通过 ⋮ › 发送给班级，每位学生都会在自己的应用中收到。",
 "Aquarela": "水彩",
 "Aqui aparece, sem custo, o que os grupos compartilharam com você. Para usar a aba com os seus próprios dados, assine a aba.": "这里免费显示群组与你共享的内容。如需用你自己的数据使用此标签页，请订阅该标签页。",
 "Arquivados": "已归档",
 "Arraste para a direita para excluir, ou para a esquerda para arquivar.": "向右滑动删除，向左滑动归档。",
 "As cobranças desta aula extra já existem.": "这节加课的收费已存在。",
 "As notas vão só para cada aluno. Para isso, o nome da pessoa no grupo precisa ser igual ao nome do aluno ou do responsável no cadastro.": "成绩只发给每位学生本人。为此，群组中的名字必须与登记的学生或家长姓名一致。",
 "Atestado": "证明",
 "Atestados": "证明",
 "Até quando (opcional)": "截止日期（可选）",
 "Até {d}": "至 {d}",
 "Aula extra": "加课",
 "Aula extra (fora dos dias de aula)": "加课（非上课日）",
 "Aula extra de {d}": "{d} 的加课",
 "Avaliação de {d}": "{d} 的评估",
 "Avaliação salva": "评估已保存",
 "Avançar": "下一步",
 "Aviso da revisão do mês": "月度回顾提醒",
 "Aviso no último dia do mês: \"Que tal revisar o seu mês? ✨\"": "每月最后一天提醒：“回顾一下你的这个月吧？✨”",
 "Aviso sem nenhum conteúdo do diário: \"Como foi o seu dia? ✍️\"": "不含任何日记内容的提醒：“你今天过得怎么样？✍️”",
 "Avulsa": "单次",
 "Avulsas": "单次",
 "Azul": "蓝色",
 "Baixar na App Store": "在 App Store 下载",
 "Baixar na Google Play": "在 Google Play 下载",
 "Baixe o My Planner na loja: Android {android} · iPhone {iphone}": "在应用商店下载 My Planner：Android {android} · iPhone {iphone}",
 "Biometria, reconhecimento facial ou a senha do app. A senha do diário fica guardada para a primeira vez em cada aparelho.": "生物识别、面部识别或应用密码。每台设备第一次使用时需输入日记密码。",
 "Branco": "白色",
 "Buscando o clima…": "正在获取天气…",
 "Básicas": "基础",
 "COMO ESTOU": "我的状态",
 "COMO O DIÁRIO ABRE": "日记打开方式",
 "COR DA FOLHA": "纸张颜色",
 "Caixinha no My Planner": "My Planner 中的小金库",
 "Caixinha {m}": "小金库 {m}",
 "Carta de {d}": "{d} 的信",
 "Carta guardada": "信已保存",
 "Carta para o futuro": "给未来的信",
 "Carta trancada": "信已锁定",
 "Cartas abertas podem ser lidas, mas não editadas.": "已打开的信可以阅读，但不能编辑。",
 "Cartas para o Futuro": "给未来的信",
 "Cartões arquivados": "已归档的卡",
 "Chegou uma carta da {nome} de {tempo} atrás 💌": "收到一封 {tempo} 前的 {nome} 写来的信 💌",
 "Chegou! Toque para abrir 💌": "信到了！点按打开 💌",
 "Cinza-escuro": "深灰色",
 "Clara (segue o tema)": "浅色（跟随主题）",
 "Claras e pastel (boas para folha escura)": "浅色和粉彩（适合深色纸张）",
 "Clima (toque para preencher)": "天气（点按填写）",
 "Clima automático": "自动天气",
 "Clima do dia": "今日天气",
 "Cobrar a aula extra": "收取加课费用",
 "Cobrar a aula extra dos presentes": "向出席学生收取加课费用",
 "Cobrar a turma toda": "向全班收费",
 "Cole um link que comece com https://": "请粘贴以 https:// 开头的链接",
 "Coloque o valor da aula extra na turma (Editar).": "请在班级中填写加课费用（编辑）。",
 "Coloque o valor.": "请填写金额。",
 "Colunas": "栏",
 "Com a sua IA ligada (Ajustes › Inteligência artificial), o app lê o valor, a data e a descrição pela foto.": "开启你的 AI（设置 › 人工智能）后，应用会从照片中读取金额、日期和说明。",
 "Como cuidei de mim hoje?": "我今天如何照顾了自己？",
 "Como foi o seu dia? ✍️": "你今天过得怎么样？✍️",
 "Compartilhar este projeto (convidar)": "共享此项目（邀请）",
 "Compartilhar o texto": "分享文本",
 "Completa": "完整",
 "Comprovante (foto, PDF ou print)": "凭证（照片、PDF 或截图）",
 "Comprovante anexado": "已附加凭证",
 "Comprovante de pagamento (foto ou PDF)": "付款凭证（照片或 PDF）",
 "Concluído: hábito formado": "已完成：习惯已养成",
 "Concluídos": "已完成",
 "Configurar o Diário": "设置日记",
 "Confirmar pagamento": "确认付款",
 "Confirmar recebimento": "确认收款",
 "Conquistas": "成就",
 "Contas arquivadas": "已归档的账款",
 "Continuar escrevendo": "继续写",
 "Copiado ✓": "已复制 ✓",
 "Copiar código": "复制代码",
 "Copiar link": "复制链接",
 "Cor atual": "当前颜色",
 "Cor {n}": "颜色 {n}",
 "Creme": "米色",
 "Criada em {d}": "创建于 {d}",
 "Criar as cobranças": "创建收费",
 "Criar o grupo da turma": "创建班级群组",
 "Criar o meu diário": "创建我的日记",
 "Crie a senha do diário (6 ou mais)": "设置日记密码（6 位或以上）",
 "Crie o grupo da turma e mande o convite aos alunos. Depois, o envio vai direto para eles.": "创建班级群组并向学生发送邀请。之后，发送内容会直接送达他们。",
 "Crie sua primeira meta, objetivo ou sonho com o botão + abaixo.": "点按下方的 + 按钮，创建你的第一个目标、目的或梦想。",
 "Crie um projeto, convide quem participa e divida os passos. Cada pessoa marca o que fez.": "创建项目，邀请参与者并分配步骤。每个人勾选自己完成的部分。",
 "Crie uma senha nova para começar.": "设置一个新密码即可开始。",
 "Cuidados arquivados": "已归档的养护",
 "Cuidados pessoais do dia feitos (Bem-Estar)": "今日个人护理已完成（健康）",
 "Curto prazo": "短期",
 "Custos": "成本",
 "Céu estrelado": "星空",
 "Círculo": "圆形",
 "Cômodos arquivados": "已归档的房间",
 "DIAS CUMPRIDOS": "完成天数",
 "Data (opcional)": "日期（可选）",
 "De {d}": "来自 {d}",
 "Desafixar do topo": "取消置顶",
 "Desenho mais fraco ou mais forte": "线条更淡或更浓",
 "Desfazer \"Concluído\" ({d})": "撤销“已完成”（{d}）",
 "Desligado": "关闭",
 "Desmarcar": "取消勾选",
 "Desmarcar como paga?": "取消标记为已付款？",
 "Desmarcar como recebida?": "取消标记为已收款？",
 "Desmarque o que você não usa: some da tela e deixa a aba mais simples. Dá para mudar depois em Ajustes › Abas › {aba} › Partes desta aba.": "取消勾选你不用的部分：它们会从界面上消失，让标签页更简洁。之后可在 设置 › 标签页 › {aba} › 此标签页的组成部分 中更改。",
 "Dias da semana": "星期",
 "Dias de aula": "上课日",
 "Dias de aula: {d}": "上课日：{d}",
 "Dias escritos": "已写天数",
 "Dica: desenhe a forma à mão e segure o dedo no fim do traço para ela ficar perfeita.": "提示：手绘形状，并在笔画结束时按住手指，它就会变得完美。",
 "Ditado": "听写",
 "Ditar (falar para escrever)": "听写（说话输入文字）",
 "Diário apagado": "日记已删除",
 "Diário protegido": "日记已保护",
 "Dom": "周日",
 "Dê um nome a ele na pasta Hábitos.": "在“习惯”文件夹中给它起个名字。",
 "EVOLUÇÃO": "变化趋势",
 "Editada em {d}": "编辑于 {d}",
 "Ela abre em {d} ({n} dias). Até lá não dá para reler nem editar.": "它将在 {d} 打开（{n} 天后）。在此之前无法重读或编辑。",
 "Ela abre em {d}. Você vai receber um aviso nesse dia.": "它将在 {d} 打开。那天你会收到提醒。",
 "Ela fica guardada com a data de hoje para comparar depois.": "它会以今天的日期保存，方便以后对比。",
 "Enorme": "超大",
 "Enviado ao paciente": "已发送给患者",
 "Enviado em": "发送于",
 "Enviar \"{t}\" para todos do grupo {g}?": "将“{t}”发送给群组 {g} 的所有人？",
 "Enviar a nota para cada aluno": "将成绩发送给每位学生",
 "Enviar as notas": "发送成绩",
 "Enviar o arquivo: {nome}": "发送文件：{nome}",
 "Enviar o recado para a turma": "向班级发送通知",
 "Enviar o título para outra aba": "将标题发送到其他标签页",
 "Enviar para a turma": "发送给班级",
 "Enviar para outra aba": "发送到其他标签页",
 "Escolha a cor desta bolinha": "选择这个圆点的颜色",
 "Escolha uma data no futuro": "请选择未来的日期",
 "Escolher qualquer cor": "选择任意颜色",
 "Esconder a barra": "隐藏工具栏",
 "Escreva a frase": "写下这句话",
 "Escreva a que se refere a cobrança.": "请填写此收费的用途。",
 "Escreva alguma coisa antes de guardar.": "保存前请先写点内容。",
 "Escreva alguma coisa antes de salvar.": "保存前请先写点内容。",
 "Escreva hoje, abra no futuro": "今天写下，未来打开",
 "Escreva o que você quer mudar a partir de hoje": "写下你从今天起想改变的事",
 "Escreva para você do futuro. A carta fica trancada até o dia de abrir.": "写给未来的自己。这封信会锁定到打开的那一天。",
 "Escrever uma carta": "写一封信",
 "Escrita em {e} · abre em {a}": "写于 {e} · {a} 打开",
 "Escuras (boas para folha clara)": "深色（适合浅色纸张）",
 "Esperado": "预期",
 "Esperado: {e} · Feito: {f} · Faltou: {fa}": "预期：{e} · 完成：{f} · 缺少：{fa}",
 "Esqueceu a senha do diário?": "忘记日记密码了？",
 "Esqueci a senha do diário": "我忘记了日记密码",
 "Esta semana": "本周",
 "Este lançamento vem de outra parte do app e não se apaga aqui.": "这笔记录来自应用的其他部分，无法在这里删除。",
 "Estudo: {h}": "学习：{h}",
 "Esvaziar": "清空",
 "Esvaziar a lixeira": "清空回收站",
 "Esvaziar a lixeira?": "清空回收站？",
 "Ex.: Comer uma fruta por dia": "例如：每天吃一个水果",
 "Ex.: Exercícios para casa, Atestado de 2 dias": "例如：家庭作业、2 天的证明",
 "Ex.: Reservar a pousada": "例如：预订民宿",
 "Ex.: Viagem em família, juntar para a festa": "例如：家庭旅行、为聚会攒钱",
 "Excluir de vez?": "永久删除？",
 "Excluir esta avaliação?": "删除这次评估？",
 "Excluir este bloco?": "删除这个区块？",
 "Excluir este desenho?": "删除这幅画？",
 "Excluir este item?": "删除此项？",
 "Excluir {n} item(ns)?": "删除 {n} 项？",
 "Exportar como imagem": "导出为图片",
 "Exportar em PDF": "导出为 PDF",
 "FOTOS": "照片",
 "FRASE DO DIA": "每日一句",
 "FREQUÊNCIA": "出勤",
 "Falta o valor": "缺少金额",
 "Feriado": "节假日",
 "Feriado: {f}": "节假日：{f}",
 "Fica 30 dias na lixeira.": "在回收站保留 30 天。",
 "Ficam 30 dias na lixeira.": "在回收站保留 30 天。",
 "Fichários arquivados": "已归档的活页夹",
 "Fixar no topo": "置顶",
 "Floral": "花卉",
 "Folha": "纸张",
 "Folha, tema e cores das páginas com escrita": "书写页面的纸张、主题和颜色",
 "Folhas e plantas": "树叶和植物",
 "Foto adicionada": "已添加照片",
 "Foto do sonho": "梦想照片",
 "Fotos do dia": "今日照片",
 "Frase": "句子",
 "Frase do dia (aparece no topo do Meu Dia)": "每日一句（显示在“我的一天”顶部）",
 "Frases, textos, vídeos e fotos que motivam": "激励你的句子、文字、视频和照片",
 "Geométrico": "几何",
 "Gerar": "生成",
 "Gravar lembretes e anotações por voz e ditar textos (🎤) quando você pedir. O microfone só liga com o seu toque, e o áudio do ditado não é guardado.": "在你需要时，用语音录制提醒和笔记，并听写文字（🎤）。麦克风只在你点按时开启，听写的音频不会被保存。",
 "Guardar e trancar": "保存并锁定",
 "Guardar e trancar?": "保存并锁定？",
 "Guarde aqui o que te motiva: frases, textos seus, vídeos e fotos.": "把激励你的东西保存在这里：句子、你自己的文字、视频和照片。",
 "Guarde bem esta senha: sem ela o diário não pode ser recuperado.": "请妥善保管此密码：没有它，日记将无法恢复。",
 "Hoje é feriado: {f}. Registrar mesmo assim?": "今天是节假日：{f}。仍要记录吗？",
 "Humor do mês": "本月心情",
 "Humor do período": "期间心情",
 "HÁBITOS LIGADOS": "关联的习惯",
 "Há itens grandes na seleção. Eles só podem ser excluídos um por um, com confirmação e senha.": "所选内容中有大型项目。它们只能逐个删除，并需要确认和密码。",
 "Há um ano": "一年前",
 "Há um mês": "一个月前",
 "Hábito": "习惯",
 "Hábito criado": "习惯已创建",
 "Hábitos": "习惯",
 "Hábitos cumpridos": "已完成的习惯",
 "Hábitos cumpridos: {f} de {n}": "已完成的习惯：{f} / {n}",
 "Hábitos formados": "已养成的习惯",
 "INSPIRAÇÃO": "灵感",
 "Imagem adicionada": "已添加图片",
 "Imagem não encontrada": "未找到图片",
 "Incrível": "棒极了",
 "Informação nutricional": "营养信息",
 "Inserir": "插入",
 "Inspiração": "灵感",
 "Item para o paciente": "给患者的项目",
 "Itens grandes só se excluem um por um.": "大型项目只能逐个删除。",
 "Junte fotos do que você quer viver. Segure e arraste para organizar.": "收集你想经历的事物的照片。按住并拖动来整理。",
 "LIGAR A UM SONHO DO PROJETO DE VIDA (OPCIONAL)": "关联到人生规划中的梦想（可选）",
 "LIGAR A UMA META (OPCIONAL)": "关联到目标（可选）",
 "LINKS DE VÍDEO": "视频链接",
 "Lance as notas antes de enviar.": "发送前请先录入成绩。",
 "Lançamentos arquivados": "已归档的收支记录",
 "Legenda (opcional)": "说明（可选）",
 "Lembrete diário": "每日提醒",
 "Lendo o comprovante...": "正在读取凭证...",
 "Ler o comprovante com a minha IA": "用我的 AI 读取凭证",
 "Ligado": "开启",
 "Ligar um texto de motivação (Inspiração)": "关联一段激励文字（灵感）",
 "Lilás": "淡紫色",
 "Limpar a folha inteira?": "清空整张纸？",
 "Linha reta": "直线",
 "Linhas": "横线",
 "Link do vídeo (YouTube, Instagram...)": "视频链接（YouTube、Instagram...）",
 "Lisa": "空白",
 "Liste os passos do projeto e diga quem faz cada um.": "列出项目的步骤，并指定每一步由谁负责。",
 "Lixeira": "回收站",
 "Longo prazo": "长期",
 "MARCAR SOZINHO PELO BEM-ESTAR (OPCIONAL)": "通过健康自动勾选（可选）",
 "META OU SONHO LIGADO (OPCIONAL)": "关联的目标或梦想（可选）",
 "Mais opções": "更多选项",
 "Mal": "不好",
 "Mandar ao paciente pelo WhatsApp": "通过 WhatsApp 发送给患者",
 "Marque o que fez em cada dia": "勾选每天完成的事",
 "Marque os dias de aula na turma (Editar) para a chamada mostrar só esses dias.": "在班级中标记上课日（编辑），点名就只显示这些日子。",
 "Matérias arquivadas": "已归档的科目",
 "Mensalidade": "月费",
 "Meta de água do Bem-Estar": "健康的饮水目标",
 "Metas arquivadas": "已归档的目标",
 "Metas e sonhos concluídos": "已完成的目标和梦想",
 "Metas em andamento": "进行中的目标",
 "Metas que avançaram": "有进展的目标",
 "Metas, objetivos e sonhos, com passos e prazos": "目标、目的和梦想，附带步骤和期限",
 "Meu Dia": "我的一天",
 "Meu Dia com página livre, projeto de vida, hábitos, quadro dos sonhos, roda da vida, cartas para o futuro e conquistas. Protegido com senha.": "“我的一天”自由页面、人生规划、习惯、梦想板、生命之轮、给未来的信和成就。受密码保护。",
 "Minimalista": "极简",
 "Mostrar as contas antes do vencimento": "在到期前显示账款",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. A localização aproximada do celular só é usada quando você pede o clima do dia no Diário, e não fica guardada.": "根据你所在的地区显示正确的日期、时间、货币和节假日。只有当你在日记中请求今日天气时才会使用手机的大致位置，且不会保存。",
 "Muito bem": "很好",
 "Muito mal": "很差",
 "Mural de fotos dos seus sonhos": "你梦想的照片墙",
 "Mural, relatório e revisão do mês": "展示墙、报告和月度回顾",
 "Médio prazo": "中期",
 "N dias cumpridos no mês": "本月完成 N 天",
 "N dias seguidos": "连续 N 天",
 "NESTE DIA": "这一天",
 "Nada a enviar": "没有可发送的内容",
 "Nenhum estudo registrado nesta semana.": "本周没有学习记录。",
 "Nenhum hábito ainda. Ex.: \"Comer uma fruta por dia\", \"Beber 2 L de água\", \"Não pular o café da manhã\".": "还没有习惯。例如：“每天吃一个水果”、“喝 2 L 水”、“不跳过早餐”。",
 "Nenhum no período.": "此期间没有。",
 "Nenhuma": "无",
 "Nenhuma carta ainda.": "还没有信。",
 "Nenhuma foto ainda.": "还没有照片。",
 "Neutras e opacas": "中性和哑光色",
 "Ninguém encontrado no grupo": "群组中未找到任何人",
 "No computador: {link}": "在电脑上：{link}",
 "No navegador, a senha do diário é pedida sempre.": "在浏览器中，每次都需要输入日记密码。",
 "No último dia do mês: \"Que tal revisar o seu mês? ✨\"": "每月最后一天：“回顾一下你的这个月吧？✨”",
 "Nome da página (opcional)": "页面名称（可选）",
 "Nome de quem faz este passo": "负责此步骤的人",
 "Nome do vídeo (opcional)": "视频名称（可选）",
 "Normal": "普通",
 "Nota de 0 a 10 para cada área da vida": "为每个生活领域打 0 到 10 分",
 "Nota: {a}": "分数：{a}",
 "Nova caixa": "新收纳盒",
 "Nova carta": "新信",
 "Nova meta, objetivo ou sonho": "新目标、目的或梦想",
 "Nova senha (6 caracteres ou mais)": "新密码（6 个字符或以上）",
 "Nova área (ex.: Espiritualidade)": "新领域（例如：灵性）",
 "Novo cômodo": "新房间",
 "Novo hábito": "新习惯",
 "Não dá para excluir em grupo": "无法批量删除",
 "Não enviados": "未发送",
 "Não estão no grupo (ou com outro nome): {l}": "不在群组中（或名字不同）：{l}",
 "Não foi possível exportar": "无法导出",
 "Não foi possível ouvir agora ({erro}).": "现在无法收听（{erro}）。",
 "Não pede a senha do diário. É a única parte que pode ser compartilhada.": "不需要日记密码。这是唯一可以共享的部分。",
 "Não é dia de aula desta turma. A chamada fica como reposição ou aula extra.": "今天不是这个班级的上课日。点名将记为补课或加课。",
 "O app avisa {n} dia(s) antes e no dia do vencimento, às 9h. Dá para mudar em Ajustes › Abas › Finanças.": "应用会在到期前 {n} 天和到期当天 9 点提醒。可在 设置 › 标签页 › 金融 中更改。",
 "O clima automático usa a localização do celular. Sem permissão, ele fica para preencher aqui.": "自动天气使用手机的位置。没有权限时，可以在这里手动填写。",
 "O conteúdo desta carta não foi encontrado.": "未找到这封信的内容。",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja (ou instale o APK novo) para usar o microfone.": "听写功能将随新版应用推出。请通过应用商店更新 My Planner（或安装新的 APK）以使用麦克风。",
 "O diário pede a senha sempre que você entra nele, mesmo com o app desbloqueado.": "即使应用已解锁，每次进入日记时都需要输入密码。",
 "O diário só abre com essa senha, sempre.": "日记始终只能用这个密码打开。",
 "O diário é criptografado: sem a senha, ninguém consegue abrir, nem o suporte. Se quiser, dá para apagar o diário e começar um novo (os Projetos em Grupo continuam).": "日记是加密的：没有密码，谁都无法打开，包括客服。如果你愿意，可以删除日记并重新开始（群组项目会保留）。",
 "O que aprendi hoje?": "我今天学到了什么？",
 "O que este mês te ensinou? O que quer levar para o próximo?": "这个月教会了你什么？你想把什么带到下个月？",
 "O que fica desmarcado some da tela. Os dados continuam guardados.": "未勾选的部分会从界面上消失。数据仍会保留。",
 "O que foi bom hoje?": "今天有什么好事？",
 "O que foi excluído nos últimos 30 dias": "最近 30 天内删除的内容",
 "O que quero melhorar amanhã?": "明天我想改进什么？",
 "O que quero mudar agora": "我现在想改变的事",
 "O que você escreveu nesta carta vai se perder.": "你在这封信中写的内容将会丢失。",
 "O que você quer fazer com o arquivo?": "你想如何处理这个文件？",
 "Objetivo": "目的",
 "Oculta": "隐藏",
 "Orientação": "指导",
 "Orientações, receitas, atestados e materiais para entregar ao paciente, com arquivos. Só o que está aqui é enviado: o prontuário nunca sai por esta pasta.": "要交给患者的指导、处方、证明和资料，可附文件。只会发送这里的内容：病历永远不会通过此文件夹发出。",
 "Os dias com página escrita ficam marcados. Toque num dia para abrir.": "写过页面的日子会被标记。点按某一天即可打开。",
 "Os itens saem de vez e não podem mais ser restaurados.": "这些项目将被永久删除，无法再恢复。",
 "Outra data": "其他日期",
 "Outras moedas": "其他货币",
 "Ouvindo…": "正在聆听…",
 "PASSOS": "步骤",
 "PDF com seus dados e assinatura": "含你的资料和签名的 PDF",
 "POR DIA": "按天",
 "POR MATÉRIA": "按科目",
 "PROGRESSO": "进度",
 "Paciente: {nome}": "患者：{nome}",
 "Para o paciente": "给患者",
 "Para trocar a forma de abrir, entre no Diário com a senha dele e volte aqui.": "如需更改打开方式，请用日记密码进入日记后再回到这里。",
 "Para {nome} de {tempo} depois": "致 {tempo} 后的 {nome}",
 "Parar o ditado": "停止听写",
 "Parcelado": "分期",
 "Partes desta aba": "此标签页的组成部分",
 "Passo": "步骤",
 "Pastas arquivadas": "已归档的文件夹",
 "Pastas arquivadas ({n})": "已归档的文件夹（{n}）",
 "Pautada": "横线",
 "Pautada com margem": "带边距的横线",
 "Pedido de exame": "检查申请",
 "Pelo que sou grata hoje?": "今天我感恩什么？",
 "Permita o microfone e o reconhecimento de fala para o My Planner nos ajustes do celular.": "请在手机设置中允许 My Planner 使用麦克风和语音识别。",
 "Personalizar: tipo, cor e tema da folha e cores das bolinhas, só para esta aba": "自定义：纸张类型、颜色、主题和圆点颜色，仅限此标签页",
 "Pontilhada": "点阵",
 "Posto": "加油站",
 "Preenche o clima do Meu Dia pela localização do celular.": "根据手机位置填写“我的一天”的天气。",
 "Preencher pela foto do comprovante": "通过凭证照片填写",
 "Primeira vez neste aparelho: digite a senha do diário.": "首次在此设备上使用：请输入日记密码。",
 "Projeto": "项目",
 "Projeto de Vida": "人生规划",
 "Projetos com amigos e família (compartilhados)": "与朋友和家人的项目（共享）",
 "Projetos em Grupo": "群组项目",
 "Proprietário / Locador": "房东 / 出租人",
 "Páginas arquivadas": "已归档的页面",
 "Páginas desta aba": "此标签页的页面",
 "QUANDO ELA ABRE": "打开时间",
 "Qua": "周三",
 "Quadriculada": "方格",
 "Quadro dos Sonhos": "梦想板",
 "Quais partes você vai usar?": "你会使用哪些部分？",
 "Quando você concluir uma meta ou formar um hábito, ele aparece aqui para celebrar. 🎉": "当你完成一个目标或养成一个习惯时，它会出现在这里供你庆祝。🎉",
 "Quanto você pagou?": "你付了多少？",
 "Quanto você recebeu?": "你收到了多少？",
 "Que tal revisar o seu mês? ✨": "回顾一下你的这个月吧？✨",
 "Quem faz": "负责人",
 "Quem fez o meu dia melhor?": "谁让我的今天更美好？",
 "Quer guardar o comprovante agora?": "要现在保存凭证吗？",
 "Qui": "周四",
 "REFLEXÃO DO MÊS": "本月反思",
 "Recebeu {v} a mais": "多收了 {v}",
 "Recebeu {v} a menos": "少收了 {v}",
 "Receita médica": "医疗处方",
 "Receitas médicas": "医疗处方",
 "Recolher": "收起",
 "Refeições arquivadas": "已归档的餐食",
 "Refeições do cronograma feitas (Bem-Estar)": "日程中的餐食已完成（健康）",
 "Referente a (ex.: material, passeio, inscrição)": "用途（例如：资料费、出游、报名）",
 "Registrar": "记录",
 "Relacionamentos": "人际关系",
 "Relatório de estudos": "学习报告",
 "Relatório de realizações": "成就报告",
 "Relatório em PDF": "PDF 报告",
 "Renomear, adicionar ou tirar áreas": "重命名、添加或移除领域",
 "Reposição": "补课",
 "Restaurado": "已恢复",
 "Resumida": "简要",
 "Resumida: só uma linha com o total. Completa: mostra os itens do dia. Oculta: não aparece. Nada desta aba vira tarefa sozinho.": "简要：只显示一行总计。完整：显示当天的项目。隐藏：不显示。此标签页中的任何内容都不会自动变成任务。",
 "Resumo de {nome}": "{nome} 的摘要",
 "Resumo do dia": "今日摘要",
 "Retângulo": "矩形",
 "Revisar antes": "先检查",
 "Revisão do mês": "月度回顾",
 "Roda da Vida": "生命之轮",
 "Rosa": "粉色",
 "Sair sem guardar?": "不保存就退出？",
 "Salvar avaliação de hoje": "保存今天的评估",
 "Salvar ou enviar": "保存或发送",
 "Seg": "周一",
 "Segure e arraste as pastas para mudar a ordem. Arraste para a esquerda para arquivar.": "按住并拖动文件夹以更改顺序。向左滑动即可归档。",
 "Sem chamada neste dia: cobra todos os alunos.": "这天没有点名：向所有学生收费。",
 "Sem ideia do que escrever? Toque numa pergunta:": "不知道写什么？点按一个问题：",
 "Sem registros de humor.": "没有心情记录。",
 "Sem tema": "无主题",
 "Semana de {d}": "{d} 这一周",
 "Senha atual do diário": "当前日记密码",
 "Senha do diário": "日记密码",
 "Senha do diário incorreta.": "日记密码错误。",
 "Senha do diário trocada": "日记密码已更改",
 "Senha própria só do diário": "日记专用密码",
 "Sequência dos hábitos": "习惯连续记录",
 "Seta": "箭头",
 "Seu diário, só seu": "你的日记，只属于你",
 "Seu texto de motivação": "你的激励文字",
 "Sex": "周五",
 "Sonho": "梦想",
 "Suplementos arquivados": "已归档的补充剂",
 "Sáb": "周六",
 "Só abre com a senha do diário.": "只能用日记密码打开。",
 "TEMA DECORATIVO": "装饰主题",
 "TIPO DE FOLHA": "纸张类型",
 "Tarefas arquivadas": "已归档的任务",
 "Ter": "周二",
 "Texto para o paciente": "给患者的文字",
 "Tipo, cor e tema da folha": "纸张类型、颜色和主题",
 "Tirar a área \"{a}\"?": "移除领域“{a}”？",
 "Tirar da frase do dia": "从每日一句中移除",
 "Tirar do arquivo": "取消归档",
 "Tirar esta foto do quadro?": "从梦想板上移除这张照片？",
 "Tirar esta pergunta?": "移除这个问题？",
 "Tirar este vídeo?": "移除这个视频？",
 "Todo dia às {h}: \"Como foi o seu dia? ✍️\"": "每天 {h}：“你今天过得怎么样？✍️”",
 "Todos os alunos já têm uma cobrança com esta referência.": "所有学生都已有此用途的收费。",
 "Toque de novo para \"Outros\" (dispensado, atestado...): não conta como falta nem como aula.": "再点一次设为“其他”（免除、证明...）：既不算缺勤，也不算上课。",
 "Toque no círculo para marcar o que fez hoje. Os hábitos não vão para o My Planner sozinhos: use Enviar, no menu ⋮.": "点按圆圈标记今天完成的事。习惯不会自动进入 My Planner：请使用 ⋮ 菜单中的“发送”。",
 "Toque num dia para marcar ou desmarcar.": "点按某一天来勾选或取消勾选。",
 "Toque numa bolinha para trocar a cor. Na página, segurar a bolinha faz o mesmo.": "点按圆点更换颜色。在页面上按住圆点也可以。",
 "Toque para abrir. Arraste para a esquerda para arquivar ou duplicar, ou para a direita para excluir.": "点按打开。向左滑动可归档或复制，向右滑动可删除。",
 "Treino do dia feito (Bem-Estar)": "今日训练已完成（健康）",
 "Treinos arquivados": "已归档的训练",
 "Trocar a senha do diário": "更改日记密码",
 "Tudo o que você escrever no diário fica criptografado neste dispositivo antes de ir para a sua conta. Ninguém mais consegue ler, nem o suporte.": "你在日记中写的所有内容都会先在此设备上加密，再上传到你的账户。其他人都无法读取，包括客服。",
 "Tudo o que você exclui fica aqui por 30 dias. Depois disso sai de vez.": "你删除的所有内容都会在这里保留 30 天，之后将被永久删除。",
 "Título (ex.: Ter uma boa alimentação)": "标题（例如：保持良好饮食）",
 "Uma cobrança avulsa para cada um dos {n} aluno(s). Para cobrar só um aluno, toque em +.": "为 {n} 位学生每人创建一笔单次收费。如只向一位学生收费，请点按 +。",
 "Uma senha própria, só do diário": "一个日记专用的密码",
 "Usar a senha do diário": "使用日记密码",
 "Usar como frase do dia": "设为每日一句",
 "Usar este valor": "使用此金额",
 "Usar o padrão do app": "使用应用默认设置",
 "Vale para os valores de todas as abas (Finanças, aluguel, mensalidades...).": "适用于所有标签页中的金额（金融、租金、月费...）。",
 "Vale para todas as páginas com escrita (Estudos, Anotações, Diário, Documentos...). Cada aba pode ter o próprio padrão em Ajustes › Abas, e cada página pode mudar a folha no ⋮ › Folha.": "适用于所有书写页面（学习、笔记、日记、证件...）。每个标签页可在 设置 › 标签页 中设置自己的默认值，每个页面也可通过 ⋮ › 纸张 更换纸张。",
 "Valor da aula extra (por aluno)": "加课费用（每位学生）",
 "Valor por aluno": "每位学生的金额",
 "Valor previsto: {v}": "预计金额：{v}",
 "Vencimento: {d}": "到期日：{d}",
 "Ver o comprovante": "查看凭证",
 "Verde": "绿色",
 "Visualizar": "预览",
 "Você está como convidado": "你正以访客身份使用",
 "Voltar a acompanhar este hábito": "重新追踪此习惯",
 "Voltar ao início da folha": "回到纸张顶部",
 "Voltar ao padrão inicial (folha pautada; preto, azul, vermelho e verde)": "恢复初始默认（横线纸；黑、蓝、红、绿）",
 "Voltar para a nova avaliação": "返回新的评估",
 "Vídeos": "视频",
 "X vezes por semana": "每周 X 次",
 "abre em {n} dias": "{n} 天后打开",
 "agradável": "宜人",
 "arquivo": "文件",
 "aula extra": "加课",
 "calor": "炎热",
 "chuva": "雨",
 "concluído": "已完成",
 "céu limpo": "晴朗",
 "de {n} planejados": "共计划 {n}",
 "dentro de {p}": "{p} 内",
 "enviado em {d}": "发送于 {d}",
 "estudados na semana": "本周已学习",
 "excluído em {d}": "删除于 {d}",
 "falta 1 dia": "还剩 1 天",
 "faltam {n} dias": "还剩 {n} 天",
 "feito {dur} na semana": "本周已完成 {dur}",
 "fresco": "凉爽",
 "frio": "寒冷",
 "garoa": "毛毛雨",
 "hoje não está planejado": "今天没有计划",
 "hábito formado ✨": "习惯已养成 ✨",
 "incorreta": "错误",
 "neblina": "雾",
 "neve": "雪",
 "nublado": "多云",
 "não enviado": "未发送",
 "parcela {k}/{n}": "第 {k}/{n} 期",
 "passou há {n} dias": "已过去 {n} 天",
 "pelo Bem-Estar": "通过健康",
 "poucas nuvens": "少云",
 "reposição": "补课",
 "sai de vez em {n} dia(s)": "{n} 天后永久删除",
 "sem registros": "无记录",
 "tempestade": "暴风雨",
 "tracejado: {d}": "虚线：{d}",
 "ver mais": "查看更多",
 "ver menos": "收起",
 "{aluno}: {n} de {max}": "{aluno}：{n} / {max}",
 "{d} é feriado: {f}. Registrar mesmo assim?": "{d} 是节假日：{f}。仍要记录吗？",
 "{f} de {n} passos feitos": "已完成 {f} / {n} 个步骤",
 "{f}/{n} passos": "{f}/{n} 步",
 "{nome} daqui a 1 ano": "1 年后的 {nome}",
 "{nome} daqui a 10 anos": "10 年后的 {nome}",
 "{nome} daqui a 6 meses": "6 个月后的 {nome}",
 "{n} aluno(s) recebem só a própria nota de \"{a}\".": "{n} 位学生只会收到自己“{a}”的成绩。",
 "{n} aluno(s) receberam a nota.": "{n} 位学生已收到成绩。",
 "{n} aluno(s) · {v} cada": "{n} 位学生 · 每人 {v}",
 "{n} anos": "{n} 年",
 "{n} dia(s) antes": "提前 {n} 天",
 "{n} dia(s) cumprido(s) no mês": "本月完成 {n} 天",
 "{n} dia(s) registrado(s) · média {e}": "已记录 {n} 天 · 平均 {e}",
 "{n} dia(s) registrado(s), média {m} de 6": "已记录 {n} 天，平均 {m} / 6",
 "{n} dia(s) seguido(s)": "连续 {n} 天",
 "{n} dispensada(s) hoje": "今天免除 {n} 项",
 "{n} meses": "{n} 个月",
 "{n} outro(s)": "其他 {n} 个",
 "{n} selecionado(s)": "已选择 {n} 项",
 "{n} tarefa(s) concluída(s) no My Planner": "在 My Planner 中完成了 {n} 项任务",
 "{n} vez(es) por semana": "每周 {n} 次",
 "{n}x": "{n} 次",
 "Água: {a} de {m} ml": "饮水：{a} / {m} ml",
 "ÚLTIMAS 8 SEMANAS": "最近 8 周",
 "Última parcela em {d}": "最后一期于 {d}",
 "é hoje!": "就是今天！",
 "A mesma do app": "与应用相同",
 "Abrir com o código": "用代码打开",
 "Ainda não criado": "尚未创建",
 "Ao criar, o app mostra um código de recuperação para você guardar.": "创建时，应用会显示一个恢复代码供你保存。",
 "Apagar o diário e começar de novo": "删除日记并重新开始",
 "Biometria ou código do dispositivo": "生物识别或设备密码",
 "Biometria, PIN do dispositivo ou a senha do app. Não precisa criar outra senha.": "生物识别、设备 PIN 或应用密码。无需另设密码。",
 "Bloquear o app": "锁定应用",
 "Cadastre digital, rosto ou um código de bloqueio no dispositivo para usar.": "请在设备上设置指纹、面部或锁屏密码后再使用。",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, a mesma janela oferece o código/PIN/padrão do dispositivo; a senha do app continua valendo.": "开启生物识别后会优先使用它。如果失败，同一窗口会提供设备的密码/PIN/图案；应用密码依然有效。",
 "Com ele você recupera o diário se esquecer a senha ou trocar de dispositivo.": "如果忘记密码或更换设备，可以用它恢复日记。",
 "Com este código você recupera o diário se esquecer a senha ou trocar de dispositivo. Guarde em lugar seguro e não mostre a ninguém.": "如果忘记密码或更换设备，可以用此代码恢复日记。请保存在安全的地方，不要给任何人看。",
 "Como funciona a Roda da Vida": "生命之轮怎么用",
 "Como o diário abre": "日记的打开方式",
 "Crie a senha que vai abrir o diário.": "创建用于打开日记的密码。",
 "Crie o PIN do diário (4 a 6 números)": "创建日记 PIN（4 至 6 位数字）",
 "Crie o diário de novo para começar.": "请重新创建日记以开始。",
 "Código aceito. Crie uma senha nova para o diário.": "代码正确。请为日记创建新密码。",
 "Código de recuperação": "恢复代码",
 "Código de recuperação (ex.: ABCD-EFGH-...)": "恢复代码（例如：ABCD-EFGH-...）",
 "Código de recuperação incorreto.": "恢复代码不正确。",
 "Cômodos": "房间",
 "Depois de 1 minuto": "1 分钟后",
 "Depois de {n} minutos": "{n} 分钟后",
 "Desenhe o padrão do diário": "绘制日记图案",
 "Dias no mês": "本月天数",
 "Dias seguidos": "连续天数",
 "Digite o seu PIN": "输入你的 PIN",
 "Diário ainda não criado": "尚未创建日记",
 "Dê uma nota de 0 a 10 para como você se sente hoje em cada área da vida. O desenho mostra onde a sua vida está equilibrada e onde precisa de atenção. Salve a avaliação e repita de tempos em tempos (por exemplo, todo mês) para comparar e ver a sua evolução. Você pode renomear, adicionar ou tirar áreas.": "为你今天在每个生活领域的感受打 0 到 10 分。图形会显示你的生活哪里平衡、哪里需要关注。保存评估并定期重复（例如每月一次），以便比较并查看你的进步。你可以重命名、添加或删除领域。",
 "Entre na aba Diário para criar o seu diário.": "前往“日记”标签页创建你的日记。",
 "Entre no Diário (com a senha dele ou o desbloqueio do app) e volte aqui.": "进入日记（使用日记密码或应用解锁），然后返回这里。",
 "Esconder a senha": "隐藏密码",
 "Gerar novo código": "生成新代码",
 "Gerar um código de recuperação novo?": "生成新的恢复代码？",
 "Guarde este código": "保存此代码",
 "Já guardei": "我已保存",
 "Ligar um hábito que já existe": "关联已有的习惯",
 "Mostrar a senha": "显示密码",
 "Mudar como o diário abre": "更改日记的打开方式",
 "My Planner · Código de recuperação do Diário": "My Planner · 日记恢复代码",
 "Não foi possível abrir com a chave deste dispositivo. Use a senha do diário ou o código de recuperação.": "无法用此设备的密钥打开。请使用日记密码或恢复代码。",
 "O Caps Lock parece estar ligado.": "大写锁定似乎已开启。",
 "O PIN fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o PIN.": "PIN 仅受保护地保存在此设备上。如果忘记 PIN，密码依然有效。",
 "O PIN precisa ter de 4 a 6 números.": "PIN 必须为 4 至 6 位数字。",
 "O código anterior deixa de valer. Por segurança, o código não fica guardado no app: só dá para ver na hora em que é gerado.": "之前的代码将失效。出于安全考虑，代码不会保存在应用中：只能在生成时查看。",
 "O código não fica guardado em lugar nenhum que o suporte possa ver. Sem a senha e sem o código, o diário não pode ser recuperado.": "代码不会保存在任何客服能看到的地方。没有密码和代码，日记将无法恢复。",
 "O diário agora abre só com a senha dele.": "现在日记只能用它自己的密码打开。",
 "O reconhecimento de rosto deste dispositivo não pode ser usado por apps. Use a digital ou o código/PIN do dispositivo.": "此设备的面部识别无法供应用使用。请使用指纹或设备的密码/PIN。",
 "O tempo conta a partir do momento em que o app sai da tela (outro app, tela inicial ou tela apagada). Puxar as notificações, a janela da biometria, um pedido de permissão ou escolher uma foto ou arquivo não contam.": "从应用离开屏幕（切换到其他应用、主屏幕或屏幕熄灭）时开始计时。下拉通知、生物识别窗口、权限请求或选择照片或文件不计入。",
 "Os PINs não conferem.": "两次输入的 PIN 不一致。",
 "PIN": "PIN",
 "PIN (4 a 6 números)": "PIN（4 至 6 位数字）",
 "PIN (só números, 4 a 6)": "PIN（仅限数字，4 至 6 位）",
 "PIN do diário": "日记 PIN",
 "PIN incorreto": "PIN 不正确",
 "PIN salvo.": "PIN 已保存。",
 "Padrão do app": "应用默认",
 "Para apagar, confirme com a senha do app, biometria ou PIN do dispositivo. Isso apaga o Meu Dia, metas, hábitos, cartas e fotos do diário. Projetos em Grupo continuam.": "删除前，请用应用密码、生物识别或设备 PIN 确认。这将删除日记中的我的一天、目标、习惯、信件和照片。群组项目会保留。",
 "Para continuar, digite a senha do app ou use a biometria/o código do dispositivo.": "如需继续，请输入应用密码或使用生物识别/设备密码。",
 "Para recuperar o diário se esquecer a senha ou trocar de dispositivo.": "用于在忘记密码或更换设备时恢复日记。",
 "Pastas": "文件夹",
 "Pedir a senha de novo": "再次要求输入密码",
 "Personalizada": "自定义",
 "Primeira vez neste dispositivo: digite a senha do diário ou use o código de recuperação.": "首次在此设备使用：请输入日记密码或使用恢复代码。",
 "Primeira vez neste dispositivo: digite o código de recuperação do diário.": "首次在此设备使用：请输入日记恢复代码。",
 "Reconhecimento de rosto": "面部识别",
 "Repita o PIN": "再次输入 PIN",
 "Salvar a senha nova": "保存新密码",
 "Salvar em arquivo / no Drive": "保存到文件 / Drive",
 "Salvar o código de recuperação": "保存恢复代码",
 "Senha (letras e números)": "密码（字母和数字）",
 "Senha do app": "应用密码",
 "Senha nova do diário": "新的日记密码",
 "Senha própria": "独立密码",
 "Senha própria do diário": "日记独立密码",
 "Tarefas": "任务",
 "Trocar o PIN": "更改 PIN",
 "Usar a senha": "使用密码",
 "Usar o PIN": "使用 PIN",
 "Usar o código de recuperação": "使用恢复代码",
 "Usar o desbloqueio do app": "使用应用解锁",
 "Use a biometria ou o código/PIN/padrão do dispositivo.": "请使用生物识别或设备的密码/PIN/图案。",
 "Use o código de recuperação que apareceu quando o diário foi criado. Sem a senha e sem o código, ninguém consegue abrir o diário, nem o suporte.": "请使用创建日记时显示的恢复代码。没有密码和代码，任何人都无法打开日记，客服也不行。",
 "Voltar a usar só a senha?": "恢复为仅使用密码？",
 "incorreto": "不正确",
 "1 h": "1 小时",
 "12 horas (2:30 PM)": "12 小时制（2:30 PM）",
 "15 min": "15 分钟",
 "24 horas (14:30)": "24 小时制（14:30）",
 "30 min": "30 分钟",
 "A lixeira tem itens grandes. Confirme com a senha do app, a biometria ou o código do dispositivo.": "回收站中有大型项目。请使用应用密码、生物识别或设备密码确认。",
 "A semana começa na": "每周开始于",
 "Abra o Diário primeiro": "请先打开日志",
 "Abrir configurações do celular": "打开手机设置",
 "Agenda e mapas": "日历和地图",
 "Agora: {m}": "当前：{m}",
 "Ajuda e sobre": "帮助与关于",
 "Alarme (som)": "闹钟（声音）",
 "Alarme ou vibração das pausas": "休息的闹钟或振动",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Pede a sua senha antes.": "永久删除账户以及云端和此设备上的所有数据。删除前会要求输入密码。",
 "Apagar todas ({n})": "全部删除（{n}）",
 "Apagar {n} selecionada(s)": "删除所选的 {n} 项",
 "Aparência": "外观",
 "App das rotas": "路线应用",
 "Ardósia": "石板灰",
 "Arrastar para a direita": "向右滑动",
 "Arrastar para a esquerda": "向左滑动",
 "As contas de Finanças aparecem no My Planner com essa antecedência.": "金融中的账单会提前这么久显示在 My Planner 中。",
 "Atualizações e sobre": "更新与关于",
 "Avisar antes do vencimento": "到期前提醒",
 "Aviso marcado": "已设置提醒",
 "Aviso no começo e no fim de cada pausa": "每次休息开始和结束时提醒",
 "Avisos desta aba": "此标签页的提醒",
 "Avisos e alarmes": "提醒和闹钟",
 "Avisos silenciosos": "静音提醒",
 "Avisos: som e vibração": "提醒：声音和振动",
 "Avisos: só som": "提醒：仅声音",
 "Avisos: só vibração": "提醒：仅振动",
 "Azul elétrico": "电光蓝",
 "Azul-aço": "钢蓝",
 "Azul-bebê": "婴儿蓝",
 "Azul-marinho": "海军蓝",
 "Baixar meus dados": "下载我的数据",
 "Baixar todos os meus dados": "下载我的全部数据",
 "Baixar todos os meus dados e excluir a conta (LGPD)": "下载我的全部数据并删除账户（LGPD）",
 "Biometria": "生物识别",
 "Bissexual": "双性恋",
 "Brilhante": "明亮",
 "Buscar abas": "搜索标签页",
 "Buscar nos ajustes": "搜索设置",
 "Cancelar aviso": "取消提醒",
 "Cinza-chumbo": "铅灰",
 "Cofre": "保险库",
 "Coloque pelo menos uma matéria.": "请至少添加一个科目。",
 "Como usar": "使用说明",
 "Conexões": "连接",
 "Cor da aba": "标签页颜色",
 "Cor de destaque": "强调色",
 "Crie uma matéria primeiro": "请先创建一个科目",
 "Cítrico": "柑橘",
 "Cópia de segurança em arquivo": "备份到文件",
 "Dados de paciente e prontuário. Confirme com a senha do app, a biometria ou o código do dispositivo.": "患者数据和病历。请使用应用密码、生物识别或设备密码确认。",
 "Desligadas": "已关闭",
 "Digite a senha da sua conta para confirmar.": "请输入账户密码以确认。",
 "Duração padrão de uma tarefa nova": "新任务的默认时长",
 "Editar sessão": "编辑学习时段",
 "Ela se repete sem data de fim: aparecem as vezes até {data}. Com todas marcadas, sai a tarefa inteira.": "此任务无结束日期地重复：显示截至 {data} 的各次。全部勾选后，将删除整个任务。",
 "Em atividade": "进行中",
 "Em pausa": "休息中",
 "Emoji da pausa": "休息表情",
 "Encerrar": "结束",
 "Encerrar a sessão?": "结束学习时段？",
 "Entra no modo seleção, para escolher vários itens de uma vez.": "进入选择模式，可一次选择多个项目。",
 "Escolha um horário no futuro.": "请选择一个将来的时间。",
 "Escolher a matéria": "选择科目",
 "Esconde os valores em dinheiro (R$ •••)": "隐藏金额（R$ •••）",
 "Esconder o CPF": "隐藏 CPF",
 "Esconder os valores": "隐藏金额",
 "Esta e as próximas": "此次及以后",
 "Esta tarefa se repete. Onde aplicar a mudança?": "此任务会重复。要将更改应用到哪里？",
 "Este item tem muita coisa dentro. Confirme com a senha do app, a biometria ou o código do dispositivo.": "此项目包含大量内容。请使用应用密码、生物识别或设备密码确认。",
 "Exclui o item (pede confirmação). Depois dá para desfazer ou restaurar pela Lixeira.": "删除项目（需确认）。之后可以撤销，或从回收站恢复。",
 "Excluir minha conta": "删除我的账户",
 "Ficha protegida": "受保护的档案",
 "Formato da hora": "时间格式",
 "Foto do Quadro dos Sonhos": "梦想板照片",
 "Geral": "通用",
 "Gestos": "手势",
 "Google Drive, OneDrive e arquivo de cópia": "Google Drive、OneDrive 和备份文件",
 "Grafite": "石墨",
 "Guardar em": "保存到",
 "Hábito do Diário": "日志习惯",
 "Idioma e moeda": "语言和货币",
 "Inspiração do Diário": "日志灵感",
 "Intenso": "浓烈",
 "Item arquivado": "项目已归档",
 "Item excluído": "项目已删除",
 "Lavanda": "薰衣草",
 "Ligadas": "已开启",
 "Limite de energia": "精力上限",
 "Lésbica": "女同性恋",
 "Marque as vezes que vão ser apagadas.": "勾选要删除的各次。",
 "Matéria": "科目",
 "Me avise em…": "提醒我于…",
 "Menta": "薄荷",
 "Menu ⋮": "菜单 ⋮",
 "Meta do Diário": "日志目标",
 "Modo discreto": "隐私模式",
 "Monte a sessão uma vez (matérias, tempo de cada uma e pausas) e repita nos outros dias tocando em Começar. O tempo estudado entra sozinho na meta.": "只需设置一次学习时段（科目、各科时长和休息），之后在其他日子点击“开始”即可重复。学习时间会自动计入目标。",
 "Mostra Arquivar e Duplicar.": "显示“归档”和“复制”。",
 "Mostrar feriados no topo": "在顶部显示假日",
 "Mostrar os valores": "显示金额",
 "Muda a ordem dos itens.": "更改项目顺序。",
 "Muda só a cor do My Planner. A cor de destaque do app fica em Ajustes > Aparência. Cada tarefa pode ter uma cor própria na ficha.": "仅更改 My Planner 的颜色。应用的强调色在 设置 > 外观 中。每个任务都可以在卡片中设置自己的颜色。",
 "Nada encontrado nos ajustes.": "未在设置中找到相关内容。",
 "Nenhuma sessão salva ainda.": "尚未保存任何学习时段。",
 "Neon": "霓虹",
 "Nesse horário o app não toca nem vibra. Os avisos continuam chegando, em silêncio.": "在此时间段内，应用不会响铃或振动。提醒仍会静默送达。",
 "No menu ⋮ de qualquer item: o celular avisa na hora escolhida, sem criar tarefa no My Planner.": "在任意项目的菜单 ⋮ 中：手机会在所选时间提醒你，而不会在 My Planner 中创建任务。",
 "Nome (ex.: Sessão do mestrado)": "名称（例如：硕士学习时段）",
 "Nova sessão": "新建学习时段",
 "Nuvem e cópias de segurança": "云端与备份",
 "Não perturbe": "勿扰模式",
 "Não perturbe {de}–{ate}": "勿扰 {de}–{ate}",
 "Não-binário": "非二元",
 "O botão 🎉 Feriados no topo do My Planner. O país e a lista de feriados ficam em Ajustes > Feriados.": "My Planner 顶部的 🎉 假日按钮。国家和假日列表在 设置 > 假日 中。",
 "O celular avisa às {h}.": "手机将在 {h} 提醒你。",
 "O que sai do Diário fica cifrado na lixeira. Entre no Diário e depois volte aqui para restaurar.": "从日志中删除的内容会加密保存在回收站中。请先进入日志，再回到这里进行恢复。",
 "O que sair fica na Lixeira por 30 dias. Digite a senha da sua conta para confirmar.": "删除的内容会在回收站中保留 30 天。请输入账户密码以确认。",
 "O que saiu fica na Lixeira por 30 dias.": "删除的内容会在回收站中保留 30 天。",
 "O tema muda as cores das abas, a cor de destaque e um toque leve no fundo, nos modos claro e escuro. Para trocar a cor de uma aba só, vá em Ajustes > Abas.": "主题会在浅色和深色模式下更改标签页颜色、强调色以及背景的淡淡色调。如只想更改某个标签页的颜色，请前往 设置 > 标签页。",
 "O tempo estudado até agora entra na meta.": "到目前为止的学习时间会计入目标。",
 "Oliva": "橄榄绿",
 "Orgulho": "骄傲",
 "Os avisos funcionam no app instalado, com as notificações ligadas.": "提醒需在已安装的应用中开启通知后才能使用。",
 "Os gestos do app": "应用手势",
 "Outro (escolher a hora)": "其他（选择时间）",
 "Pansexual": "泛性恋",
 "Para ligar, use o app no celular (Ajustes › Agenda e mapas › Agenda do Google). Depois, tudo aparece aqui também.": "如需开启，请在手机上使用应用（设置 › 日历和地图 › Google 日历）。之后所有内容也会显示在这里。",
 "Para não perguntar mais, escolha o app em Ajustes › Agenda e mapas.": "如不想再被询问，请在 设置 › 日历和地图 中选择应用。",
 "Pausa": "休息",
 "Petróleo": "石油蓝",
 "Pink elétrico": "电光粉",
 "Preto total": "纯黑",
 "Progresso": "进度",
 "Pêssego": "蜜桃",
 "Quantos dias antes as contas aparecem fica em Ajustes > Avisos e alarmes.": "账单提前几天显示，可在 设置 > 提醒和闹钟 中设置。",
 "Rosa-chá": "茶玫瑰",
 "Roxo-profundo": "深紫",
 "Segurança e dados": "安全与数据",
 "Segurar e arrastar": "长按并拖动",
 "Segurar e soltar": "长按并松开",
 "Selecionar todas": "全选",
 "Semana começa na {dia}": "每周开始于{dia}",
 "Sessão de estudo": "学习时段",
 "Sessão encerrada": "学习时段已结束",
 "Sessão pausada": "学习时段已暂停",
 "Som e vibração": "声音和振动",
 "Suave": "柔和",
 "Só esta semana": "仅本周",
 "Só hoje": "仅今天",
 "Só neste dia ({data})": "仅此日（{data}）",
 "Tamanho das caixas": "格子大小",
 "Tamanho do texto": "文字大小",
 "Tarefa nova": "新任务",
 "Tela inicial": "主屏幕",
 "Tema e cor de destaque": "主题和强调色",
 "Testar alerta": "测试提醒",
 "Testar alerta, \"Não perturbe\" e as configurações do celular ficam em Ajustes > Avisos e alarmes.": "测试提醒、“勿扰模式”和手机设置位于 设置 > 提醒和闹钟。",
 "Testar e conferir": "测试与检查",
 "Todas as opções do item: editar, mover, compartilhar, arquivar, excluir...": "项目的所有选项：编辑、移动、分享、归档、删除……",
 "Toque numa cor do tema {tema} para usar nos botões, no botão + e no item selecionado.": "点按主题 {tema} 中的一种颜色，用于按钮、+ 按钮和所选项目。",
 "Total: {dur}": "总计：{dur}",
 "Tropical": "热带",
 "Turquesa": "绿松石",
 "Um arquivo com todos os seus dados do My Planner, para guardar ou levar para outro lugar (portabilidade, LGPD).": "包含你在 My Planner 中所有数据的文件，可用于保存或迁移到其他地方（可携带权，LGPD）。",
 "Usar no computador, pelo navegador": "在电脑上通过浏览器使用",
 "Usar o padrão": "使用默认值",
 "Usar o padrão ({emoji})": "使用默认值（{emoji}）",
 "Use o app no celular para baixar o arquivo.": "请在手机上使用应用下载该文件。",
 "Vale para todas as abas. Cada aba pode ter o seu em Ajustes > Abas.": "适用于所有标签页。每个标签页可在 设置 > 标签页 中单独设置。",
 "Valem para as tarefas com pausas. Cada tarefa pode mudar o alarme e o emoji na própria ficha.": "适用于带休息的任务。每个任务都可以在自己的卡片中更改闹钟和表情。",
 "Ver lista": "查看列表",
 "Ver o CPF inteiro": "查看完整 CPF",
 "Verde-floresta": "森林绿",
 "Verde-água": "水绿",
 "Vibração": "振动",
 "Vinho": "酒红",
 "Você pediu para ser avisado agora.": "你要求现在提醒。",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (baixar os seus dados em Ajustes > Meus dados), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "你可以：确认我们是否处理你的数据、访问、更正、要求数据可携带（在 设置 > 我的信息 中下载你的数据）、要求删除、了解我们与谁共享、撤回同意，以及向 ANPD 投诉。",
 "Voltar ao filtro": "返回筛选",
 "Voltar à lista": "返回列表",
 "Vá em Ajustes › My Planner Web e toque em \"Conectar navegador\".": "前往 设置 › My Planner Web 并点击“连接浏览器”。",
 "atividade {n} de {total}": "活动 {n}/{total}",
 "matéria {n} de {t}": "科目 {n}/{t}",
 "padrão": "默认",
 "pausa em {n} min": "{n} 分钟后休息",
 "pausa {n} de {total}": "休息 {n}/{total}",
 "termina em {n} min": "{n} 分钟后结束",
 "todas as vezes": "所有次数",
 "troca em {n} min": "{n} 分钟后切换",
 "volta em {n} min": "{n} 分钟后继续",
 "{nome} · {n} dia(s)": "{nome} · {n} 天",
 "{n} de {total} vezes": "{n}/{total} 次",
 "{n} itens arquivados": "已归档 {n} 个项目",
 "{n} itens excluídos": "已删除 {n} 个项目",
 "{n} marcada(s)": "已勾选 {n} 项",
 "{n} vezes": "{n} 次",
 "{rotulo}: {feito} min / {total}": "{rotulo}：{feito} 分钟 / {total}",
 "📔 Diário": "📔 日志",
 "Agendados": "已安排",
 "Atrasado": "逾期",
 "Atrasado: {v}": "逾期：{v}",
 "Atualizar o a receber": "更新应收款",
 "Até (fim do contrato, se houver)": "至（合同结束日期，如有）",
 "Clínica": "诊所",
 "Conta cada dia com chamada feita ou com plano de aula marcado como \"Aula dada\".": "每天只要点过名或有标记为\"已上课\"的教案，就计为一天。",
 "Data do recebimento": "收款日期",
 "Data prevista do pagamento": "预计付款日期",
 "Desmarcar como recebido": "取消标记为已收款",
 "Dia do pagamento": "付款日",
 "Diferença: {v} (juros/multa)": "差额：{v}（利息/罚金）",
 "Diferença: {v} (taxas/descontos)": "差额：{v}（手续费/折扣）",
 "Escolas, universidades e cursos que pagam você. Com salário fixo, o app gera o a receber de todo mês; por hora-aula, soma as aulas dadas nas turmas ligadas à instituição.": "向你付薪的学校、大学和培训机构。固定工资时，应用每月生成应收款；按课时计时，汇总与该机构关联班级的已上课程。",
 "Escolha o tipo de pagamento (Editar) para o app calcular o que você tem a receber.": "选择付款方式（编辑），以便应用计算你的应收款。",
 "Este valor vem da parte \"Onde trabalho\" da aba {aba}. Marque aqui como recebido ou abra a aba para ver a instituição.": "此金额来自 {aba} 标签页中的\"工作单位\"部分。可在此标记为已收款，或打开该标签页查看机构。",
 "Ex.: Colégio Estadual, Universidade Federal": "例如：州立中学、联邦大学",
 "Ex.: Hospital Santa Casa, Clínica Vida": "例如：圣卡萨医院、生命诊所",
 "Ex.: Salário de outubro, 13º, férias": "例如：10月工资、第13薪、假期工资",
 "Feitos": "已完成",
 "Horas-aula de cada aula": "每节课的课时数",
 "Hospitais e clínicas que pagam você. Com salário fixo, o app gera o a receber de todo mês; por plantão ou atendimento, marque os feitos e o app calcula.": "向你付薪的医院和诊所。固定工资时，应用每月生成应收款；按值班或接诊计时，标记已完成的项目，应用会自动计算。",
 "Hospital": "医院",
 "Instituição": "机构",
 "Instituição (Onde trabalho)": "机构（工作单位）",
 "Ligue as turmas a esta instituição (na turma, Editar › Instituição) para o app somar as aulas dadas.": "将班级关联到此机构（在班级中：编辑 › 机构），以便应用汇总已上课程。",
 "Marque cada plantão ou atendimento como feito: o app soma e calcula o valor do mês.": "将每次值班或接诊标记为已完成：应用会汇总并计算当月金额。",
 "Marque cada plantão ou atendimento feito nesta instituição. O app soma e calcula o valor a receber do mês.": "标记在此机构完成的每次值班或接诊。应用会汇总并计算当月应收金额。",
 "Nome da instituição": "机构名称",
 "O que a instituição tem a pagar a você, mês a mês. Marque como recebido quando o dinheiro entrar: vai junto para a aba Finanças.": "机构每月应付给你的款项。收到钱后标记为已收款：会同步到财务标签页。",
 "Onde trabalho": "工作单位",
 "Plantão": "值班",
 "Plantão ou atendimento": "值班或接诊",
 "Plantões e atendimentos": "值班和接诊",
 "Por atendimento ou procedimento": "按接诊或项目",
 "Por hora-aula": "按课时",
 "Por plantão": "按值班",
 "Previsto: {v}": "预计：{v}",
 "Previsão do mês: {v}": "本月预计：{v}",
 "Quantidade (aulas, plantões ou atendimentos)": "数量（课程、值班或接诊）",
 "Recebe no mês seguinte ao trabalhado": "在工作月份的次月收款",
 "Receber: {t}": "应收：{t}",
 "Recebimentos": "收款记录",
 "Salário": "工资",
 "Salário (valor do mês)": "工资（当月金额）",
 "Salário fixo": "固定工资",
 "Telefone (RH ou financeiro)": "电话（人事或财务）",
 "Tipo de pagamento": "付款方式",
 "Universidade": "大学",
 "Valor da hora-aula": "课时费",
 "Valor de cada um (se for diferente)": "每项金额（如不同）",
 "Valor do plantão": "值班费",
 "Valor por atendimento ou procedimento": "每次接诊或项目金额",
 "Valor previsto": "预计金额",
 "feito": "已完成",
 "recebido em {d}": "于 {d} 收款",
 "{n} aula(s) dada(s)": "已上 {n} 节课",
 "{n} hora(s)-aula": "{n} 课时",
 "{n} plantão(ões)": "{n} 次值班",
 "Abas do My Planner Anne": "My Planner Anne 的标签页",
 "Acesso ao Não perturbe": "\"勿扰\"访问权限",
 "Alarme dos remédios (mesmo no silencioso)": "用药闹钟（静音时也响）",
 "Algodão-doce": "棉花糖",
 "Aplicar tema": "应用主题",
 "As cores próprias de cada tema: floral rosado, folhas verdes, céu azul...": "每个主题的专属颜色：粉色花卉、绿叶、蓝天……",
 "Assim ficam as letras no app.": "应用中的文字将显示为这样。",
 "Automática": "自动",
 "Baht tailandês": "泰铢",
 "Boliviano": "玻利维亚诺",
 "Bolívar venezuelano": "委内瑞拉玻利瓦尔",
 "Botão": "按钮",
 "Buscar moeda": "搜索货币",
 "Cor do desenho": "绘图颜色",
 "Coroa dinamarquesa": "丹麦克朗",
 "Coroa norueguesa": "挪威克朗",
 "Coroa sueca": "瑞典克朗",
 "Coroa tcheca": "捷克克朗",
 "Crepúsculo": "暮光",
 "Crescente": "渐强",
 "Curta": "短",
 "Despesas em outra moeda (fora do lucro): {v}": "其他货币支出（不计入利润）：{v}",
 "Dirham dos Emirados Árabes Unidos": "阿联酋迪拉姆",
 "Dirham marroquino": "摩洛哥迪拉姆",
 "Do seu país": "你所在国家的",
 "Dong vietnamita": "越南盾",
 "Dupla": "双次",
 "Dólar americano": "美元",
 "Dólar australiano": "澳元",
 "Dólar canadense": "加元",
 "Dólar de Hong Kong": "港元",
 "Dólar de Singapura": "新加坡元",
 "Dólar neozelandês": "新西兰元",
 "Envia todos os itens desta lista, inclusive os novos que forem criados depois.": "发送此列表中的所有项目，包括以后新建的项目。",
 "Enviar todos para a equipe": "全部发送给团队",
 "Escolha se o alarme deste remédio deve tocar mesmo com o celular no silencioso.": "选择此药的闹钟是否在手机静音时也响铃。",
 "Euro": "欧元",
 "Exemplo": "示例",
 "Falta uma resposta": "还差一个回答",
 "Folha, tema e cores da caneta e das letras": "纸张、主题以及笔和文字颜色",
 "Franco suíço": "瑞士法郎",
 "Guarani paraguaio": "巴拉圭瓜拉尼",
 "Hryvnia ucraniana": "乌克兰格里夫纳",
 "Iene japonês": "日元",
 "Kwanza angolano": "安哥拉宽扎",
 "Libra egípcia": "埃及镑",
 "Libra esterlina": "英镑",
 "Lira turca": "土耳其里拉",
 "Longa": "长",
 "Mais usadas": "最常用",
 "Metical moçambicano": "莫桑比克梅蒂卡尔",
 "Na página, segurar a bolinha faz o mesmo.": "在页面上长按圆点也有同样效果。",
 "Naira nigeriana": "尼日利亚奈拉",
 "Nenhuma moeda encontrada": "未找到货币",
 "No Android, para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "在 Android 上，若要在开启\"勿扰\"时让用药闹钟响铃，手机需要允许 My Planner 访问\"勿扰\"。点按\"打开设置\"，在列表中找到 My Planner 并开启权限。",
 "No My Planner": "在 My Planner 中",
 "No iPhone, o silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "在 iPhone 上，手机静音可能会阻止闹钟响铃。请将手机保持在正常模式。",
 "No iPhone, o ▶ mostra uma ideia de cada tipo. Os avisos de verdade usam a vibração padrão do iPhone.": "在 iPhone 上，▶ 仅演示每种类型的大致效果。实际提醒使用 iPhone 的标准振动。",
 "Novo dólar taiwanês": "新台币",
 "Novo shekel israelense": "以色列新谢克尔",
 "Ouvir/Sentir": "试听/感受",
 "Peso argentino": "阿根廷比索",
 "Peso chileno": "智利比索",
 "Peso colombiano": "哥伦比亚比索",
 "Peso filipino": "菲律宾比索",
 "Peso mexicano": "墨西哥比索",
 "Peso uruguaio": "乌拉圭比索",
 "Política de privacidade": "隐私政策",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer em silêncio.": "完成。锁定屏幕并等待 1 分钟：提醒应静默出现。",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer vibrando, sem som.": "完成。锁定屏幕并等待 1 分钟：提醒应以振动方式出现，没有声音。",
 "Páginas e canetas": "页面和笔",
 "Pôr do sol": "日落",
 "Rand sul-africano": "南非兰特",
 "Real brasileiro": "巴西雷亚尔",
 "Ringgit malaio": "马来西亚林吉特",
 "Riyal saudita": "沙特里亚尔",
 "Rublo russo": "俄罗斯卢布",
 "Rupia indiana": "印度卢比",
 "Rupia indonésia": "印尼盾",
 "Rupia paquistanesa": "巴基斯坦卢比",
 "Se o My Planner não aparecer na lista, essa permissão chega na próxima versão do app (atualize pela loja).": "如果列表中没有 My Planner，此权限将在应用的下一版本中提供（请在应用商店更新）。",
 "Sentir": "感受",
 "Sol peruano": "秘鲁索尔",
 "São as cores rápidas da caneta e das letras nas páginas. A primeira é a cor padrão ao abrir uma página. Toque numa bolinha para trocar a cor dela.": "这些是页面上笔和文字的快捷颜色。第一个是打开页面时的默认颜色。点按圆点即可更换其颜色。",
 "Taka bengali": "孟加拉塔卡",
 "Teste grátis por {n} dias": "免费试用 {n} 天",
 "Tipo de vibração": "振动类型",
 "Tirar do My Planner": "从 My Planner 移除",
 "Tocar mesmo no silencioso e no Não perturbe": "静音和勿扰模式下也响铃",
 "Tocar só se o celular estiver no normal": "仅在手机处于正常模式时响铃",
 "Todos os itens desta lista aparecem no My Planner, inclusive os novos.": "此列表中的所有项目都会显示在 My Planner 中，包括新项目。",
 "Vaga-lume": "萤火虫",
 "Vale para todos os avisos que vibram (Vibração e Som e vibração).": "适用于所有振动提醒（振动、声音和振动）。",
 "Won sul-coreano": "韩元",
 "Xelim queniano": "肯尼亚先令",
 "Yuan chinês": "人民币",
 "Zloty polonês": "波兰兹罗提",
 "🔕🔇 O alarme deste remédio deve tocar mesmo com o celular no silencioso?": "🔕🔇 此药的闹钟是否应在手机静音时也响铃？",
 "A galeria de fotos chega na próxima versão do app. Por enquanto, use Arquivos ou Tirar foto.": "照片库将在下一版本中推出。目前请使用“文件”或“拍照”。",
 "Abrir o fichário do grupo": "打开小组活页夹",
 "Arrastar a barra": "拖动滑块",
 "Assim que o fichário for compartilhado, ele aparece aqui.": "活页夹一经共享，就会显示在这里。",
 "Buscar ícone pelo nome (ex.: livro, casa, café)": "按名称搜索图标（例如：书、家、咖啡）",
 "Com a aba Estudos você cria seus fichários, usa o cronômetro, acompanha seu relatório e muito mais. ✨": "在“学习”标签页中，你可以创建活页夹、使用计时器、查看学习报告等等。✨",
 "Com a aba {aba} você cria o que é seu e usa todos os recursos. ✨": "在“{aba}”标签页中，你可以创建自己的内容并使用全部功能。✨",
 "Conhecer a aba": "了解此标签页",
 "Crie um fichário em Estudos e volte aqui.": "请先在“学习”中创建一个活页夹，然后再回来。",
 "Em sessão": "学习中",
 "Encerrar e salvar o cronômetro e começar a sessão?": "结束并保存计时器，然后开始学习时段？",
 "Encerrar e salvar o cronômetro e continuar a sessão?": "结束并保存计时器，然后继续学习时段？",
 "Enquadre e toque no botão": "对准画面后点击按钮",
 "Escolha o fichário que os colegas vão ver na tela (só para ler).": "选择同学们将在屏幕上看到的活页夹（仅供阅读）。",
 "Esconder": "隐藏",
 "Este arquivo está guardado só no dispositivo ou no Drive de quem compartilhou, por isso não aparece aqui.": "此文件仅保存在共享者的设备或 Drive 中，因此不会显示在这里。",
 "Fichário do grupo": "小组活页夹",
 "Guia passo a passo do app e de cada aba": "应用及各标签页的分步指南",
 "Há um cronômetro em andamento.": "有一个计时器正在运行。",
 "Há uma sessão em andamento.": "有一个学习时段正在进行。",
 "Inserir imagem": "插入图片",
 "Mais ícones": "更多图标",
 "Nenhum ícone com esse nome. Tente outra palavra ou escolha numa categoria.": "没有找到该名称的图标。请换个词试试，或从分类中选择。",
 "Nenhuma matéria neste fichário ainda.": "此活页夹中还没有科目。",
 "Nenhuma página nesta matéria ainda.": "此科目中还没有页面。",
 "No grupo de estudos, imagens e PDFs abrem aqui na tela. Este tipo de arquivo não tem visualização dentro do app.": "在学习小组中，图片和 PDF 会直接在屏幕上打开。此类文件无法在应用内预览。",
 "Não deu para mostrar agora. Confira a internet e tente de novo.": "暂时无法显示。请检查网络后重试。",
 "O compartilhamento de fichários ainda está sendo preparado. Volte daqui a pouco.": "活页夹共享功能仍在准备中。请稍后再来。",
 "O fichário deste grupo está em outro dispositivo seu. Ele continua compartilhado a partir de lá.": "此小组的活页夹在你的另一台设备上，将继续从那台设备共享。",
 "OK = Conhecer a aba · Cancelar = Agora não": "确定 = 了解此标签页 · 取消 = 以后再说",
 "Os colegas deixam de ver o fichário. Tudo continua com você.": "同学们将无法再看到此活页夹。所有内容仍保留在你这里。",
 "Os colegas veem este fichário na tela, só para ler: não editam, não baixam, não imprimem e não compartilham. As suas metas, o cronômetro e as páginas revisadas continuam só seus.": "同学们可以在屏幕上查看此活页夹，仅供阅读：不能编辑、下载、打印或分享。你的目标、计时器和已复习页面仍然只属于你。",
 "Para ver PDFs aqui na tela, instale a versão mais nova do app pela loja.": "要在屏幕上查看 PDF，请从应用商店安装最新版本的应用。",
 "Parar de compartilhar": "停止共享",
 "Pausar a sessão": "暂停学习时段",
 "Pausar a sessão e estudar só esta?": "暂停学习时段，只学习这一项？",
 "Página em branco.": "空白页。",
 "Quer estudar com tudo isso?": "想用这些功能来学习吗？",
 "Quer usar tudo isso?": "想使用所有这些功能吗？",
 "Selecionar todos": "全选",
 "Trocar fichário": "更换活页夹",
 "Você está participando do grupo de {nome}": "你正在参加 {nome} 的小组",
 "Você vê na tela o que foi compartilhado neste grupo, para ler e acompanhar.": "你可以在屏幕上查看此小组中共享的内容，用于阅读和跟进。",
 "abacate, fruta": "牛油果, 水果",
 "academia, musculação, treino, peso": "健身房, 健身, 训练, 举重",
 "acampamento, camping": "露营, 野营",
 "alfinete, fixar, importante": "图钉, 固定, 重要",
 "almoço, arroz, prato": "午餐, 米饭, 盘子",
 "alvo, meta, objetivo, foco": "靶子, 目标, 目的, 专注",
 "aniversário, bolo": "生日, 蛋糕",
 "anotação, nota, lista, escrever": "笔记, 便签, 清单, 写",
 "arco-íris": "彩虹",
 "avião, viagem, voo": "飞机, 旅行, 航班",
 "balança, direito, justiça, lei, processo": "天平, 法律, 正义, 法规, 诉讼",
 "balde, limpeza": "水桶, 清洁",
 "banana, fruta": "香蕉, 水果",
 "banheira, banho, banheiro": "浴缸, 洗澡, 浴室",
 "barbear, barba, lâmina": "剃须, 胡子, 刀片",
 "bicicleta, pedalar, bike": "自行车, 骑车, 单车",
 "bolo, doce, sobremesa": "蛋糕, 甜点, 甜品",
 "brilho, mágica": "闪光, 魔法",
 "cabelo, cabeleireiro, corte": "头发, 理发师, 剪发",
 "cachorro, cão, pet": "狗, 小狗, 宠物",
 "caderno": "笔记本",
 "caderno, fichário, amarelo": "笔记本, 活页夹, 黄色",
 "café, xícara, pausa": "咖啡, 杯子, 休息",
 "caixa, pacote, mudança, entrega": "箱子, 包裹, 搬家, 快递",
 "calendário, agenda, data": "日历, 日程, 日期",
 "cama, quarto": "床, 卧室",
 "caminhada, caminhar, andar": "散步, 步行, 走路",
 "camisa, gravata, roupa, trabalho": "衬衫, 领带, 衣服, 工作",
 "carne, churrasco": "肉, 烧烤",
 "carrinho, mercado, compras, supermercado": "购物车, 市场, 购物, 超市",
 "carro, dirigir, veículo": "汽车, 开车, 车辆",
 "certo, feito, visto": "对勾, 完成, 勾选",
 "cesto, roupa, lavanderia, lavar roupa": "洗衣篮, 衣服, 洗衣房, 洗衣服",
 "chave de fenda, ferramenta, conserto": "螺丝刀, 工具, 维修",
 "chave, senha": "钥匙, 密码",
 "chocolate, doce": "巧克力, 甜食",
 "chuveiro, banho": "淋浴, 洗澡",
 "chá, xícara": "茶, 杯子",
 "compras, sacolas, shopping": "购物, 购物袋, 商场",
 "computador, monitor, tela": "电脑, 显示器, 屏幕",
 "computador, notebook, informática": "电脑, 笔记本电脑, 信息技术",
 "coração amarelo": "黄色爱心",
 "coração azul": "蓝色爱心",
 "coração branco": "白色爱心",
 "coração laranja": "橙色爱心",
 "coração roxo": "紫色爱心",
 "coração verde": "绿色爱心",
 "coração, amor, saúde, vermelho": "爱心, 爱, 健康, 红色",
 "corrida, correr": "跑步, 奔跑",
 "creme, hidratante, pele, skincare": "面霜, 保湿, 皮肤, 护肤",
 "croissant, pão, café da manhã": "可颂, 面包, 早餐",
 "câmera, foto, fotografia": "相机, 照片, 摄影",
 "cérebro, mente, memória, pensar": "大脑, 心智, 记忆, 思考",
 "dado, jogo de tabuleiro": "骰子, 桌游",
 "dente, dentista": "牙齿, 牙医",
 "despertador, relógio, alarme, acordar": "闹钟, 时钟, 闹铃, 起床",
 "diamante, joia": "钻石, 珠宝",
 "dinheiro, pagar, conta, pagamento": "钱, 付款, 账单, 支付",
 "dormir, sono, descanso": "睡觉, 睡眠, 休息",
 "e-mail, mensagem, carta": "电子邮件, 消息, 信件",
 "escada": "楼梯",
 "escova de dentes, dentes": "牙刷, 牙齿",
 "escrever, redação, caneta": "写作, 作文, 笔",
 "esponja, lavar louça": "海绵, 洗碗",
 "esquadro, régua, geometria, desenho técnico": "三角尺, 尺子, 几何, 工程制图",
 "estrela brilhante, destaque": "闪亮星星, 重点",
 "estrela, favorito": "星星, 收藏",
 "etiqueta, marcador": "标签, 标记",
 "extintor, segurança, incêndio": "灭火器, 安全, 火灾",
 "falar, idioma, inglês, conversa": "说话, 语言, 英语, 对话",
 "feito, concluído, certo": "完成, 已完成, 对勾",
 "ferramenta, conserto, manutenção": "工具, 维修, 保养",
 "festa, comemoração": "派对, 庆祝",
 "filme, cinema, série": "电影, 影院, 剧集",
 "fogo, urgente, sequência": "火, 紧急, 连续",
 "folha, natureza, erva, chá": "叶子, 自然, 草药, 茶",
 "fone de ouvido, áudio, música, podcast": "耳机, 音频, 音乐, 播客",
 "formatura, capelo, faculdade, diploma, universidade": "毕业, 学士帽, 大学, 文凭, 高校",
 "força, braço, músculo": "力量, 手臂, 肌肉",
 "frango, coxa": "鸡肉, 鸡腿",
 "frigideira, cozinhar, ovo, cozinha": "平底锅, 烹饪, 鸡蛋, 厨房",
 "futebol, bola, esporte": "足球, 球, 运动",
 "gato, pet": "猫, 宠物",
 "gelo, geladeira, congelador": "冰, 冰箱, 冷冻室",
 "gráfico, planilha, finanças, relatório": "图表, 电子表格, 财务, 报告",
 "ingresso, show, evento": "门票, 演出, 活动",
 "jogo, videogame, game": "游戏, 电子游戏, 电玩",
 "lancha, barco": "快艇, 船",
 "leite, copo": "牛奶, 杯子",
 "letras, alfabeto, português": "字母, 字母表, 语文",
 "link, corrente": "链接, 链条",
 "livro aberto, leitura, ler": "打开的书, 阅读, 读书",
 "livro azul, caderno": "蓝色书, 笔记本",
 "livro laranja, caderno": "橙色书, 笔记本",
 "livro verde, caderno": "绿色书, 笔记本",
 "livro vermelho, caderno": "红色书, 笔记本",
 "livros, estudo, estudar, biblioteca": "书, 学习, 读书, 图书馆",
 "lixo, lixeira": "垃圾, 垃圾桶",
 "lua, noite": "月亮, 夜晚",
 "lâmpada, ideia, luz": "灯泡, 想法, 灯光",
 "macarrão, massa": "面条, 意大利面",
 "maleta, trabalho, escritório, negócios": "公文包, 工作, 办公室, 商务",
 "massagem, relaxar": "按摩, 放松",
 "maçã, fruta": "苹果, 水果",
 "microfone, cantar, karaokê, palestra": "麦克风, 唱歌, 卡拉OK, 讲座",
 "microscópio, ciência, biologia": "显微镜, 科学, 生物",
 "mochila, escola, filhos": "书包, 学校, 孩子",
 "montanha, trilha": "山, 徒步",
 "mundo, planeta, geografia": "世界, 地球, 地理",
 "médico, consulta, exame, saúde": "医生, 就诊, 检查, 健康",
 "música, nota musical": "音乐, 音符",
 "natação, nadar, piscina": "游泳, 游泳池",
 "olho, visão, oftalmologista": "眼睛, 视力, 眼科医生",
 "oração, orar, gratidão, igreja": "祈祷, 祷告, 感恩, 教堂",
 "ovo": "鸡蛋",
 "pastas, arquivo, fichário, divisórias": "文件夹, 档案, 活页夹, 分隔页",
 "peixe": "鱼",
 "pescaria, pescar": "钓鱼, 垂钓",
 "pessoas, reunião, equipe, grupo": "人们, 会议, 团队, 小组",
 "piano, teclado musical": "钢琴, 键盘乐器",
 "pintura, arte, desenho": "绘画, 艺术, 素描",
 "pipa": "风筝",
 "pipoca, cinema": "爆米花, 电影院",
 "pizza": "披萨",
 "planta, vaso, regar": "植物, 花盆, 浇水",
 "porta, entrada": "门, 入口",
 "praia, férias": "海滩, 假期",
 "prato, refeição, louça, jantar": "盘子, 餐点, 餐具, 晚餐",
 "prédio, história, governo, tribunal": "建筑, 历史, 政府, 法院",
 "pão, padaria": "面包, 面包店",
 "pé, podólogo": "脚, 足科医生",
 "pôr do sol, amanhecer": "日落, 日出",
 "quebra-cabeça, peça": "拼图, 拼块",
 "queijo": "奶酪",
 "raio, energia, rápido": "闪电, 能量, 快速",
 "refrigerante, suco, bebida": "汽水, 果汁, 饮料",
 "remédio, medicamento, vitamina, farmácia": "药, 药品, 维生素, 药房",
 "sabão, sabonete, lavar": "肥皂, 香皂, 清洗",
 "salada, dieta, verdura": "沙拉, 节食, 蔬菜",
 "sanduíche, lanche": "三明治, 零食",
 "sino, aviso, lembrete": "铃铛, 通知, 提醒",
 "skate": "滑板",
 "sofá, sala": "沙发, 客厅",
 "sol, manhã, dia": "太阳, 早晨, 白天",
 "spa, sauna, autocuidado": "水疗, 桑拿, 自我关爱",
 "teatro, máscaras": "戏剧, 面具",
 "telefone, ligação, ligar": "电话, 通话, 打电话",
 "tigela, cereal, sopa, mingau": "碗, 麦片, 汤, 粥",
 "trevo, sorte": "四叶草, 幸运",
 "troféu, conquista, prêmio": "奖杯, 成就, 奖品",
 "tubo de ensaio, química, laboratório": "试管, 化学, 实验室",
 "tênis, esporte": "网球, 运动",
 "unha, manicure": "指甲, 美甲",
 "vassoura, limpeza, faxina, varrer": "扫帚, 清洁, 大扫除, 扫地",
 "violão, guitarra": "吉他, 电吉他",
 "yoga, meditação, alongamento": "瑜伽, 冥想, 拉伸",
 "{n} selecionada": "已选择 {n} 项",
 "{n} selecionadas": "已选择 {n} 项",
 "{n} selecionado": "已选择 {n} 项",
 "{n} selecionados": "已选择 {n} 项",
 "ábaco, matemática, contas, cálculo, contabilidade": "算盘, 数学, 算账, 计算, 会计",
 "água, gota, hidratar": "水, 水滴, 补水",
 "árvore, jardim, quintal": "树, 花园, 院子",
 "ônibus, transporte": "公交车, 交通",
 "1 dia antes": "提前 1 天",
 "1 dia depois": "1 天后",
 "A assinatura é feita no app do celular, pela loja de apps, e vale também aqui no site.": "订阅在手机应用中通过应用商店完成，在本网站上同样有效。",
 "A chave está incompleta (curta demais). Copie de novo pelo botão de copiar da página da chave.": "密钥不完整（太短）。请在密钥页面用复制按钮重新复制。",
 "A chave tem caracteres que não fazem parte de uma chave. Copie de novo, só a chave, sem texto em volta.": "密钥中含有不属于密钥的字符。请重新复制，只复制密钥本身，不要带周围的文字。",
 "A galeria chega na próxima atualização do app.": "图库将在应用的下一次更新中推出。",
 "ALERTAS": "提醒",
 "Abra uma aba paga e comece o teste grátis. Depois volte aqui.": "打开一个付费标签页并开始免费试用，然后回到这里。",
 "Abrir a barra do editor": "打开编辑器工具栏",
 "Agora é horário do Não perturbe do app: o aviso chega em até 5 segundos, sem som nem vibração.": "现在是应用的勿扰时段：提醒将在 5 秒内送达，无声音也无振动。",
 "Aguardando confirmação": "等待确认",
 "Aguardando envio ao My Planner": "等待发送到 My Planner",
 "Alertas de cada fatura": "每张账单的提醒",
 "Alertas do fim da garantia": "保修到期提醒",
 "Alertas do vencimento": "到期提醒",
 "Alertas: {campo}": "提醒：{campo}",
 "Alvorada": "晨曦",
 "Ao abrir esta aba, o app pede o mesmo desbloqueio do app (senha, biometria ou PIN). Dá para mudar em Ajustes > Abas.": "打开此标签页时，应用会要求与应用相同的解锁方式（密码、生物识别或 PIN）。可在 设置 > 标签页 中更改。",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (se o celular perguntar, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "点按附件时，它会在你选择的手机应用中打开（如果手机询问，选择“仅此一次”或“始终”）。你在那里所做的编辑会直接保存在文件中。",
 "App instalado": "已安装的应用",
 "Apple Watch: já grava tudo no app Saúde do celular. Não precisa fazer nada.": "Apple Watch：已经会把所有数据记录到手机的“健康”应用中。无需任何操作。",
 "Arquivados e fixados": "已归档和已置顶",
 "Arquivo para ler e guardar, organizado por aba. Gerado em {data}.": "供阅读和保存的文件，按标签页整理。生成于 {data}。",
 "As notificações do My Planner estão desligadas no celular.": "My Planner 的通知在手机上已关闭。",
 "Atualização automática disponível no app instalado.": "已安装的应用支持自动更新。",
 "Aurora": "极光",
 "Avisos: alarme (som)": "提醒：闹钟（声音）",
 "Baixar o app": "下载应用",
 "Baixar o arquivo técnico": "下载技术文件",
 "Baixar para ler (PDF)": "下载阅读版（PDF）",
 "Barra do editor (caneta, marca-texto, texto)": "编辑器工具栏（钢笔、荧光笔、文字）",
 "Brisa": "微风",
 "Campainha": "门铃",
 "Canal": "渠道",
 "Cole a chave antes de testar.": "测试前请先粘贴密钥。",
 "Começa em": "开始于",
 "Como avisar": "提醒方式",
 "Confira a chave": "检查密钥",
 "Conta de teste de compras": "购买测试账号",
 "Conta vencida": "账单已到期",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-\".": "请立即复制密钥（它只显示一次）。以 \"sk-\" 开头。",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-ant-\".": "请立即复制密钥（它只显示一次）。以 \"sk-ant-\" 开头。",
 "Cristal": "水晶",
 "Daqui a 1 hora": "1 小时后",
 "Daqui a 1 semana": "1 周后",
 "Daqui a 3 dias": "3 天后",
 "Depois de 5 min fora": "离开 5 分钟后",
 "Depois de 5 minutos fora": "离开 5 分钟后",
 "Desligar a senha desta aba": "关闭此标签页的密码",
 "Detalhes técnicos": "技术详情",
 "Dia {n} de {t}": "第 {n} 天，共 {t} 天",
 "Dica: a chave é como uma senha. Não mande por mensagem nem publique. Se vazar, apague-a no site e crie outra.": "提示：密钥就像密码。不要通过消息发送，也不要公开。如果泄露，请在网站上删除它并创建新的。",
 "Documento vencido": "证件已过期",
 "Ela abre em {d}.": "它将于 {d} 开启。",
 "Ela abre em {d}. Você vai receber avisos: {quando}.": "它将于 {d} 开启。你将收到提醒：{quando}。",
 "Ela abre em {d}. Você vai receber um aviso: {quando}.": "它将于 {d} 开启。你将收到一条提醒：{quando}。",
 "Em \"API keys\", toque em \"Create key\" (Criar chave) e dê um nome, por exemplo \"My Planner\".": "在 \"API keys\" 中，点按 \"Create key\"（创建密钥）并起个名字，例如 \"My Planner\"。",
 "Em \"Billing\" (Cobrança), adicione um cartão e alguns dólares de crédito. A assinatura ChatGPT Plus não vale aqui.": "在 \"Billing\"（账单）中，添加一张卡并充值几美元额度。ChatGPT Plus 订阅在这里无效。",
 "Em \"Billing\" (Cobrança), compre créditos. A assinatura Claude Pro não vale aqui.": "在 \"Billing\"（账单）中购买额度。Claude Pro 订阅在这里无效。",
 "Em breve": "即将推出",
 "Entre com a mesma conta do ChatGPT ou crie uma.": "使用与 ChatGPT 相同的账号登录，或创建一个新账号。",
 "Entre com a sua conta Google (a mesma do Gmail serve).": "使用你的 Google 账号登录（Gmail 账号即可）。",
 "Entre ou crie uma conta (pode ser o mesmo e-mail do Claude).": "登录或创建账号（可以使用与 Claude 相同的邮箱）。",
 "Enviados para o My Planner": "已发送到 My Planner",
 "Enviar agora": "立即发送",
 "Escolha hoje ou uma data futura.": "请选择今天或将来的日期。",
 "Escolhas lembradas": "已记住的选择",
 "Escolher a data": "选择日期",
 "Escolher células": "选择单元格",
 "Escolher quando": "选择时间",
 "Espessura": "粗细",
 "Esquecer": "忘记",
 "Esta chave é de outro serviço ({servico}). Aqui funcionam só chaves do Claude, do ChatGPT ou do Gemini.": "此密钥属于其他服务（{servico}）。这里只能使用 Claude、ChatGPT 或 Gemini 的密钥。",
 "Esta chave é do {ia}, não do {escolhida}.": "此密钥属于 {ia}，而不是 {escolhida}。",
 "Esta conta vê o app como uma conta nova, sem nenhuma aba liberada, para conferir os cadeados, o teste grátis e a compra. As outras contas não mudam.": "此账号会把应用视为新账号，没有任何已解锁的标签页，用于检查锁定、免费试用和购买流程。其他账号不受影响。",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou atualize o My Planner pela loja.": "此工具需要查看 PDF 的页面，这项功能将随新版应用（0.50 版）推出。请使用浏览器，或通过应用商店更新 My Planner。",
 "Esta não parece uma chave do {ia}. As chaves do {ia} começam com {ini}.": "这看起来不像 {ia} 的密钥。{ia} 的密钥以 {ini} 开头。",
 "Este aviso está em \"Desligado\": nada vai tocar.": "此提醒设置为 \"关闭\"：不会响铃。",
 "Este celular ainda não recebe avisos com o app fechado. Atualize o My Planner pela loja (versão {v} ou mais nova). Com o app aberto, os avisos já funcionam.": "这部手机在应用关闭时还无法接收提醒。请通过应用商店更新 My Planner（{v} 版或更新版本）。应用打开时，提醒已经可以正常使用。",
 "Este tipo de aviso está desligado nas configurações de notificação do celular.": "此类提醒已在手机的通知设置中关闭。",
 "Estudado": "已学习",
 "Estudado: {dur}": "已学习：{dur}",
 "Faltou: {dur}": "还差：{dur}",
 "Fazer os testes terminarem agora": "立即结束试用",
 "Fechar a barra do editor": "关闭编辑器工具栏",
 "Fichário": "活页夹",
 "Figurinhas e emojis": "贴纸和表情",
 "Garantia terminou": "保修已结束",
 "Gerando…": "正在生成…",
 "Guarda documentos, exames e histórico de saúde com uma senha só dele. Nem o suporte consegue ler. Se você esquecer a senha, não há como recuperar.": "用专属密码保存证件、检查报告和健康记录。连客服也无法读取。如果忘记密码，将无法找回。",
 "Harpa": "竖琴",
 "Horas por dia": "每天小时数",
 "Identificação": "身份信息",
 "Isso parece um link ou um e-mail, não uma chave. Copie a chave inteira na página de chaves de API.": "这看起来像链接或邮箱，而不是密钥。请在 API 密钥页面复制完整的密钥。",
 "Isto só aparece no My Planner se você enviar. Quer enviar agora?": "只有发送后，这条内容才会出现在 My Planner 中。现在发送吗？",
 "Já dá para confirmar {titulo}?": "现在可以确认 {titulo} 了吗？",
 "Lembrar minha escolha nesta aba": "在此标签页记住我的选择",
 "Lembrete para confirmar: {data}": "确认提醒：{data}",
 "Marimba": "马林巴",
 "Marque pelo menos um dia da semana no plano.": "请在计划中至少勾选一周中的一天。",
 "Me lembre de confirmar": "提醒我确认",
 "Me lembre depois": "稍后提醒我",
 "Menos": "收起",
 "Meta somada": "目标合计",
 "Meta somada: {dur}": "目标合计：{dur}",
 "Meus dados - My Planner {data}": "我的数据 - My Planner {data}",
 "Meus dados do My Planner": "我的 My Planner 数据",
 "Mostrar a barra": "显示工具栏",
 "Mudar senha do diário": "更改日记密码",
 "Na primeira vez, aceite os termos de uso.": "首次使用时，请接受使用条款。",
 "Na versão das lojas, a compra será pela loja de apps do celular. Por enquanto a chave simula a assinatura para testes.": "在应用商店版本中，将通过手机的应用商店购买。目前该密钥仅用于模拟订阅以便测试。",
 "Nada de outras abas vai sozinho para o My Planner. Estes itens têm data e ainda não foram enviados.": "其他标签页的内容不会自动进入 My Planner。这些项目有日期，但尚未发送。",
 "Nenhum estudo registrado neste mês.": "本月没有学习记录。",
 "Nenhum item aguardando envio.": "没有等待发送的项目。",
 "Nenhum teste começado": "尚未开始任何试用",
 "Nesta tela não há nada para adicionar.": "此页面没有可添加的内容。",
 "No dia": "当天",
 "Nova nota rápida": "新建速记",
 "Nova página do dia": "新建当日页面",
 "Não deu certo": "没有成功",
 "Não entram: o conteúdo do Diário e os campos do cofre (ficam protegidos pela senha), fotos e arquivos anexados. Para restaurar os dados no app, use o arquivo técnico.": "不包括：日记的内容和保险库的字段（受其密码保护）、照片和附件。若要在应用中恢复数据，请使用技术文件。",
 "Não foi possível gerar o PDF.": "无法生成 PDF。",
 "Não foi possível testar agora. Tente de novo em alguns segundos.": "现在无法测试。请几秒后再试。",
 "Não lembrar": "不记住",
 "Não, obrigada": "不用了，谢谢",
 "O Diário é protegido pela senha dele e não entra neste arquivo.": "日记受其自身密码保护，不包含在此文件中。",
 "O app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "应用会打开 \"存储到文件\" ，供你选择文件夹（可以是 iCloud Drive）。",
 "O app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "应用只保存所选文件的快捷方式：文件仍留在原处（Drive、OneDrive、下载），并在手机应用中打开。不会复制任何内容。此选项适用于用相机拍摄的照片。",
 "O app instalado neste dispositivo é a versão {v}. Para fazer chamadas de áudio e vídeo, atualize o My Planner pela loja (versão 0.35 ou mais nova). As mensagens já funcionam.": "此设备上安装的应用版本为 {v}。若要进行语音和视频通话，请通过应用商店更新 My Planner（0.35 版或更新版本）。消息功能已经可以使用。",
 "O aviso vai chegar em silêncio, direto na lista de notificações: ligue os alertas do My Planner nas configurações do celular.": "提醒将静默送达，直接进入通知列表：请在手机设置中开启 My Planner 的提醒。",
 "O aviso vai chegar sem som: o som deste tipo de aviso foi desligado nas configurações do celular.": "提醒将无声送达：此类提醒的声音已在手机设置中关闭。",
 "O aviso vai chegar, mas o som das notificações do My Planner está desligado no celular.": "提醒会送达，但 My Planner 通知的声音在手机上已关闭。",
 "O convite leva o link para baixar o app. Quem entra pelo link cai direto no escritório.": "邀请中包含下载应用的链接。通过链接加入的人会直接进入办公室。",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja para usar o microfone.": "听写功能将随新版应用推出。请通过应用商店更新 My Planner 以使用麦克风。",
 "O mesmo desbloqueio do app: senha, biometria ou PIN. Pede uma vez ao entrar; dentro da aba não pede de novo. Abrir a galeria, a câmera ou os arquivos não conta como sair. Itens grandes continuam pedindo a senha para excluir.": "与应用相同的解锁方式：密码、生物识别或 PIN。进入时询问一次；在标签页内不会再次询问。打开图库、相机或文件不算离开。删除大型项目时仍会要求输入密码。",
 "O modo silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "手机的静音模式可能会阻止闹钟响起。请让手机保持正常模式。",
 "O plano fica só em Estudos (não vai para o My Planner).": "该计划只保留在“学习”中（不会进入 My Planner）。",
 "Opcional: prazo, horas por dia e dias da semana.": "可选：截止日期、每天小时数和每周哪几天。",
 "Os avisos do celular funcionam no app instalado.": "手机提醒在已安装的应用中可用。",
 "Os avisos no celular funcionam no app instalado.": "手机上的提醒在已安装的应用中可用。",
 "Os testes começados terminaram. Abra a aba para ver \"O teste grátis terminou\".": "已开始的试用已结束。打开标签页即可看到 \"免费试用已结束\"。",
 "Outros dados": "其他数据",
 "Ouvir": "收听",
 "Pacote em uso": "当前套餐",
 "Para assinar, atualize o My Planner pela loja de apps do celular.": "若要订阅，请通过手机的应用商店更新 My Planner。",
 "Para ler (PDF): organizado por aba, com títulos e datas. Abre em qualquer dispositivo ou computador.": "阅读版（PDF）：按标签页整理，带标题和日期。可在任何设备或电脑上打开。",
 "Para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "若要在开启 \"勿扰模式\" 时让服药闹钟响起，手机需要允许 My Planner 访问 \"勿扰模式\"。点按 \"打开设置\"，在列表中找到 My Planner 并开启权限。",
 "Passo a passo para criar a chave": "创建密钥的分步说明",
 "Pedir de novo": "再次请求",
 "Pedir senha ao abrir esta aba": "打开此标签页时要求密码",
 "Plano com período": "有期限的计划",
 "Plano começa em {d}": "计划开始于 {d}",
 "Por matéria": "按科目",
 "Prolongar": "延长",
 "Pronto: o aviso chega em até 5 segundos, com som. Se não tocar, confira se o celular está no silencioso.": "完成：提醒将在 5 秒内送达，带声音。如果没有响，请检查手机是否处于静音状态。",
 "Pronto: o aviso chega em até 5 segundos, só vibrando.": "完成：提醒将在 5 秒内送达，仅振动。",
 "Publicado em": "发布于",
 "Pulso": "脉冲",
 "Quando o app bloquear": "应用锁定时",
 "Quer proteger esta aba com senha?": "要用密码保护此标签页吗？",
 "Recolher ou arrastar a barra": "收起或拖动工具栏",
 "Recomeçar os testes grátis": "重新开始免费试用",
 "Recomeçar os testes grátis?": "重新开始免费试用吗？",
 "Rolar a folha para os lados": "左右滚动页面",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect ou do app Saúde do celular. O app só lê e nunca altera esses dados.": "如果你连接手表：每天的步数、距离、卡路里、运动、心率和睡眠总计，读取自 Health Connect 或手机的“健康”应用。应用只读取这些数据，绝不会修改。",
 "Sem internet ou a conexão caiu. Confira o Wi-Fi ou os dados móveis e tente de novo.": "没有网络或连接已中断。请检查 Wi-Fi 或移动数据后重试。",
 "Senha desta aba": "此标签页的密码",
 "Seu plano terminou": "你的计划已结束",
 "Sino": "铃铛",
 "Som do alarme": "闹钟声音",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia.": "包含法定保修和厂商保修。请查看保修条款。",
 "São dois arquivos com os seus dados do My Planner (portabilidade, LGPD):": "这是两个包含你 My Planner 数据的文件（数据可携带权，LGPD）：",
 "Só quando o app bloquear": "仅在应用锁定时",
 "Tamanho da borracha": "橡皮擦大小",
 "Tamanho da letra": "字体大小",
 "Tempo": "时间",
 "Termina em": "结束于",
 "Testar": "测试",
 "Texto de exemplo": "示例文字",
 "Toca nos avisos em \"Alarme (som)\". \"Som e vibração\" usa o som de notificação do celular.": "用于 \"闹钟（声音）\" 提醒。\"声音和振动\" 使用手机的通知声音。",
 "Toda vez que sair": "每次离开时",
 "Toda vez que sair da aba": "每次离开标签页时",
 "Todas as abas voltam a \"{n} dias grátis para testar\", como numa conta nova. As assinaturas simuladas são desligadas.": "所有标签页都将恢复为 \"免费试用 {n} 天\"，就像新账号一样。模拟订阅将被关闭。",
 "Todos os fichários": "所有活页夹",
 "Toque em \"Create API key\" (Criar chave de API). Se pedir um projeto, escolha o que aparecer ou crie um novo.": "点按 \"Create API key\"（创建 API 密钥）。如果要求选择项目，请选择显示的项目或新建一个。",
 "Toque em \"Criar minha chave de API\" acima. Abre a plataforma da OpenAI (não é o site do ChatGPT).": "点按上方的 \"创建我的 API 密钥\"。将打开 OpenAI 平台（不是 ChatGPT 网站）。",
 "Toque em \"Criar minha chave de API\" acima. Abre o Console da Anthropic (não é o site do Claude).": "点按上方的 \"创建我的 API 密钥\"。将打开 Anthropic 控制台（不是 Claude 网站）。",
 "Toque em \"Criar minha chave de API\" acima. Abre o Google AI Studio.": "点按上方的 \"创建我的 API 密钥\"。将打开 Google AI Studio。",
 "Toque em Conectar e, na tela do app Saúde, ligue os itens que o My Planner pode ler.": "点按 连接，然后在“健康”应用的界面中开启 My Planner 可以读取的项目。",
 "Toque no ícone de copiar ao lado da chave. Ela começa com \"AIza\" ou \"AQ.\".": "点按密钥旁边的复制图标。密钥以 \"AIza\" 或 \"AQ.\" 开头。",
 "Toque numa célula da tabela (ou em \"Escolher células\") para mudar o tamanho da letra dela.": "点按表格中的单元格（或点按 \"选择单元格\"）即可更改其字体大小。",
 "Transparência": "透明度",
 "Técnico (para restaurar): cópia completa que só o My Planner lê. Para usar, vá em Ajustes › Nuvem e cópias de segurança › Importar arquivo.": "技术版（用于恢复）：只有 My Planner 能读取的完整副本。使用方法：前往 设置 › 云端与备份 › 导入文件。",
 "Uma carta da {nome} abre em {n} dias 💌": "来自 {nome} 的一封信将在 {n} 天后开启 💌",
 "Usa a senha do app": "使用应用密码",
 "Usar no {ia}": "在 {ia} 中使用",
 "Use o app no celular para baixar o arquivo técnico.": "请在手机上使用应用下载技术文件。",
 "Valor final definido pela loja de apps, já na moeda do seu país.": "最终价格由应用商店决定，并以你所在国家的货币显示。",
 "Você ainda não enviou {titulo} para o My Planner.": "你还没有把 {titulo} 发送到 My Planner。",
 "Volte aqui, cole no campo abaixo e toque em \"Salvar e testar\".": "回到这里，粘贴到下方的输入框中，然后点按 \"保存并测试\"。",
 "Volte em \"API keys\" e toque em \"Create new secret key\" (Criar chave).": "回到 \"API keys\"，点按 \"Create new secret key\"（创建密钥）。",
 "atualização automática": "自动更新",
 "erro desconhecido": "未知错误",
 "estudados no mês": "本月已学习",
 "faltou {dur}": "还差 {dur}",
 "hoje {feito} de {meta}": "今天 {feito} / {meta}",
 "hoje é folga": "今天休息",
 "login do Google (não é chave de API)": "Google 登录（不是 API 密钥）",
 "meta cumprida": "目标已完成",
 "o que veio com a instalação": "安装时自带的",
 "outro": "其他",
 "provisório": "临时",
 "superou {dur}": "超出 {dur}",
 "token de login (não é chave de API)": "登录令牌（不是 API 密钥）",
 "{ia} demorou demais para responder. Tente de novo em instantes.": "{ia} 响应时间过长。请稍后再试。",
 "{ia} está fora do ar ou sobrecarregado agora. Não é problema da sua chave: tente de novo mais tarde.": "{ia} 目前无法访问或负载过高。这不是你的密钥的问题：请稍后再试。",
 "{ia} respondeu ao teste com o modelo {modelo}. Já pode usar nas abas.": "{ia} 已使用模型 {modelo} 响应测试。现在可以在各标签页中使用了。",
 "{ia} se recusou a ler este conteúdo (filtro de segurança da empresa).": "{ia} 拒绝读取此内容（该公司的安全过滤）。",
 "{ia}: a chave existe, mas não tem permissão para usar a IA. Crie uma chave nova na página indicada no passo a passo.": "{ia}：密钥存在，但没有使用 AI 的权限。请在分步说明中指示的页面创建新密钥。",
 "{ia}: chave inválida. Confira se copiou a chave inteira ou crie uma nova.": "{ia}：密钥无效。请检查是否复制了完整的密钥，或创建一个新的。",
 "{ia}: esta chave foi bloqueada pela empresa porque apareceu publicada na internet. Apague-a e crie outra.": "{ia}：此密钥因被公开发布到网上而被该公司封禁。请删除它并创建新的。",
 "{ia}: limite de uso atingido. Espere alguns minutos (ou até amanhã, no plano gratuito) e tente de novo.": "{ia}：已达到使用上限。请等待几分钟（免费套餐可能要等到明天）后再试。",
 "{ia}: o modelo escolhido não está disponível para a sua conta. Escolha outro em \"Modelo\".": "{ia}：所选模型对你的账号不可用。请在 \"模型\" 中选择其他模型。",
 "{ia}: o serviço não está disponível na sua região ou para este tipo de conta.": "{ia}：该服务在你所在的地区或此类账号中不可用。",
 "{ia}: sua conta de API está sem saldo ou sem forma de pagamento. Adicione créditos no site da empresa.": "{ia}：你的 API 账号余额不足或没有付款方式。请在该公司网站上充值。",
 "{item}: a garantia termina hoje ({data}).": "{item}：保修今天到期（{data}）。",
 "{item}: a garantia terminou em {data}.": "{item}：保修已于 {data} 结束。",
 "{item}: venceu em {data}.": "{item}：已于 {data} 到期。",
 "{mes} de {ano}": "{ano}年{mes}",
 "{nome} protegida com senha": "{nome} 已用密码保护",
 "{nome}: encerrar o plano ou prolongar com uma nova data final? Nada é apagado.": "{nome}：结束计划，还是设置新的结束日期来延长？不会删除任何内容。",
 "{n} dias antes": "提前 {n} 天",
 "{n} dias de estudo no plano · {dur} por dia": "计划中有 {n} 个学习日 · 每天 {dur}",
 "{n} dias de plano": "计划共 {n} 天",
 "{n} dias depois": "{n} 天后",
 "{n} item(ns) aguardando envio ao My Planner": "{n} 个项目等待发送到 My Planner",
 "{n} itens aguardando envio": "{n} 个项目等待发送",
 "{quando} às {hora}": "{quando} {hora}",
 "ÚLTIMOS 6 MESES": "最近 6 个月",
 "Abra o My Planner Anne e entre com o seu CPF ou e-mail e a sua senha.": "打开 My Planner Anne，使用你的 CPF 或邮箱和密码登录。",
 "Anexo": "附件",
 "Assédio ou ameaça": "骚扰或威胁",
 "Bloquear {nome}": "屏蔽 {nome}",
 "Conte mais (opcional)": "详细说明（可选）",
 "Conteúdo impróprio": "不当内容",
 "Conteúdo ofensivo e usuários abusivos não são tolerados. As denúncias são analisadas pela nossa equipe em até 24 horas.": "我们不容忍冒犯性内容和滥用行为的用户。我们的团队会在 24 小时内审核举报。",
 "Denunciar": "举报",
 "Denunciar contato": "举报联系人",
 "Denunciar grupo": "举报群组",
 "Denunciar mensagem": "举报消息",
 "Denúncia enviada": "举报已提交",
 "Denúncias que você faz nas Mensagens: o motivo, quem foi denunciado e o trecho da mensagem denunciada. Só a equipe do My Planner lê, para analisar o caso.": "你在消息中提交的举报：原因、被举报人以及被举报消息的片段。只有 My Planner 团队会阅读，用于审核该情况。",
 "Enviar denúncia": "提交举报",
 "Mande um e-mail pedindo a exclusão, com o CPF ou o e-mail da conta. Respondemos em até 15 dias.": "发送邮件申请删除，并附上账户的 CPF 或邮箱。我们会在 15 天内回复。",
 "Não toleramos conteúdo ofensivo, ilegal ou impróprio nem usuários abusivos nas Mensagens e nos grupos. Qualquer pessoa pode denunciar uma mensagem, um contato ou um grupo (segure a mensagem ou toque em ⋮ > Denunciar) e bloquear quem quiser. As denúncias são analisadas pela nossa equipe em até 24 horas: o conteúdo pode ser removido e quem o enviou pode ter a conta suspensa ou encerrada.": "我们不容忍消息和群组中出现冒犯性、违法或不当内容，也不容忍滥用行为的用户。任何人都可以举报消息、联系人或群组（长按消息或点按 ⋮ > 举报），并屏蔽任何人。我们的团队会在 24 小时内审核举报：相关内容可能被删除，发送者的账户可能被暂停或注销。",
 "Obrigado. Nossa equipe vai analisar em até 24 horas.": "谢谢。我们的团队将在 24 小时内审核。",
 "Para contas que entram com CPF, a senha nova é criada pelo nosso suporte, depois de confirmar que a conta é sua. Escreva para {email} informando o seu CPF ou o e-mail cadastrado.": "对于使用 CPF 登录的账户，新密码由我们的客服在确认账户属于你之后创建。请发送邮件至 {email}，并提供你的 CPF 或注册邮箱。",
 "Por que você está denunciando? A pessoa denunciada não fica sabendo quem denunciou.": "你为什么要举报？被举报人不会知道是谁举报的。",
 "Spam": "垃圾信息",
 "{nome} não pode mais conversar com você.": "{nome} 无法再与你聊天。",
 "{nome}\nVale até {d}. Ele fica criptografado no seu cofre, só neste dispositivo e na sua cópia da nuvem.": "{nome}\n有效期至 {d}。证书加密保存在你的保险库中，仅存于此设备和你的云端副本。",
 "1. No computador, abra {url} e escolha Entrar com QR Code.": "1. 在电脑上打开 {url}，选择\"用二维码登录\"。",
 "2. Aqui, toque em Conectar navegador e aponte a câmera para o QR Code do computador.": "2. 在这里点\"连接浏览器\"，用相机对准电脑上的二维码。",
 "Abandonados": "已放弃",
 "Bloquear o computador": "锁定电脑",
 "Cheguei na página...": "我读到第…页",
 "Computador conectado": "已连接的电脑",
 "Computador desconectado": "电脑已断开",
 "Conectado em {d}": "连接于 {d}",
 "Crie o grupo e mande o link: quem entrar vê o material do livro e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "创建小组并发送链接：加入的人可以看到这本书的资料并跟进阅读。管理员可以添加、编辑和上传照片，也可以把这些权限开放给同样使用该标签的人。只有管理员能添加或移除成员。",
 "Depois de {n} minutos parado": "闲置 {n} 分钟后",
 "Desconectar o computador?": "断开这台电脑？",
 "Difícil demais": "太难了",
 "Editar livro": "编辑书籍",
 "Entrar com o QR Code": "用二维码登录",
 "Escreva (ex.: filosofia)": "请输入（例如：哲学）",
 "Este computador": "这台电脑",
 "Este computador foi desconectado (pelo celular ou porque outro computador entrou). Para usar de novo, entre com o QR Code.": "这台电脑已被断开（通过手机，或因为另一台电脑登录）。要再次使用，请用二维码登录。",
 "Já existe um computador conectado": "已有一台电脑连接",
 "Já existe um computador conectado. Trocar para este? O outro será desconectado.": "已有一台电脑连接。要换成这台吗？另一台将被断开。",
 "Navegador": "浏览器",
 "Nenhum computador conectado": "没有连接的电脑",
 "Novo livro": "新书",
 "Não gostei": "不喜欢",
 "Não, abandonei": "不，放弃了",
 "O My Planner fecha no computador. Para usar de novo, é só conectar pelo QR Code.": "My Planner 将在电脑上关闭。要再次使用，用二维码连接即可。",
 "O QR Code muda a cada 3 minutos e só vale uma vez. Em computador compartilhado, use Ajustes › Sair deste computador ao terminar.": "二维码每 3 分钟更换一次，只能用一次。在共用电脑上，用完后请点 设置 › 退出这台电脑。",
 "Os seus dados continuam salvos na nuvem e no celular. Para entrar de novo, use o QR Code.": "你的数据仍保存在云端和手机上。再次登录请使用二维码。",
 "Parei em": "停止于",
 "Perdi o interesse": "失去兴趣",
 "Por que parei": "为什么停下",
 "Páginas e meta": "页数和目标",
 "Quero voltar a ler?": "还想再读吗？",
 "Sair deste computador": "退出这台电脑",
 "Sair deste computador?": "退出这台电脑？",
 "Se quiser, escreva com as suas palavras": "愿意的话，用你自己的话写下来",
 "Sem mexer no mouse ou no teclado por esse tempo, o My Planner bloqueia. Para voltar, digite a senha da conta (ou entre com o QR Code de novo).": "在这段时间内不动鼠标或键盘，My Planner 会锁定。要回来，请输入账户密码（或重新用二维码登录）。",
 "Sem tempo": "没时间",
 "Sim, depois": "是的，以后",
 "Só um computador pode ficar conectado por vez.": "同一时间只能连接一台电脑。",
 "A foto ou o PDF do certificado vai em \"Fotos, arquivos e links\": marque como Certificado.": "证书的照片或 PDF 放在\"照片、文件和链接\"里，并标记为证书。",
 "ABNT copiada": "已复制 ABNT",
 "APA copiada": "已复制 APA",
 "Ano inválido": "年份无效",
 "Ano ou data de publicação": "出版年份或日期",
 "Assisti em": "观看于",
 "Buscando os dados...": "正在查找数据…",
 "Calculado pelos módulos": "按模块计算",
 "Carga horária (horas)": "学时（小时）",
 "Certificado": "证书",
 "Certificado emitido em": "证书签发日期",
 "Cheguei na aula": "我学到第几课",
 "Cheguei na aula...": "我学到第…课",
 "Cheguei na temporada": "我看到第几季",
 "Cheguei no episódio": "我看到第几集",
 "Citação copiada": "已复制引用",
 "Colocar em pasta": "放入文件夹",
 "Coloque livros, filmes ou cursos nesta pasta para montar a lista.": "把书、影视或课程放进这个文件夹来生成列表。",
 "Comentário": "评论",
 "Copiar ABNT": "复制 ABNT",
 "Copiar APA": "复制 APA",
 "Copiar citação (ABNT)": "复制引用（ABNT）",
 "Copiar citação (APA)": "复制引用（APA）",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para Arquivar ou Duplicar.": "为这门课创建带清单、列表、自由文本或手绘的卡片。向右滑动删除，向左滑动归档或复制。",
 "Crie o grupo e mande o link: quem entrar vê a lista e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "创建小组并发送链接：加入的人可以看到列表并跟进。管理员可以添加、编辑和上传照片，也可以开放给同样使用该标签的人。只有管理员能添加或移除成员。",
 "Crie o grupo e mande o link: quem entrar vê o material do curso e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "创建小组并发送链接：加入的人可以看到课程资料并跟进。管理员可以添加、编辑和上传照片，也可以开放给同样使用该标签的人。只有管理员能添加或移除成员。",
 "Crie uma pasta primeiro, na parte 📁 Pastas desta aba.": "请先在本标签的 📁 文件夹 部分创建文件夹。",
 "DOI (artigos)": "DOI（文章）",
 "Data de acesso": "访问日期",
 "Deixar avulsas": "保留为单独课时",
 "Descrição (objetivo)": "描述（目标）",
 "Digite o ano com 4 números (ex.: {a}).": "请用 4 位数字输入年份（例如 {a}）。",
 "Direção": "导演",
 "Editar pasta": "编辑文件夹",
 "Editora": "出版社",
 "Edição": "版次",
 "Em 1 mês": "1 个月后",
 "Em {n} meses": "{n} 个月后",
 "Episódios por temporada (opcional)": "每季集数（可选）",
 "Escreva o trecho na anotação para copiar a citação.": "先在笔记里写下段落，才能复制引用。",
 "Este item já está em todas as pastas.": "此项目已在所有文件夹中。",
 "Ex.: 10.1590/...": "例如 10.1590/...",
 "Ex.: TCC — Ética e Direito": "例如：毕业论文——伦理与法律",
 "Ex.: {a}": "例如 {a}",
 "Fazendo": "进行中",
 "Grupo de filmes e séries": "影视小组",
 "Grupo de leitura": "读书小组",
 "Grupo do curso": "课程小组",
 "ISBN": "ISBN",
 "Ideia minha": "我的想法",
 "Instrutor": "讲师",
 "Itens da pasta": "文件夹内容",
 "Junte livros, filmes e cursos numa pasta (ex.: \"TCC\", \"Só romances\"). O mesmo item pode estar em várias pastas.": "把书、影视和课程放进文件夹（例如\"毕业论文\"、\"只看小说\"）。同一项目可以在多个文件夹里。",
 "Link (material online)": "链接（在线资料）",
 "Lista copiada": "已复制列表",
 "Lista de referências": "参考文献列表",
 "Mais de um autor: separe com ponto e vírgula (;).": "多位作者：用分号（;）分隔。",
 "Módulo": "模块",
 "Nada novo": "没有新内容",
 "No ⋮ de um livro, filme ou curso, toque em \"Colocar em pasta\".": "在书、影视或课程的 ⋮ 中点\"放入文件夹\"。",
 "Nome da pasta": "文件夹名称",
 "Não achei dados novos para completar a ficha.": "没有找到可补充的新数据。",
 "Não foi possível preencher": "无法填写",
 "O módulo não tem cards de anotações.": "这个模块没有笔记卡片。",
 "Organizador": "编者",
 "Os dados vêm da ficha do livro (Editar › Referência).": "数据来自书籍资料（编辑 › 参考文献）。",
 "Os livros, filmes e cursos da pasta NÃO são apagados: continuam na aba.": "文件夹里的书、影视和课程不会被删除，仍保留在标签中。",
 "Os {n} card(s) de anotações deste módulo também vão para a lixeira.": "这个模块的 {n} 张笔记卡片也会进入回收站。",
 "Pasta vazia": "空文件夹",
 "Preencha o título (e o que mais tiver) na ficha.": "请在资料中填写标题（以及其他已有信息）。",
 "Preencher pelo DOI": "通过 DOI 填写",
 "Preencher pelo link": "通过链接填写",
 "Produtora ou país": "制作公司或国家",
 "Quero fazer": "想学",
 "Quero voltar?": "还想继续吗？",
 "Referência vazia": "参考文献为空",
 "Referências": "参考文献",
 "Se deixar avulsas, elas continuam somando no total do curso.": "保留为单独课时的话，仍计入课程总数。",
 "Subtítulo": "副标题",
 "Tirar da pasta": "从文件夹移出",
 "Total de episódios (opcional)": "总集数（可选）",
 "Total de temporadas (opcional)": "总季数（可选）",
 "Tradutor": "译者",
 "Trecho (citação)": "摘录（引用）",
 "Trecho vazio": "摘录为空",
 "Você já assistiu {n} aula(s). Colocar em qual módulo?": "你已经看了 {n} 节课。放进哪个模块？",
 "Volume": "卷",
 "{n} item(ns)": "{n} 项",
 "{n} referência(s) em ordem alfabética.": "{n} 条参考文献，按字母顺序。",
 "Ícone": "图标",
 "ASSISTIDOS POR DIA": "每日观看",
 "ASSISTIDOS POR MÊS": "每月观看",
 "AULAS POR DIA": "每日课时",
 "AULAS POR MÊS": "每月课时",
 "Apagar a meta": "删除目标",
 "Assisti {a} · Estou assistindo {b} · Parei {c} · Quero assistir {d}": "看完 {a} · 在看 {b} · 停下 {c} · 想看 {d}",
 "Aulas": "课时",
 "CURSOS": "课程",
 "Concluí {a} · Fazendo {b} · Parei {c}": "完成 {a} · 进行中 {b} · 停下 {c}",
 "Datas": "日期",
 "Datas escolhidas": "所选日期",
 "Datas à escolha": "自选日期",
 "Definir meta de {ano}": "设定 {ano} 年目标",
 "Definir meta do ano": "设定年度目标",
 "FILMES E SÉRIES": "影视",
 "Faltam {f} curso(s): dá cerca de {m} por mês": "还差 {f} 门：每月约 {m} 门",
 "Faltam {f} livro(s): dá cerca de {m} por mês": "还差 {f} 本：每月约 {m} 本",
 "Faltam {f} título(s): dá cerca de {m} por mês": "还差 {f} 部：每月约 {m} 部",
 "Gênero": "类型",
 "Incluir lista de referências no PDF": "在 PDF 中加入参考文献",
 "LIVROS": "书籍",
 "Li {a} livro(s) · Parei {b} · Estou lendo {c}": "读完 {a} 本 · 停下 {b} · 在读 {c}",
 "Meta de {ano}": "{ano} 年目标",
 "Meta de {ano}: usar a de {antes} ({n})?": "{ano} 年目标：沿用 {antes} 年的（{n}）？",
 "Meta do ano cumprida": "年度目标已达成",
 "Mudar": "修改",
 "Nada neste período.": "此期间没有内容。",
 "Nota": "评分",
 "O PDF não leva as suas anotações, resumos e comentários.": "PDF 不包含你的笔记、摘要和评论。",
 "POR ITEM": "逐项",
 "Plataforma": "平台",
 "PÁGINAS POR DIA": "每日页数",
 "PÁGINAS POR MÊS": "每月页数",
 "Quantos no ano?": "一年多少？",
 "Quero ler {a} · Abandonei {b}": "想读 {a} · 放弃 {b}",
 "Relatório de leitura e mídia": "阅读与影视报告",
 "concluídos no período": "期间内完成",
 "cursos concluídos no período": "期间内完成的课程",
 "livros lidos no período": "期间内读完的书",
 "pág. {a} de {n}": "第 {a}/{n} 页",
 "títulos assistidos no período": "期间内看完的影视",
 "{a} aula(s) assistida(s) no período · {h} hora(s) de cursos concluídos": "期间内上了 {a} 节课 · 完成课程共 {h} 小时",
 "{a} de {n} aulas ({p}%)": "{a}/{n} 课（{p}%）",
 "{a} de {n} curso(s) concluído(s) em {ano}": "{ano} 年完成 {a}/{n} 门课程",
 "{a} de {n} livro(s) em {ano}": "{ano} 年 {a}/{n} 本书",
 "{a} de {n} título(s) assistido(s) em {ano}": "{ano} 年看完 {a}/{n} 部",
 "{n} item(ns) sem data de mudança de situação: usei a data de criação.": "{n} 个项目没有状态变更日期：已使用创建日期。",
 "{p} página(s) lida(s) em {d} dia(s) · melhor sequência: {s} dia(s)": "{d} 天读了 {p} 页 · 最长连续 {s} 天",
 "{p}% lido · falta {f}%": "已读 {p}% · 剩 {f}%",
 "Esta aba pede senha. Desbloqueie a aba primeiro e o guia continua daqui.": "此标签需要密码。请先解锁，指南会从这里继续。",
 "Abrir esta aba": "打开此标签",
 "Mostrar na tela": "在屏幕上显示",
 "Não achei este ponto na tela agora. Confira se a tela certa está aberta e tente de novo.": "现在屏幕上找不到这个位置。请确认打开了正确的页面后再试。",
 "Primeiros passos": "入门",
 "Buscar no guia": "在指南中搜索",
 "Entendi": "知道了",
 "{n} de {total} passos feitos": "已完成 {n}/{total} 步",
 "Já fiz": "已完成",
 "Guia em construção": "指南编写中",
 "Limpar marcações": "清除标记",
 "Este ponto ainda não está marcado no app.": "这个位置还没有在应用中标记。",
 "Dicas e atalhos": "提示与快捷方式",
 "Gestos do app": "应用手势",
 "Procurando na tela…": "正在屏幕上查找…",
 "Guia das abas": "各标签指南",
 "Voltar ao guia": "返回指南",
 "Para que serve": "用途",
 "Disponível no app do celular.": "手机应用中可用。",
 "Nada encontrado no guia.": "指南中没有找到。",
 "Recursos que valem para todas as abas": "适用于所有标签的功能",
 "Perguntas comuns": "常见问题",
 "Ligar e desligar partes": "开关各部分",
 "Entrada cancelada. Este computador não foi conectado.": "已取消登录。此电脑未连接。",
 "Alterações ainda não enviadas": "更改尚未发送",
 "Algumas alterações ainda não foram enviadas para o servidor (sem internet?). Se sair agora, elas se perdem. Sair mesmo assim?": "部分更改尚未发送到服务器（没有网络？）。现在退出，这些更改将会丢失。仍要退出吗？",
 "Sair mesmo assim": "仍然退出",
 "O seu papel no grupo não permite mudar aqui.": "你在群组中的角色不允许在此更改。",
 "Não foi possível consultar o DOI agora (sem internet?). Tente de novo.": "现在无法查询 DOI（没有网络？）。请重试。",
 "DOI inválido.": "DOI 无效。",
 "DOI não encontrado.": "未找到 DOI。",
 "O site não deixou ler os dados daqui (no navegador do computador isso é comum). Tente pelo app no celular, use o DOI, ou digite os campos.": "该网站不允许从这里读取数据（在电脑浏览器中很常见）。请在手机上使用应用、使用 DOI，或手动填写字段。",
 "Atualizando...": "正在更新...",
 "Banco de dados (Supabase, plano grátis)": "数据库（Supabase，免费套餐）",
 "Cadeado (HTTPS) até": "HTTPS 锁有效期至",
 "Dados das abas: {d}": "各标签页的数据：{d}",
 "Disco": "磁盘",
 "Esta conta não tem acesso a estas informações.": "此账户无权查看这些信息。",
 "Ligado há": "已运行",
 "Livre: {l} · site: {s}": "可用：{l} · 网站：{s}",
 "Maiores tabelas": "最大的表",
 "Memória em uso": "已用内存",
 "O servidor ainda não mandou o relatório. Ele manda a cada 10 minutos depois do 53-SERVIDOR-0.78.bat.": "服务器尚未发送报告。运行 53-SERVIDOR-0.78.bat 后，它每 10 分钟发送一次。",
 "O servidor ainda não tem esta função. Rode o 53-SERVIDOR-0.78.bat no computador.": "服务器还没有此功能。请在电脑上运行 53-SERVIDOR-0.78.bat。",
 "O sistema do servidor pede reinício (atualização de segurança instalada).": "服务器系统需要重启（已安装安全更新）。",
 "Processador": "处理器",
 "Relatório do servidor: {q}": "服务器报告：{q}",
 "Servidor": "服务器",
 "Servidor do site (Locaweb)": "网站服务器（Locaweb）",
 "Sistema": "系统",
 "Só você vê este quadro.": "只有你能看到此面板。",
 "Versão do site no ar": "线上网站版本",
 "atrasado: confira se o servidor está ligado": "已延迟：请检查服务器是否运行",
 "sem cadeado": "无锁",
 "{a} ({n} guardadas)": "{a}（保留 {n} 个）",
 "{d} dia(s) e {h} h": "{d} 天 {h} 小时",
 "{n} núcleo(s) · carga {c}": "{n} 个核心 · 负载 {c}",
 "{n} · {novas} nova(s) e {ativas} ativa(s) em 7 dias": "{n} · 7 天内新增 {novas}，活跃 {ativas}",
 "{u} de {t} ({p}%)": "{u} / {t}（{p}%）",
 "Fechar teclado": "关闭键盘",
 "Mostrar as ferramentas": "显示工具",
 "Últimas cores usadas": "最近使用的颜色",
 "Voltar ao topo": "回到顶部",
 "Topo": "顶部",
 "1 atividade do roteiro por fazer": "行程中还有 1 项活动待完成",
 "1 dia": "1 天",
 "1 item por pôr na mala": "还有 1 件物品待装箱",
 "1 lista de Viagens ia inteira para o My Planner e saiu de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "1 个“旅行”列表曾整体发送到 My Planner，现已从那里移除。现在请通过每个项目的 ⋮ 逐项发送。",
 "1 lugar não visitado": "1 个地点未去过",
 "1 reserva por confirmar": "1 个预订待确认",
 "Abrir o bloco": "展开区块",
 "Adicionar pessoa": "添加人员",
 "Ainda pode gastar {v}": "还可花费 {v}",
 "Ao ligar, o valor entra em Gastos como pago.": "开启后，该金额将作为已付计入“花费”。",
 "Até (dd/mm/aaaa)": "截至（日/月/年）",
 "Coloque as pessoas em \"Quem vai\" (edite a viagem).": "在\"谁去\"中添加人员（编辑旅行）。",
 "Como foi?": "感觉如何？",
 "Concluído em {d}": "完成于 {d}",
 "Confirmada em {d}": "确认于 {d}",
 "Confirmadas": "已确认",
 "Dia anterior": "前一天",
 "Dias": "天数",
 "Dias × valor por dia": "天数 × 每日金额",
 "Documentos (só o tipo e a validade)": "证件（仅类型和有效期）",
 "EXIGÊNCIAS DO DESTINO": "目的地要求",
 "Em mãos": "已备好",
 "Escreva o que o destino pede (ex.: 2 páginas em branco no passaporte, certificado de vacina). Confira no site oficial do país.": "填写目的地的要求（例如：护照需有 2 页空白页、疫苗接种证明）。请查看该国官方网站。",
 "Ex.: Lisboa (LIS)": "例如：里斯本 (LIS)",
 "Ex.: São Paulo (GRU)": "例如：圣保罗 (GRU)",
 "Falta confirmar": "待确认",
 "Falta pôr": "待装",
 "Faltou ({n}): {l}": "漏带（{n}）：{l}",
 "Foi ({n}): {l}": "已带（{n}）：{l}",
 "Fotos (lista das legendas)": "照片（说明列表）",
 "Gasto de {nome} em {d}": "{nome} 在 {d} 的花费",
 "Gastos do dia": "当日花费",
 "Gastos em outras moedas (não convertidos): {v}": "其他货币的花费（未换算）：{v}",
 "Gastos por dia": "每日花费",
 "Horário de chegada": "到达时间",
 "Lugares (visitados, faltam, imperdíveis e a nota)": "地点（已去、未去、必去和评分）",
 "Mala (o que foi e o que faltou)": "行李（带了什么、漏了什么）",
 "Marcar como acertado": "标记为已结清",
 "Marcar como acertado?": "标记为已结清？",
 "Na mala": "已装",
 "Nenhuma parada ainda": "暂无停靠点",
 "Nova exigência": "新增要求",
 "Números de documentos e o que está no cofre nunca vão para o relatório. Valores em moedas diferentes aparecem separados.": "证件号码和保险箱中的内容绝不会出现在报告中。不同货币的金额会分开显示。",
 "O QUE AINDA FALTA": "尚未完成",
 "O QUE INCLUIR": "包含内容",
 "Opcional. O app avisa se o passaporte vencer antes disso, contado da volta. Confira a exigência do país.": "可选。如果护照在此之前过期（从返程日起算），应用会提醒你。请查看该国的要求。",
 "Orçamento previsto × gasto por categoria": "预算 × 各类别实际花费",
 "Passou do previsto em {v}": "超出预算 {v}",
 "Ponha a validade de cada documento: o app avisa antes de vencer. As fotos dos documentos ficam protegidas no cofre.": "填写每份证件的有效期：到期前应用会提醒你。证件照片会在保险箱中受到保护。",
 "Próximo dia": "后一天",
 "Quem está no grupo da viagem entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app.": "旅行群组中的成员会自动加入。没有此应用的人请使用\"+ 添加人员\"。",
 "Recolher o bloco": "收起区块",
 "Relatório da viagem": "旅行报告",
 "Reserva confirmada": "预订已确认",
 "Resumo da viagem": "旅行概览",
 "Resumo da viagem (datas, destino, pessoas)": "旅行概览（日期、目的地、人员）",
 "Roteiro por dia (feito e falta)": "每日行程（已完成和未完成）",
 "Sem data": "无日期",
 "Seu passaporte pode não ser aceito. Confira a exigência do país": "你的护照可能不被接受。请查看该国的要求",
 "Subir": "上移",
 "Total do dia: {v}": "当日合计：{v}",
 "Uma frase (opcional)": "一句话（可选）",
 "Validade mínima exigida (meses)": "护照所需最短有效期（月）",
 "Validade: {d}": "有效期：{d}",
 "Valor por dia": "每日金额",
 "Viagens no My Planner": "My Planner 中的旅行",
 "Visitado": "已去过",
 "Visitado em {d}": "于 {d} 去过",
 "Voltaria: {r}": "还会再去：{r}",
 "Voltaria?": "还会再去吗？",
 "confirmada": "已确认",
 "em mãos": "已备好",
 "gasto na viagem {d}": "旅行花费 {d}",
 "meses": "个月",
 "outro gasto": "其他花费",
 "vence em {d}": "{d} 到期",
 "{a} de {b} confirmadas": "已确认 {a}/{b}",
 "{a} de {b} em mãos": "已备好 {a}/{b}",
 "{a} de {b} feitos": "已完成 {a}/{b}",
 "{a} de {b} na mala": "已装 {a}/{b}",
 "{a} de {b} pagos": "已付 {a}/{b}",
 "{a} de {b} visitados": "已去 {a}/{b}",
 "{de} deve {v} a {para}": "{de} 欠 {para} {v}",
 "{g} de {p}": "{g} / {p}",
 "{n} atividades do roteiro por fazer": "行程中还有 {n} 项活动待完成",
 "{n} item(ns) enviado(s).": "已发送 {n} 项。",
 "{n} itens por pôr na mala": "还有 {n} 件物品待装箱",
 "{n} já estava(m) no My Planner.": "{n} 项已在 My Planner 中。",
 "{n} listas de Viagens iam inteiras para o My Planner e saíram de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "{n} 个“旅行”列表曾整体发送到 My Planner，现已从那里移除。现在请通过每个项目的 ⋮ 逐项发送。",
 "{n} lugares não visitados": "{n} 个地点未去过",
 "{n} reservas por confirmar": "{n} 个预订待确认",
 "{n} sem data (não foi).": "{n} 项没有日期（未发送）。",
 "ARTIGOS E SITES": "文章和网站",
 "Agora o envio é item por item (pelo ⋮ do item ou selecionando vários). Estas listas iam inteiras e saíram do My Planner ({n} item(ns), nada foi apagado):": "现在改为逐项发送（通过项目的 ⋮ 或选择多项）。以下列表原本整体发送，已从 My Planner 移除（{n} 项，未删除任何内容）：",
 "Artigo científico": "学术文章",
 "Artigo de site ou blog": "网站或博客文章",
 "Artigo ou site": "文章或网站",
 "Artigos e sites": "文章和网站",
 "Autor(es)": "作者",
 "Cadastrar pela foto ou PDF": "通过照片或 PDF 添加",
 "Capítulo de livro": "书籍章节",
 "Crie o grupo e mande o link: quem entrar vê os artigos e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "创建小组并发送链接：加入的人可以看到文章并跟进阅读。管理员可以添加、编辑和上传照片，并可将此权限开放给同样使用此标签页的人。只有管理员可以添加或移除成员。",
 "DOI": "DOI",
 "Data ou ano de publicação": "发表日期或年份",
 "Editar artigo ou site": "编辑文章或网站",
 "Enviar para o My Planner (lembrete de renovação)": "发送到 My Planner（续期提醒）",
 "Envio para o My Planner": "发送到 My Planner",
 "Ex.: 2024 ou 12/03/2024": "例如：2024 或 2024/03/12",
 "Ex.: 45-60": "例如：45-60",
 "Grupo de artigos": "文章小组",
 "Guarde artigos, notícias e páginas da internet com a referência pronta (ABNT e APA). Preencha pelo DOI ou pelo link.": "保存文章、新闻和网页，参考文献格式已备好（ABNT 和 APA）。可通过 DOI 或链接填写。",
 "Li {a} · Lendo {b} · Parei {c} · Quero ler {d}": "已读 {a} · 在读 {b} · 中断 {c} · 想读 {d}",
 "Minhas anotações do artigo": "我的文章笔记",
 "Notícia": "新闻",
 "Novo artigo ou site": "新文章或网站",
 "Os dados vêm da ficha do artigo (Editar).": "数据来自文章卡片（编辑）。",
 "Páginas (opcional)": "页码（可选）",
 "Revista, site ou veículo": "期刊、网站或媒体",
 "artigos e sites lidos no período": "期间内读过的文章和网站",
 "1 confirmado": "1 人已确认",
 "1 convidado que estava em \"Pendente\" passou para \"A convidar\". Ao enviar o convite pelo app, ele passa sozinho para \"Convidado, sem resposta\".": "1 位原为“待定”的宾客已改为“待邀请”。通过应用发送邀请后，会自动变为“已邀请，未回复”。",
 "1 extra": "额外 1 人",
 "1 talvez": "1 人待定",
 "A convidar": "待邀请",
 "Agendar na igreja": "预约教堂",
 "Agora": "现在",
 "Agradeci": "已致谢",
 "Agradeci em {d}": "已于 {d} 致谢",
 "Agradecidos": "已致谢",
 "Alianças": "婚戒",
 "Aluguéis (mesas, cadeiras, louças)": "租赁（桌椅、餐具）",
 "Avisar a data (save the date)": "提前告知日期（save the date）",
 "Bebidas": "饮品",
 "Beca e cerimônia": "学位服与典礼",
 "Bolo": "蛋糕",
 "Brincadeiras": "游戏",
 "Brincadeiras e amigo secreto": "游戏和神秘圣诞老人",
 "Brindes": "赠品",
 "Buffet": "餐饮",
 "Calculado sozinho: valor menos o sinal.": "自动计算：金额减去定金。",
 "Calcular quantidades": "计算数量",
 "Categoria do orçamento": "预算类别",
 "Celebrante": "主持人",
 "Cerimônia": "仪式",
 "Cerveja (adultos)": "啤酒（成人）",
 "Checklist de preparação": "准备清单",
 "Coloque a data do evento (edite o evento) para ver até quando fazer cada item.": "设置活动日期（编辑活动）以查看每项的截止时间。",
 "Coloque as pessoas em \"Pessoas do evento\" (edite o evento).": "在“活动人员”中添加人员（编辑活动）。",
 "Coloque quanto pretende gastar em cada categoria. Use o ⊕ para calcular por convidado. Os fornecedores contratados entram sozinhos na categoria escolhida.": "填写每个类别计划花费多少。使用 ⊕ 按宾客计算。已签约的供应商会自动计入所选类别。",
 "Combinado: {v}": "约定：{v}",
 "Comprado": "已购买",
 "Comprados": "已购买",
 "Comprar a decoração e as lembrancinhas": "购买装饰和伴手礼",
 "Comprar as alianças": "购买婚戒",
 "Comprar as lembrancinhas": "购买伴手礼",
 "Comprar bebidas e gelo": "购买饮品和冰块",
 "Comprar comida e bebidas": "购买食物和饮品",
 "Comprar o que falta": "购买缺少的东西",
 "Comprar ou alugar a roupa": "购买或租借服装",
 "Confirmados com os acompanhantes. Muda sozinho quando alguém confirma ou desconfirma.": "已确认人数（含随行人员）。有人确认或取消时自动更新。",
 "Confirmar a presença dos convidados": "确认宾客出席",
 "Confirmar os fornecedores": "确认供应商",
 "Confirmar os fornecedores e os convidados": "确认供应商和宾客",
 "Contratar a comida": "预订餐食",
 "Contratar a comida e o bolo": "预订餐食和蛋糕",
 "Contratar a decoração": "预订装饰",
 "Contratar comida e bebidas": "预订餐食和饮品",
 "Contratar foto e vídeo": "预订摄影摄像",
 "Contratar o buffet": "预订餐饮服务",
 "Convidado, sem resposta": "已邀请，未回复",
 "Convidados (por situação, com acompanhantes)": "宾客（按状态，含随行人员）",
 "Convidados que contam no ⊕": "计入 ⊕ 的宾客",
 "Convites": "请柬",
 "Cronograma do dia (com responsáveis e situação)": "当天流程（含负责人和状态）",
 "Data do restante": "尾款日期",
 "Data do sinal": "定金日期",
 "Decoração": "装饰",
 "Definir a data e o orçamento": "确定日期和预算",
 "Definir a lista de convidados": "确定宾客名单",
 "Doces": "甜点",
 "Dá para mudar, tirar e incluir itens depois.": "之后可以修改、删除和添加项目。",
 "Enviar os convites": "发送请柬",
 "Equipamentos (projetor, som)": "设备（投影仪、音响）",
 "Equipe (garçons, limpeza)": "人员（服务员、清洁）",
 "Escolha \"Outro\" para escrever o nome.": "选择“其他”以输入名称。",
 "Escolher a roupa": "挑选服装",
 "Escolher a roupa dos noivos": "挑选新人礼服",
 "Escolher os padrinhos": "挑选伴郎伴娘/教父母",
 "Estimativa para {n} convidados. Mude o que quiser antes de levar.": "按 {n} 位宾客估算。添加前可随意修改。",
 "Eu faço": "我来做",
 "Ex.: 200 un.": "例：200 个",
 "Ex.: Copos descartáveis": "例：一次性杯子",
 "Ex.: Jogo de panelas": "例：锅具套装",
 "Ex.: Reservar o local": "例：预订场地",
 "Ex.: em negociação": "例：洽谈中",
 "Extras de margem (quem aparece sem avisar)": "额外余量（不请自来的人）",
 "Falta 1 dia": "还剩 1 天",
 "Falta agradecer": "待致谢",
 "Falta comprar": "待购买",
 "Falta pagar": "待付款",
 "Fazer a lista de presentes": "制作礼物清单",
 "Fazer o curso de batismo": "参加洗礼课程",
 "Fornecedores (contratado, pago, falta)": "供应商（合同、已付、待付）",
 "Foto e vídeo": "摄影摄像",
 "Fraldas": "尿布",
 "Frase curta (opcional)": "简短语句（可选）",
 "Hoje é o dia do evento!": "今天就是活动日！",
 "Igreja e celebrante": "教堂和主持人",
 "Incluir os Talvez": "包括待定",
 "Incluir telefones": "包括电话号码",
 "Item da lista de compras": "购物清单项目",
 "Item da preparação": "准备项目",
 "Já deram: {d} · Falta: {f}": "已出：{d} · 还差：{f}",
 "Já deu": "已出",
 "L": "升",
 "Lance aqui o que foi gasto. Os pagamentos aos fornecedores e as compras marcadas entram sozinhos.": "在此记录已花费的金额。供应商付款和已勾选的购物会自动计入。",
 "Lançar o gasto": "记录支出",
 "Lembrancinhas": "伴手礼",
 "Levar para os itens": "加入项目",
 "Local / espaço": "场地",
 "Mais um extra": "多加 1 人",
 "Menos um extra": "少加 1 人",
 "Música / som / DJ": "音乐 / 音响 / DJ",
 "No dia do evento": "活动当天",
 "O que comprar": "要买什么",
 "O total muda sozinho quando alguém confirma ou desconfirma.": "有人确认或取消时，总数会自动更新。",
 "O valor do contrato entra sozinho como previsto nesta categoria, e o que for pago entra nos gastos.": "合同金额会自动作为此类别的预计金额，已付款项会计入支出。",
 "O valor entra nos gastos do evento, na categoria do item. Se preferir, pule.": "金额将计入活动支出中该项目的类别。也可以跳过。",
 "Onde comprar": "在哪买",
 "Orçamento do evento": "活动预算",
 "Os itens marcados entram na categoria com o ⊕ por convidado. Depois é só tocar no ⊕ e pôr o valor unitário.": "勾选的项目会以 ⊕ 按宾客计入类别。之后只需点 ⊕ 并填写单价。",
 "Os telefones dos convidados só saem no PDF se você marcar \"Incluir telefones\". Valores em moedas diferentes aparecem separados.": "只有勾选“包括电话号码”时，宾客电话才会出现在 PDF 中。不同货币的金额分开显示。",
 "Pago em {d}": "已于 {d} 付款",
 "Parte da vaquinha": "凑份子份额",
 "Pessoas do evento": "活动人员",
 "Pessoas do evento: {p}": "活动人员：{p}",
 "Preparar as brincadeiras": "准备游戏",
 "Preparação": "准备",
 "Presente recebido": "已收礼物",
 "Presentes": "礼物",
 "Prova final da roupa": "最终试衣",
 "Pular": "跳过",
 "Quantidade por convidado": "每位宾客数量",
 "Quantidade por convidado × valor unitário": "每位宾客数量 × 单价",
 "Quanto custou?": "花了多少钱？",
 "Quanto já deu": "已出金额",
 "Quanto vai contribuir": "计划出资",
 "Quantos dias antes do evento": "活动前几天",
 "Quem deu": "送礼人",
 "Quem está no grupo do evento entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app. Esta lista é usada no cronograma, nos gastos e na vaquinha.": "活动群组中的成员会自动加入。没有应用的人请用“+ 添加人员”。此名单用于流程、支出和凑份子。",
 "Recreação e brinquedos": "娱乐与游乐设施",
 "Refrigerante": "软饮",
 "Relatório do evento": "活动报告",
 "Relatório do evento (PDF)": "活动报告（PDF）",
 "Reservar o local": "预订场地",
 "Reservar o local da cerimônia e da festa": "预订仪式和派对场地",
 "Reservar o local ou a mesa da festa": "预订派对场地或餐桌",
 "Restante": "尾款",
 "Restante pago": "尾款已付",
 "Resumo do evento": "活动摘要",
 "Roupa e beleza": "服装与美容",
 "Salgados": "咸点心",
 "Separar a roupa e o que levar": "准备好服装和要带的东西",
 "Separar os documentos e as alianças": "准备好证件和婚戒",
 "Separar os documentos e os ingressos": "准备好证件和门票",
 "Sinal": "定金",
 "Sinal pago": "定金已付",
 "Sinal {v} pago": "定金 {v} 已付",
 "Usar a lista pronta para {tipo}": "使用 {tipo} 的现成清单",
 "Vai contribuir": "将出资",
 "Valor unitário": "单价",
 "Vaquinha": "凑份子",
 "Você acompanha tudo o que foi compartilhado, sempre atualizado. Para incluir, editar e pegar tarefas, assine a aba.": "你可以查看所有共享内容，始终保持最新。如需添加、编辑和认领任务，请订阅此标签页。",
 "agradeci": "已致谢",
 "atrasado": "已逾期",
 "completo": "已完成",
 "deu {d} de {v}": "已出 {d}／{v}",
 "em {l}": "在 {l}",
 "falta o valor": "缺少金额",
 "falta {v} até {d}": "{d} 前还需 {v}",
 "gasto em {e}": "用于 {e} 的支出",
 "kg": "kg",
 "o evento": "活动",
 "restante": "尾款",
 "sinal": "定金",
 "total": "合计",
 "un.": "个",
 "{n} confirmados": "{n} 人已确认",
 "{n} convidados contam no ⊕ por convidado.": "{n} 位宾客计入 ⊕ 按宾客计算。",
 "{n} convidados que estavam em \"Pendente\" passaram para \"A convidar\". Ao enviar o convite pelo app, eles passam sozinhos para \"Convidado, sem resposta\".": "{n} 位原为“待定”的宾客已改为“待邀请”。通过应用发送邀请后，会自动变为“已邀请，未回复”。",
 "{n} extras": "额外 {n} 人",
 "{n} talvez": "{n} 人待定",
 "{q} por convidado": "每位宾客 {q}",
 "{v} por convidado": "每位宾客 {v}",
 "Item completo": "完整项目",
 "Nota rápida": "快速笔记",
 "📝 Nota rápida": "📝 快速笔记",
 "Conteúdo da nota": "笔记内容",
 "{c} confirmado(s) de {n} convidado(s)": "{n} 位来宾中 {c} 位已确认",
 "Serão apagados para todos: os documentos, as reuniões marcadas e as gravações do escritório \"{nome}\". A conversa continua no Mensagens.": "将为所有人删除：办公室“{nome}”的文件、已安排的会议和录音。聊天仍保留在消息中。",
 "Confirme para apagar o escritório": "确认删除办公室",
 "Escreva o assunto da reunião para poder marcar.": "填写会议主题后才能安排。",
 "{n} min (marcada para {m} min)": "{n} 分钟（原定 {m} 分钟）",
 "Não foi possível baixar o arquivo agora. Confira a internet e tente de novo.": "暂时无法下载文件。请检查网络后重试。",
 "Meus clientes": "我的客户",
 "Uma lista só de clientes, usada por todas as abas de trabalho: contato, endereço, etiquetas, anotações e arquivos.": "一份客户列表，所有工作标签页共用：联系方式、地址、标签、备注和文件。",
 "Copiar para Meus clientes": "复制到我的客户",
 "Ver ou mudar": "查看或更改",
 "Ver o documento completo": "查看完整证件号",
 "CEP incompleto": "CEP 不完整",
 "O CEP tem 8 números.": "CEP 为 8 位数字。",
 "CEP não encontrado": "未找到该 CEP",
 "Confira os números ou preencha o endereço à mão.": "请检查数字，或手动填写地址。",
 "Não foi possível buscar o CEP": "无法查询 CEP",
 "Confira a internet ou preencha o endereço à mão.": "请检查网络连接，或手动填写地址。",
 "Parece que falta algo neste e-mail (ex.: nome@site.com).": "此邮箱似乎缺少内容（例如：name@site.com）。",
 "opcional": "可选",
 "Os seus clientes agora ficam numa lista só, usada por todas as abas de trabalho.": "你的客户现在都在同一份列表中，所有工作标签页共用。",
 "Portal do Cliente: {n} cliente(s).": "客户门户：{n} 位客户。",
 "Freelancer & Projetos: {n} cliente(s).": "自由职业与项目：{n} 位客户。",
 "{n} eram o mesmo cliente em mais de uma aba e viraram uma ficha só.": "{n} 位是多个标签页中的同一客户，已合并为一份档案。",
 "Nenhum cliente repetido.": "没有重复的客户。",
 "Nada foi apagado: documentos, pedidos, cartões e horas continuam onde estavam.": "没有删除任何内容：文档、订单、卡片和工时都保留在原处。",
 "Já está em Meus clientes": "已在我的客户中",
 "{nome} já está na lista.": "{nome} 已在列表中。",
 "Copiado para Meus clientes": "已复制到我的客户",
 "Só o nome e o contato foram copiados.": "仅复制了姓名和联系方式。",
 "Aniversário hoje!": "今天生日！",
 "Fechar tudo": "全部收起",
 "Abrir tudo": "全部展开",
 "Quem é": "基本信息",
 "Razão social": "公司法定名称",
 "Nome fantasia": "商号",
 "Data de abertura": "成立日期",
 "Inscrição estadual / municipal": "州 / 市级登记号",
 "Outras pessoas de contato": "其他联系人",
 "Como chamar": "称呼",
 "Cliente desde": "成为客户时间",
 "Outro telefone": "其他电话",
 "Site": "网站",
 "Melhor jeito de falar": "最佳联系方式",
 "Autorizou receber mensagens": "已同意接收消息",
 "Outros endereços": "其他地址",
 "Relacionamento": "客户关系",
 "Como me conheceu": "如何认识我",
 "Etiquetas": "标签",
 "Nada anotado ainda.": "暂无备注。",
 "Bloco da aba {aba}": "{aba} 标签页区块",
 "Abrir na aba {aba}": "在 {aba} 标签页中打开",
 "Uma lista só, usada por todas as abas de trabalho.": "一份列表，所有工作标签页共用。",
 "Escreva o nome do cliente.": "请输入客户名称。",
 "Telefone / WhatsApp": "电话 / WhatsApp",
 "Só o nome é obrigatório. Abra as partes que quiser preencher.": "只有名称为必填项。展开你想填写的部分。",
 "Como chamar (apelido)": "称呼（昵称）",
 "Inscrição estadual / municipal (opcional)": "州 / 市级登记号（可选）",
 "Cargo": "职位",
 "Telefone da pessoa de contato": "联系人电话",
 "Outras pessoas de contato (uma por linha: nome, cargo, telefone)": "其他联系人（每行一位：姓名、职位、电话）",
 "O telefone principal é WhatsApp": "主电话可用 WhatsApp",
 "O outro telefone é WhatsApp": "其他电话可用 WhatsApp",
 "Instagram": "Instagram",
 "Ex.: @nome": "例如：@name",
 "Ex.: WhatsApp, à tarde": "例如：WhatsApp，下午",
 "Estado (UF)": "州（UF）",
 "Endereço (como estava escrito)": "地址（原始写法）",
 "Outros endereços (trabalho, entrega...)": "其他地址（工作、收货……）",
 "Google": "Google",
 "Passou na frente": "路过门店",
 "Indicado por": "推荐人",
 "Criar etiqueta": "创建标签",
 "Ex.: VIP, Mensal, Atacado": "例如：VIP、月付、批发",
 "Ativo": "活跃",
 "Inativo": "不活跃",
 "Em negociação": "洽谈中",
 "O cliente autorizou receber mensagens?": "客户是否同意接收消息？",
 "Sem autorização, nada de mensagem de aniversário, cobrança automática ou promoção para este cliente.": "未经同意，不会向此客户发送生日消息、自动催款或促销信息。",
 "aniversário hoje": "今天生日",
 "contato: {n}": "联系人：{n}",
 "com esse telefone": "使用此电话",
 "com esse e-mail": "使用此邮箱",
 "com esse documento": "使用此证件号",
 "com esse nome": "使用此名称",
 "Cliente parecido": "相似客户",
 "Já existe {nome} {por}. Abrir?": "已存在 {nome}（{por}）。要打开吗？",
 "Cadastrar mesmo assim": "仍然添加",
 "Serão apagados: a ficha, as anotações e os arquivos deste cliente.": "将删除：此客户的档案、备注和文件。",
 "Também nas abas: {abas} (com os documentos, pedidos, cartões e horas de lá).": "同时包括以下标签页：{abas}（连同其中的文档、订单、卡片和工时）。",
 "Juntar com outra ficha": "与其他档案合并",
 "Juntar fichas": "合并档案",
 "Não há outra ficha para juntar.": "没有其他可合并的档案。",
 "Juntar \"{nome}\" com:": "将“{nome}”合并到：",
 "Juntar as duas fichas?": "合并这两份档案？",
 "\"{a}\" fica com tudo de \"{b}\" (dados, anotações, arquivos e as ligações com as abas). A ficha \"{b}\" deixa de existir.": "“{a}”将获得“{b}”的全部内容（资料、备注、文件及与标签页的关联）。“{b}”档案将不再存在。",
 "Juntar": "合并",
 "Confirme para juntar as fichas": "确认以合并档案",
 "Aniversariantes do mês": "本月生日",
 "Ativos": "活跃",
 "Inativos": "不活跃",
 "Cadastre cada cliente uma vez: ele aparece em todas as abas de trabalho que você usa.": "每位客户只需添加一次：它会出现在你使用的所有工作标签页中。",
 "Novo cliente": "新建客户",
 "Editar cliente": "编辑客户",
 "Linha do tempo": "时间线",
 "{n} registro(s)": "{n} 条记录",
 "Nada ainda. Vendas, pagamentos, documentos e horas aparecem aqui.": "还没有内容。销售、付款、文件和工时会显示在这里。",
 "Me deve": "欠我",
 "Total pago": "已付总额",
 "Última compra ou atendimento": "最近一次购买或服务",
 "Próximo compromisso": "下一个预约",
 "na entrega": "交付时",
 "Passou do limite de fiado ({v}).": "已超过赊账额度（{v}）。",
 "Recebeu {v} ({p})": "已收 {v}（{p}）",
 "Hoje é aniversário de {n}.": "今天是{n}的生日。",
 "Mandar parabéns": "发送祝福",
 "{n}: parcela de {v} atrasada.": "{n}：{v} 的分期已逾期。",
 "Cobrar": "催款",
 "{n} não compra há {d} dias.": "{n} 已经 {d} 天没有购买了。",
 "Chamar de volta": "重新联系",
 "🟢 em dia · 🟡 sumido": "🟢 正常 · 🟡 久未光顾",
 "🟢 em dia · 🟡 algo vencendo ou cliente sumido · 🔴 atrasado": "🟢 正常 · 🟡 即将到期或久未光顾 · 🔴 逾期",
 "Limite de fiado (opcional)": "赊账额度（可选）",
 "Avisa quando o que ele deve passar deste valor.": "欠款超过此金额时提醒你。",
 "A prazo": "分期",
 "parcela atrasada": "逾期分期",
 "falta na entrega": "交付时付清余款",
 "Sumidos": "久未光顾",
 "Sinal pago, falta o resto": "定金已付，尚欠余款",
 "Pagou {a} de {b}": "已付 {a}／共 {b}",
 "Esta parcela vem de Meus clientes. Marque aqui como recebida ou abra o cliente para cobrar e gerar o recibo.": "此分期来自“我的客户”。可在此标记为已收款，或打开客户进行催款并生成收据。",
 "Sinal + restante": "定金 + 余款",
 "Pix": "Pix",
 "Cartão de crédito à vista": "信用卡一次付清",
 "Cartão de crédito parcelado": "信用卡分期",
 "Fiado / a prazo": "赊账／分期",
 "Parcela única": "一次付清",
 "Oi, {nome}! Feliz aniversário! 🎉 Que o seu dia seja lindo. Um abraço!": "{nome}，你好！生日快乐！🎉 祝你今天过得美好。",
 "Oi, {nome}! Faz tempo que a gente não se fala. Posso ajudar em alguma coisa? Vai ser um prazer te atender de novo!": "{nome}，你好！好久没联系了。有什么可以帮你的吗？很乐意再次为你服务！",
 "Oi, {nome}! Passando para lembrar da parcela de {v} que venceu dia {d}. Qualquer coisa, me chama. Obrigada!": "{nome}，你好！温馨提醒一下，{v} 的分期已于 {d} 到期。有任何问题随时找我。谢谢！",
 "Oi, {nome}! Passando para lembrar da parcela de {v}{d}. Qualquer coisa, me chama. Obrigada!": "{nome}，你好！温馨提醒一下，{v} 的分期{d}。有任何问题随时找我。谢谢！",
 "que vence dia {d}": "将于 {d} 到期",
 "Quanto recebeu?": "收到多少？",
 "Falta {v}. Pode ser só uma parte.": "还差 {v}。可以只收一部分。",
 "(seu nome ou sua marca, em Como você recebe?)": "（你的名字或品牌，在“收款方式”中设置）",
 "Recibo {c}": "收据 {c}",
 "Recebi de {c} a quantia de {v}, referente a {o}.": "兹收到 {c} 支付的 {v}，用于 {o}。",
 "{v} no {f} → recebe {l}": "{v} 通过 {f} → 实收 {l}",
 "Pagou {a} de {b}, faltam {c}": "已付 {a}／共 {b}，还差 {c}",
 "Recebido em {d}": "已于 {d} 收款",
 "Cobrar pelo WhatsApp": "通过 WhatsApp 催款",
 "Sem autorização": "未获授权",
 "Este cliente não autorizou receber mensagens (ficha do cliente › Relacionamento).": "该客户未同意接收消息（客户档案 › 关系）。",
 "Sem telefone": "无电话号码",
 "Coloque o telefone na ficha do cliente.": "请在客户档案中填写电话号码。",
 "Gerar recibo": "生成收据",
 "Como você recebe?": "收款方式",
 "Só \"À vista\": a tela fica limpa, sem a prazo, parcelas nem vermelho.": "仅“一次付清”：界面简洁，没有分期，也没有红色提醒。",
 "Taxa da maquininha (%)": "刷卡机手续费（%）",
 "Taxa {k}": "{k} 手续费",
 "Cliente sumido depois de (dias sem comprar)": "久未光顾的判定（未购买天数）",
 "Dias para considerar sumido": "判定为久未光顾的天数",
 "Lembretes de cobrança por parcela atrasada": "逾期分期的催款提醒",
 "Nome ou marca no recibo": "收据上的名字或品牌",
 "Ex.: Ana Beatriz Doces": "例如：Ana Beatriz 甜品",
 "Venda ou serviço": "销售或服务",
 "O que foi vendido ou feito": "卖了什么或做了什么",
 "Ex.: Bolo de aniversário": "例如：生日蛋糕",
 "Como paga": "付款方式",
 "Sinal (%)": "定金（%）",
 "Ou escreva o valor do sinal logo abaixo.": "或在下方直接填写定金金额。",
 "Sinal (valor)": "定金（金额）",
 "Restante na entrega": "余款交付时付",
 "Próximo vencimento": "下次到期日",
 "Sinal a receber": "待收定金",
 "falta {v}{q}": "还差 {v}{q}",
 "quitado": "已结清",
 "Parcelas mantidas": "分期保持不变",
 "Já há pagamento registrado: as parcelas não foram refeitas. Para mudar, desfaça os pagamentos primeiro.": "已有付款记录：分期未重新生成。如需修改，请先撤销付款。",
 "Registre o que o cliente comprou ou o serviço que você fez, e como ele paga.": "记录客户购买了什么或你提供了什么服务，以及付款方式。",
 "Débito": "借记卡",
 "Crédito à vista": "信用卡一次付清",
 "Crédito 2x": "信用卡分2期",
 "Crédito 3x": "信用卡分3期",
 "Crédito 4x": "信用卡分4期",
 "Crédito 5x": "信用卡分5期",
 "Crédito 6x": "信用卡分6期",
 "Crédito 7x": "信用卡分7期",
 "Crédito 8x": "信用卡分8期",
 "Crédito 9x": "信用卡分9期",
 "Crédito 10x": "信用卡分10期",
 "Crédito 11x": "信用卡分11期",
 "Crédito 12x": "信用卡分12期",
 "ATRASADOS": "逾期",
 "Atrasado (hoje): {v}": "逾期（截至今天）：{v}",
 "Buscar um cliente": "搜索客户",
 "CPF/CNPJ completo, endereço completo e data de nascimento. Pede a senha do app.": "完整的 CPF/CNPJ、完整地址和出生日期。需要输入应用密码。",
 "Cliente cadastrado": "客户已添加",
 "Com documentos: guarde o arquivo em lugar seguro.": "包含证件：请将文件保存在安全的地方。",
 "Como pagou": "付款方式",
 "Esse contato não tem nome.": "此联系人没有姓名。",
 "Exportar planilha": "导出表格",
 "Falta receber": "待收款",
 "Falta receber (hoje): {v}": "待收款（截至今天）：{v}",
 "Importar dos contatos": "从通讯录导入",
 "Importar dos contatos do celular": "从手机通讯录导入",
 "Incluir documentos": "包含证件",
 "Incluir documentos no relatório": "在报告中包含证件",
 "MELHORES CLIENTES": "最佳客户",
 "Melhores clientes": "最佳客户",
 "Não foi possível gerar a planilha.": "无法生成表格。",
 "O que foi": "内容",
 "Pago em": "付款日期",
 "Para trazer clientes dos contatos do celular, atualize o My Planner pela loja de aplicativos.": "如需从手机通讯录导入客户，请在应用商店更新 My Planner。",
 "RECEBIDO POR DIA": "每日收款",
 "RECEBIDO POR MÊS": "每月收款",
 "Recebeu": "已收款",
 "Recebeu no período": "期间内收款",
 "Recebeu no período: {v}": "期间内收款：{v}",
 "Recebido no período": "期间内收款",
 "Relatório de clientes": "客户报告",
 "Relatório deste cliente": "此客户的报告",
 "Sem a permissão de contatos não dá para escolher um contato. Você pode liberar nos ajustes do celular.": "没有通讯录权限就无法选择联系人。你可以在手机设置中开启。",
 "Sem documentos: o CPF/CNPJ sai só com os 2 últimos números. As anotações nunca saem.": "不含证件：CPF/CNPJ 仅显示最后 2 位。备注永远不会包含在内。",
 "Todos os clientes": "所有客户",
 "Trabalha em: {e}": "工作单位：{e}",
 "Trazer outro": "再导入一个",
 "VENDAS E ATENDIMENTOS": "销售与服务",
 "Vence": "到期",
 "Venceu": "已到期",
 "Vendas e atendimentos": "销售与服务",
 "Vendeu": "销售额",
 "Vendeu no período": "期间内销售额",
 "Vendeu no período: {v}": "期间内销售额：{v}",
 "venceu {d}": "已于 {d} 到期",
 "vendido no período": "期间内销售额",
 "{nome} comprou no período": "{nome} 期间内购买额",
 "{nome} entrou em Meus clientes. Confira a ficha e marque se ele autorizou receber mensagens.": "{nome} 已加入“我的客户”。请检查资料，并标记其是否同意接收消息。",
 "{n} compra(s)": "{n} 次购买",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure numa parte livre da caixa e arraste para mudar a ordem.": "向左滑动框可归档，向右滑动可删除。按住框的空白处拖动可调整顺序。",
 "Bloco": "区块",
 "Confirme para apagar o grupo": "确认删除群组",
 "Descer": "下移",
 "Opções do bloco": "区块选项",
 "Exigências do destino": "目的地要求",
 "{n} para acertar": "{n} 笔待结清",
 "{n} parada(s)": "{n} 个停留点",
 "Cor do item selecionado": "所选项目的颜色",
 "Abrir o grupo": "展开分组",
 "Recolher o grupo": "收起分组",
 "Arraste uma caixa para a direita para excluir ou para a esquerda para arquivar. Segure e arraste para mudar a ordem.": "向右滑动框可删除，向左滑动可归档。按住并拖动可调整顺序。",
 "Editar subtítulo": "编辑小标题",
 "Início da caixa": "框的开头",
 "Mover para…": "移动到…",
 "Mover {n} item(ns) para": "将 {n} 项移动到",
 "Opções do item": "项目选项",
 "Transformar em subtítulo": "转为小标题",
 "Transformar em texto": "转为文本",
 "esta caixa": "此框",
 "{a} de {n} feitos": "已完成 {a}/{n}",
 "1 documento pedido atrasado": "1 份请求的文件已逾期",
 "1 pedido vence logo": "1 个请求即将到期",
 "A lista vem de \"Meus clientes\".": "列表来自“我的客户”。",
 "Abrir Meus clientes": "打开我的客户",
 "As abas Escritório e Portal do Cliente agora são uma aba só.": "“办公室”和“客户门户”标签现已合并为一个。",
 "Clientes com pendência": "有待办事项的客户",
 "Com pendência ({n})": "待处理 ({n})",
 "Conversa da equipe": "团队聊天",
 "Crie o escritório e chame a equipe (amigos do app ou convite pelo link): conversa, reuniões de vídeo e documentos internos. Trabalha sozinho? Use só os Clientes.": "创建办公室并邀请团队（应用好友或链接邀请）：聊天、视频会议和内部文件。独自工作？只用“客户”即可。",
 "Documentos internos": "内部文件",
 "Entrar com um código de convite": "使用邀请码加入",
 "Escritório & Clientes": "办公室与客户",
 "Escritórios: {n}": "办公室：{n}",
 "Esta parte é para quem trabalha com equipe": "这部分适合团队协作的用户",
 "Guias vencendo": "即将到期的税单",
 "Minhas tarefas": "我的任务",
 "Nada foi apagado: a equipe, a conversa, as reuniões, os documentos e os clientes convidados continuam como estavam.": "没有删除任何内容：团队、聊天、会议、文件和已邀请的客户都保持不变。",
 "Nenhum cliente ainda. Cadastre em \"Meus clientes\": ele aparece aqui na hora.": "还没有客户。在“我的客户”中添加后会立即显示在这里。",
 "Para quem trabalha com clientes, sozinho ou com equipe: a pasta de cada cliente (documentos, pedidos, guias), equipe, conversa, reuniões e documentos internos.": "适合与客户合作的用户，无论独自还是团队：每位客户的文件夹（文件、请求、税单）、团队、聊天、会议和内部文件。",
 "Pastas de clientes do Portal: {c} (com {d} documentos e {p} pedidos)": "门户客户文件夹：{c}（含 {d} 份文件和 {p} 个请求）",
 "Pessoa física": "个人",
 "Procurar por nome, CNPJ ou CPF": "按名称、CNPJ 或 CPF 搜索",
 "Reuniões hoje": "今日的会议",
 "Sem escritório (equipe). Toque para criar ou entrar com um código.": "暂无办公室（团队）。点按以创建或使用邀请码加入。",
 "Só a equipe vê. Clientes nunca veem esta parte.": "仅团队可见。客户永远看不到这部分。",
 "Tudo em dia": "一切正常",
 "Vencendo ({n})": "即将到期 ({n})",
 "chega na próxima versão": "将在下个版本推出",
 "nos próximos 7 dias": "未来 7 天内",
 "vence amanhã": "明天到期",
 "vence hoje": "今天到期",
 "{doc} venceu em {d}": "{doc} 已于 {d} 到期",
 "{n} documentos pedidos atrasados": "{n} 份请求的文件已逾期",
 "{n} pedidos vencem logo": "{n} 个请求即将到期",
 "🟢 em dia · 🟡 algo vence logo · 🔴 pedido atrasado ou guia vencida": "🟢 正常 · 🟡 即将到期 · 🔴 请求逾期或税单过期",
 "Acesso ao gov.br": "gov.br 账号",
 "Alvará": "营业许可证",
 "Até o dia (do mês)": "截止日（每月）",
 "CCMEI (certificado do MEI)": "CCMEI（MEI 证书）",
 "Cadastre o telefone do cliente para lembrar pelo WhatsApp.": "添加客户电话，即可通过 WhatsApp 提醒。",
 "Cartão CNPJ": "CNPJ 登记卡",
 "Checklist criado": "清单已创建",
 "Checklist de cliente novo": "新客户清单",
 "Cliente viu {doc}": "客户已查看 {doc}",
 "Cole no app do banco, em Pix copia e cola.": "粘贴到银行 App 的 Pix 复制粘贴中。",
 "Cole no app do banco.": "粘贴到银行 App 中。",
 "Comprovante de endereço": "地址证明",
 "Contrato social e alterações": "公司章程及修订",
 "Copiado": "已复制",
 "Copiar Pix": "复制 Pix",
 "Copiar código de barras": "复制条形码",
 "Código de barras (linha digitável)": "条形码（数字行）",
 "Dados bancários": "银行信息",
 "Escreva o recado.": "写下留言。",
 "Escritório enviou {doc}": "事务所已发送 {doc}",
 "Este cliente não autorizou receber mensagens (ficha em Meus clientes).": "该客户未同意接收消息（见“我的客户”中的资料）。",
 "Extratos bancários": "银行对账单",
 "Ficha completa": "完整资料",
 "Guia": "缴税单",
 "Guias a pagar": "待缴税单",
 "Honorário": "服务费",
 "Honorário por": "服务费按",
 "Informes de rendimentos": "收入证明",
 "Lembrar pelo WhatsApp": "通过 WhatsApp 提醒",
 "Ler a guia ou o boleto com a minha IA": "用我的 AI 读取税单或 boleto",
 "Lucro presumido": "推定利润制",
 "Lucro real": "实际利润制",
 "Nada ainda.": "还没有内容。",
 "Nenhum pedido em aberto.": "没有未完成的请求。",
 "Notas fiscais emitidas": "已开发票",
 "O cliente": "客户",
 "O pedido entrou em Pedidos de documentos.": "请求已加入“文件请求”。",
 "Oi, {nome}! Falta: {itens}. Pode mandar por aqui?": "{nome}，你好！还缺：{itens}。可以在这里发给我吗？",
 "Oi, {nome}! Faltam: {itens}. Pode mandar por aqui?": "{nome}，你好！还缺：{itens}。可以在这里发给我吗？",
 "Oi, {nome}! Tudo certo por aí?": "{nome}，你好！一切都好吗？",
 "Pedido criado": "请求已创建",
 "Pedido feito: {o}": "已发出请求：{o}",
 "Pedido recebido: {o}": "已收到请求：{o}",
 "Pedidos pendentes": "待处理请求",
 "Pedir de novo todo mês": "每月重新请求",
 "Pedir nova ({c})": "请求新的（{c}）",
 "Pendentes": "待处理",
 "Que tipo de cliente?": "什么类型的客户？",
 "RG e CPF": "RG 和 CPF",
 "RG e CPF do titular": "所有人的 RG 和 CPF",
 "RG e CPF dos sócios": "合伙人的 RG 和 CPF",
 "Recados": "留言",
 "Recados entre você e o cliente, presos à pasta dele.": "你与客户之间的留言，保存在其文件夹中。",
 "Responde ao pedido": "回应请求",
 "Tipo / regime": "类型 / 税制",
 "Visto pelo cliente em {d}": "客户于 {d} 查看",
 "Válido até": "有效期至",
 "ano": "年",
 "código Pix copia e cola, se houver": "Pix 复制粘贴码（如有）",
 "data de vencimento": "到期日",
 "documento": "文件",
 "linha digitável do boleto ou da guia, só números": "boleto 或税单的数字行，仅数字",
 "mês": "月",
 "novo": "新",
 "todo mês, até o dia {n}": "每月 {n} 日前",
 "valor a pagar": "应付金额",
 "válido até {d}": "有效期至 {d}",
 "{c} nova": "新的 {c}",
 "{doc} pago": "{doc} 已支付",
 "{n} a pagar": "{n} 项待付",
 "{n} enviou {doc}": "{n} 发送了 {doc}",
 "{n} novo(s)": "{n} 个新的",
 "{n} pedido(s) de documentos criados, com prazo de 7 dias.": "已创建 {n} 个文件请求，期限 7 天。",
 "{n} vencida(s)": "{n} 项已逾期",
 "Última declaração do Imposto de Renda": "最近一次所得税申报",
 "Últimas guias pagas": "最近已缴税单",
 "Esta parte do Escritório ainda não foi ligada no servidor. No computador, rode o 56-SERVIDOR-0.96.bat (uma vez só).": "办公室的这一部分尚未连接到服务器。请在电脑上运行 56-SERVIDOR-0.96.bat（只需运行一次）。",
 "Só vê": "仅查看",
 "Nova versão": "新版本",
 "Já havia um arquivo com este nome: o anterior fica guardado como versão {n}.": "已有同名文件：之前的文件将保存为版本 {n}。",
 "Visto por e comentários": "查看者与评论",
 "Arquivar (só neste aparelho)": "归档（仅限此设备）",
 "Tirar do topo": "取消置顶",
 "Fixar no topo (para todos)": "置顶（对所有人）",
 "Mover para a pasta…": "移动到文件夹…",
 "versão {n}": "版本 {n}",
 "visto por {n}": "{n} 人已查看",
 "Até 50 MB por arquivo. Enviar um arquivo com o mesmo nome guarda o anterior como versão.": "每个文件最大 50 MB。上传同名文件会将之前的文件保存为一个版本。",
 "Procurar documento ou pasta": "搜索文档或文件夹",
 "Fixados": "已置顶",
 "Abrir o documento": "打开文档",
 "enviado por {nome}": "由 {nome} 上传",
 "Versões ({n})": "版本 ({n})",
 "Versão {n} (atual)": "版本 {n}（当前）",
 "Versão {n}": "版本 {n}",
 "Visto por ({n})": "查看者 ({n})",
 "Ninguém da equipe abriu ainda.": "团队中还没有人打开过。",
 "{nome} em {d}": "{nome}，{d}",
 "Comentários ({n})": "评论 ({n})",
 "Escreva um comentário": "写评论",
 "Contratos": "合同",
 "Financeiro do escritório": "办公室财务",
 "RH": "人事",
 "Mover para a pasta": "移动到文件夹",
 "Ou escreva o nome de uma pasta nova": "或输入新文件夹的名称",
 "Ela se repete toda semana: cancelando, sai de todas as semanas, da lista e dos Recebidos da equipe.": "此会议每周重复：取消后，将从所有周、列表以及团队的收件箱中移除。",
 "a equipe toda": "全体团队",
 "Com {quem}": "与 {quem}",
 "toda semana": "每周",
 "Vão: {n}": "参加：{n}",
 "Não vão: {n}": "不参加：{n}",
 "Vou": "我参加",
 "Não vou": "我不参加",
 "Pauta": "议程",
 "Ata": "会议纪要",
 "Escrever a ata": "撰写会议纪要",
 "Abrir o link": "打开链接",
 "Cada pessoa convidada recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "每位受邀者会在收件箱中收到会议，轻点一下即可加入 Planner 并带有提醒。",
 "Escreva primeiro as anotações da reunião (o que foi falado e decidido); a IA organiza em ata.": "请先写下会议记录要点（讨论和决定的内容），AI 会将其整理成会议纪要。",
 "Ata: {nome}": "会议纪要：{nome}",
 "Gerando...": "生成中...",
 "Gerar ata com a minha IA": "用我的 AI 生成会议纪要",
 "A IA organiza a pauta e as suas anotações em ata. Confira antes de salvar.": "AI 会将议程和您的记录整理成会议纪要。保存前请核对。",
 "Ainda sem ata.": "暂无会议纪要。",
 "Tarefas da reunião ({n})": "会议任务 ({n})",
 "Tarefa da reunião": "会议任务",
 "Salvar a ata": "保存会议纪要",
 "Repetir toda semana ({dia})": "每周重复（{dia}）",
 "Quem participa": "参与者",
 "A equipe toda": "全体团队",
 "Link externo (opcional: Meet, Zoom, Teams)": "外部链接（可选：Meet, Zoom, Teams）",
 "O link precisa começar com https://": "链接必须以 https:// 开头",
 "Marcar e avisar quem participa": "安排并通知参与者",
 "Cargo e papel": "职位与角色",
 "Passar o Admin": "移交管理员",
 "Passar o Admin para {nome}?": "将管理员移交给 {nome}？",
 "{nome} passa a ser quem cuida do escritório (pode apagá-lo). Você continua na equipe como administrador (quem recebe pode mudar isso depois).": "{nome} 将成为办公室的负责人（可以删除办公室）。您仍留在团队中担任管理员（接收者之后可以更改）。",
 "Passar": "移交",
 "{nome} agora cuida do escritório.": "{nome} 现在负责办公室。",
 "Seu papel aqui é \"Só vê\": você acompanha avisos, tarefas, reuniões e documentos.": "您在此的角色是“仅查看”：可关注通知、任务、会议和文档。",
 "Edita": "可编辑",
 "Incluir": "添加",
 "Novo aviso no mural": "公告栏新通知",
 "Você só pode ver este escritório: quem administra escolheu o papel \"Só vê\" para você. Peça a quem administra para mudar, se precisar.": "您只能查看此办公室：管理员为您选择了“仅查看”角色。如有需要，请联系管理员更改。",
 "Quem viu": "谁看过",
 "Apagar aviso": "删除通知",
 "Mural de avisos": "公告栏",
 "Novo aviso": "新通知",
 "Ex.: Feriado na sexta: escritório fechado": "例：周五放假：办公室关闭",
 "Fixar no mural": "固定到公告栏",
 "Nenhum aviso. Os avisos ficam fixados aqui para toda a equipe.": "暂无通知。通知会固定在此处，全体团队可见。",
 "visto por {n} de {m}": "{m} 人中 {n} 人已查看",
 "sem responsável": "无负责人",
 "atrasada desde {d}": "自 {d} 起逾期",
 "prazo {d}": "截止 {d}",
 "Comecei": "已开始",
 "Terminei": "已完成",
 "Reabrir": "重新打开",
 "Tarefas da equipe": "团队任务",
 "1 aberta": "1 项未完成",
 "{n} abertas": "{n} 项未完成",
 "Minhas tarefas ({n})": "我的任务 ({n})",
 "Nenhuma tarefa sua aberta. Toque em \"Eu faço\" numa tarefa da equipe.": "您没有未完成的任务。请在团队任务上点按“我来做”。",
 "Nenhuma tarefa aberta.": "没有未完成的任务。",
 "Feitas ({n})": "已完成 ({n})",
 "Apagar a tarefa?": "删除该任务？",
 "O que precisa ser feito? (ex.: Apurar o DAS de março)": "需要做什么？（例：核算三月的 DAS）",
 "Cliente (opcional)": "客户（可选）",
 "Prazo (opcional)": "截止日期（可选）",
 "Responsável (opcional; senão, alguém toca em \"Eu faço\")": "负责人（可选；否则由某人点按“我来做”）",
 "Escreva a tarefa para poder salvar.": "请先填写任务内容才能保存。",
 "Membro": "成员",
 "Cargo (livre)": "职位（自由填写）",
 "Ex.: Advogada, Assistente, Estagiário": "例：律师、助理、实习生",
 "Papel": "角色",
 "Admin: pode tudo no escritório.": "管理员：可在办公室中执行所有操作。",
 "Edita: inclui tarefas, avisos, documentos e reuniões": "可编辑：可添加任务、通知、文档和会议",
 "Só vê: acompanha tudo, sem incluir nem mudar": "仅查看：可关注一切，但不能添加或修改",
 "Proposta": "提案",
 "Documento sensível (pede a senha do app para abrir)": "敏感文件（打开时需要应用密码）",
 "Li e concordo: {d}": "已阅读并同意：{d}",
 "Li e concordo": "我已阅读并同意",
 "Ao tocar em Concordo, o app guarda a data e a hora em que você leu e concordou com \"{doc}\". É um aceite simples: não substitui uma assinatura digital oficial.": "点击“同意”后，应用会保存你阅读并同意“{doc}”的日期和时间。这只是简单确认，不能代替正式的电子签名。",
 "Concordo": "同意",
 "Fotos (escolha quais entram)": "照片（选择要放入的）",
 "1 foto não pôde ser lida neste dispositivo e ficou de fora.": "有 1 张照片无法在此设备上读取，已略过。",
 "{n} fotos não puderam ser lidas neste dispositivo e ficaram de fora.": "有 {n} 张照片无法在此设备上读取，已略过。",
 "Nenhuma foto no álbum desta viagem.": "这次旅行的相册里没有照片。",
 "Toque nas fotos para marcar ou desmarcar. Elas entram reduzidas, para o PDF ficar leve.": "点按照片来选择或取消。照片会被缩小，让 PDF 更轻。",
 "Sugerir até 12": "推荐最多 12 张",
 "1 foto marcada": "已选 1 张照片",
 "{n} fotos marcadas": "已选 {n} 张照片",
 "Com mais de 12 fotos o PDF fica mais pesado.": "超过 12 张照片时 PDF 会更大。",
 "Confirme para abrir este documento": "确认以打开此文件",
 "Como usar esta aba": "如何使用此分区",
 "1 cliente estava em mais de uma aba e virou uma ficha só.": "有 1 位客户出现在多个分区中，已合并为一份资料。",
 "Juntar {n} fotos num PDF?": "将 {n} 张照片合并为一个 PDF？",
 "As fotos viram as páginas de um PDF só, na ordem da lista. As fotos soltas saem desta ficha.": "照片将按列表顺序成为同一个 PDF 的各页。单独的照片会从此档案中移除。",
 "Não foi possível ler as fotos neste dispositivo.": "无法在此设备上读取照片。",
 "PDF criado": "PDF 已创建",
 "Montando o PDF...": "正在生成 PDF...",
 "Juntar as {n} fotos num PDF": "将 {n} 张照片合并为一个 PDF",
 "Baixar o mês": "下载本月",
 "Os arquivos deste mês estão em outro dispositivo e não puderam ser lidos aqui.": "本月的文件在另一台设备上，无法在此读取。",
 "Os documentos deste mês não têm arquivos.": "本月的文档没有文件。",
 "1 arquivo está em outro dispositivo e ficou de fora.": "有 1 个文件在另一台设备上，未包含在内。",
 "{n} arquivos estão em outro dispositivo e ficaram de fora.": "有 {n} 个文件在另一台设备上，未包含在内。",
 "Conversa sobre este documento": "关于此文档的对话",
 "Pergunte ou responda algo sobre este documento. O escritório e o cliente veem.": "就此文档提问或回复。事务所和客户都能看到。",
 "Escreva a mensagem": "输入消息",
 "Usar um modelo de pedido ({n})": "使用请求模板（{n}）",
 "Lembrar {nome} pelo WhatsApp: {o}": "通过 WhatsApp 提醒 {nome}：{o}",
 "Sem honorário": "无服务费",
 "Cadastre o valor do honorário no bloco \"Escritório\" da ficha do cliente, em Meus clientes.": "请在“我的客户”中客户档案的“事务所”区块填写服务费金额。",
 "Recebi de {c} a quantia de {v}, referente aos honorários da competência {m}.": "兹收到 {c} 支付的 {v}，为 {m} 所属期的服务费。",
 "Recibo honorário {m} {c}": "服务费收据 {m} {c}",
 "Recibo do honorário {m}": "服务费收据 {m}",
 "Recibo criado": "收据已创建",
 "O recibo entrou em Documentos, na competência {m}.": "收据已存入“文档”，所属期为 {m}。",
 "Vendo como o cliente": "以客户视角查看",
 "É assim que o cliente vê a pasta dele: sem as anotações internas e sem o que é só da equipe. Nada pode ser mudado neste modo.": "这是客户看到的文件夹：不含内部备注，也不含仅限团队的内容。此模式下不能做任何修改。",
 "Voltar a ver como escritório": "切换回事务所视角",
 "Ver como o cliente": "以客户视角查看",
 "🔒 Anotações internas (o cliente nunca vê)": "🔒 内部备注（客户永远看不到）",
 "Recibo do honorário…": "服务费收据…",
 "Competência do recibo": "收据所属期",
 "⬇️ Baixar o mês": "⬇️ 下载本月",
 "Me avisar para lembrar o cliente": "提醒我去提醒客户",
 "Guardar como modelo": "保存为模板",
 "Modelo guardado": "模板已保存",
 "Ao criar um pedido para qualquer cliente, toque em \"Usar um modelo de pedido\".": "为任何客户创建请求时，点击“使用请求模板”。",
 "Relatório do mês": "月度报告",
 "Notas rápidas": "快速笔记",
 "Item completo: {o}": "完整条目：{o}",
 "Reuniões do mês": "本月会议",
 "Tarefas feitas e pendentes": "已完成和待办任务",
 "Documentos internos enviados": "已发送的内部文档",
 "Documentos enviados e recebidos dos clientes": "与客户收发的文档",
 "Documentos da competência": "所属期文档",
 "Guias pagas e vencidas": "已缴和逾期的缴款单",
 "Honorários": "服务费",
 "Relatório do mês · {m}": "月度报告 · {m}",
 "Reuniões ({n})": "会议（{n}）",
 "Tarefas: {f} feitas no mês · {p} pendentes": "任务：本月完成 {f} 项 · 待办 {p} 项",
 "Quem fez": "完成人",
 "Feita em": "完成于",
 "Documentos internos enviados ({n})": "已发送的内部文档（{n}）",
 "Documentos trocados com os clientes": "与客户往来的文档",
 "Enviados pelo escritório": "事务所发送",
 "Recebidos do cliente": "客户发来",
 "Nenhum documento trocado neste mês.": "本月没有往来文档。",
 "Clientes com pendência ({n})": "有待处理事项的客户（{n}）",
 "Pendência": "待处理事项",
 "Nenhum cliente com pendência.": "没有待处理事项的客户。",
 "Documentos da competência {m} ({n})": "所属期 {m} 的文档（{n}）",
 "Pedidos de documentos ({n})": "文档请求（{n}）",
 "Guias do mês: {p} pagas · {v} vencidas": "本月缴款单：已缴 {p} · 逾期 {v}",
 "Vencida": "已逾期",
 "Recebido no mês": "本月已收",
 "Relatório {m} {q}": "报告 {m} {q}",
 "MÊS": "月份",
 "DE QUEM": "对象",
 "O escritório": "事务所",
 "Reuniões, tarefas e documentos internos entram quando há um escritório (equipe).": "有事务所（团队）时，会议、任务和内部文档会纳入报告。",
 "CPF, CNPJ, anotações internas e conversas nunca vão para o relatório.": "CPF、CNPJ、内部备注和对话绝不会进入报告。",
 "Anotações recebidas": "收到的笔记",
 "Os valores a receber desta lista aparecem no My Planner, inclusive os novos.": "此列表中待收的款项会显示在 My Planner 中，包括新增的。",
 "Envia só os valores a receber desta lista (as consultas já vão sozinhas), inclusive os novos.": "只发送此列表中待收的款项（预约会自动加入），包括新增的。",
 "Acrescentar": "添加",
 "As {n} caixas estão em {aba}, em \"Anotações recebidas\".": "这 {n} 个盒子在 {aba} 的“收到的笔记”中。",
 "Enviadas": "已发送",
 "Enviar para": "发送到",
 "Excluir 1 item?": "删除 1 项？",
 "Excluir {n} itens?": "删除 {n} 项？",
 "Inserir abaixo": "在下方插入",
 "Mover para": "移动到",
 "Mover {n} selecionados para": "将 {n} 个所选项移动到",
 "adicionar aqui": "在此添加",
 "continue segurando para selecionar": "继续按住以选择"
}
